// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../webfonts/fa-v4compatibility.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../webfonts/fa-v4compatibility.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900); }

.fas,
.far,
.fab,
.fa-solid,
.fa-regular,
.fa-brands,
.fa {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto; }

.fas::before,
.far::before,
.fab::before,
.fa-solid::before,
.fa-regular::before,
.fa-brands::before,
.fa::before {
  content: var(--fa); }

.fa-classic,
.fas,
.fa-solid,
.far,
.fa-regular {
  font-family: 'Font Awesome 6 Free'; }

.fa-brands,
.fab {
  font-family: 'Font Awesome 6 Brands'; }

.fa-1x {
  font-size: 1em; }

.fa-2x {
  font-size: 2em; }

.fa-3x {
  font-size: 3em; }

.fa-4x {
  font-size: 4em; }

.fa-5x {
  font-size: 5em; }

.fa-6x {
  font-size: 6em; }

.fa-7x {
  font-size: 7em; }

.fa-8x {
  font-size: 8em; }

.fa-9x {
  font-size: 9em; }

.fa-10x {
  font-size: 10em; }

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em; }

.fa-xs {
  font-size: 0.75em;
  line-height: 0.08333em;
  vertical-align: 0.125em; }

.fa-sm {
  font-size: 0.875em;
  line-height: 0.07143em;
  vertical-align: 0.05357em; }

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em; }

.fa-xl {
  font-size: 1.5em;
  line-height: 0.04167em;
  vertical-align: -0.125em; }

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em; }

.fa-fw {
  text-align: center;
  width: 1.25em; }

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0; }
  .fa-ul > li {
    position: relative; }

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit; }

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em); }

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em); }

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em); }

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out); }

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1)); }

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out); }

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear); }

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear); }

.fa-spin-reverse {
  --fa-animation-direction: reverse; }

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8)); }

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s; } }

@keyframes fa-beat {
  0%, 90% {
    transform: scale(1); }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25)); } }

@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0); }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0); }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em)); }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0); }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em)); }
  64% {
    transform: scale(1, 1) translateY(0); }
  100% {
    transform: scale(1, 1) translateY(0); } }

@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4); } }

@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1); }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125)); } }

@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg)); } }

@keyframes fa-shake {
  0% {
    transform: rotate(-15deg); }
  4% {
    transform: rotate(15deg); }
  8%, 24% {
    transform: rotate(-18deg); }
  12%, 28% {
    transform: rotate(18deg); }
  16% {
    transform: rotate(-22deg); }
  20% {
    transform: rotate(22deg); }
  32% {
    transform: rotate(-12deg); }
  36% {
    transform: rotate(12deg); }
  40%, 100% {
    transform: rotate(0deg); } }

@keyframes fa-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.fa-rotate-90 {
  transform: rotate(90deg); }

.fa-rotate-180 {
  transform: rotate(180deg); }

.fa-rotate-270 {
  transform: rotate(270deg); }

.fa-flip-horizontal {
  transform: scale(-1, 1); }

.fa-flip-vertical {
  transform: scale(1, -1); }

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1); }

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0)); }

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em; }

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto); }

.fa-stack-1x {
  line-height: inherit; }

.fa-stack-2x {
  font-size: 2em; }

.fa-inverse {
  color: var(--fa-inverse, #fff); }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */

.fa-0 {
  --fa: "\\30";
  --fa--fa: "\\30\\30"; }

.fa-1 {
  --fa: "\\31";
  --fa--fa: "\\31\\31"; }

.fa-2 {
  --fa: "\\32";
  --fa--fa: "\\32\\32"; }

.fa-3 {
  --fa: "\\33";
  --fa--fa: "\\33\\33"; }

.fa-4 {
  --fa: "\\34";
  --fa--fa: "\\34\\34"; }

.fa-5 {
  --fa: "\\35";
  --fa--fa: "\\35\\35"; }

.fa-6 {
  --fa: "\\36";
  --fa--fa: "\\36\\36"; }

.fa-7 {
  --fa: "\\37";
  --fa--fa: "\\37\\37"; }

.fa-8 {
  --fa: "\\38";
  --fa--fa: "\\38\\38"; }

.fa-9 {
  --fa: "\\39";
  --fa--fa: "\\39\\39"; }

.fa-fill-drip {
  --fa: "\\f576";
  --fa--fa: "\\f576\\f576"; }

.fa-arrows-to-circle {
  --fa: "\\e4bd";
  --fa--fa: "\\e4bd\\e4bd"; }

.fa-circle-chevron-right {
  --fa: "\\f138";
  --fa--fa: "\\f138\\f138"; }

.fa-chevron-circle-right {
  --fa: "\\f138";
  --fa--fa: "\\f138\\f138"; }

.fa-at {
  --fa: "\\40";
  --fa--fa: "\\40\\40"; }

.fa-trash-can {
  --fa: "\\f2ed";
  --fa--fa: "\\f2ed\\f2ed"; }

.fa-trash-alt {
  --fa: "\\f2ed";
  --fa--fa: "\\f2ed\\f2ed"; }

.fa-text-height {
  --fa: "\\f034";
  --fa--fa: "\\f034\\f034"; }

.fa-user-xmark {
  --fa: "\\f235";
  --fa--fa: "\\f235\\f235"; }

.fa-user-times {
  --fa: "\\f235";
  --fa--fa: "\\f235\\f235"; }

.fa-stethoscope {
  --fa: "\\f0f1";
  --fa--fa: "\\f0f1\\f0f1"; }

.fa-message {
  --fa: "\\f27a";
  --fa--fa: "\\f27a\\f27a"; }

.fa-comment-alt {
  --fa: "\\f27a";
  --fa--fa: "\\f27a\\f27a"; }

.fa-info {
  --fa: "\\f129";
  --fa--fa: "\\f129\\f129"; }

.fa-down-left-and-up-right-to-center {
  --fa: "\\f422";
  --fa--fa: "\\f422\\f422"; }

.fa-compress-alt {
  --fa: "\\f422";
  --fa--fa: "\\f422\\f422"; }

.fa-explosion {
  --fa: "\\e4e9";
  --fa--fa: "\\e4e9\\e4e9"; }

.fa-file-lines {
  --fa: "\\f15c";
  --fa--fa: "\\f15c\\f15c"; }

.fa-file-alt {
  --fa: "\\f15c";
  --fa--fa: "\\f15c\\f15c"; }

.fa-file-text {
  --fa: "\\f15c";
  --fa--fa: "\\f15c\\f15c"; }

.fa-wave-square {
  --fa: "\\f83e";
  --fa--fa: "\\f83e\\f83e"; }

.fa-ring {
  --fa: "\\f70b";
  --fa--fa: "\\f70b\\f70b"; }

.fa-building-un {
  --fa: "\\e4d9";
  --fa--fa: "\\e4d9\\e4d9"; }

.fa-dice-three {
  --fa: "\\f527";
  --fa--fa: "\\f527\\f527"; }

.fa-calendar-days {
  --fa: "\\f073";
  --fa--fa: "\\f073\\f073"; }

.fa-calendar-alt {
  --fa: "\\f073";
  --fa--fa: "\\f073\\f073"; }

.fa-anchor-circle-check {
  --fa: "\\e4aa";
  --fa--fa: "\\e4aa\\e4aa"; }

.fa-building-circle-arrow-right {
  --fa: "\\e4d1";
  --fa--fa: "\\e4d1\\e4d1"; }

.fa-volleyball {
  --fa: "\\f45f";
  --fa--fa: "\\f45f\\f45f"; }

.fa-volleyball-ball {
  --fa: "\\f45f";
  --fa--fa: "\\f45f\\f45f"; }

.fa-arrows-up-to-line {
  --fa: "\\e4c2";
  --fa--fa: "\\e4c2\\e4c2"; }

.fa-sort-down {
  --fa: "\\f0dd";
  --fa--fa: "\\f0dd\\f0dd"; }

.fa-sort-desc {
  --fa: "\\f0dd";
  --fa--fa: "\\f0dd\\f0dd"; }

.fa-circle-minus {
  --fa: "\\f056";
  --fa--fa: "\\f056\\f056"; }

.fa-minus-circle {
  --fa: "\\f056";
  --fa--fa: "\\f056\\f056"; }

.fa-door-open {
  --fa: "\\f52b";
  --fa--fa: "\\f52b\\f52b"; }

.fa-right-from-bracket {
  --fa: "\\f2f5";
  --fa--fa: "\\f2f5\\f2f5"; }

.fa-sign-out-alt {
  --fa: "\\f2f5";
  --fa--fa: "\\f2f5\\f2f5"; }

.fa-atom {
  --fa: "\\f5d2";
  --fa--fa: "\\f5d2\\f5d2"; }

.fa-soap {
  --fa: "\\e06e";
  --fa--fa: "\\e06e\\e06e"; }

.fa-icons {
  --fa: "\\f86d";
  --fa--fa: "\\f86d\\f86d"; }

.fa-heart-music-camera-bolt {
  --fa: "\\f86d";
  --fa--fa: "\\f86d\\f86d"; }

.fa-microphone-lines-slash {
  --fa: "\\f539";
  --fa--fa: "\\f539\\f539"; }

.fa-microphone-alt-slash {
  --fa: "\\f539";
  --fa--fa: "\\f539\\f539"; }

.fa-bridge-circle-check {
  --fa: "\\e4c9";
  --fa--fa: "\\e4c9\\e4c9"; }

.fa-pump-medical {
  --fa: "\\e06a";
  --fa--fa: "\\e06a\\e06a"; }

.fa-fingerprint {
  --fa: "\\f577";
  --fa--fa: "\\f577\\f577"; }

.fa-hand-point-right {
  --fa: "\\f0a4";
  --fa--fa: "\\f0a4\\f0a4"; }

.fa-magnifying-glass-location {
  --fa: "\\f689";
  --fa--fa: "\\f689\\f689"; }

.fa-search-location {
  --fa: "\\f689";
  --fa--fa: "\\f689\\f689"; }

.fa-forward-step {
  --fa: "\\f051";
  --fa--fa: "\\f051\\f051"; }

.fa-step-forward {
  --fa: "\\f051";
  --fa--fa: "\\f051\\f051"; }

.fa-face-smile-beam {
  --fa: "\\f5b8";
  --fa--fa: "\\f5b8\\f5b8"; }

.fa-smile-beam {
  --fa: "\\f5b8";
  --fa--fa: "\\f5b8\\f5b8"; }

.fa-flag-checkered {
  --fa: "\\f11e";
  --fa--fa: "\\f11e\\f11e"; }

.fa-football {
  --fa: "\\f44e";
  --fa--fa: "\\f44e\\f44e"; }

.fa-football-ball {
  --fa: "\\f44e";
  --fa--fa: "\\f44e\\f44e"; }

.fa-school-circle-exclamation {
  --fa: "\\e56c";
  --fa--fa: "\\e56c\\e56c"; }

.fa-crop {
  --fa: "\\f125";
  --fa--fa: "\\f125\\f125"; }

.fa-angles-down {
  --fa: "\\f103";
  --fa--fa: "\\f103\\f103"; }

.fa-angle-double-down {
  --fa: "\\f103";
  --fa--fa: "\\f103\\f103"; }

.fa-users-rectangle {
  --fa: "\\e594";
  --fa--fa: "\\e594\\e594"; }

.fa-people-roof {
  --fa: "\\e537";
  --fa--fa: "\\e537\\e537"; }

.fa-people-line {
  --fa: "\\e534";
  --fa--fa: "\\e534\\e534"; }

.fa-beer-mug-empty {
  --fa: "\\f0fc";
  --fa--fa: "\\f0fc\\f0fc"; }

.fa-beer {
  --fa: "\\f0fc";
  --fa--fa: "\\f0fc\\f0fc"; }

.fa-diagram-predecessor {
  --fa: "\\e477";
  --fa--fa: "\\e477\\e477"; }

.fa-arrow-up-long {
  --fa: "\\f176";
  --fa--fa: "\\f176\\f176"; }

.fa-long-arrow-up {
  --fa: "\\f176";
  --fa--fa: "\\f176\\f176"; }

.fa-fire-flame-simple {
  --fa: "\\f46a";
  --fa--fa: "\\f46a\\f46a"; }

.fa-burn {
  --fa: "\\f46a";
  --fa--fa: "\\f46a\\f46a"; }

.fa-person {
  --fa: "\\f183";
  --fa--fa: "\\f183\\f183"; }

.fa-male {
  --fa: "\\f183";
  --fa--fa: "\\f183\\f183"; }

.fa-laptop {
  --fa: "\\f109";
  --fa--fa: "\\f109\\f109"; }

.fa-file-csv {
  --fa: "\\f6dd";
  --fa--fa: "\\f6dd\\f6dd"; }

.fa-menorah {
  --fa: "\\f676";
  --fa--fa: "\\f676\\f676"; }

.fa-truck-plane {
  --fa: "\\e58f";
  --fa--fa: "\\e58f\\e58f"; }

.fa-record-vinyl {
  --fa: "\\f8d9";
  --fa--fa: "\\f8d9\\f8d9"; }

.fa-face-grin-stars {
  --fa: "\\f587";
  --fa--fa: "\\f587\\f587"; }

.fa-grin-stars {
  --fa: "\\f587";
  --fa--fa: "\\f587\\f587"; }

.fa-bong {
  --fa: "\\f55c";
  --fa--fa: "\\f55c\\f55c"; }

.fa-spaghetti-monster-flying {
  --fa: "\\f67b";
  --fa--fa: "\\f67b\\f67b"; }

.fa-pastafarianism {
  --fa: "\\f67b";
  --fa--fa: "\\f67b\\f67b"; }

.fa-arrow-down-up-across-line {
  --fa: "\\e4af";
  --fa--fa: "\\e4af\\e4af"; }

.fa-spoon {
  --fa: "\\f2e5";
  --fa--fa: "\\f2e5\\f2e5"; }

.fa-utensil-spoon {
  --fa: "\\f2e5";
  --fa--fa: "\\f2e5\\f2e5"; }

.fa-jar-wheat {
  --fa: "\\e517";
  --fa--fa: "\\e517\\e517"; }

.fa-envelopes-bulk {
  --fa: "\\f674";
  --fa--fa: "\\f674\\f674"; }

.fa-mail-bulk {
  --fa: "\\f674";
  --fa--fa: "\\f674\\f674"; }

.fa-file-circle-exclamation {
  --fa: "\\e4eb";
  --fa--fa: "\\e4eb\\e4eb"; }

.fa-circle-h {
  --fa: "\\f47e";
  --fa--fa: "\\f47e\\f47e"; }

.fa-hospital-symbol {
  --fa: "\\f47e";
  --fa--fa: "\\f47e\\f47e"; }

.fa-pager {
  --fa: "\\f815";
  --fa--fa: "\\f815\\f815"; }

.fa-address-book {
  --fa: "\\f2b9";
  --fa--fa: "\\f2b9\\f2b9"; }

.fa-contact-book {
  --fa: "\\f2b9";
  --fa--fa: "\\f2b9\\f2b9"; }

.fa-strikethrough {
  --fa: "\\f0cc";
  --fa--fa: "\\f0cc\\f0cc"; }

.fa-k {
  --fa: "\\4b";
  --fa--fa: "\\4b\\4b"; }

.fa-landmark-flag {
  --fa: "\\e51c";
  --fa--fa: "\\e51c\\e51c"; }

.fa-pencil {
  --fa: "\\f303";
  --fa--fa: "\\f303\\f303"; }

.fa-pencil-alt {
  --fa: "\\f303";
  --fa--fa: "\\f303\\f303"; }

.fa-backward {
  --fa: "\\f04a";
  --fa--fa: "\\f04a\\f04a"; }

.fa-caret-right {
  --fa: "\\f0da";
  --fa--fa: "\\f0da\\f0da"; }

.fa-comments {
  --fa: "\\f086";
  --fa--fa: "\\f086\\f086"; }

.fa-paste {
  --fa: "\\f0ea";
  --fa--fa: "\\f0ea\\f0ea"; }

.fa-file-clipboard {
  --fa: "\\f0ea";
  --fa--fa: "\\f0ea\\f0ea"; }

.fa-code-pull-request {
  --fa: "\\e13c";
  --fa--fa: "\\e13c\\e13c"; }

.fa-clipboard-list {
  --fa: "\\f46d";
  --fa--fa: "\\f46d\\f46d"; }

.fa-truck-ramp-box {
  --fa: "\\f4de";
  --fa--fa: "\\f4de\\f4de"; }

.fa-truck-loading {
  --fa: "\\f4de";
  --fa--fa: "\\f4de\\f4de"; }

.fa-user-check {
  --fa: "\\f4fc";
  --fa--fa: "\\f4fc\\f4fc"; }

.fa-vial-virus {
  --fa: "\\e597";
  --fa--fa: "\\e597\\e597"; }

.fa-sheet-plastic {
  --fa: "\\e571";
  --fa--fa: "\\e571\\e571"; }

.fa-blog {
  --fa: "\\f781";
  --fa--fa: "\\f781\\f781"; }

.fa-user-ninja {
  --fa: "\\f504";
  --fa--fa: "\\f504\\f504"; }

.fa-person-arrow-up-from-line {
  --fa: "\\e539";
  --fa--fa: "\\e539\\e539"; }

.fa-scroll-torah {
  --fa: "\\f6a0";
  --fa--fa: "\\f6a0\\f6a0"; }

.fa-torah {
  --fa: "\\f6a0";
  --fa--fa: "\\f6a0\\f6a0"; }

.fa-broom-ball {
  --fa: "\\f458";
  --fa--fa: "\\f458\\f458"; }

.fa-quidditch {
  --fa: "\\f458";
  --fa--fa: "\\f458\\f458"; }

.fa-quidditch-broom-ball {
  --fa: "\\f458";
  --fa--fa: "\\f458\\f458"; }

.fa-toggle-off {
  --fa: "\\f204";
  --fa--fa: "\\f204\\f204"; }

.fa-box-archive {
  --fa: "\\f187";
  --fa--fa: "\\f187\\f187"; }

.fa-archive {
  --fa: "\\f187";
  --fa--fa: "\\f187\\f187"; }

.fa-person-drowning {
  --fa: "\\e545";
  --fa--fa: "\\e545\\e545"; }

.fa-arrow-down-9-1 {
  --fa: "\\f886";
  --fa--fa: "\\f886\\f886"; }

.fa-sort-numeric-desc {
  --fa: "\\f886";
  --fa--fa: "\\f886\\f886"; }

.fa-sort-numeric-down-alt {
  --fa: "\\f886";
  --fa--fa: "\\f886\\f886"; }

.fa-face-grin-tongue-squint {
  --fa: "\\f58a";
  --fa--fa: "\\f58a\\f58a"; }

.fa-grin-tongue-squint {
  --fa: "\\f58a";
  --fa--fa: "\\f58a\\f58a"; }

.fa-spray-can {
  --fa: "\\f5bd";
  --fa--fa: "\\f5bd\\f5bd"; }

.fa-truck-monster {
  --fa: "\\f63b";
  --fa--fa: "\\f63b\\f63b"; }

.fa-w {
  --fa: "\\57";
  --fa--fa: "\\57\\57"; }

.fa-earth-africa {
  --fa: "\\f57c";
  --fa--fa: "\\f57c\\f57c"; }

.fa-globe-africa {
  --fa: "\\f57c";
  --fa--fa: "\\f57c\\f57c"; }

.fa-rainbow {
  --fa: "\\f75b";
  --fa--fa: "\\f75b\\f75b"; }

.fa-circle-notch {
  --fa: "\\f1ce";
  --fa--fa: "\\f1ce\\f1ce"; }

.fa-tablet-screen-button {
  --fa: "\\f3fa";
  --fa--fa: "\\f3fa\\f3fa"; }

.fa-tablet-alt {
  --fa: "\\f3fa";
  --fa--fa: "\\f3fa\\f3fa"; }

.fa-paw {
  --fa: "\\f1b0";
  --fa--fa: "\\f1b0\\f1b0"; }

.fa-cloud {
  --fa: "\\f0c2";
  --fa--fa: "\\f0c2\\f0c2"; }

.fa-trowel-bricks {
  --fa: "\\e58a";
  --fa--fa: "\\e58a\\e58a"; }

.fa-face-flushed {
  --fa: "\\f579";
  --fa--fa: "\\f579\\f579"; }

.fa-flushed {
  --fa: "\\f579";
  --fa--fa: "\\f579\\f579"; }

.fa-hospital-user {
  --fa: "\\f80d";
  --fa--fa: "\\f80d\\f80d"; }

.fa-tent-arrow-left-right {
  --fa: "\\e57f";
  --fa--fa: "\\e57f\\e57f"; }

.fa-gavel {
  --fa: "\\f0e3";
  --fa--fa: "\\f0e3\\f0e3"; }

.fa-legal {
  --fa: "\\f0e3";
  --fa--fa: "\\f0e3\\f0e3"; }

.fa-binoculars {
  --fa: "\\f1e5";
  --fa--fa: "\\f1e5\\f1e5"; }

.fa-microphone-slash {
  --fa: "\\f131";
  --fa--fa: "\\f131\\f131"; }

.fa-box-tissue {
  --fa: "\\e05b";
  --fa--fa: "\\e05b\\e05b"; }

.fa-motorcycle {
  --fa: "\\f21c";
  --fa--fa: "\\f21c\\f21c"; }

.fa-bell-concierge {
  --fa: "\\f562";
  --fa--fa: "\\f562\\f562"; }

.fa-concierge-bell {
  --fa: "\\f562";
  --fa--fa: "\\f562\\f562"; }

.fa-pen-ruler {
  --fa: "\\f5ae";
  --fa--fa: "\\f5ae\\f5ae"; }

.fa-pencil-ruler {
  --fa: "\\f5ae";
  --fa--fa: "\\f5ae\\f5ae"; }

.fa-people-arrows {
  --fa: "\\e068";
  --fa--fa: "\\e068\\e068"; }

.fa-people-arrows-left-right {
  --fa: "\\e068";
  --fa--fa: "\\e068\\e068"; }

.fa-mars-and-venus-burst {
  --fa: "\\e523";
  --fa--fa: "\\e523\\e523"; }

.fa-square-caret-right {
  --fa: "\\f152";
  --fa--fa: "\\f152\\f152"; }

.fa-caret-square-right {
  --fa: "\\f152";
  --fa--fa: "\\f152\\f152"; }

.fa-scissors {
  --fa: "\\f0c4";
  --fa--fa: "\\f0c4\\f0c4"; }

.fa-cut {
  --fa: "\\f0c4";
  --fa--fa: "\\f0c4\\f0c4"; }

.fa-sun-plant-wilt {
  --fa: "\\e57a";
  --fa--fa: "\\e57a\\e57a"; }

.fa-toilets-portable {
  --fa: "\\e584";
  --fa--fa: "\\e584\\e584"; }

.fa-hockey-puck {
  --fa: "\\f453";
  --fa--fa: "\\f453\\f453"; }

.fa-table {
  --fa: "\\f0ce";
  --fa--fa: "\\f0ce\\f0ce"; }

.fa-magnifying-glass-arrow-right {
  --fa: "\\e521";
  --fa--fa: "\\e521\\e521"; }

.fa-tachograph-digital {
  --fa: "\\f566";
  --fa--fa: "\\f566\\f566"; }

.fa-digital-tachograph {
  --fa: "\\f566";
  --fa--fa: "\\f566\\f566"; }

.fa-users-slash {
  --fa: "\\e073";
  --fa--fa: "\\e073\\e073"; }

.fa-clover {
  --fa: "\\e139";
  --fa--fa: "\\e139\\e139"; }

.fa-reply {
  --fa: "\\f3e5";
  --fa--fa: "\\f3e5\\f3e5"; }

.fa-mail-reply {
  --fa: "\\f3e5";
  --fa--fa: "\\f3e5\\f3e5"; }

.fa-star-and-crescent {
  --fa: "\\f699";
  --fa--fa: "\\f699\\f699"; }

.fa-house-fire {
  --fa: "\\e50c";
  --fa--fa: "\\e50c\\e50c"; }

.fa-square-minus {
  --fa: "\\f146";
  --fa--fa: "\\f146\\f146"; }

.fa-minus-square {
  --fa: "\\f146";
  --fa--fa: "\\f146\\f146"; }

.fa-helicopter {
  --fa: "\\f533";
  --fa--fa: "\\f533\\f533"; }

.fa-compass {
  --fa: "\\f14e";
  --fa--fa: "\\f14e\\f14e"; }

.fa-square-caret-down {
  --fa: "\\f150";
  --fa--fa: "\\f150\\f150"; }

.fa-caret-square-down {
  --fa: "\\f150";
  --fa--fa: "\\f150\\f150"; }

.fa-file-circle-question {
  --fa: "\\e4ef";
  --fa--fa: "\\e4ef\\e4ef"; }

.fa-laptop-code {
  --fa: "\\f5fc";
  --fa--fa: "\\f5fc\\f5fc"; }

.fa-swatchbook {
  --fa: "\\f5c3";
  --fa--fa: "\\f5c3\\f5c3"; }

.fa-prescription-bottle {
  --fa: "\\f485";
  --fa--fa: "\\f485\\f485"; }

.fa-bars {
  --fa: "\\f0c9";
  --fa--fa: "\\f0c9\\f0c9"; }

.fa-navicon {
  --fa: "\\f0c9";
  --fa--fa: "\\f0c9\\f0c9"; }

.fa-people-group {
  --fa: "\\e533";
  --fa--fa: "\\e533\\e533"; }

.fa-hourglass-end {
  --fa: "\\f253";
  --fa--fa: "\\f253\\f253"; }

.fa-hourglass-3 {
  --fa: "\\f253";
  --fa--fa: "\\f253\\f253"; }

.fa-heart-crack {
  --fa: "\\f7a9";
  --fa--fa: "\\f7a9\\f7a9"; }

.fa-heart-broken {
  --fa: "\\f7a9";
  --fa--fa: "\\f7a9\\f7a9"; }

.fa-square-up-right {
  --fa: "\\f360";
  --fa--fa: "\\f360\\f360"; }

.fa-external-link-square-alt {
  --fa: "\\f360";
  --fa--fa: "\\f360\\f360"; }

.fa-face-kiss-beam {
  --fa: "\\f597";
  --fa--fa: "\\f597\\f597"; }

.fa-kiss-beam {
  --fa: "\\f597";
  --fa--fa: "\\f597\\f597"; }

.fa-film {
  --fa: "\\f008";
  --fa--fa: "\\f008\\f008"; }

.fa-ruler-horizontal {
  --fa: "\\f547";
  --fa--fa: "\\f547\\f547"; }

.fa-people-robbery {
  --fa: "\\e536";
  --fa--fa: "\\e536\\e536"; }

.fa-lightbulb {
  --fa: "\\f0eb";
  --fa--fa: "\\f0eb\\f0eb"; }

.fa-caret-left {
  --fa: "\\f0d9";
  --fa--fa: "\\f0d9\\f0d9"; }

.fa-circle-exclamation {
  --fa: "\\f06a";
  --fa--fa: "\\f06a\\f06a"; }

.fa-exclamation-circle {
  --fa: "\\f06a";
  --fa--fa: "\\f06a\\f06a"; }

.fa-school-circle-xmark {
  --fa: "\\e56d";
  --fa--fa: "\\e56d\\e56d"; }

.fa-arrow-right-from-bracket {
  --fa: "\\f08b";
  --fa--fa: "\\f08b\\f08b"; }

.fa-sign-out {
  --fa: "\\f08b";
  --fa--fa: "\\f08b\\f08b"; }

.fa-circle-chevron-down {
  --fa: "\\f13a";
  --fa--fa: "\\f13a\\f13a"; }

.fa-chevron-circle-down {
  --fa: "\\f13a";
  --fa--fa: "\\f13a\\f13a"; }

.fa-unlock-keyhole {
  --fa: "\\f13e";
  --fa--fa: "\\f13e\\f13e"; }

.fa-unlock-alt {
  --fa: "\\f13e";
  --fa--fa: "\\f13e\\f13e"; }

.fa-cloud-showers-heavy {
  --fa: "\\f740";
  --fa--fa: "\\f740\\f740"; }

.fa-headphones-simple {
  --fa: "\\f58f";
  --fa--fa: "\\f58f\\f58f"; }

.fa-headphones-alt {
  --fa: "\\f58f";
  --fa--fa: "\\f58f\\f58f"; }

.fa-sitemap {
  --fa: "\\f0e8";
  --fa--fa: "\\f0e8\\f0e8"; }

.fa-circle-dollar-to-slot {
  --fa: "\\f4b9";
  --fa--fa: "\\f4b9\\f4b9"; }

.fa-donate {
  --fa: "\\f4b9";
  --fa--fa: "\\f4b9\\f4b9"; }

.fa-memory {
  --fa: "\\f538";
  --fa--fa: "\\f538\\f538"; }

.fa-road-spikes {
  --fa: "\\e568";
  --fa--fa: "\\e568\\e568"; }

.fa-fire-burner {
  --fa: "\\e4f1";
  --fa--fa: "\\e4f1\\e4f1"; }

.fa-flag {
  --fa: "\\f024";
  --fa--fa: "\\f024\\f024"; }

.fa-hanukiah {
  --fa: "\\f6e6";
  --fa--fa: "\\f6e6\\f6e6"; }

.fa-feather {
  --fa: "\\f52d";
  --fa--fa: "\\f52d\\f52d"; }

.fa-volume-low {
  --fa: "\\f027";
  --fa--fa: "\\f027\\f027"; }

.fa-volume-down {
  --fa: "\\f027";
  --fa--fa: "\\f027\\f027"; }

.fa-comment-slash {
  --fa: "\\f4b3";
  --fa--fa: "\\f4b3\\f4b3"; }

.fa-cloud-sun-rain {
  --fa: "\\f743";
  --fa--fa: "\\f743\\f743"; }

.fa-compress {
  --fa: "\\f066";
  --fa--fa: "\\f066\\f066"; }

.fa-wheat-awn {
  --fa: "\\e2cd";
  --fa--fa: "\\e2cd\\e2cd"; }

.fa-wheat-alt {
  --fa: "\\e2cd";
  --fa--fa: "\\e2cd\\e2cd"; }

.fa-ankh {
  --fa: "\\f644";
  --fa--fa: "\\f644\\f644"; }

.fa-hands-holding-child {
  --fa: "\\e4fa";
  --fa--fa: "\\e4fa\\e4fa"; }

.fa-asterisk {
  --fa: "\\2a";
  --fa--fa: "\\2a\\2a"; }

.fa-square-check {
  --fa: "\\f14a";
  --fa--fa: "\\f14a\\f14a"; }

.fa-check-square {
  --fa: "\\f14a";
  --fa--fa: "\\f14a\\f14a"; }

.fa-peseta-sign {
  --fa: "\\e221";
  --fa--fa: "\\e221\\e221"; }

.fa-heading {
  --fa: "\\f1dc";
  --fa--fa: "\\f1dc\\f1dc"; }

.fa-header {
  --fa: "\\f1dc";
  --fa--fa: "\\f1dc\\f1dc"; }

.fa-ghost {
  --fa: "\\f6e2";
  --fa--fa: "\\f6e2\\f6e2"; }

.fa-list {
  --fa: "\\f03a";
  --fa--fa: "\\f03a\\f03a"; }

.fa-list-squares {
  --fa: "\\f03a";
  --fa--fa: "\\f03a\\f03a"; }

.fa-square-phone-flip {
  --fa: "\\f87b";
  --fa--fa: "\\f87b\\f87b"; }

.fa-phone-square-alt {
  --fa: "\\f87b";
  --fa--fa: "\\f87b\\f87b"; }

.fa-cart-plus {
  --fa: "\\f217";
  --fa--fa: "\\f217\\f217"; }

.fa-gamepad {
  --fa: "\\f11b";
  --fa--fa: "\\f11b\\f11b"; }

.fa-circle-dot {
  --fa: "\\f192";
  --fa--fa: "\\f192\\f192"; }

.fa-dot-circle {
  --fa: "\\f192";
  --fa--fa: "\\f192\\f192"; }

.fa-face-dizzy {
  --fa: "\\f567";
  --fa--fa: "\\f567\\f567"; }

.fa-dizzy {
  --fa: "\\f567";
  --fa--fa: "\\f567\\f567"; }

.fa-egg {
  --fa: "\\f7fb";
  --fa--fa: "\\f7fb\\f7fb"; }

.fa-house-medical-circle-xmark {
  --fa: "\\e513";
  --fa--fa: "\\e513\\e513"; }

.fa-campground {
  --fa: "\\f6bb";
  --fa--fa: "\\f6bb\\f6bb"; }

.fa-folder-plus {
  --fa: "\\f65e";
  --fa--fa: "\\f65e\\f65e"; }

.fa-futbol {
  --fa: "\\f1e3";
  --fa--fa: "\\f1e3\\f1e3"; }

.fa-futbol-ball {
  --fa: "\\f1e3";
  --fa--fa: "\\f1e3\\f1e3"; }

.fa-soccer-ball {
  --fa: "\\f1e3";
  --fa--fa: "\\f1e3\\f1e3"; }

.fa-paintbrush {
  --fa: "\\f1fc";
  --fa--fa: "\\f1fc\\f1fc"; }

.fa-paint-brush {
  --fa: "\\f1fc";
  --fa--fa: "\\f1fc\\f1fc"; }

.fa-lock {
  --fa: "\\f023";
  --fa--fa: "\\f023\\f023"; }

.fa-gas-pump {
  --fa: "\\f52f";
  --fa--fa: "\\f52f\\f52f"; }

.fa-hot-tub-person {
  --fa: "\\f593";
  --fa--fa: "\\f593\\f593"; }

.fa-hot-tub {
  --fa: "\\f593";
  --fa--fa: "\\f593\\f593"; }

.fa-map-location {
  --fa: "\\f59f";
  --fa--fa: "\\f59f\\f59f"; }

.fa-map-marked {
  --fa: "\\f59f";
  --fa--fa: "\\f59f\\f59f"; }

.fa-house-flood-water {
  --fa: "\\e50e";
  --fa--fa: "\\e50e\\e50e"; }

.fa-tree {
  --fa: "\\f1bb";
  --fa--fa: "\\f1bb\\f1bb"; }

.fa-bridge-lock {
  --fa: "\\e4cc";
  --fa--fa: "\\e4cc\\e4cc"; }

.fa-sack-dollar {
  --fa: "\\f81d";
  --fa--fa: "\\f81d\\f81d"; }

.fa-pen-to-square {
  --fa: "\\f044";
  --fa--fa: "\\f044\\f044"; }

.fa-edit {
  --fa: "\\f044";
  --fa--fa: "\\f044\\f044"; }

.fa-car-side {
  --fa: "\\f5e4";
  --fa--fa: "\\f5e4\\f5e4"; }

.fa-share-nodes {
  --fa: "\\f1e0";
  --fa--fa: "\\f1e0\\f1e0"; }

.fa-share-alt {
  --fa: "\\f1e0";
  --fa--fa: "\\f1e0\\f1e0"; }

.fa-heart-circle-minus {
  --fa: "\\e4ff";
  --fa--fa: "\\e4ff\\e4ff"; }

.fa-hourglass-half {
  --fa: "\\f252";
  --fa--fa: "\\f252\\f252"; }

.fa-hourglass-2 {
  --fa: "\\f252";
  --fa--fa: "\\f252\\f252"; }

.fa-microscope {
  --fa: "\\f610";
  --fa--fa: "\\f610\\f610"; }

.fa-sink {
  --fa: "\\e06d";
  --fa--fa: "\\e06d\\e06d"; }

.fa-bag-shopping {
  --fa: "\\f290";
  --fa--fa: "\\f290\\f290"; }

.fa-shopping-bag {
  --fa: "\\f290";
  --fa--fa: "\\f290\\f290"; }

.fa-arrow-down-z-a {
  --fa: "\\f881";
  --fa--fa: "\\f881\\f881"; }

.fa-sort-alpha-desc {
  --fa: "\\f881";
  --fa--fa: "\\f881\\f881"; }

.fa-sort-alpha-down-alt {
  --fa: "\\f881";
  --fa--fa: "\\f881\\f881"; }

.fa-mitten {
  --fa: "\\f7b5";
  --fa--fa: "\\f7b5\\f7b5"; }

.fa-person-rays {
  --fa: "\\e54d";
  --fa--fa: "\\e54d\\e54d"; }

.fa-users {
  --fa: "\\f0c0";
  --fa--fa: "\\f0c0\\f0c0"; }

.fa-eye-slash {
  --fa: "\\f070";
  --fa--fa: "\\f070\\f070"; }

.fa-flask-vial {
  --fa: "\\e4f3";
  --fa--fa: "\\e4f3\\e4f3"; }

.fa-hand {
  --fa: "\\f256";
  --fa--fa: "\\f256\\f256"; }

.fa-hand-paper {
  --fa: "\\f256";
  --fa--fa: "\\f256\\f256"; }

.fa-om {
  --fa: "\\f679";
  --fa--fa: "\\f679\\f679"; }

.fa-worm {
  --fa: "\\e599";
  --fa--fa: "\\e599\\e599"; }

.fa-house-circle-xmark {
  --fa: "\\e50b";
  --fa--fa: "\\e50b\\e50b"; }

.fa-plug {
  --fa: "\\f1e6";
  --fa--fa: "\\f1e6\\f1e6"; }

.fa-chevron-up {
  --fa: "\\f077";
  --fa--fa: "\\f077\\f077"; }

.fa-hand-spock {
  --fa: "\\f259";
  --fa--fa: "\\f259\\f259"; }

.fa-stopwatch {
  --fa: "\\f2f2";
  --fa--fa: "\\f2f2\\f2f2"; }

.fa-face-kiss {
  --fa: "\\f596";
  --fa--fa: "\\f596\\f596"; }

.fa-kiss {
  --fa: "\\f596";
  --fa--fa: "\\f596\\f596"; }

.fa-bridge-circle-xmark {
  --fa: "\\e4cb";
  --fa--fa: "\\e4cb\\e4cb"; }

.fa-face-grin-tongue {
  --fa: "\\f589";
  --fa--fa: "\\f589\\f589"; }

.fa-grin-tongue {
  --fa: "\\f589";
  --fa--fa: "\\f589\\f589"; }

.fa-chess-bishop {
  --fa: "\\f43a";
  --fa--fa: "\\f43a\\f43a"; }

.fa-face-grin-wink {
  --fa: "\\f58c";
  --fa--fa: "\\f58c\\f58c"; }

.fa-grin-wink {
  --fa: "\\f58c";
  --fa--fa: "\\f58c\\f58c"; }

.fa-ear-deaf {
  --fa: "\\f2a4";
  --fa--fa: "\\f2a4\\f2a4"; }

.fa-deaf {
  --fa: "\\f2a4";
  --fa--fa: "\\f2a4\\f2a4"; }

.fa-deafness {
  --fa: "\\f2a4";
  --fa--fa: "\\f2a4\\f2a4"; }

.fa-hard-of-hearing {
  --fa: "\\f2a4";
  --fa--fa: "\\f2a4\\f2a4"; }

.fa-road-circle-check {
  --fa: "\\e564";
  --fa--fa: "\\e564\\e564"; }

.fa-dice-five {
  --fa: "\\f523";
  --fa--fa: "\\f523\\f523"; }

.fa-square-rss {
  --fa: "\\f143";
  --fa--fa: "\\f143\\f143"; }

.fa-rss-square {
  --fa: "\\f143";
  --fa--fa: "\\f143\\f143"; }

.fa-land-mine-on {
  --fa: "\\e51b";
  --fa--fa: "\\e51b\\e51b"; }

.fa-i-cursor {
  --fa: "\\f246";
  --fa--fa: "\\f246\\f246"; }

.fa-stamp {
  --fa: "\\f5bf";
  --fa--fa: "\\f5bf\\f5bf"; }

.fa-stairs {
  --fa: "\\e289";
  --fa--fa: "\\e289\\e289"; }

.fa-i {
  --fa: "\\49";
  --fa--fa: "\\49\\49"; }

.fa-hryvnia-sign {
  --fa: "\\f6f2";
  --fa--fa: "\\f6f2\\f6f2"; }

.fa-hryvnia {
  --fa: "\\f6f2";
  --fa--fa: "\\f6f2\\f6f2"; }

.fa-pills {
  --fa: "\\f484";
  --fa--fa: "\\f484\\f484"; }

.fa-face-grin-wide {
  --fa: "\\f581";
  --fa--fa: "\\f581\\f581"; }

.fa-grin-alt {
  --fa: "\\f581";
  --fa--fa: "\\f581\\f581"; }

.fa-tooth {
  --fa: "\\f5c9";
  --fa--fa: "\\f5c9\\f5c9"; }

.fa-v {
  --fa: "\\56";
  --fa--fa: "\\56\\56"; }

.fa-bangladeshi-taka-sign {
  --fa: "\\e2e6";
  --fa--fa: "\\e2e6\\e2e6"; }

.fa-bicycle {
  --fa: "\\f206";
  --fa--fa: "\\f206\\f206"; }

.fa-staff-snake {
  --fa: "\\e579";
  --fa--fa: "\\e579\\e579"; }

.fa-rod-asclepius {
  --fa: "\\e579";
  --fa--fa: "\\e579\\e579"; }

.fa-rod-snake {
  --fa: "\\e579";
  --fa--fa: "\\e579\\e579"; }

.fa-staff-aesculapius {
  --fa: "\\e579";
  --fa--fa: "\\e579\\e579"; }

.fa-head-side-cough-slash {
  --fa: "\\e062";
  --fa--fa: "\\e062\\e062"; }

.fa-truck-medical {
  --fa: "\\f0f9";
  --fa--fa: "\\f0f9\\f0f9"; }

.fa-ambulance {
  --fa: "\\f0f9";
  --fa--fa: "\\f0f9\\f0f9"; }

.fa-wheat-awn-circle-exclamation {
  --fa: "\\e598";
  --fa--fa: "\\e598\\e598"; }

.fa-snowman {
  --fa: "\\f7d0";
  --fa--fa: "\\f7d0\\f7d0"; }

.fa-mortar-pestle {
  --fa: "\\f5a7";
  --fa--fa: "\\f5a7\\f5a7"; }

.fa-road-barrier {
  --fa: "\\e562";
  --fa--fa: "\\e562\\e562"; }

.fa-school {
  --fa: "\\f549";
  --fa--fa: "\\f549\\f549"; }

.fa-igloo {
  --fa: "\\f7ae";
  --fa--fa: "\\f7ae\\f7ae"; }

.fa-joint {
  --fa: "\\f595";
  --fa--fa: "\\f595\\f595"; }

.fa-angle-right {
  --fa: "\\f105";
  --fa--fa: "\\f105\\f105"; }

.fa-horse {
  --fa: "\\f6f0";
  --fa--fa: "\\f6f0\\f6f0"; }

.fa-q {
  --fa: "\\51";
  --fa--fa: "\\51\\51"; }

.fa-g {
  --fa: "\\47";
  --fa--fa: "\\47\\47"; }

.fa-notes-medical {
  --fa: "\\f481";
  --fa--fa: "\\f481\\f481"; }

.fa-temperature-half {
  --fa: "\\f2c9";
  --fa--fa: "\\f2c9\\f2c9"; }

.fa-temperature-2 {
  --fa: "\\f2c9";
  --fa--fa: "\\f2c9\\f2c9"; }

.fa-thermometer-2 {
  --fa: "\\f2c9";
  --fa--fa: "\\f2c9\\f2c9"; }

.fa-thermometer-half {
  --fa: "\\f2c9";
  --fa--fa: "\\f2c9\\f2c9"; }

.fa-dong-sign {
  --fa: "\\e169";
  --fa--fa: "\\e169\\e169"; }

.fa-capsules {
  --fa: "\\f46b";
  --fa--fa: "\\f46b\\f46b"; }

.fa-poo-storm {
  --fa: "\\f75a";
  --fa--fa: "\\f75a\\f75a"; }

.fa-poo-bolt {
  --fa: "\\f75a";
  --fa--fa: "\\f75a\\f75a"; }

.fa-face-frown-open {
  --fa: "\\f57a";
  --fa--fa: "\\f57a\\f57a"; }

.fa-frown-open {
  --fa: "\\f57a";
  --fa--fa: "\\f57a\\f57a"; }

.fa-hand-point-up {
  --fa: "\\f0a6";
  --fa--fa: "\\f0a6\\f0a6"; }

.fa-money-bill {
  --fa: "\\f0d6";
  --fa--fa: "\\f0d6\\f0d6"; }

.fa-bookmark {
  --fa: "\\f02e";
  --fa--fa: "\\f02e\\f02e"; }

.fa-align-justify {
  --fa: "\\f039";
  --fa--fa: "\\f039\\f039"; }

.fa-umbrella-beach {
  --fa: "\\f5ca";
  --fa--fa: "\\f5ca\\f5ca"; }

.fa-helmet-un {
  --fa: "\\e503";
  --fa--fa: "\\e503\\e503"; }

.fa-bullseye {
  --fa: "\\f140";
  --fa--fa: "\\f140\\f140"; }

.fa-bacon {
  --fa: "\\f7e5";
  --fa--fa: "\\f7e5\\f7e5"; }

.fa-hand-point-down {
  --fa: "\\f0a7";
  --fa--fa: "\\f0a7\\f0a7"; }

.fa-arrow-up-from-bracket {
  --fa: "\\e09a";
  --fa--fa: "\\e09a\\e09a"; }

.fa-folder {
  --fa: "\\f07b";
  --fa--fa: "\\f07b\\f07b"; }

.fa-folder-blank {
  --fa: "\\f07b";
  --fa--fa: "\\f07b\\f07b"; }

.fa-file-waveform {
  --fa: "\\f478";
  --fa--fa: "\\f478\\f478"; }

.fa-file-medical-alt {
  --fa: "\\f478";
  --fa--fa: "\\f478\\f478"; }

.fa-radiation {
  --fa: "\\f7b9";
  --fa--fa: "\\f7b9\\f7b9"; }

.fa-chart-simple {
  --fa: "\\e473";
  --fa--fa: "\\e473\\e473"; }

.fa-mars-stroke {
  --fa: "\\f229";
  --fa--fa: "\\f229\\f229"; }

.fa-vial {
  --fa: "\\f492";
  --fa--fa: "\\f492\\f492"; }

.fa-gauge {
  --fa: "\\f624";
  --fa--fa: "\\f624\\f624"; }

.fa-dashboard {
  --fa: "\\f624";
  --fa--fa: "\\f624\\f624"; }

.fa-gauge-med {
  --fa: "\\f624";
  --fa--fa: "\\f624\\f624"; }

.fa-tachometer-alt-average {
  --fa: "\\f624";
  --fa--fa: "\\f624\\f624"; }

.fa-wand-magic-sparkles {
  --fa: "\\e2ca";
  --fa--fa: "\\e2ca\\e2ca"; }

.fa-magic-wand-sparkles {
  --fa: "\\e2ca";
  --fa--fa: "\\e2ca\\e2ca"; }

.fa-e {
  --fa: "\\45";
  --fa--fa: "\\45\\45"; }

.fa-pen-clip {
  --fa: "\\f305";
  --fa--fa: "\\f305\\f305"; }

.fa-pen-alt {
  --fa: "\\f305";
  --fa--fa: "\\f305\\f305"; }

.fa-bridge-circle-exclamation {
  --fa: "\\e4ca";
  --fa--fa: "\\e4ca\\e4ca"; }

.fa-user {
  --fa: "\\f007";
  --fa--fa: "\\f007\\f007"; }

.fa-school-circle-check {
  --fa: "\\e56b";
  --fa--fa: "\\e56b\\e56b"; }

.fa-dumpster {
  --fa: "\\f793";
  --fa--fa: "\\f793\\f793"; }

.fa-van-shuttle {
  --fa: "\\f5b6";
  --fa--fa: "\\f5b6\\f5b6"; }

.fa-shuttle-van {
  --fa: "\\f5b6";
  --fa--fa: "\\f5b6\\f5b6"; }

.fa-building-user {
  --fa: "\\e4da";
  --fa--fa: "\\e4da\\e4da"; }

.fa-square-caret-left {
  --fa: "\\f191";
  --fa--fa: "\\f191\\f191"; }

.fa-caret-square-left {
  --fa: "\\f191";
  --fa--fa: "\\f191\\f191"; }

.fa-highlighter {
  --fa: "\\f591";
  --fa--fa: "\\f591\\f591"; }

.fa-key {
  --fa: "\\f084";
  --fa--fa: "\\f084\\f084"; }

.fa-bullhorn {
  --fa: "\\f0a1";
  --fa--fa: "\\f0a1\\f0a1"; }

.fa-globe {
  --fa: "\\f0ac";
  --fa--fa: "\\f0ac\\f0ac"; }

.fa-synagogue {
  --fa: "\\f69b";
  --fa--fa: "\\f69b\\f69b"; }

.fa-person-half-dress {
  --fa: "\\e548";
  --fa--fa: "\\e548\\e548"; }

.fa-road-bridge {
  --fa: "\\e563";
  --fa--fa: "\\e563\\e563"; }

.fa-location-arrow {
  --fa: "\\f124";
  --fa--fa: "\\f124\\f124"; }

.fa-c {
  --fa: "\\43";
  --fa--fa: "\\43\\43"; }

.fa-tablet-button {
  --fa: "\\f10a";
  --fa--fa: "\\f10a\\f10a"; }

.fa-building-lock {
  --fa: "\\e4d6";
  --fa--fa: "\\e4d6\\e4d6"; }

.fa-pizza-slice {
  --fa: "\\f818";
  --fa--fa: "\\f818\\f818"; }

.fa-money-bill-wave {
  --fa: "\\f53a";
  --fa--fa: "\\f53a\\f53a"; }

.fa-chart-area {
  --fa: "\\f1fe";
  --fa--fa: "\\f1fe\\f1fe"; }

.fa-area-chart {
  --fa: "\\f1fe";
  --fa--fa: "\\f1fe\\f1fe"; }

.fa-house-flag {
  --fa: "\\e50d";
  --fa--fa: "\\e50d\\e50d"; }

.fa-person-circle-minus {
  --fa: "\\e540";
  --fa--fa: "\\e540\\e540"; }

.fa-ban {
  --fa: "\\f05e";
  --fa--fa: "\\f05e\\f05e"; }

.fa-cancel {
  --fa: "\\f05e";
  --fa--fa: "\\f05e\\f05e"; }

.fa-camera-rotate {
  --fa: "\\e0d8";
  --fa--fa: "\\e0d8\\e0d8"; }

.fa-spray-can-sparkles {
  --fa: "\\f5d0";
  --fa--fa: "\\f5d0\\f5d0"; }

.fa-air-freshener {
  --fa: "\\f5d0";
  --fa--fa: "\\f5d0\\f5d0"; }

.fa-star {
  --fa: "\\f005";
  --fa--fa: "\\f005\\f005"; }

.fa-repeat {
  --fa: "\\f363";
  --fa--fa: "\\f363\\f363"; }

.fa-cross {
  --fa: "\\f654";
  --fa--fa: "\\f654\\f654"; }

.fa-box {
  --fa: "\\f466";
  --fa--fa: "\\f466\\f466"; }

.fa-venus-mars {
  --fa: "\\f228";
  --fa--fa: "\\f228\\f228"; }

.fa-arrow-pointer {
  --fa: "\\f245";
  --fa--fa: "\\f245\\f245"; }

.fa-mouse-pointer {
  --fa: "\\f245";
  --fa--fa: "\\f245\\f245"; }

.fa-maximize {
  --fa: "\\f31e";
  --fa--fa: "\\f31e\\f31e"; }

.fa-expand-arrows-alt {
  --fa: "\\f31e";
  --fa--fa: "\\f31e\\f31e"; }

.fa-charging-station {
  --fa: "\\f5e7";
  --fa--fa: "\\f5e7\\f5e7"; }

.fa-shapes {
  --fa: "\\f61f";
  --fa--fa: "\\f61f\\f61f"; }

.fa-triangle-circle-square {
  --fa: "\\f61f";
  --fa--fa: "\\f61f\\f61f"; }

.fa-shuffle {
  --fa: "\\f074";
  --fa--fa: "\\f074\\f074"; }

.fa-random {
  --fa: "\\f074";
  --fa--fa: "\\f074\\f074"; }

.fa-person-running {
  --fa: "\\f70c";
  --fa--fa: "\\f70c\\f70c"; }

.fa-running {
  --fa: "\\f70c";
  --fa--fa: "\\f70c\\f70c"; }

.fa-mobile-retro {
  --fa: "\\e527";
  --fa--fa: "\\e527\\e527"; }

.fa-grip-lines-vertical {
  --fa: "\\f7a5";
  --fa--fa: "\\f7a5\\f7a5"; }

.fa-spider {
  --fa: "\\f717";
  --fa--fa: "\\f717\\f717"; }

.fa-hands-bound {
  --fa: "\\e4f9";
  --fa--fa: "\\e4f9\\e4f9"; }

.fa-file-invoice-dollar {
  --fa: "\\f571";
  --fa--fa: "\\f571\\f571"; }

.fa-plane-circle-exclamation {
  --fa: "\\e556";
  --fa--fa: "\\e556\\e556"; }

.fa-x-ray {
  --fa: "\\f497";
  --fa--fa: "\\f497\\f497"; }

.fa-spell-check {
  --fa: "\\f891";
  --fa--fa: "\\f891\\f891"; }

.fa-slash {
  --fa: "\\f715";
  --fa--fa: "\\f715\\f715"; }

.fa-computer-mouse {
  --fa: "\\f8cc";
  --fa--fa: "\\f8cc\\f8cc"; }

.fa-mouse {
  --fa: "\\f8cc";
  --fa--fa: "\\f8cc\\f8cc"; }

.fa-arrow-right-to-bracket {
  --fa: "\\f090";
  --fa--fa: "\\f090\\f090"; }

.fa-sign-in {
  --fa: "\\f090";
  --fa--fa: "\\f090\\f090"; }

.fa-shop-slash {
  --fa: "\\e070";
  --fa--fa: "\\e070\\e070"; }

.fa-store-alt-slash {
  --fa: "\\e070";
  --fa--fa: "\\e070\\e070"; }

.fa-server {
  --fa: "\\f233";
  --fa--fa: "\\f233\\f233"; }

.fa-virus-covid-slash {
  --fa: "\\e4a9";
  --fa--fa: "\\e4a9\\e4a9"; }

.fa-shop-lock {
  --fa: "\\e4a5";
  --fa--fa: "\\e4a5\\e4a5"; }

.fa-hourglass-start {
  --fa: "\\f251";
  --fa--fa: "\\f251\\f251"; }

.fa-hourglass-1 {
  --fa: "\\f251";
  --fa--fa: "\\f251\\f251"; }

.fa-blender-phone {
  --fa: "\\f6b6";
  --fa--fa: "\\f6b6\\f6b6"; }

.fa-building-wheat {
  --fa: "\\e4db";
  --fa--fa: "\\e4db\\e4db"; }

.fa-person-breastfeeding {
  --fa: "\\e53a";
  --fa--fa: "\\e53a\\e53a"; }

.fa-right-to-bracket {
  --fa: "\\f2f6";
  --fa--fa: "\\f2f6\\f2f6"; }

.fa-sign-in-alt {
  --fa: "\\f2f6";
  --fa--fa: "\\f2f6\\f2f6"; }

.fa-venus {
  --fa: "\\f221";
  --fa--fa: "\\f221\\f221"; }

.fa-passport {
  --fa: "\\f5ab";
  --fa--fa: "\\f5ab\\f5ab"; }

.fa-thumbtack-slash {
  --fa: "\\e68f";
  --fa--fa: "\\e68f\\e68f"; }

.fa-thumb-tack-slash {
  --fa: "\\e68f";
  --fa--fa: "\\e68f\\e68f"; }

.fa-heart-pulse {
  --fa: "\\f21e";
  --fa--fa: "\\f21e\\f21e"; }

.fa-heartbeat {
  --fa: "\\f21e";
  --fa--fa: "\\f21e\\f21e"; }

.fa-people-carry-box {
  --fa: "\\f4ce";
  --fa--fa: "\\f4ce\\f4ce"; }

.fa-people-carry {
  --fa: "\\f4ce";
  --fa--fa: "\\f4ce\\f4ce"; }

.fa-temperature-high {
  --fa: "\\f769";
  --fa--fa: "\\f769\\f769"; }

.fa-microchip {
  --fa: "\\f2db";
  --fa--fa: "\\f2db\\f2db"; }

.fa-crown {
  --fa: "\\f521";
  --fa--fa: "\\f521\\f521"; }

.fa-weight-hanging {
  --fa: "\\f5cd";
  --fa--fa: "\\f5cd\\f5cd"; }

.fa-xmarks-lines {
  --fa: "\\e59a";
  --fa--fa: "\\e59a\\e59a"; }

.fa-file-prescription {
  --fa: "\\f572";
  --fa--fa: "\\f572\\f572"; }

.fa-weight-scale {
  --fa: "\\f496";
  --fa--fa: "\\f496\\f496"; }

.fa-weight {
  --fa: "\\f496";
  --fa--fa: "\\f496\\f496"; }

.fa-user-group {
  --fa: "\\f500";
  --fa--fa: "\\f500\\f500"; }

.fa-user-friends {
  --fa: "\\f500";
  --fa--fa: "\\f500\\f500"; }

.fa-arrow-up-a-z {
  --fa: "\\f15e";
  --fa--fa: "\\f15e\\f15e"; }

.fa-sort-alpha-up {
  --fa: "\\f15e";
  --fa--fa: "\\f15e\\f15e"; }

.fa-chess-knight {
  --fa: "\\f441";
  --fa--fa: "\\f441\\f441"; }

.fa-face-laugh-squint {
  --fa: "\\f59b";
  --fa--fa: "\\f59b\\f59b"; }

.fa-laugh-squint {
  --fa: "\\f59b";
  --fa--fa: "\\f59b\\f59b"; }

.fa-wheelchair {
  --fa: "\\f193";
  --fa--fa: "\\f193\\f193"; }

.fa-circle-arrow-up {
  --fa: "\\f0aa";
  --fa--fa: "\\f0aa\\f0aa"; }

.fa-arrow-circle-up {
  --fa: "\\f0aa";
  --fa--fa: "\\f0aa\\f0aa"; }

.fa-toggle-on {
  --fa: "\\f205";
  --fa--fa: "\\f205\\f205"; }

.fa-person-walking {
  --fa: "\\f554";
  --fa--fa: "\\f554\\f554"; }

.fa-walking {
  --fa: "\\f554";
  --fa--fa: "\\f554\\f554"; }

.fa-l {
  --fa: "\\4c";
  --fa--fa: "\\4c\\4c"; }

.fa-fire {
  --fa: "\\f06d";
  --fa--fa: "\\f06d\\f06d"; }

.fa-bed-pulse {
  --fa: "\\f487";
  --fa--fa: "\\f487\\f487"; }

.fa-procedures {
  --fa: "\\f487";
  --fa--fa: "\\f487\\f487"; }

.fa-shuttle-space {
  --fa: "\\f197";
  --fa--fa: "\\f197\\f197"; }

.fa-space-shuttle {
  --fa: "\\f197";
  --fa--fa: "\\f197\\f197"; }

.fa-face-laugh {
  --fa: "\\f599";
  --fa--fa: "\\f599\\f599"; }

.fa-laugh {
  --fa: "\\f599";
  --fa--fa: "\\f599\\f599"; }

.fa-folder-open {
  --fa: "\\f07c";
  --fa--fa: "\\f07c\\f07c"; }

.fa-heart-circle-plus {
  --fa: "\\e500";
  --fa--fa: "\\e500\\e500"; }

.fa-code-fork {
  --fa: "\\e13b";
  --fa--fa: "\\e13b\\e13b"; }

.fa-city {
  --fa: "\\f64f";
  --fa--fa: "\\f64f\\f64f"; }

.fa-microphone-lines {
  --fa: "\\f3c9";
  --fa--fa: "\\f3c9\\f3c9"; }

.fa-microphone-alt {
  --fa: "\\f3c9";
  --fa--fa: "\\f3c9\\f3c9"; }

.fa-pepper-hot {
  --fa: "\\f816";
  --fa--fa: "\\f816\\f816"; }

.fa-unlock {
  --fa: "\\f09c";
  --fa--fa: "\\f09c\\f09c"; }

.fa-colon-sign {
  --fa: "\\e140";
  --fa--fa: "\\e140\\e140"; }

.fa-headset {
  --fa: "\\f590";
  --fa--fa: "\\f590\\f590"; }

.fa-store-slash {
  --fa: "\\e071";
  --fa--fa: "\\e071\\e071"; }

.fa-road-circle-xmark {
  --fa: "\\e566";
  --fa--fa: "\\e566\\e566"; }

.fa-user-minus {
  --fa: "\\f503";
  --fa--fa: "\\f503\\f503"; }

.fa-mars-stroke-up {
  --fa: "\\f22a";
  --fa--fa: "\\f22a\\f22a"; }

.fa-mars-stroke-v {
  --fa: "\\f22a";
  --fa--fa: "\\f22a\\f22a"; }

.fa-champagne-glasses {
  --fa: "\\f79f";
  --fa--fa: "\\f79f\\f79f"; }

.fa-glass-cheers {
  --fa: "\\f79f";
  --fa--fa: "\\f79f\\f79f"; }

.fa-clipboard {
  --fa: "\\f328";
  --fa--fa: "\\f328\\f328"; }

.fa-house-circle-exclamation {
  --fa: "\\e50a";
  --fa--fa: "\\e50a\\e50a"; }

.fa-file-arrow-up {
  --fa: "\\f574";
  --fa--fa: "\\f574\\f574"; }

.fa-file-upload {
  --fa: "\\f574";
  --fa--fa: "\\f574\\f574"; }

.fa-wifi {
  --fa: "\\f1eb";
  --fa--fa: "\\f1eb\\f1eb"; }

.fa-wifi-3 {
  --fa: "\\f1eb";
  --fa--fa: "\\f1eb\\f1eb"; }

.fa-wifi-strong {
  --fa: "\\f1eb";
  --fa--fa: "\\f1eb\\f1eb"; }

.fa-bath {
  --fa: "\\f2cd";
  --fa--fa: "\\f2cd\\f2cd"; }

.fa-bathtub {
  --fa: "\\f2cd";
  --fa--fa: "\\f2cd\\f2cd"; }

.fa-underline {
  --fa: "\\f0cd";
  --fa--fa: "\\f0cd\\f0cd"; }

.fa-user-pen {
  --fa: "\\f4ff";
  --fa--fa: "\\f4ff\\f4ff"; }

.fa-user-edit {
  --fa: "\\f4ff";
  --fa--fa: "\\f4ff\\f4ff"; }

.fa-signature {
  --fa: "\\f5b7";
  --fa--fa: "\\f5b7\\f5b7"; }

.fa-stroopwafel {
  --fa: "\\f551";
  --fa--fa: "\\f551\\f551"; }

.fa-bold {
  --fa: "\\f032";
  --fa--fa: "\\f032\\f032"; }

.fa-anchor-lock {
  --fa: "\\e4ad";
  --fa--fa: "\\e4ad\\e4ad"; }

.fa-building-ngo {
  --fa: "\\e4d7";
  --fa--fa: "\\e4d7\\e4d7"; }

.fa-manat-sign {
  --fa: "\\e1d5";
  --fa--fa: "\\e1d5\\e1d5"; }

.fa-not-equal {
  --fa: "\\f53e";
  --fa--fa: "\\f53e\\f53e"; }

.fa-border-top-left {
  --fa: "\\f853";
  --fa--fa: "\\f853\\f853"; }

.fa-border-style {
  --fa: "\\f853";
  --fa--fa: "\\f853\\f853"; }

.fa-map-location-dot {
  --fa: "\\f5a0";
  --fa--fa: "\\f5a0\\f5a0"; }

.fa-map-marked-alt {
  --fa: "\\f5a0";
  --fa--fa: "\\f5a0\\f5a0"; }

.fa-jedi {
  --fa: "\\f669";
  --fa--fa: "\\f669\\f669"; }

.fa-square-poll-vertical {
  --fa: "\\f681";
  --fa--fa: "\\f681\\f681"; }

.fa-poll {
  --fa: "\\f681";
  --fa--fa: "\\f681\\f681"; }

.fa-mug-hot {
  --fa: "\\f7b6";
  --fa--fa: "\\f7b6\\f7b6"; }

.fa-car-battery {
  --fa: "\\f5df";
  --fa--fa: "\\f5df\\f5df"; }

.fa-battery-car {
  --fa: "\\f5df";
  --fa--fa: "\\f5df\\f5df"; }

.fa-gift {
  --fa: "\\f06b";
  --fa--fa: "\\f06b\\f06b"; }

.fa-dice-two {
  --fa: "\\f528";
  --fa--fa: "\\f528\\f528"; }

.fa-chess-queen {
  --fa: "\\f445";
  --fa--fa: "\\f445\\f445"; }

.fa-glasses {
  --fa: "\\f530";
  --fa--fa: "\\f530\\f530"; }

.fa-chess-board {
  --fa: "\\f43c";
  --fa--fa: "\\f43c\\f43c"; }

.fa-building-circle-check {
  --fa: "\\e4d2";
  --fa--fa: "\\e4d2\\e4d2"; }

.fa-person-chalkboard {
  --fa: "\\e53d";
  --fa--fa: "\\e53d\\e53d"; }

.fa-mars-stroke-right {
  --fa: "\\f22b";
  --fa--fa: "\\f22b\\f22b"; }

.fa-mars-stroke-h {
  --fa: "\\f22b";
  --fa--fa: "\\f22b\\f22b"; }

.fa-hand-back-fist {
  --fa: "\\f255";
  --fa--fa: "\\f255\\f255"; }

.fa-hand-rock {
  --fa: "\\f255";
  --fa--fa: "\\f255\\f255"; }

.fa-square-caret-up {
  --fa: "\\f151";
  --fa--fa: "\\f151\\f151"; }

.fa-caret-square-up {
  --fa: "\\f151";
  --fa--fa: "\\f151\\f151"; }

.fa-cloud-showers-water {
  --fa: "\\e4e4";
  --fa--fa: "\\e4e4\\e4e4"; }

.fa-chart-bar {
  --fa: "\\f080";
  --fa--fa: "\\f080\\f080"; }

.fa-bar-chart {
  --fa: "\\f080";
  --fa--fa: "\\f080\\f080"; }

.fa-hands-bubbles {
  --fa: "\\e05e";
  --fa--fa: "\\e05e\\e05e"; }

.fa-hands-wash {
  --fa: "\\e05e";
  --fa--fa: "\\e05e\\e05e"; }

.fa-less-than-equal {
  --fa: "\\f537";
  --fa--fa: "\\f537\\f537"; }

.fa-train {
  --fa: "\\f238";
  --fa--fa: "\\f238\\f238"; }

.fa-eye-low-vision {
  --fa: "\\f2a8";
  --fa--fa: "\\f2a8\\f2a8"; }

.fa-low-vision {
  --fa: "\\f2a8";
  --fa--fa: "\\f2a8\\f2a8"; }

.fa-crow {
  --fa: "\\f520";
  --fa--fa: "\\f520\\f520"; }

.fa-sailboat {
  --fa: "\\e445";
  --fa--fa: "\\e445\\e445"; }

.fa-window-restore {
  --fa: "\\f2d2";
  --fa--fa: "\\f2d2\\f2d2"; }

.fa-square-plus {
  --fa: "\\f0fe";
  --fa--fa: "\\f0fe\\f0fe"; }

.fa-plus-square {
  --fa: "\\f0fe";
  --fa--fa: "\\f0fe\\f0fe"; }

.fa-torii-gate {
  --fa: "\\f6a1";
  --fa--fa: "\\f6a1\\f6a1"; }

.fa-frog {
  --fa: "\\f52e";
  --fa--fa: "\\f52e\\f52e"; }

.fa-bucket {
  --fa: "\\e4cf";
  --fa--fa: "\\e4cf\\e4cf"; }

.fa-image {
  --fa: "\\f03e";
  --fa--fa: "\\f03e\\f03e"; }

.fa-microphone {
  --fa: "\\f130";
  --fa--fa: "\\f130\\f130"; }

.fa-cow {
  --fa: "\\f6c8";
  --fa--fa: "\\f6c8\\f6c8"; }

.fa-caret-up {
  --fa: "\\f0d8";
  --fa--fa: "\\f0d8\\f0d8"; }

.fa-screwdriver {
  --fa: "\\f54a";
  --fa--fa: "\\f54a\\f54a"; }

.fa-folder-closed {
  --fa: "\\e185";
  --fa--fa: "\\e185\\e185"; }

.fa-house-tsunami {
  --fa: "\\e515";
  --fa--fa: "\\e515\\e515"; }

.fa-square-nfi {
  --fa: "\\e576";
  --fa--fa: "\\e576\\e576"; }

.fa-arrow-up-from-ground-water {
  --fa: "\\e4b5";
  --fa--fa: "\\e4b5\\e4b5"; }

.fa-martini-glass {
  --fa: "\\f57b";
  --fa--fa: "\\f57b\\f57b"; }

.fa-glass-martini-alt {
  --fa: "\\f57b";
  --fa--fa: "\\f57b\\f57b"; }

.fa-square-binary {
  --fa: "\\e69b";
  --fa--fa: "\\e69b\\e69b"; }

.fa-rotate-left {
  --fa: "\\f2ea";
  --fa--fa: "\\f2ea\\f2ea"; }

.fa-rotate-back {
  --fa: "\\f2ea";
  --fa--fa: "\\f2ea\\f2ea"; }

.fa-rotate-backward {
  --fa: "\\f2ea";
  --fa--fa: "\\f2ea\\f2ea"; }

.fa-undo-alt {
  --fa: "\\f2ea";
  --fa--fa: "\\f2ea\\f2ea"; }

.fa-table-columns {
  --fa: "\\f0db";
  --fa--fa: "\\f0db\\f0db"; }

.fa-columns {
  --fa: "\\f0db";
  --fa--fa: "\\f0db\\f0db"; }

.fa-lemon {
  --fa: "\\f094";
  --fa--fa: "\\f094\\f094"; }

.fa-head-side-mask {
  --fa: "\\e063";
  --fa--fa: "\\e063\\e063"; }

.fa-handshake {
  --fa: "\\f2b5";
  --fa--fa: "\\f2b5\\f2b5"; }

.fa-gem {
  --fa: "\\f3a5";
  --fa--fa: "\\f3a5\\f3a5"; }

.fa-dolly {
  --fa: "\\f472";
  --fa--fa: "\\f472\\f472"; }

.fa-dolly-box {
  --fa: "\\f472";
  --fa--fa: "\\f472\\f472"; }

.fa-smoking {
  --fa: "\\f48d";
  --fa--fa: "\\f48d\\f48d"; }

.fa-minimize {
  --fa: "\\f78c";
  --fa--fa: "\\f78c\\f78c"; }

.fa-compress-arrows-alt {
  --fa: "\\f78c";
  --fa--fa: "\\f78c\\f78c"; }

.fa-monument {
  --fa: "\\f5a6";
  --fa--fa: "\\f5a6\\f5a6"; }

.fa-snowplow {
  --fa: "\\f7d2";
  --fa--fa: "\\f7d2\\f7d2"; }

.fa-angles-right {
  --fa: "\\f101";
  --fa--fa: "\\f101\\f101"; }

.fa-angle-double-right {
  --fa: "\\f101";
  --fa--fa: "\\f101\\f101"; }

.fa-cannabis {
  --fa: "\\f55f";
  --fa--fa: "\\f55f\\f55f"; }

.fa-circle-play {
  --fa: "\\f144";
  --fa--fa: "\\f144\\f144"; }

.fa-play-circle {
  --fa: "\\f144";
  --fa--fa: "\\f144\\f144"; }

.fa-tablets {
  --fa: "\\f490";
  --fa--fa: "\\f490\\f490"; }

.fa-ethernet {
  --fa: "\\f796";
  --fa--fa: "\\f796\\f796"; }

.fa-euro-sign {
  --fa: "\\f153";
  --fa--fa: "\\f153\\f153"; }

.fa-eur {
  --fa: "\\f153";
  --fa--fa: "\\f153\\f153"; }

.fa-euro {
  --fa: "\\f153";
  --fa--fa: "\\f153\\f153"; }

.fa-chair {
  --fa: "\\f6c0";
  --fa--fa: "\\f6c0\\f6c0"; }

.fa-circle-check {
  --fa: "\\f058";
  --fa--fa: "\\f058\\f058"; }

.fa-check-circle {
  --fa: "\\f058";
  --fa--fa: "\\f058\\f058"; }

.fa-circle-stop {
  --fa: "\\f28d";
  --fa--fa: "\\f28d\\f28d"; }

.fa-stop-circle {
  --fa: "\\f28d";
  --fa--fa: "\\f28d\\f28d"; }

.fa-compass-drafting {
  --fa: "\\f568";
  --fa--fa: "\\f568\\f568"; }

.fa-drafting-compass {
  --fa: "\\f568";
  --fa--fa: "\\f568\\f568"; }

.fa-plate-wheat {
  --fa: "\\e55a";
  --fa--fa: "\\e55a\\e55a"; }

.fa-icicles {
  --fa: "\\f7ad";
  --fa--fa: "\\f7ad\\f7ad"; }

.fa-person-shelter {
  --fa: "\\e54f";
  --fa--fa: "\\e54f\\e54f"; }

.fa-neuter {
  --fa: "\\f22c";
  --fa--fa: "\\f22c\\f22c"; }

.fa-id-badge {
  --fa: "\\f2c1";
  --fa--fa: "\\f2c1\\f2c1"; }

.fa-marker {
  --fa: "\\f5a1";
  --fa--fa: "\\f5a1\\f5a1"; }

.fa-face-laugh-beam {
  --fa: "\\f59a";
  --fa--fa: "\\f59a\\f59a"; }

.fa-laugh-beam {
  --fa: "\\f59a";
  --fa--fa: "\\f59a\\f59a"; }

.fa-helicopter-symbol {
  --fa: "\\e502";
  --fa--fa: "\\e502\\e502"; }

.fa-universal-access {
  --fa: "\\f29a";
  --fa--fa: "\\f29a\\f29a"; }

.fa-circle-chevron-up {
  --fa: "\\f139";
  --fa--fa: "\\f139\\f139"; }

.fa-chevron-circle-up {
  --fa: "\\f139";
  --fa--fa: "\\f139\\f139"; }

.fa-lari-sign {
  --fa: "\\e1c8";
  --fa--fa: "\\e1c8\\e1c8"; }

.fa-volcano {
  --fa: "\\f770";
  --fa--fa: "\\f770\\f770"; }

.fa-person-walking-dashed-line-arrow-right {
  --fa: "\\e553";
  --fa--fa: "\\e553\\e553"; }

.fa-sterling-sign {
  --fa: "\\f154";
  --fa--fa: "\\f154\\f154"; }

.fa-gbp {
  --fa: "\\f154";
  --fa--fa: "\\f154\\f154"; }

.fa-pound-sign {
  --fa: "\\f154";
  --fa--fa: "\\f154\\f154"; }

.fa-viruses {
  --fa: "\\e076";
  --fa--fa: "\\e076\\e076"; }

.fa-square-person-confined {
  --fa: "\\e577";
  --fa--fa: "\\e577\\e577"; }

.fa-user-tie {
  --fa: "\\f508";
  --fa--fa: "\\f508\\f508"; }

.fa-arrow-down-long {
  --fa: "\\f175";
  --fa--fa: "\\f175\\f175"; }

.fa-long-arrow-down {
  --fa: "\\f175";
  --fa--fa: "\\f175\\f175"; }

.fa-tent-arrow-down-to-line {
  --fa: "\\e57e";
  --fa--fa: "\\e57e\\e57e"; }

.fa-certificate {
  --fa: "\\f0a3";
  --fa--fa: "\\f0a3\\f0a3"; }

.fa-reply-all {
  --fa: "\\f122";
  --fa--fa: "\\f122\\f122"; }

.fa-mail-reply-all {
  --fa: "\\f122";
  --fa--fa: "\\f122\\f122"; }

.fa-suitcase {
  --fa: "\\f0f2";
  --fa--fa: "\\f0f2\\f0f2"; }

.fa-person-skating {
  --fa: "\\f7c5";
  --fa--fa: "\\f7c5\\f7c5"; }

.fa-skating {
  --fa: "\\f7c5";
  --fa--fa: "\\f7c5\\f7c5"; }

.fa-filter-circle-dollar {
  --fa: "\\f662";
  --fa--fa: "\\f662\\f662"; }

.fa-funnel-dollar {
  --fa: "\\f662";
  --fa--fa: "\\f662\\f662"; }

.fa-camera-retro {
  --fa: "\\f083";
  --fa--fa: "\\f083\\f083"; }

.fa-circle-arrow-down {
  --fa: "\\f0ab";
  --fa--fa: "\\f0ab\\f0ab"; }

.fa-arrow-circle-down {
  --fa: "\\f0ab";
  --fa--fa: "\\f0ab\\f0ab"; }

.fa-file-import {
  --fa: "\\f56f";
  --fa--fa: "\\f56f\\f56f"; }

.fa-arrow-right-to-file {
  --fa: "\\f56f";
  --fa--fa: "\\f56f\\f56f"; }

.fa-square-arrow-up-right {
  --fa: "\\f14c";
  --fa--fa: "\\f14c\\f14c"; }

.fa-external-link-square {
  --fa: "\\f14c";
  --fa--fa: "\\f14c\\f14c"; }

.fa-box-open {
  --fa: "\\f49e";
  --fa--fa: "\\f49e\\f49e"; }

.fa-scroll {
  --fa: "\\f70e";
  --fa--fa: "\\f70e\\f70e"; }

.fa-spa {
  --fa: "\\f5bb";
  --fa--fa: "\\f5bb\\f5bb"; }

.fa-location-pin-lock {
  --fa: "\\e51f";
  --fa--fa: "\\e51f\\e51f"; }

.fa-pause {
  --fa: "\\f04c";
  --fa--fa: "\\f04c\\f04c"; }

.fa-hill-avalanche {
  --fa: "\\e507";
  --fa--fa: "\\e507\\e507"; }

.fa-temperature-empty {
  --fa: "\\f2cb";
  --fa--fa: "\\f2cb\\f2cb"; }

.fa-temperature-0 {
  --fa: "\\f2cb";
  --fa--fa: "\\f2cb\\f2cb"; }

.fa-thermometer-0 {
  --fa: "\\f2cb";
  --fa--fa: "\\f2cb\\f2cb"; }

.fa-thermometer-empty {
  --fa: "\\f2cb";
  --fa--fa: "\\f2cb\\f2cb"; }

.fa-bomb {
  --fa: "\\f1e2";
  --fa--fa: "\\f1e2\\f1e2"; }

.fa-registered {
  --fa: "\\f25d";
  --fa--fa: "\\f25d\\f25d"; }

.fa-address-card {
  --fa: "\\f2bb";
  --fa--fa: "\\f2bb\\f2bb"; }

.fa-contact-card {
  --fa: "\\f2bb";
  --fa--fa: "\\f2bb\\f2bb"; }

.fa-vcard {
  --fa: "\\f2bb";
  --fa--fa: "\\f2bb\\f2bb"; }

.fa-scale-unbalanced-flip {
  --fa: "\\f516";
  --fa--fa: "\\f516\\f516"; }

.fa-balance-scale-right {
  --fa: "\\f516";
  --fa--fa: "\\f516\\f516"; }

.fa-subscript {
  --fa: "\\f12c";
  --fa--fa: "\\f12c\\f12c"; }

.fa-diamond-turn-right {
  --fa: "\\f5eb";
  --fa--fa: "\\f5eb\\f5eb"; }

.fa-directions {
  --fa: "\\f5eb";
  --fa--fa: "\\f5eb\\f5eb"; }

.fa-burst {
  --fa: "\\e4dc";
  --fa--fa: "\\e4dc\\e4dc"; }

.fa-house-laptop {
  --fa: "\\e066";
  --fa--fa: "\\e066\\e066"; }

.fa-laptop-house {
  --fa: "\\e066";
  --fa--fa: "\\e066\\e066"; }

.fa-face-tired {
  --fa: "\\f5c8";
  --fa--fa: "\\f5c8\\f5c8"; }

.fa-tired {
  --fa: "\\f5c8";
  --fa--fa: "\\f5c8\\f5c8"; }

.fa-money-bills {
  --fa: "\\e1f3";
  --fa--fa: "\\e1f3\\e1f3"; }

.fa-smog {
  --fa: "\\f75f";
  --fa--fa: "\\f75f\\f75f"; }

.fa-crutch {
  --fa: "\\f7f7";
  --fa--fa: "\\f7f7\\f7f7"; }

.fa-cloud-arrow-up {
  --fa: "\\f0ee";
  --fa--fa: "\\f0ee\\f0ee"; }

.fa-cloud-upload {
  --fa: "\\f0ee";
  --fa--fa: "\\f0ee\\f0ee"; }

.fa-cloud-upload-alt {
  --fa: "\\f0ee";
  --fa--fa: "\\f0ee\\f0ee"; }

.fa-palette {
  --fa: "\\f53f";
  --fa--fa: "\\f53f\\f53f"; }

.fa-arrows-turn-right {
  --fa: "\\e4c0";
  --fa--fa: "\\e4c0\\e4c0"; }

.fa-vest {
  --fa: "\\e085";
  --fa--fa: "\\e085\\e085"; }

.fa-ferry {
  --fa: "\\e4ea";
  --fa--fa: "\\e4ea\\e4ea"; }

.fa-arrows-down-to-people {
  --fa: "\\e4b9";
  --fa--fa: "\\e4b9\\e4b9"; }

.fa-seedling {
  --fa: "\\f4d8";
  --fa--fa: "\\f4d8\\f4d8"; }

.fa-sprout {
  --fa: "\\f4d8";
  --fa--fa: "\\f4d8\\f4d8"; }

.fa-left-right {
  --fa: "\\f337";
  --fa--fa: "\\f337\\f337"; }

.fa-arrows-alt-h {
  --fa: "\\f337";
  --fa--fa: "\\f337\\f337"; }

.fa-boxes-packing {
  --fa: "\\e4c7";
  --fa--fa: "\\e4c7\\e4c7"; }

.fa-circle-arrow-left {
  --fa: "\\f0a8";
  --fa--fa: "\\f0a8\\f0a8"; }

.fa-arrow-circle-left {
  --fa: "\\f0a8";
  --fa--fa: "\\f0a8\\f0a8"; }

.fa-group-arrows-rotate {
  --fa: "\\e4f6";
  --fa--fa: "\\e4f6\\e4f6"; }

.fa-bowl-food {
  --fa: "\\e4c6";
  --fa--fa: "\\e4c6\\e4c6"; }

.fa-candy-cane {
  --fa: "\\f786";
  --fa--fa: "\\f786\\f786"; }

.fa-arrow-down-wide-short {
  --fa: "\\f160";
  --fa--fa: "\\f160\\f160"; }

.fa-sort-amount-asc {
  --fa: "\\f160";
  --fa--fa: "\\f160\\f160"; }

.fa-sort-amount-down {
  --fa: "\\f160";
  --fa--fa: "\\f160\\f160"; }

.fa-cloud-bolt {
  --fa: "\\f76c";
  --fa--fa: "\\f76c\\f76c"; }

.fa-thunderstorm {
  --fa: "\\f76c";
  --fa--fa: "\\f76c\\f76c"; }

.fa-text-slash {
  --fa: "\\f87d";
  --fa--fa: "\\f87d\\f87d"; }

.fa-remove-format {
  --fa: "\\f87d";
  --fa--fa: "\\f87d\\f87d"; }

.fa-face-smile-wink {
  --fa: "\\f4da";
  --fa--fa: "\\f4da\\f4da"; }

.fa-smile-wink {
  --fa: "\\f4da";
  --fa--fa: "\\f4da\\f4da"; }

.fa-file-word {
  --fa: "\\f1c2";
  --fa--fa: "\\f1c2\\f1c2"; }

.fa-file-powerpoint {
  --fa: "\\f1c4";
  --fa--fa: "\\f1c4\\f1c4"; }

.fa-arrows-left-right {
  --fa: "\\f07e";
  --fa--fa: "\\f07e\\f07e"; }

.fa-arrows-h {
  --fa: "\\f07e";
  --fa--fa: "\\f07e\\f07e"; }

.fa-house-lock {
  --fa: "\\e510";
  --fa--fa: "\\e510\\e510"; }

.fa-cloud-arrow-down {
  --fa: "\\f0ed";
  --fa--fa: "\\f0ed\\f0ed"; }

.fa-cloud-download {
  --fa: "\\f0ed";
  --fa--fa: "\\f0ed\\f0ed"; }

.fa-cloud-download-alt {
  --fa: "\\f0ed";
  --fa--fa: "\\f0ed\\f0ed"; }

.fa-children {
  --fa: "\\e4e1";
  --fa--fa: "\\e4e1\\e4e1"; }

.fa-chalkboard {
  --fa: "\\f51b";
  --fa--fa: "\\f51b\\f51b"; }

.fa-blackboard {
  --fa: "\\f51b";
  --fa--fa: "\\f51b\\f51b"; }

.fa-user-large-slash {
  --fa: "\\f4fa";
  --fa--fa: "\\f4fa\\f4fa"; }

.fa-user-alt-slash {
  --fa: "\\f4fa";
  --fa--fa: "\\f4fa\\f4fa"; }

.fa-envelope-open {
  --fa: "\\f2b6";
  --fa--fa: "\\f2b6\\f2b6"; }

.fa-handshake-simple-slash {
  --fa: "\\e05f";
  --fa--fa: "\\e05f\\e05f"; }

.fa-handshake-alt-slash {
  --fa: "\\e05f";
  --fa--fa: "\\e05f\\e05f"; }

.fa-mattress-pillow {
  --fa: "\\e525";
  --fa--fa: "\\e525\\e525"; }

.fa-guarani-sign {
  --fa: "\\e19a";
  --fa--fa: "\\e19a\\e19a"; }

.fa-arrows-rotate {
  --fa: "\\f021";
  --fa--fa: "\\f021\\f021"; }

.fa-refresh {
  --fa: "\\f021";
  --fa--fa: "\\f021\\f021"; }

.fa-sync {
  --fa: "\\f021";
  --fa--fa: "\\f021\\f021"; }

.fa-fire-extinguisher {
  --fa: "\\f134";
  --fa--fa: "\\f134\\f134"; }

.fa-cruzeiro-sign {
  --fa: "\\e152";
  --fa--fa: "\\e152\\e152"; }

.fa-greater-than-equal {
  --fa: "\\f532";
  --fa--fa: "\\f532\\f532"; }

.fa-shield-halved {
  --fa: "\\f3ed";
  --fa--fa: "\\f3ed\\f3ed"; }

.fa-shield-alt {
  --fa: "\\f3ed";
  --fa--fa: "\\f3ed\\f3ed"; }

.fa-book-atlas {
  --fa: "\\f558";
  --fa--fa: "\\f558\\f558"; }

.fa-atlas {
  --fa: "\\f558";
  --fa--fa: "\\f558\\f558"; }

.fa-virus {
  --fa: "\\e074";
  --fa--fa: "\\e074\\e074"; }

.fa-envelope-circle-check {
  --fa: "\\e4e8";
  --fa--fa: "\\e4e8\\e4e8"; }

.fa-layer-group {
  --fa: "\\f5fd";
  --fa--fa: "\\f5fd\\f5fd"; }

.fa-arrows-to-dot {
  --fa: "\\e4be";
  --fa--fa: "\\e4be\\e4be"; }

.fa-archway {
  --fa: "\\f557";
  --fa--fa: "\\f557\\f557"; }

.fa-heart-circle-check {
  --fa: "\\e4fd";
  --fa--fa: "\\e4fd\\e4fd"; }

.fa-house-chimney-crack {
  --fa: "\\f6f1";
  --fa--fa: "\\f6f1\\f6f1"; }

.fa-house-damage {
  --fa: "\\f6f1";
  --fa--fa: "\\f6f1\\f6f1"; }

.fa-file-zipper {
  --fa: "\\f1c6";
  --fa--fa: "\\f1c6\\f1c6"; }

.fa-file-archive {
  --fa: "\\f1c6";
  --fa--fa: "\\f1c6\\f1c6"; }

.fa-square {
  --fa: "\\f0c8";
  --fa--fa: "\\f0c8\\f0c8"; }

.fa-martini-glass-empty {
  --fa: "\\f000";
  --fa--fa: "\\f000\\f000"; }

.fa-glass-martini {
  --fa: "\\f000";
  --fa--fa: "\\f000\\f000"; }

.fa-couch {
  --fa: "\\f4b8";
  --fa--fa: "\\f4b8\\f4b8"; }

.fa-cedi-sign {
  --fa: "\\e0df";
  --fa--fa: "\\e0df\\e0df"; }

.fa-italic {
  --fa: "\\f033";
  --fa--fa: "\\f033\\f033"; }

.fa-table-cells-column-lock {
  --fa: "\\e678";
  --fa--fa: "\\e678\\e678"; }

.fa-church {
  --fa: "\\f51d";
  --fa--fa: "\\f51d\\f51d"; }

.fa-comments-dollar {
  --fa: "\\f653";
  --fa--fa: "\\f653\\f653"; }

.fa-democrat {
  --fa: "\\f747";
  --fa--fa: "\\f747\\f747"; }

.fa-z {
  --fa: "\\5a";
  --fa--fa: "\\5a\\5a"; }

.fa-person-skiing {
  --fa: "\\f7c9";
  --fa--fa: "\\f7c9\\f7c9"; }

.fa-skiing {
  --fa: "\\f7c9";
  --fa--fa: "\\f7c9\\f7c9"; }

.fa-road-lock {
  --fa: "\\e567";
  --fa--fa: "\\e567\\e567"; }

.fa-a {
  --fa: "\\41";
  --fa--fa: "\\41\\41"; }

.fa-temperature-arrow-down {
  --fa: "\\e03f";
  --fa--fa: "\\e03f\\e03f"; }

.fa-temperature-down {
  --fa: "\\e03f";
  --fa--fa: "\\e03f\\e03f"; }

.fa-feather-pointed {
  --fa: "\\f56b";
  --fa--fa: "\\f56b\\f56b"; }

.fa-feather-alt {
  --fa: "\\f56b";
  --fa--fa: "\\f56b\\f56b"; }

.fa-p {
  --fa: "\\50";
  --fa--fa: "\\50\\50"; }

.fa-snowflake {
  --fa: "\\f2dc";
  --fa--fa: "\\f2dc\\f2dc"; }

.fa-newspaper {
  --fa: "\\f1ea";
  --fa--fa: "\\f1ea\\f1ea"; }

.fa-rectangle-ad {
  --fa: "\\f641";
  --fa--fa: "\\f641\\f641"; }

.fa-ad {
  --fa: "\\f641";
  --fa--fa: "\\f641\\f641"; }

.fa-circle-arrow-right {
  --fa: "\\f0a9";
  --fa--fa: "\\f0a9\\f0a9"; }

.fa-arrow-circle-right {
  --fa: "\\f0a9";
  --fa--fa: "\\f0a9\\f0a9"; }

.fa-filter-circle-xmark {
  --fa: "\\e17b";
  --fa--fa: "\\e17b\\e17b"; }

.fa-locust {
  --fa: "\\e520";
  --fa--fa: "\\e520\\e520"; }

.fa-sort {
  --fa: "\\f0dc";
  --fa--fa: "\\f0dc\\f0dc"; }

.fa-unsorted {
  --fa: "\\f0dc";
  --fa--fa: "\\f0dc\\f0dc"; }

.fa-list-ol {
  --fa: "\\f0cb";
  --fa--fa: "\\f0cb\\f0cb"; }

.fa-list-1-2 {
  --fa: "\\f0cb";
  --fa--fa: "\\f0cb\\f0cb"; }

.fa-list-numeric {
  --fa: "\\f0cb";
  --fa--fa: "\\f0cb\\f0cb"; }

.fa-person-dress-burst {
  --fa: "\\e544";
  --fa--fa: "\\e544\\e544"; }

.fa-money-check-dollar {
  --fa: "\\f53d";
  --fa--fa: "\\f53d\\f53d"; }

.fa-money-check-alt {
  --fa: "\\f53d";
  --fa--fa: "\\f53d\\f53d"; }

.fa-vector-square {
  --fa: "\\f5cb";
  --fa--fa: "\\f5cb\\f5cb"; }

.fa-bread-slice {
  --fa: "\\f7ec";
  --fa--fa: "\\f7ec\\f7ec"; }

.fa-language {
  --fa: "\\f1ab";
  --fa--fa: "\\f1ab\\f1ab"; }

.fa-face-kiss-wink-heart {
  --fa: "\\f598";
  --fa--fa: "\\f598\\f598"; }

.fa-kiss-wink-heart {
  --fa: "\\f598";
  --fa--fa: "\\f598\\f598"; }

.fa-filter {
  --fa: "\\f0b0";
  --fa--fa: "\\f0b0\\f0b0"; }

.fa-question {
  --fa: "\\3f";
  --fa--fa: "\\3f\\3f"; }

.fa-file-signature {
  --fa: "\\f573";
  --fa--fa: "\\f573\\f573"; }

.fa-up-down-left-right {
  --fa: "\\f0b2";
  --fa--fa: "\\f0b2\\f0b2"; }

.fa-arrows-alt {
  --fa: "\\f0b2";
  --fa--fa: "\\f0b2\\f0b2"; }

.fa-house-chimney-user {
  --fa: "\\e065";
  --fa--fa: "\\e065\\e065"; }

.fa-hand-holding-heart {
  --fa: "\\f4be";
  --fa--fa: "\\f4be\\f4be"; }

.fa-puzzle-piece {
  --fa: "\\f12e";
  --fa--fa: "\\f12e\\f12e"; }

.fa-money-check {
  --fa: "\\f53c";
  --fa--fa: "\\f53c\\f53c"; }

.fa-star-half-stroke {
  --fa: "\\f5c0";
  --fa--fa: "\\f5c0\\f5c0"; }

.fa-star-half-alt {
  --fa: "\\f5c0";
  --fa--fa: "\\f5c0\\f5c0"; }

.fa-code {
  --fa: "\\f121";
  --fa--fa: "\\f121\\f121"; }

.fa-whiskey-glass {
  --fa: "\\f7a0";
  --fa--fa: "\\f7a0\\f7a0"; }

.fa-glass-whiskey {
  --fa: "\\f7a0";
  --fa--fa: "\\f7a0\\f7a0"; }

.fa-building-circle-exclamation {
  --fa: "\\e4d3";
  --fa--fa: "\\e4d3\\e4d3"; }

.fa-magnifying-glass-chart {
  --fa: "\\e522";
  --fa--fa: "\\e522\\e522"; }

.fa-arrow-up-right-from-square {
  --fa: "\\f08e";
  --fa--fa: "\\f08e\\f08e"; }

.fa-external-link {
  --fa: "\\f08e";
  --fa--fa: "\\f08e\\f08e"; }

.fa-cubes-stacked {
  --fa: "\\e4e6";
  --fa--fa: "\\e4e6\\e4e6"; }

.fa-won-sign {
  --fa: "\\f159";
  --fa--fa: "\\f159\\f159"; }

.fa-krw {
  --fa: "\\f159";
  --fa--fa: "\\f159\\f159"; }

.fa-won {
  --fa: "\\f159";
  --fa--fa: "\\f159\\f159"; }

.fa-virus-covid {
  --fa: "\\e4a8";
  --fa--fa: "\\e4a8\\e4a8"; }

.fa-austral-sign {
  --fa: "\\e0a9";
  --fa--fa: "\\e0a9\\e0a9"; }

.fa-f {
  --fa: "\\46";
  --fa--fa: "\\46\\46"; }

.fa-leaf {
  --fa: "\\f06c";
  --fa--fa: "\\f06c\\f06c"; }

.fa-road {
  --fa: "\\f018";
  --fa--fa: "\\f018\\f018"; }

.fa-taxi {
  --fa: "\\f1ba";
  --fa--fa: "\\f1ba\\f1ba"; }

.fa-cab {
  --fa: "\\f1ba";
  --fa--fa: "\\f1ba\\f1ba"; }

.fa-person-circle-plus {
  --fa: "\\e541";
  --fa--fa: "\\e541\\e541"; }

.fa-chart-pie {
  --fa: "\\f200";
  --fa--fa: "\\f200\\f200"; }

.fa-pie-chart {
  --fa: "\\f200";
  --fa--fa: "\\f200\\f200"; }

.fa-bolt-lightning {
  --fa: "\\e0b7";
  --fa--fa: "\\e0b7\\e0b7"; }

.fa-sack-xmark {
  --fa: "\\e56a";
  --fa--fa: "\\e56a\\e56a"; }

.fa-file-excel {
  --fa: "\\f1c3";
  --fa--fa: "\\f1c3\\f1c3"; }

.fa-file-contract {
  --fa: "\\f56c";
  --fa--fa: "\\f56c\\f56c"; }

.fa-fish-fins {
  --fa: "\\e4f2";
  --fa--fa: "\\e4f2\\e4f2"; }

.fa-building-flag {
  --fa: "\\e4d5";
  --fa--fa: "\\e4d5\\e4d5"; }

.fa-face-grin-beam {
  --fa: "\\f582";
  --fa--fa: "\\f582\\f582"; }

.fa-grin-beam {
  --fa: "\\f582";
  --fa--fa: "\\f582\\f582"; }

.fa-object-ungroup {
  --fa: "\\f248";
  --fa--fa: "\\f248\\f248"; }

.fa-poop {
  --fa: "\\f619";
  --fa--fa: "\\f619\\f619"; }

.fa-location-pin {
  --fa: "\\f041";
  --fa--fa: "\\f041\\f041"; }

.fa-map-marker {
  --fa: "\\f041";
  --fa--fa: "\\f041\\f041"; }

.fa-kaaba {
  --fa: "\\f66b";
  --fa--fa: "\\f66b\\f66b"; }

.fa-toilet-paper {
  --fa: "\\f71e";
  --fa--fa: "\\f71e\\f71e"; }

.fa-helmet-safety {
  --fa: "\\f807";
  --fa--fa: "\\f807\\f807"; }

.fa-hard-hat {
  --fa: "\\f807";
  --fa--fa: "\\f807\\f807"; }

.fa-hat-hard {
  --fa: "\\f807";
  --fa--fa: "\\f807\\f807"; }

.fa-eject {
  --fa: "\\f052";
  --fa--fa: "\\f052\\f052"; }

.fa-circle-right {
  --fa: "\\f35a";
  --fa--fa: "\\f35a\\f35a"; }

.fa-arrow-alt-circle-right {
  --fa: "\\f35a";
  --fa--fa: "\\f35a\\f35a"; }

.fa-plane-circle-check {
  --fa: "\\e555";
  --fa--fa: "\\e555\\e555"; }

.fa-face-rolling-eyes {
  --fa: "\\f5a5";
  --fa--fa: "\\f5a5\\f5a5"; }

.fa-meh-rolling-eyes {
  --fa: "\\f5a5";
  --fa--fa: "\\f5a5\\f5a5"; }

.fa-object-group {
  --fa: "\\f247";
  --fa--fa: "\\f247\\f247"; }

.fa-chart-line {
  --fa: "\\f201";
  --fa--fa: "\\f201\\f201"; }

.fa-line-chart {
  --fa: "\\f201";
  --fa--fa: "\\f201\\f201"; }

.fa-mask-ventilator {
  --fa: "\\e524";
  --fa--fa: "\\e524\\e524"; }

.fa-arrow-right {
  --fa: "\\f061";
  --fa--fa: "\\f061\\f061"; }

.fa-signs-post {
  --fa: "\\f277";
  --fa--fa: "\\f277\\f277"; }

.fa-map-signs {
  --fa: "\\f277";
  --fa--fa: "\\f277\\f277"; }

.fa-cash-register {
  --fa: "\\f788";
  --fa--fa: "\\f788\\f788"; }

.fa-person-circle-question {
  --fa: "\\e542";
  --fa--fa: "\\e542\\e542"; }

.fa-h {
  --fa: "\\48";
  --fa--fa: "\\48\\48"; }

.fa-tarp {
  --fa: "\\e57b";
  --fa--fa: "\\e57b\\e57b"; }

.fa-screwdriver-wrench {
  --fa: "\\f7d9";
  --fa--fa: "\\f7d9\\f7d9"; }

.fa-tools {
  --fa: "\\f7d9";
  --fa--fa: "\\f7d9\\f7d9"; }

.fa-arrows-to-eye {
  --fa: "\\e4bf";
  --fa--fa: "\\e4bf\\e4bf"; }

.fa-plug-circle-bolt {
  --fa: "\\e55b";
  --fa--fa: "\\e55b\\e55b"; }

.fa-heart {
  --fa: "\\f004";
  --fa--fa: "\\f004\\f004"; }

.fa-mars-and-venus {
  --fa: "\\f224";
  --fa--fa: "\\f224\\f224"; }

.fa-house-user {
  --fa: "\\e1b0";
  --fa--fa: "\\e1b0\\e1b0"; }

.fa-home-user {
  --fa: "\\e1b0";
  --fa--fa: "\\e1b0\\e1b0"; }

.fa-dumpster-fire {
  --fa: "\\f794";
  --fa--fa: "\\f794\\f794"; }

.fa-house-crack {
  --fa: "\\e3b1";
  --fa--fa: "\\e3b1\\e3b1"; }

.fa-martini-glass-citrus {
  --fa: "\\f561";
  --fa--fa: "\\f561\\f561"; }

.fa-cocktail {
  --fa: "\\f561";
  --fa--fa: "\\f561\\f561"; }

.fa-face-surprise {
  --fa: "\\f5c2";
  --fa--fa: "\\f5c2\\f5c2"; }

.fa-surprise {
  --fa: "\\f5c2";
  --fa--fa: "\\f5c2\\f5c2"; }

.fa-bottle-water {
  --fa: "\\e4c5";
  --fa--fa: "\\e4c5\\e4c5"; }

.fa-circle-pause {
  --fa: "\\f28b";
  --fa--fa: "\\f28b\\f28b"; }

.fa-pause-circle {
  --fa: "\\f28b";
  --fa--fa: "\\f28b\\f28b"; }

.fa-toilet-paper-slash {
  --fa: "\\e072";
  --fa--fa: "\\e072\\e072"; }

.fa-apple-whole {
  --fa: "\\f5d1";
  --fa--fa: "\\f5d1\\f5d1"; }

.fa-apple-alt {
  --fa: "\\f5d1";
  --fa--fa: "\\f5d1\\f5d1"; }

.fa-kitchen-set {
  --fa: "\\e51a";
  --fa--fa: "\\e51a\\e51a"; }

.fa-r {
  --fa: "\\52";
  --fa--fa: "\\52\\52"; }

.fa-temperature-quarter {
  --fa: "\\f2ca";
  --fa--fa: "\\f2ca\\f2ca"; }

.fa-temperature-1 {
  --fa: "\\f2ca";
  --fa--fa: "\\f2ca\\f2ca"; }

.fa-thermometer-1 {
  --fa: "\\f2ca";
  --fa--fa: "\\f2ca\\f2ca"; }

.fa-thermometer-quarter {
  --fa: "\\f2ca";
  --fa--fa: "\\f2ca\\f2ca"; }

.fa-cube {
  --fa: "\\f1b2";
  --fa--fa: "\\f1b2\\f1b2"; }

.fa-bitcoin-sign {
  --fa: "\\e0b4";
  --fa--fa: "\\e0b4\\e0b4"; }

.fa-shield-dog {
  --fa: "\\e573";
  --fa--fa: "\\e573\\e573"; }

.fa-solar-panel {
  --fa: "\\f5ba";
  --fa--fa: "\\f5ba\\f5ba"; }

.fa-lock-open {
  --fa: "\\f3c1";
  --fa--fa: "\\f3c1\\f3c1"; }

.fa-elevator {
  --fa: "\\e16d";
  --fa--fa: "\\e16d\\e16d"; }

.fa-money-bill-transfer {
  --fa: "\\e528";
  --fa--fa: "\\e528\\e528"; }

.fa-money-bill-trend-up {
  --fa: "\\e529";
  --fa--fa: "\\e529\\e529"; }

.fa-house-flood-water-circle-arrow-right {
  --fa: "\\e50f";
  --fa--fa: "\\e50f\\e50f"; }

.fa-square-poll-horizontal {
  --fa: "\\f682";
  --fa--fa: "\\f682\\f682"; }

.fa-poll-h {
  --fa: "\\f682";
  --fa--fa: "\\f682\\f682"; }

.fa-circle {
  --fa: "\\f111";
  --fa--fa: "\\f111\\f111"; }

.fa-backward-fast {
  --fa: "\\f049";
  --fa--fa: "\\f049\\f049"; }

.fa-fast-backward {
  --fa: "\\f049";
  --fa--fa: "\\f049\\f049"; }

.fa-recycle {
  --fa: "\\f1b8";
  --fa--fa: "\\f1b8\\f1b8"; }

.fa-user-astronaut {
  --fa: "\\f4fb";
  --fa--fa: "\\f4fb\\f4fb"; }

.fa-plane-slash {
  --fa: "\\e069";
  --fa--fa: "\\e069\\e069"; }

.fa-trademark {
  --fa: "\\f25c";
  --fa--fa: "\\f25c\\f25c"; }

.fa-basketball {
  --fa: "\\f434";
  --fa--fa: "\\f434\\f434"; }

.fa-basketball-ball {
  --fa: "\\f434";
  --fa--fa: "\\f434\\f434"; }

.fa-satellite-dish {
  --fa: "\\f7c0";
  --fa--fa: "\\f7c0\\f7c0"; }

.fa-circle-up {
  --fa: "\\f35b";
  --fa--fa: "\\f35b\\f35b"; }

.fa-arrow-alt-circle-up {
  --fa: "\\f35b";
  --fa--fa: "\\f35b\\f35b"; }

.fa-mobile-screen-button {
  --fa: "\\f3cd";
  --fa--fa: "\\f3cd\\f3cd"; }

.fa-mobile-alt {
  --fa: "\\f3cd";
  --fa--fa: "\\f3cd\\f3cd"; }

.fa-volume-high {
  --fa: "\\f028";
  --fa--fa: "\\f028\\f028"; }

.fa-volume-up {
  --fa: "\\f028";
  --fa--fa: "\\f028\\f028"; }

.fa-users-rays {
  --fa: "\\e593";
  --fa--fa: "\\e593\\e593"; }

.fa-wallet {
  --fa: "\\f555";
  --fa--fa: "\\f555\\f555"; }

.fa-clipboard-check {
  --fa: "\\f46c";
  --fa--fa: "\\f46c\\f46c"; }

.fa-file-audio {
  --fa: "\\f1c7";
  --fa--fa: "\\f1c7\\f1c7"; }

.fa-burger {
  --fa: "\\f805";
  --fa--fa: "\\f805\\f805"; }

.fa-hamburger {
  --fa: "\\f805";
  --fa--fa: "\\f805\\f805"; }

.fa-wrench {
  --fa: "\\f0ad";
  --fa--fa: "\\f0ad\\f0ad"; }

.fa-bugs {
  --fa: "\\e4d0";
  --fa--fa: "\\e4d0\\e4d0"; }

.fa-rupee-sign {
  --fa: "\\f156";
  --fa--fa: "\\f156\\f156"; }

.fa-rupee {
  --fa: "\\f156";
  --fa--fa: "\\f156\\f156"; }

.fa-file-image {
  --fa: "\\f1c5";
  --fa--fa: "\\f1c5\\f1c5"; }

.fa-circle-question {
  --fa: "\\f059";
  --fa--fa: "\\f059\\f059"; }

.fa-question-circle {
  --fa: "\\f059";
  --fa--fa: "\\f059\\f059"; }

.fa-plane-departure {
  --fa: "\\f5b0";
  --fa--fa: "\\f5b0\\f5b0"; }

.fa-handshake-slash {
  --fa: "\\e060";
  --fa--fa: "\\e060\\e060"; }

.fa-book-bookmark {
  --fa: "\\e0bb";
  --fa--fa: "\\e0bb\\e0bb"; }

.fa-code-branch {
  --fa: "\\f126";
  --fa--fa: "\\f126\\f126"; }

.fa-hat-cowboy {
  --fa: "\\f8c0";
  --fa--fa: "\\f8c0\\f8c0"; }

.fa-bridge {
  --fa: "\\e4c8";
  --fa--fa: "\\e4c8\\e4c8"; }

.fa-phone-flip {
  --fa: "\\f879";
  --fa--fa: "\\f879\\f879"; }

.fa-phone-alt {
  --fa: "\\f879";
  --fa--fa: "\\f879\\f879"; }

.fa-truck-front {
  --fa: "\\e2b7";
  --fa--fa: "\\e2b7\\e2b7"; }

.fa-cat {
  --fa: "\\f6be";
  --fa--fa: "\\f6be\\f6be"; }

.fa-anchor-circle-exclamation {
  --fa: "\\e4ab";
  --fa--fa: "\\e4ab\\e4ab"; }

.fa-truck-field {
  --fa: "\\e58d";
  --fa--fa: "\\e58d\\e58d"; }

.fa-route {
  --fa: "\\f4d7";
  --fa--fa: "\\f4d7\\f4d7"; }

.fa-clipboard-question {
  --fa: "\\e4e3";
  --fa--fa: "\\e4e3\\e4e3"; }

.fa-panorama {
  --fa: "\\e209";
  --fa--fa: "\\e209\\e209"; }

.fa-comment-medical {
  --fa: "\\f7f5";
  --fa--fa: "\\f7f5\\f7f5"; }

.fa-teeth-open {
  --fa: "\\f62f";
  --fa--fa: "\\f62f\\f62f"; }

.fa-file-circle-minus {
  --fa: "\\e4ed";
  --fa--fa: "\\e4ed\\e4ed"; }

.fa-tags {
  --fa: "\\f02c";
  --fa--fa: "\\f02c\\f02c"; }

.fa-wine-glass {
  --fa: "\\f4e3";
  --fa--fa: "\\f4e3\\f4e3"; }

.fa-forward-fast {
  --fa: "\\f050";
  --fa--fa: "\\f050\\f050"; }

.fa-fast-forward {
  --fa: "\\f050";
  --fa--fa: "\\f050\\f050"; }

.fa-face-meh-blank {
  --fa: "\\f5a4";
  --fa--fa: "\\f5a4\\f5a4"; }

.fa-meh-blank {
  --fa: "\\f5a4";
  --fa--fa: "\\f5a4\\f5a4"; }

.fa-square-parking {
  --fa: "\\f540";
  --fa--fa: "\\f540\\f540"; }

.fa-parking {
  --fa: "\\f540";
  --fa--fa: "\\f540\\f540"; }

.fa-house-signal {
  --fa: "\\e012";
  --fa--fa: "\\e012\\e012"; }

.fa-bars-progress {
  --fa: "\\f828";
  --fa--fa: "\\f828\\f828"; }

.fa-tasks-alt {
  --fa: "\\f828";
  --fa--fa: "\\f828\\f828"; }

.fa-faucet-drip {
  --fa: "\\e006";
  --fa--fa: "\\e006\\e006"; }

.fa-cart-flatbed {
  --fa: "\\f474";
  --fa--fa: "\\f474\\f474"; }

.fa-dolly-flatbed {
  --fa: "\\f474";
  --fa--fa: "\\f474\\f474"; }

.fa-ban-smoking {
  --fa: "\\f54d";
  --fa--fa: "\\f54d\\f54d"; }

.fa-smoking-ban {
  --fa: "\\f54d";
  --fa--fa: "\\f54d\\f54d"; }

.fa-terminal {
  --fa: "\\f120";
  --fa--fa: "\\f120\\f120"; }

.fa-mobile-button {
  --fa: "\\f10b";
  --fa--fa: "\\f10b\\f10b"; }

.fa-house-medical-flag {
  --fa: "\\e514";
  --fa--fa: "\\e514\\e514"; }

.fa-basket-shopping {
  --fa: "\\f291";
  --fa--fa: "\\f291\\f291"; }

.fa-shopping-basket {
  --fa: "\\f291";
  --fa--fa: "\\f291\\f291"; }

.fa-tape {
  --fa: "\\f4db";
  --fa--fa: "\\f4db\\f4db"; }

.fa-bus-simple {
  --fa: "\\f55e";
  --fa--fa: "\\f55e\\f55e"; }

.fa-bus-alt {
  --fa: "\\f55e";
  --fa--fa: "\\f55e\\f55e"; }

.fa-eye {
  --fa: "\\f06e";
  --fa--fa: "\\f06e\\f06e"; }

.fa-face-sad-cry {
  --fa: "\\f5b3";
  --fa--fa: "\\f5b3\\f5b3"; }

.fa-sad-cry {
  --fa: "\\f5b3";
  --fa--fa: "\\f5b3\\f5b3"; }

.fa-audio-description {
  --fa: "\\f29e";
  --fa--fa: "\\f29e\\f29e"; }

.fa-person-military-to-person {
  --fa: "\\e54c";
  --fa--fa: "\\e54c\\e54c"; }

.fa-file-shield {
  --fa: "\\e4f0";
  --fa--fa: "\\e4f0\\e4f0"; }

.fa-user-slash {
  --fa: "\\f506";
  --fa--fa: "\\f506\\f506"; }

.fa-pen {
  --fa: "\\f304";
  --fa--fa: "\\f304\\f304"; }

.fa-tower-observation {
  --fa: "\\e586";
  --fa--fa: "\\e586\\e586"; }

.fa-file-code {
  --fa: "\\f1c9";
  --fa--fa: "\\f1c9\\f1c9"; }

.fa-signal {
  --fa: "\\f012";
  --fa--fa: "\\f012\\f012"; }

.fa-signal-5 {
  --fa: "\\f012";
  --fa--fa: "\\f012\\f012"; }

.fa-signal-perfect {
  --fa: "\\f012";
  --fa--fa: "\\f012\\f012"; }

.fa-bus {
  --fa: "\\f207";
  --fa--fa: "\\f207\\f207"; }

.fa-heart-circle-xmark {
  --fa: "\\e501";
  --fa--fa: "\\e501\\e501"; }

.fa-house-chimney {
  --fa: "\\e3af";
  --fa--fa: "\\e3af\\e3af"; }

.fa-home-lg {
  --fa: "\\e3af";
  --fa--fa: "\\e3af\\e3af"; }

.fa-window-maximize {
  --fa: "\\f2d0";
  --fa--fa: "\\f2d0\\f2d0"; }

.fa-face-frown {
  --fa: "\\f119";
  --fa--fa: "\\f119\\f119"; }

.fa-frown {
  --fa: "\\f119";
  --fa--fa: "\\f119\\f119"; }

.fa-prescription {
  --fa: "\\f5b1";
  --fa--fa: "\\f5b1\\f5b1"; }

.fa-shop {
  --fa: "\\f54f";
  --fa--fa: "\\f54f\\f54f"; }

.fa-store-alt {
  --fa: "\\f54f";
  --fa--fa: "\\f54f\\f54f"; }

.fa-floppy-disk {
  --fa: "\\f0c7";
  --fa--fa: "\\f0c7\\f0c7"; }

.fa-save {
  --fa: "\\f0c7";
  --fa--fa: "\\f0c7\\f0c7"; }

.fa-vihara {
  --fa: "\\f6a7";
  --fa--fa: "\\f6a7\\f6a7"; }

.fa-scale-unbalanced {
  --fa: "\\f515";
  --fa--fa: "\\f515\\f515"; }

.fa-balance-scale-left {
  --fa: "\\f515";
  --fa--fa: "\\f515\\f515"; }

.fa-sort-up {
  --fa: "\\f0de";
  --fa--fa: "\\f0de\\f0de"; }

.fa-sort-asc {
  --fa: "\\f0de";
  --fa--fa: "\\f0de\\f0de"; }

.fa-comment-dots {
  --fa: "\\f4ad";
  --fa--fa: "\\f4ad\\f4ad"; }

.fa-commenting {
  --fa: "\\f4ad";
  --fa--fa: "\\f4ad\\f4ad"; }

.fa-plant-wilt {
  --fa: "\\e5aa";
  --fa--fa: "\\e5aa\\e5aa"; }

.fa-diamond {
  --fa: "\\f219";
  --fa--fa: "\\f219\\f219"; }

.fa-face-grin-squint {
  --fa: "\\f585";
  --fa--fa: "\\f585\\f585"; }

.fa-grin-squint {
  --fa: "\\f585";
  --fa--fa: "\\f585\\f585"; }

.fa-hand-holding-dollar {
  --fa: "\\f4c0";
  --fa--fa: "\\f4c0\\f4c0"; }

.fa-hand-holding-usd {
  --fa: "\\f4c0";
  --fa--fa: "\\f4c0\\f4c0"; }

.fa-chart-diagram {
  --fa: "\\e695";
  --fa--fa: "\\e695\\e695"; }

.fa-bacterium {
  --fa: "\\e05a";
  --fa--fa: "\\e05a\\e05a"; }

.fa-hand-pointer {
  --fa: "\\f25a";
  --fa--fa: "\\f25a\\f25a"; }

.fa-drum-steelpan {
  --fa: "\\f56a";
  --fa--fa: "\\f56a\\f56a"; }

.fa-hand-scissors {
  --fa: "\\f257";
  --fa--fa: "\\f257\\f257"; }

.fa-hands-praying {
  --fa: "\\f684";
  --fa--fa: "\\f684\\f684"; }

.fa-praying-hands {
  --fa: "\\f684";
  --fa--fa: "\\f684\\f684"; }

.fa-arrow-rotate-right {
  --fa: "\\f01e";
  --fa--fa: "\\f01e\\f01e"; }

.fa-arrow-right-rotate {
  --fa: "\\f01e";
  --fa--fa: "\\f01e\\f01e"; }

.fa-arrow-rotate-forward {
  --fa: "\\f01e";
  --fa--fa: "\\f01e\\f01e"; }

.fa-redo {
  --fa: "\\f01e";
  --fa--fa: "\\f01e\\f01e"; }

.fa-biohazard {
  --fa: "\\f780";
  --fa--fa: "\\f780\\f780"; }

.fa-location-crosshairs {
  --fa: "\\f601";
  --fa--fa: "\\f601\\f601"; }

.fa-location {
  --fa: "\\f601";
  --fa--fa: "\\f601\\f601"; }

.fa-mars-double {
  --fa: "\\f227";
  --fa--fa: "\\f227\\f227"; }

.fa-child-dress {
  --fa: "\\e59c";
  --fa--fa: "\\e59c\\e59c"; }

.fa-users-between-lines {
  --fa: "\\e591";
  --fa--fa: "\\e591\\e591"; }

.fa-lungs-virus {
  --fa: "\\e067";
  --fa--fa: "\\e067\\e067"; }

.fa-face-grin-tears {
  --fa: "\\f588";
  --fa--fa: "\\f588\\f588"; }

.fa-grin-tears {
  --fa: "\\f588";
  --fa--fa: "\\f588\\f588"; }

.fa-phone {
  --fa: "\\f095";
  --fa--fa: "\\f095\\f095"; }

.fa-calendar-xmark {
  --fa: "\\f273";
  --fa--fa: "\\f273\\f273"; }

.fa-calendar-times {
  --fa: "\\f273";
  --fa--fa: "\\f273\\f273"; }

.fa-child-reaching {
  --fa: "\\e59d";
  --fa--fa: "\\e59d\\e59d"; }

.fa-head-side-virus {
  --fa: "\\e064";
  --fa--fa: "\\e064\\e064"; }

.fa-user-gear {
  --fa: "\\f4fe";
  --fa--fa: "\\f4fe\\f4fe"; }

.fa-user-cog {
  --fa: "\\f4fe";
  --fa--fa: "\\f4fe\\f4fe"; }

.fa-arrow-up-1-9 {
  --fa: "\\f163";
  --fa--fa: "\\f163\\f163"; }

.fa-sort-numeric-up {
  --fa: "\\f163";
  --fa--fa: "\\f163\\f163"; }

.fa-door-closed {
  --fa: "\\f52a";
  --fa--fa: "\\f52a\\f52a"; }

.fa-shield-virus {
  --fa: "\\e06c";
  --fa--fa: "\\e06c\\e06c"; }

.fa-dice-six {
  --fa: "\\f526";
  --fa--fa: "\\f526\\f526"; }

.fa-mosquito-net {
  --fa: "\\e52c";
  --fa--fa: "\\e52c\\e52c"; }

.fa-file-fragment {
  --fa: "\\e697";
  --fa--fa: "\\e697\\e697"; }

.fa-bridge-water {
  --fa: "\\e4ce";
  --fa--fa: "\\e4ce\\e4ce"; }

.fa-person-booth {
  --fa: "\\f756";
  --fa--fa: "\\f756\\f756"; }

.fa-text-width {
  --fa: "\\f035";
  --fa--fa: "\\f035\\f035"; }

.fa-hat-wizard {
  --fa: "\\f6e8";
  --fa--fa: "\\f6e8\\f6e8"; }

.fa-pen-fancy {
  --fa: "\\f5ac";
  --fa--fa: "\\f5ac\\f5ac"; }

.fa-person-digging {
  --fa: "\\f85e";
  --fa--fa: "\\f85e\\f85e"; }

.fa-digging {
  --fa: "\\f85e";
  --fa--fa: "\\f85e\\f85e"; }

.fa-trash {
  --fa: "\\f1f8";
  --fa--fa: "\\f1f8\\f1f8"; }

.fa-gauge-simple {
  --fa: "\\f629";
  --fa--fa: "\\f629\\f629"; }

.fa-gauge-simple-med {
  --fa: "\\f629";
  --fa--fa: "\\f629\\f629"; }

.fa-tachometer-average {
  --fa: "\\f629";
  --fa--fa: "\\f629\\f629"; }

.fa-book-medical {
  --fa: "\\f7e6";
  --fa--fa: "\\f7e6\\f7e6"; }

.fa-poo {
  --fa: "\\f2fe";
  --fa--fa: "\\f2fe\\f2fe"; }

.fa-quote-right {
  --fa: "\\f10e";
  --fa--fa: "\\f10e\\f10e"; }

.fa-quote-right-alt {
  --fa: "\\f10e";
  --fa--fa: "\\f10e\\f10e"; }

.fa-shirt {
  --fa: "\\f553";
  --fa--fa: "\\f553\\f553"; }

.fa-t-shirt {
  --fa: "\\f553";
  --fa--fa: "\\f553\\f553"; }

.fa-tshirt {
  --fa: "\\f553";
  --fa--fa: "\\f553\\f553"; }

.fa-cubes {
  --fa: "\\f1b3";
  --fa--fa: "\\f1b3\\f1b3"; }

.fa-divide {
  --fa: "\\f529";
  --fa--fa: "\\f529\\f529"; }

.fa-tenge-sign {
  --fa: "\\f7d7";
  --fa--fa: "\\f7d7\\f7d7"; }

.fa-tenge {
  --fa: "\\f7d7";
  --fa--fa: "\\f7d7\\f7d7"; }

.fa-headphones {
  --fa: "\\f025";
  --fa--fa: "\\f025\\f025"; }

.fa-hands-holding {
  --fa: "\\f4c2";
  --fa--fa: "\\f4c2\\f4c2"; }

.fa-hands-clapping {
  --fa: "\\e1a8";
  --fa--fa: "\\e1a8\\e1a8"; }

.fa-republican {
  --fa: "\\f75e";
  --fa--fa: "\\f75e\\f75e"; }

.fa-arrow-left {
  --fa: "\\f060";
  --fa--fa: "\\f060\\f060"; }

.fa-person-circle-xmark {
  --fa: "\\e543";
  --fa--fa: "\\e543\\e543"; }

.fa-ruler {
  --fa: "\\f545";
  --fa--fa: "\\f545\\f545"; }

.fa-align-left {
  --fa: "\\f036";
  --fa--fa: "\\f036\\f036"; }

.fa-dice-d6 {
  --fa: "\\f6d1";
  --fa--fa: "\\f6d1\\f6d1"; }

.fa-restroom {
  --fa: "\\f7bd";
  --fa--fa: "\\f7bd\\f7bd"; }

.fa-j {
  --fa: "\\4a";
  --fa--fa: "\\4a\\4a"; }

.fa-users-viewfinder {
  --fa: "\\e595";
  --fa--fa: "\\e595\\e595"; }

.fa-file-video {
  --fa: "\\f1c8";
  --fa--fa: "\\f1c8\\f1c8"; }

.fa-up-right-from-square {
  --fa: "\\f35d";
  --fa--fa: "\\f35d\\f35d"; }

.fa-external-link-alt {
  --fa: "\\f35d";
  --fa--fa: "\\f35d\\f35d"; }

.fa-table-cells {
  --fa: "\\f00a";
  --fa--fa: "\\f00a\\f00a"; }

.fa-th {
  --fa: "\\f00a";
  --fa--fa: "\\f00a\\f00a"; }

.fa-file-pdf {
  --fa: "\\f1c1";
  --fa--fa: "\\f1c1\\f1c1"; }

.fa-book-bible {
  --fa: "\\f647";
  --fa--fa: "\\f647\\f647"; }

.fa-bible {
  --fa: "\\f647";
  --fa--fa: "\\f647\\f647"; }

.fa-o {
  --fa: "\\4f";
  --fa--fa: "\\4f\\4f"; }

.fa-suitcase-medical {
  --fa: "\\f0fa";
  --fa--fa: "\\f0fa\\f0fa"; }

.fa-medkit {
  --fa: "\\f0fa";
  --fa--fa: "\\f0fa\\f0fa"; }

.fa-user-secret {
  --fa: "\\f21b";
  --fa--fa: "\\f21b\\f21b"; }

.fa-otter {
  --fa: "\\f700";
  --fa--fa: "\\f700\\f700"; }

.fa-person-dress {
  --fa: "\\f182";
  --fa--fa: "\\f182\\f182"; }

.fa-female {
  --fa: "\\f182";
  --fa--fa: "\\f182\\f182"; }

.fa-comment-dollar {
  --fa: "\\f651";
  --fa--fa: "\\f651\\f651"; }

.fa-business-time {
  --fa: "\\f64a";
  --fa--fa: "\\f64a\\f64a"; }

.fa-briefcase-clock {
  --fa: "\\f64a";
  --fa--fa: "\\f64a\\f64a"; }

.fa-table-cells-large {
  --fa: "\\f009";
  --fa--fa: "\\f009\\f009"; }

.fa-th-large {
  --fa: "\\f009";
  --fa--fa: "\\f009\\f009"; }

.fa-book-tanakh {
  --fa: "\\f827";
  --fa--fa: "\\f827\\f827"; }

.fa-tanakh {
  --fa: "\\f827";
  --fa--fa: "\\f827\\f827"; }

.fa-phone-volume {
  --fa: "\\f2a0";
  --fa--fa: "\\f2a0\\f2a0"; }

.fa-volume-control-phone {
  --fa: "\\f2a0";
  --fa--fa: "\\f2a0\\f2a0"; }

.fa-hat-cowboy-side {
  --fa: "\\f8c1";
  --fa--fa: "\\f8c1\\f8c1"; }

.fa-clipboard-user {
  --fa: "\\f7f3";
  --fa--fa: "\\f7f3\\f7f3"; }

.fa-child {
  --fa: "\\f1ae";
  --fa--fa: "\\f1ae\\f1ae"; }

.fa-lira-sign {
  --fa: "\\f195";
  --fa--fa: "\\f195\\f195"; }

.fa-satellite {
  --fa: "\\f7bf";
  --fa--fa: "\\f7bf\\f7bf"; }

.fa-plane-lock {
  --fa: "\\e558";
  --fa--fa: "\\e558\\e558"; }

.fa-tag {
  --fa: "\\f02b";
  --fa--fa: "\\f02b\\f02b"; }

.fa-comment {
  --fa: "\\f075";
  --fa--fa: "\\f075\\f075"; }

.fa-cake-candles {
  --fa: "\\f1fd";
  --fa--fa: "\\f1fd\\f1fd"; }

.fa-birthday-cake {
  --fa: "\\f1fd";
  --fa--fa: "\\f1fd\\f1fd"; }

.fa-cake {
  --fa: "\\f1fd";
  --fa--fa: "\\f1fd\\f1fd"; }

.fa-envelope {
  --fa: "\\f0e0";
  --fa--fa: "\\f0e0\\f0e0"; }

.fa-angles-up {
  --fa: "\\f102";
  --fa--fa: "\\f102\\f102"; }

.fa-angle-double-up {
  --fa: "\\f102";
  --fa--fa: "\\f102\\f102"; }

.fa-paperclip {
  --fa: "\\f0c6";
  --fa--fa: "\\f0c6\\f0c6"; }

.fa-arrow-right-to-city {
  --fa: "\\e4b3";
  --fa--fa: "\\e4b3\\e4b3"; }

.fa-ribbon {
  --fa: "\\f4d6";
  --fa--fa: "\\f4d6\\f4d6"; }

.fa-lungs {
  --fa: "\\f604";
  --fa--fa: "\\f604\\f604"; }

.fa-arrow-up-9-1 {
  --fa: "\\f887";
  --fa--fa: "\\f887\\f887"; }

.fa-sort-numeric-up-alt {
  --fa: "\\f887";
  --fa--fa: "\\f887\\f887"; }

.fa-litecoin-sign {
  --fa: "\\e1d3";
  --fa--fa: "\\e1d3\\e1d3"; }

.fa-border-none {
  --fa: "\\f850";
  --fa--fa: "\\f850\\f850"; }

.fa-circle-nodes {
  --fa: "\\e4e2";
  --fa--fa: "\\e4e2\\e4e2"; }

.fa-parachute-box {
  --fa: "\\f4cd";
  --fa--fa: "\\f4cd\\f4cd"; }

.fa-indent {
  --fa: "\\f03c";
  --fa--fa: "\\f03c\\f03c"; }

.fa-truck-field-un {
  --fa: "\\e58e";
  --fa--fa: "\\e58e\\e58e"; }

.fa-hourglass {
  --fa: "\\f254";
  --fa--fa: "\\f254\\f254"; }

.fa-hourglass-empty {
  --fa: "\\f254";
  --fa--fa: "\\f254\\f254"; }

.fa-mountain {
  --fa: "\\f6fc";
  --fa--fa: "\\f6fc\\f6fc"; }

.fa-user-doctor {
  --fa: "\\f0f0";
  --fa--fa: "\\f0f0\\f0f0"; }

.fa-user-md {
  --fa: "\\f0f0";
  --fa--fa: "\\f0f0\\f0f0"; }

.fa-circle-info {
  --fa: "\\f05a";
  --fa--fa: "\\f05a\\f05a"; }

.fa-info-circle {
  --fa: "\\f05a";
  --fa--fa: "\\f05a\\f05a"; }

.fa-cloud-meatball {
  --fa: "\\f73b";
  --fa--fa: "\\f73b\\f73b"; }

.fa-camera {
  --fa: "\\f030";
  --fa--fa: "\\f030\\f030"; }

.fa-camera-alt {
  --fa: "\\f030";
  --fa--fa: "\\f030\\f030"; }

.fa-square-virus {
  --fa: "\\e578";
  --fa--fa: "\\e578\\e578"; }

.fa-meteor {
  --fa: "\\f753";
  --fa--fa: "\\f753\\f753"; }

.fa-car-on {
  --fa: "\\e4dd";
  --fa--fa: "\\e4dd\\e4dd"; }

.fa-sleigh {
  --fa: "\\f7cc";
  --fa--fa: "\\f7cc\\f7cc"; }

.fa-arrow-down-1-9 {
  --fa: "\\f162";
  --fa--fa: "\\f162\\f162"; }

.fa-sort-numeric-asc {
  --fa: "\\f162";
  --fa--fa: "\\f162\\f162"; }

.fa-sort-numeric-down {
  --fa: "\\f162";
  --fa--fa: "\\f162\\f162"; }

.fa-hand-holding-droplet {
  --fa: "\\f4c1";
  --fa--fa: "\\f4c1\\f4c1"; }

.fa-hand-holding-water {
  --fa: "\\f4c1";
  --fa--fa: "\\f4c1\\f4c1"; }

.fa-water {
  --fa: "\\f773";
  --fa--fa: "\\f773\\f773"; }

.fa-calendar-check {
  --fa: "\\f274";
  --fa--fa: "\\f274\\f274"; }

.fa-braille {
  --fa: "\\f2a1";
  --fa--fa: "\\f2a1\\f2a1"; }

.fa-prescription-bottle-medical {
  --fa: "\\f486";
  --fa--fa: "\\f486\\f486"; }

.fa-prescription-bottle-alt {
  --fa: "\\f486";
  --fa--fa: "\\f486\\f486"; }

.fa-landmark {
  --fa: "\\f66f";
  --fa--fa: "\\f66f\\f66f"; }

.fa-truck {
  --fa: "\\f0d1";
  --fa--fa: "\\f0d1\\f0d1"; }

.fa-crosshairs {
  --fa: "\\f05b";
  --fa--fa: "\\f05b\\f05b"; }

.fa-person-cane {
  --fa: "\\e53c";
  --fa--fa: "\\e53c\\e53c"; }

.fa-tent {
  --fa: "\\e57d";
  --fa--fa: "\\e57d\\e57d"; }

.fa-vest-patches {
  --fa: "\\e086";
  --fa--fa: "\\e086\\e086"; }

.fa-check-double {
  --fa: "\\f560";
  --fa--fa: "\\f560\\f560"; }

.fa-arrow-down-a-z {
  --fa: "\\f15d";
  --fa--fa: "\\f15d\\f15d"; }

.fa-sort-alpha-asc {
  --fa: "\\f15d";
  --fa--fa: "\\f15d\\f15d"; }

.fa-sort-alpha-down {
  --fa: "\\f15d";
  --fa--fa: "\\f15d\\f15d"; }

.fa-money-bill-wheat {
  --fa: "\\e52a";
  --fa--fa: "\\e52a\\e52a"; }

.fa-cookie {
  --fa: "\\f563";
  --fa--fa: "\\f563\\f563"; }

.fa-arrow-rotate-left {
  --fa: "\\f0e2";
  --fa--fa: "\\f0e2\\f0e2"; }

.fa-arrow-left-rotate {
  --fa: "\\f0e2";
  --fa--fa: "\\f0e2\\f0e2"; }

.fa-arrow-rotate-back {
  --fa: "\\f0e2";
  --fa--fa: "\\f0e2\\f0e2"; }

.fa-arrow-rotate-backward {
  --fa: "\\f0e2";
  --fa--fa: "\\f0e2\\f0e2"; }

.fa-undo {
  --fa: "\\f0e2";
  --fa--fa: "\\f0e2\\f0e2"; }

.fa-hard-drive {
  --fa: "\\f0a0";
  --fa--fa: "\\f0a0\\f0a0"; }

.fa-hdd {
  --fa: "\\f0a0";
  --fa--fa: "\\f0a0\\f0a0"; }

.fa-face-grin-squint-tears {
  --fa: "\\f586";
  --fa--fa: "\\f586\\f586"; }

.fa-grin-squint-tears {
  --fa: "\\f586";
  --fa--fa: "\\f586\\f586"; }

.fa-dumbbell {
  --fa: "\\f44b";
  --fa--fa: "\\f44b\\f44b"; }

.fa-rectangle-list {
  --fa: "\\f022";
  --fa--fa: "\\f022\\f022"; }

.fa-list-alt {
  --fa: "\\f022";
  --fa--fa: "\\f022\\f022"; }

.fa-tarp-droplet {
  --fa: "\\e57c";
  --fa--fa: "\\e57c\\e57c"; }

.fa-house-medical-circle-check {
  --fa: "\\e511";
  --fa--fa: "\\e511\\e511"; }

.fa-person-skiing-nordic {
  --fa: "\\f7ca";
  --fa--fa: "\\f7ca\\f7ca"; }

.fa-skiing-nordic {
  --fa: "\\f7ca";
  --fa--fa: "\\f7ca\\f7ca"; }

.fa-calendar-plus {
  --fa: "\\f271";
  --fa--fa: "\\f271\\f271"; }

.fa-plane-arrival {
  --fa: "\\f5af";
  --fa--fa: "\\f5af\\f5af"; }

.fa-circle-left {
  --fa: "\\f359";
  --fa--fa: "\\f359\\f359"; }

.fa-arrow-alt-circle-left {
  --fa: "\\f359";
  --fa--fa: "\\f359\\f359"; }

.fa-train-subway {
  --fa: "\\f239";
  --fa--fa: "\\f239\\f239"; }

.fa-subway {
  --fa: "\\f239";
  --fa--fa: "\\f239\\f239"; }

.fa-chart-gantt {
  --fa: "\\e0e4";
  --fa--fa: "\\e0e4\\e0e4"; }

.fa-indian-rupee-sign {
  --fa: "\\e1bc";
  --fa--fa: "\\e1bc\\e1bc"; }

.fa-indian-rupee {
  --fa: "\\e1bc";
  --fa--fa: "\\e1bc\\e1bc"; }

.fa-inr {
  --fa: "\\e1bc";
  --fa--fa: "\\e1bc\\e1bc"; }

.fa-crop-simple {
  --fa: "\\f565";
  --fa--fa: "\\f565\\f565"; }

.fa-crop-alt {
  --fa: "\\f565";
  --fa--fa: "\\f565\\f565"; }

.fa-money-bill-1 {
  --fa: "\\f3d1";
  --fa--fa: "\\f3d1\\f3d1"; }

.fa-money-bill-alt {
  --fa: "\\f3d1";
  --fa--fa: "\\f3d1\\f3d1"; }

.fa-left-long {
  --fa: "\\f30a";
  --fa--fa: "\\f30a\\f30a"; }

.fa-long-arrow-alt-left {
  --fa: "\\f30a";
  --fa--fa: "\\f30a\\f30a"; }

.fa-dna {
  --fa: "\\f471";
  --fa--fa: "\\f471\\f471"; }

.fa-virus-slash {
  --fa: "\\e075";
  --fa--fa: "\\e075\\e075"; }

.fa-minus {
  --fa: "\\f068";
  --fa--fa: "\\f068\\f068"; }

.fa-subtract {
  --fa: "\\f068";
  --fa--fa: "\\f068\\f068"; }

.fa-chess {
  --fa: "\\f439";
  --fa--fa: "\\f439\\f439"; }

.fa-arrow-left-long {
  --fa: "\\f177";
  --fa--fa: "\\f177\\f177"; }

.fa-long-arrow-left {
  --fa: "\\f177";
  --fa--fa: "\\f177\\f177"; }

.fa-plug-circle-check {
  --fa: "\\e55c";
  --fa--fa: "\\e55c\\e55c"; }

.fa-street-view {
  --fa: "\\f21d";
  --fa--fa: "\\f21d\\f21d"; }

.fa-franc-sign {
  --fa: "\\e18f";
  --fa--fa: "\\e18f\\e18f"; }

.fa-volume-off {
  --fa: "\\f026";
  --fa--fa: "\\f026\\f026"; }

.fa-hands-asl-interpreting {
  --fa: "\\f2a3";
  --fa--fa: "\\f2a3\\f2a3"; }

.fa-american-sign-language-interpreting {
  --fa: "\\f2a3";
  --fa--fa: "\\f2a3\\f2a3"; }

.fa-asl-interpreting {
  --fa: "\\f2a3";
  --fa--fa: "\\f2a3\\f2a3"; }

.fa-hands-american-sign-language-interpreting {
  --fa: "\\f2a3";
  --fa--fa: "\\f2a3\\f2a3"; }

.fa-gear {
  --fa: "\\f013";
  --fa--fa: "\\f013\\f013"; }

.fa-cog {
  --fa: "\\f013";
  --fa--fa: "\\f013\\f013"; }

.fa-droplet-slash {
  --fa: "\\f5c7";
  --fa--fa: "\\f5c7\\f5c7"; }

.fa-tint-slash {
  --fa: "\\f5c7";
  --fa--fa: "\\f5c7\\f5c7"; }

.fa-mosque {
  --fa: "\\f678";
  --fa--fa: "\\f678\\f678"; }

.fa-mosquito {
  --fa: "\\e52b";
  --fa--fa: "\\e52b\\e52b"; }

.fa-star-of-david {
  --fa: "\\f69a";
  --fa--fa: "\\f69a\\f69a"; }

.fa-person-military-rifle {
  --fa: "\\e54b";
  --fa--fa: "\\e54b\\e54b"; }

.fa-cart-shopping {
  --fa: "\\f07a";
  --fa--fa: "\\f07a\\f07a"; }

.fa-shopping-cart {
  --fa: "\\f07a";
  --fa--fa: "\\f07a\\f07a"; }

.fa-vials {
  --fa: "\\f493";
  --fa--fa: "\\f493\\f493"; }

.fa-plug-circle-plus {
  --fa: "\\e55f";
  --fa--fa: "\\e55f\\e55f"; }

.fa-place-of-worship {
  --fa: "\\f67f";
  --fa--fa: "\\f67f\\f67f"; }

.fa-grip-vertical {
  --fa: "\\f58e";
  --fa--fa: "\\f58e\\f58e"; }

.fa-hexagon-nodes {
  --fa: "\\e699";
  --fa--fa: "\\e699\\e699"; }

.fa-arrow-turn-up {
  --fa: "\\f148";
  --fa--fa: "\\f148\\f148"; }

.fa-level-up {
  --fa: "\\f148";
  --fa--fa: "\\f148\\f148"; }

.fa-u {
  --fa: "\\55";
  --fa--fa: "\\55\\55"; }

.fa-square-root-variable {
  --fa: "\\f698";
  --fa--fa: "\\f698\\f698"; }

.fa-square-root-alt {
  --fa: "\\f698";
  --fa--fa: "\\f698\\f698"; }

.fa-clock {
  --fa: "\\f017";
  --fa--fa: "\\f017\\f017"; }

.fa-clock-four {
  --fa: "\\f017";
  --fa--fa: "\\f017\\f017"; }

.fa-backward-step {
  --fa: "\\f048";
  --fa--fa: "\\f048\\f048"; }

.fa-step-backward {
  --fa: "\\f048";
  --fa--fa: "\\f048\\f048"; }

.fa-pallet {
  --fa: "\\f482";
  --fa--fa: "\\f482\\f482"; }

.fa-faucet {
  --fa: "\\e005";
  --fa--fa: "\\e005\\e005"; }

.fa-baseball-bat-ball {
  --fa: "\\f432";
  --fa--fa: "\\f432\\f432"; }

.fa-s {
  --fa: "\\53";
  --fa--fa: "\\53\\53"; }

.fa-timeline {
  --fa: "\\e29c";
  --fa--fa: "\\e29c\\e29c"; }

.fa-keyboard {
  --fa: "\\f11c";
  --fa--fa: "\\f11c\\f11c"; }

.fa-caret-down {
  --fa: "\\f0d7";
  --fa--fa: "\\f0d7\\f0d7"; }

.fa-house-chimney-medical {
  --fa: "\\f7f2";
  --fa--fa: "\\f7f2\\f7f2"; }

.fa-clinic-medical {
  --fa: "\\f7f2";
  --fa--fa: "\\f7f2\\f7f2"; }

.fa-temperature-three-quarters {
  --fa: "\\f2c8";
  --fa--fa: "\\f2c8\\f2c8"; }

.fa-temperature-3 {
  --fa: "\\f2c8";
  --fa--fa: "\\f2c8\\f2c8"; }

.fa-thermometer-3 {
  --fa: "\\f2c8";
  --fa--fa: "\\f2c8\\f2c8"; }

.fa-thermometer-three-quarters {
  --fa: "\\f2c8";
  --fa--fa: "\\f2c8\\f2c8"; }

.fa-mobile-screen {
  --fa: "\\f3cf";
  --fa--fa: "\\f3cf\\f3cf"; }

.fa-mobile-android-alt {
  --fa: "\\f3cf";
  --fa--fa: "\\f3cf\\f3cf"; }

.fa-plane-up {
  --fa: "\\e22d";
  --fa--fa: "\\e22d\\e22d"; }

.fa-piggy-bank {
  --fa: "\\f4d3";
  --fa--fa: "\\f4d3\\f4d3"; }

.fa-battery-half {
  --fa: "\\f242";
  --fa--fa: "\\f242\\f242"; }

.fa-battery-3 {
  --fa: "\\f242";
  --fa--fa: "\\f242\\f242"; }

.fa-mountain-city {
  --fa: "\\e52e";
  --fa--fa: "\\e52e\\e52e"; }

.fa-coins {
  --fa: "\\f51e";
  --fa--fa: "\\f51e\\f51e"; }

.fa-khanda {
  --fa: "\\f66d";
  --fa--fa: "\\f66d\\f66d"; }

.fa-sliders {
  --fa: "\\f1de";
  --fa--fa: "\\f1de\\f1de"; }

.fa-sliders-h {
  --fa: "\\f1de";
  --fa--fa: "\\f1de\\f1de"; }

.fa-folder-tree {
  --fa: "\\f802";
  --fa--fa: "\\f802\\f802"; }

.fa-network-wired {
  --fa: "\\f6ff";
  --fa--fa: "\\f6ff\\f6ff"; }

.fa-map-pin {
  --fa: "\\f276";
  --fa--fa: "\\f276\\f276"; }

.fa-hamsa {
  --fa: "\\f665";
  --fa--fa: "\\f665\\f665"; }

.fa-cent-sign {
  --fa: "\\e3f5";
  --fa--fa: "\\e3f5\\e3f5"; }

.fa-flask {
  --fa: "\\f0c3";
  --fa--fa: "\\f0c3\\f0c3"; }

.fa-person-pregnant {
  --fa: "\\e31e";
  --fa--fa: "\\e31e\\e31e"; }

.fa-wand-sparkles {
  --fa: "\\f72b";
  --fa--fa: "\\f72b\\f72b"; }

.fa-ellipsis-vertical {
  --fa: "\\f142";
  --fa--fa: "\\f142\\f142"; }

.fa-ellipsis-v {
  --fa: "\\f142";
  --fa--fa: "\\f142\\f142"; }

.fa-ticket {
  --fa: "\\f145";
  --fa--fa: "\\f145\\f145"; }

.fa-power-off {
  --fa: "\\f011";
  --fa--fa: "\\f011\\f011"; }

.fa-right-long {
  --fa: "\\f30b";
  --fa--fa: "\\f30b\\f30b"; }

.fa-long-arrow-alt-right {
  --fa: "\\f30b";
  --fa--fa: "\\f30b\\f30b"; }

.fa-flag-usa {
  --fa: "\\f74d";
  --fa--fa: "\\f74d\\f74d"; }

.fa-laptop-file {
  --fa: "\\e51d";
  --fa--fa: "\\e51d\\e51d"; }

.fa-tty {
  --fa: "\\f1e4";
  --fa--fa: "\\f1e4\\f1e4"; }

.fa-teletype {
  --fa: "\\f1e4";
  --fa--fa: "\\f1e4\\f1e4"; }

.fa-diagram-next {
  --fa: "\\e476";
  --fa--fa: "\\e476\\e476"; }

.fa-person-rifle {
  --fa: "\\e54e";
  --fa--fa: "\\e54e\\e54e"; }

.fa-house-medical-circle-exclamation {
  --fa: "\\e512";
  --fa--fa: "\\e512\\e512"; }

.fa-closed-captioning {
  --fa: "\\f20a";
  --fa--fa: "\\f20a\\f20a"; }

.fa-person-hiking {
  --fa: "\\f6ec";
  --fa--fa: "\\f6ec\\f6ec"; }

.fa-hiking {
  --fa: "\\f6ec";
  --fa--fa: "\\f6ec\\f6ec"; }

.fa-venus-double {
  --fa: "\\f226";
  --fa--fa: "\\f226\\f226"; }

.fa-images {
  --fa: "\\f302";
  --fa--fa: "\\f302\\f302"; }

.fa-calculator {
  --fa: "\\f1ec";
  --fa--fa: "\\f1ec\\f1ec"; }

.fa-people-pulling {
  --fa: "\\e535";
  --fa--fa: "\\e535\\e535"; }

.fa-n {
  --fa: "\\4e";
  --fa--fa: "\\4e\\4e"; }

.fa-cable-car {
  --fa: "\\f7da";
  --fa--fa: "\\f7da\\f7da"; }

.fa-tram {
  --fa: "\\f7da";
  --fa--fa: "\\f7da\\f7da"; }

.fa-cloud-rain {
  --fa: "\\f73d";
  --fa--fa: "\\f73d\\f73d"; }

.fa-building-circle-xmark {
  --fa: "\\e4d4";
  --fa--fa: "\\e4d4\\e4d4"; }

.fa-ship {
  --fa: "\\f21a";
  --fa--fa: "\\f21a\\f21a"; }

.fa-arrows-down-to-line {
  --fa: "\\e4b8";
  --fa--fa: "\\e4b8\\e4b8"; }

.fa-download {
  --fa: "\\f019";
  --fa--fa: "\\f019\\f019"; }

.fa-face-grin {
  --fa: "\\f580";
  --fa--fa: "\\f580\\f580"; }

.fa-grin {
  --fa: "\\f580";
  --fa--fa: "\\f580\\f580"; }

.fa-delete-left {
  --fa: "\\f55a";
  --fa--fa: "\\f55a\\f55a"; }

.fa-backspace {
  --fa: "\\f55a";
  --fa--fa: "\\f55a\\f55a"; }

.fa-eye-dropper {
  --fa: "\\f1fb";
  --fa--fa: "\\f1fb\\f1fb"; }

.fa-eye-dropper-empty {
  --fa: "\\f1fb";
  --fa--fa: "\\f1fb\\f1fb"; }

.fa-eyedropper {
  --fa: "\\f1fb";
  --fa--fa: "\\f1fb\\f1fb"; }

.fa-file-circle-check {
  --fa: "\\e5a0";
  --fa--fa: "\\e5a0\\e5a0"; }

.fa-forward {
  --fa: "\\f04e";
  --fa--fa: "\\f04e\\f04e"; }

.fa-mobile {
  --fa: "\\f3ce";
  --fa--fa: "\\f3ce\\f3ce"; }

.fa-mobile-android {
  --fa: "\\f3ce";
  --fa--fa: "\\f3ce\\f3ce"; }

.fa-mobile-phone {
  --fa: "\\f3ce";
  --fa--fa: "\\f3ce\\f3ce"; }

.fa-face-meh {
  --fa: "\\f11a";
  --fa--fa: "\\f11a\\f11a"; }

.fa-meh {
  --fa: "\\f11a";
  --fa--fa: "\\f11a\\f11a"; }

.fa-align-center {
  --fa: "\\f037";
  --fa--fa: "\\f037\\f037"; }

.fa-book-skull {
  --fa: "\\f6b7";
  --fa--fa: "\\f6b7\\f6b7"; }

.fa-book-dead {
  --fa: "\\f6b7";
  --fa--fa: "\\f6b7\\f6b7"; }

.fa-id-card {
  --fa: "\\f2c2";
  --fa--fa: "\\f2c2\\f2c2"; }

.fa-drivers-license {
  --fa: "\\f2c2";
  --fa--fa: "\\f2c2\\f2c2"; }

.fa-outdent {
  --fa: "\\f03b";
  --fa--fa: "\\f03b\\f03b"; }

.fa-dedent {
  --fa: "\\f03b";
  --fa--fa: "\\f03b\\f03b"; }

.fa-heart-circle-exclamation {
  --fa: "\\e4fe";
  --fa--fa: "\\e4fe\\e4fe"; }

.fa-house {
  --fa: "\\f015";
  --fa--fa: "\\f015\\f015"; }

.fa-home {
  --fa: "\\f015";
  --fa--fa: "\\f015\\f015"; }

.fa-home-alt {
  --fa: "\\f015";
  --fa--fa: "\\f015\\f015"; }

.fa-home-lg-alt {
  --fa: "\\f015";
  --fa--fa: "\\f015\\f015"; }

.fa-calendar-week {
  --fa: "\\f784";
  --fa--fa: "\\f784\\f784"; }

.fa-laptop-medical {
  --fa: "\\f812";
  --fa--fa: "\\f812\\f812"; }

.fa-b {
  --fa: "\\42";
  --fa--fa: "\\42\\42"; }

.fa-file-medical {
  --fa: "\\f477";
  --fa--fa: "\\f477\\f477"; }

.fa-dice-one {
  --fa: "\\f525";
  --fa--fa: "\\f525\\f525"; }

.fa-kiwi-bird {
  --fa: "\\f535";
  --fa--fa: "\\f535\\f535"; }

.fa-arrow-right-arrow-left {
  --fa: "\\f0ec";
  --fa--fa: "\\f0ec\\f0ec"; }

.fa-exchange {
  --fa: "\\f0ec";
  --fa--fa: "\\f0ec\\f0ec"; }

.fa-rotate-right {
  --fa: "\\f2f9";
  --fa--fa: "\\f2f9\\f2f9"; }

.fa-redo-alt {
  --fa: "\\f2f9";
  --fa--fa: "\\f2f9\\f2f9"; }

.fa-rotate-forward {
  --fa: "\\f2f9";
  --fa--fa: "\\f2f9\\f2f9"; }

.fa-utensils {
  --fa: "\\f2e7";
  --fa--fa: "\\f2e7\\f2e7"; }

.fa-cutlery {
  --fa: "\\f2e7";
  --fa--fa: "\\f2e7\\f2e7"; }

.fa-arrow-up-wide-short {
  --fa: "\\f161";
  --fa--fa: "\\f161\\f161"; }

.fa-sort-amount-up {
  --fa: "\\f161";
  --fa--fa: "\\f161\\f161"; }

.fa-mill-sign {
  --fa: "\\e1ed";
  --fa--fa: "\\e1ed\\e1ed"; }

.fa-bowl-rice {
  --fa: "\\e2eb";
  --fa--fa: "\\e2eb\\e2eb"; }

.fa-skull {
  --fa: "\\f54c";
  --fa--fa: "\\f54c\\f54c"; }

.fa-tower-broadcast {
  --fa: "\\f519";
  --fa--fa: "\\f519\\f519"; }

.fa-broadcast-tower {
  --fa: "\\f519";
  --fa--fa: "\\f519\\f519"; }

.fa-truck-pickup {
  --fa: "\\f63c";
  --fa--fa: "\\f63c\\f63c"; }

.fa-up-long {
  --fa: "\\f30c";
  --fa--fa: "\\f30c\\f30c"; }

.fa-long-arrow-alt-up {
  --fa: "\\f30c";
  --fa--fa: "\\f30c\\f30c"; }

.fa-stop {
  --fa: "\\f04d";
  --fa--fa: "\\f04d\\f04d"; }

.fa-code-merge {
  --fa: "\\f387";
  --fa--fa: "\\f387\\f387"; }

.fa-upload {
  --fa: "\\f093";
  --fa--fa: "\\f093\\f093"; }

.fa-hurricane {
  --fa: "\\f751";
  --fa--fa: "\\f751\\f751"; }

.fa-mound {
  --fa: "\\e52d";
  --fa--fa: "\\e52d\\e52d"; }

.fa-toilet-portable {
  --fa: "\\e583";
  --fa--fa: "\\e583\\e583"; }

.fa-compact-disc {
  --fa: "\\f51f";
  --fa--fa: "\\f51f\\f51f"; }

.fa-file-arrow-down {
  --fa: "\\f56d";
  --fa--fa: "\\f56d\\f56d"; }

.fa-file-download {
  --fa: "\\f56d";
  --fa--fa: "\\f56d\\f56d"; }

.fa-caravan {
  --fa: "\\f8ff";
  --fa--fa: "\\f8ff\\f8ff"; }

.fa-shield-cat {
  --fa: "\\e572";
  --fa--fa: "\\e572\\e572"; }

.fa-bolt {
  --fa: "\\f0e7";
  --fa--fa: "\\f0e7\\f0e7"; }

.fa-zap {
  --fa: "\\f0e7";
  --fa--fa: "\\f0e7\\f0e7"; }

.fa-glass-water {
  --fa: "\\e4f4";
  --fa--fa: "\\e4f4\\e4f4"; }

.fa-oil-well {
  --fa: "\\e532";
  --fa--fa: "\\e532\\e532"; }

.fa-vault {
  --fa: "\\e2c5";
  --fa--fa: "\\e2c5\\e2c5"; }

.fa-mars {
  --fa: "\\f222";
  --fa--fa: "\\f222\\f222"; }

.fa-toilet {
  --fa: "\\f7d8";
  --fa--fa: "\\f7d8\\f7d8"; }

.fa-plane-circle-xmark {
  --fa: "\\e557";
  --fa--fa: "\\e557\\e557"; }

.fa-yen-sign {
  --fa: "\\f157";
  --fa--fa: "\\f157\\f157"; }

.fa-cny {
  --fa: "\\f157";
  --fa--fa: "\\f157\\f157"; }

.fa-jpy {
  --fa: "\\f157";
  --fa--fa: "\\f157\\f157"; }

.fa-rmb {
  --fa: "\\f157";
  --fa--fa: "\\f157\\f157"; }

.fa-yen {
  --fa: "\\f157";
  --fa--fa: "\\f157\\f157"; }

.fa-ruble-sign {
  --fa: "\\f158";
  --fa--fa: "\\f158\\f158"; }

.fa-rouble {
  --fa: "\\f158";
  --fa--fa: "\\f158\\f158"; }

.fa-rub {
  --fa: "\\f158";
  --fa--fa: "\\f158\\f158"; }

.fa-ruble {
  --fa: "\\f158";
  --fa--fa: "\\f158\\f158"; }

.fa-sun {
  --fa: "\\f185";
  --fa--fa: "\\f185\\f185"; }

.fa-guitar {
  --fa: "\\f7a6";
  --fa--fa: "\\f7a6\\f7a6"; }

.fa-face-laugh-wink {
  --fa: "\\f59c";
  --fa--fa: "\\f59c\\f59c"; }

.fa-laugh-wink {
  --fa: "\\f59c";
  --fa--fa: "\\f59c\\f59c"; }

.fa-horse-head {
  --fa: "\\f7ab";
  --fa--fa: "\\f7ab\\f7ab"; }

.fa-bore-hole {
  --fa: "\\e4c3";
  --fa--fa: "\\e4c3\\e4c3"; }

.fa-industry {
  --fa: "\\f275";
  --fa--fa: "\\f275\\f275"; }

.fa-circle-down {
  --fa: "\\f358";
  --fa--fa: "\\f358\\f358"; }

.fa-arrow-alt-circle-down {
  --fa: "\\f358";
  --fa--fa: "\\f358\\f358"; }

.fa-arrows-turn-to-dots {
  --fa: "\\e4c1";
  --fa--fa: "\\e4c1\\e4c1"; }

.fa-florin-sign {
  --fa: "\\e184";
  --fa--fa: "\\e184\\e184"; }

.fa-arrow-down-short-wide {
  --fa: "\\f884";
  --fa--fa: "\\f884\\f884"; }

.fa-sort-amount-desc {
  --fa: "\\f884";
  --fa--fa: "\\f884\\f884"; }

.fa-sort-amount-down-alt {
  --fa: "\\f884";
  --fa--fa: "\\f884\\f884"; }

.fa-less-than {
  --fa: "\\3c";
  --fa--fa: "\\3c\\3c"; }

.fa-angle-down {
  --fa: "\\f107";
  --fa--fa: "\\f107\\f107"; }

.fa-car-tunnel {
  --fa: "\\e4de";
  --fa--fa: "\\e4de\\e4de"; }

.fa-head-side-cough {
  --fa: "\\e061";
  --fa--fa: "\\e061\\e061"; }

.fa-grip-lines {
  --fa: "\\f7a4";
  --fa--fa: "\\f7a4\\f7a4"; }

.fa-thumbs-down {
  --fa: "\\f165";
  --fa--fa: "\\f165\\f165"; }

.fa-user-lock {
  --fa: "\\f502";
  --fa--fa: "\\f502\\f502"; }

.fa-arrow-right-long {
  --fa: "\\f178";
  --fa--fa: "\\f178\\f178"; }

.fa-long-arrow-right {
  --fa: "\\f178";
  --fa--fa: "\\f178\\f178"; }

.fa-anchor-circle-xmark {
  --fa: "\\e4ac";
  --fa--fa: "\\e4ac\\e4ac"; }

.fa-ellipsis {
  --fa: "\\f141";
  --fa--fa: "\\f141\\f141"; }

.fa-ellipsis-h {
  --fa: "\\f141";
  --fa--fa: "\\f141\\f141"; }

.fa-chess-pawn {
  --fa: "\\f443";
  --fa--fa: "\\f443\\f443"; }

.fa-kit-medical {
  --fa: "\\f479";
  --fa--fa: "\\f479\\f479"; }

.fa-first-aid {
  --fa: "\\f479";
  --fa--fa: "\\f479\\f479"; }

.fa-person-through-window {
  --fa: "\\e5a9";
  --fa--fa: "\\e5a9\\e5a9"; }

.fa-toolbox {
  --fa: "\\f552";
  --fa--fa: "\\f552\\f552"; }

.fa-hands-holding-circle {
  --fa: "\\e4fb";
  --fa--fa: "\\e4fb\\e4fb"; }

.fa-bug {
  --fa: "\\f188";
  --fa--fa: "\\f188\\f188"; }

.fa-credit-card {
  --fa: "\\f09d";
  --fa--fa: "\\f09d\\f09d"; }

.fa-credit-card-alt {
  --fa: "\\f09d";
  --fa--fa: "\\f09d\\f09d"; }

.fa-car {
  --fa: "\\f1b9";
  --fa--fa: "\\f1b9\\f1b9"; }

.fa-automobile {
  --fa: "\\f1b9";
  --fa--fa: "\\f1b9\\f1b9"; }

.fa-hand-holding-hand {
  --fa: "\\e4f7";
  --fa--fa: "\\e4f7\\e4f7"; }

.fa-book-open-reader {
  --fa: "\\f5da";
  --fa--fa: "\\f5da\\f5da"; }

.fa-book-reader {
  --fa: "\\f5da";
  --fa--fa: "\\f5da\\f5da"; }

.fa-mountain-sun {
  --fa: "\\e52f";
  --fa--fa: "\\e52f\\e52f"; }

.fa-arrows-left-right-to-line {
  --fa: "\\e4ba";
  --fa--fa: "\\e4ba\\e4ba"; }

.fa-dice-d20 {
  --fa: "\\f6cf";
  --fa--fa: "\\f6cf\\f6cf"; }

.fa-truck-droplet {
  --fa: "\\e58c";
  --fa--fa: "\\e58c\\e58c"; }

.fa-file-circle-xmark {
  --fa: "\\e5a1";
  --fa--fa: "\\e5a1\\e5a1"; }

.fa-temperature-arrow-up {
  --fa: "\\e040";
  --fa--fa: "\\e040\\e040"; }

.fa-temperature-up {
  --fa: "\\e040";
  --fa--fa: "\\e040\\e040"; }

.fa-medal {
  --fa: "\\f5a2";
  --fa--fa: "\\f5a2\\f5a2"; }

.fa-bed {
  --fa: "\\f236";
  --fa--fa: "\\f236\\f236"; }

.fa-square-h {
  --fa: "\\f0fd";
  --fa--fa: "\\f0fd\\f0fd"; }

.fa-h-square {
  --fa: "\\f0fd";
  --fa--fa: "\\f0fd\\f0fd"; }

.fa-podcast {
  --fa: "\\f2ce";
  --fa--fa: "\\f2ce\\f2ce"; }

.fa-temperature-full {
  --fa: "\\f2c7";
  --fa--fa: "\\f2c7\\f2c7"; }

.fa-temperature-4 {
  --fa: "\\f2c7";
  --fa--fa: "\\f2c7\\f2c7"; }

.fa-thermometer-4 {
  --fa: "\\f2c7";
  --fa--fa: "\\f2c7\\f2c7"; }

.fa-thermometer-full {
  --fa: "\\f2c7";
  --fa--fa: "\\f2c7\\f2c7"; }

.fa-bell {
  --fa: "\\f0f3";
  --fa--fa: "\\f0f3\\f0f3"; }

.fa-superscript {
  --fa: "\\f12b";
  --fa--fa: "\\f12b\\f12b"; }

.fa-plug-circle-xmark {
  --fa: "\\e560";
  --fa--fa: "\\e560\\e560"; }

.fa-star-of-life {
  --fa: "\\f621";
  --fa--fa: "\\f621\\f621"; }

.fa-phone-slash {
  --fa: "\\f3dd";
  --fa--fa: "\\f3dd\\f3dd"; }

.fa-paint-roller {
  --fa: "\\f5aa";
  --fa--fa: "\\f5aa\\f5aa"; }

.fa-handshake-angle {
  --fa: "\\f4c4";
  --fa--fa: "\\f4c4\\f4c4"; }

.fa-hands-helping {
  --fa: "\\f4c4";
  --fa--fa: "\\f4c4\\f4c4"; }

.fa-location-dot {
  --fa: "\\f3c5";
  --fa--fa: "\\f3c5\\f3c5"; }

.fa-map-marker-alt {
  --fa: "\\f3c5";
  --fa--fa: "\\f3c5\\f3c5"; }

.fa-file {
  --fa: "\\f15b";
  --fa--fa: "\\f15b\\f15b"; }

.fa-greater-than {
  --fa: "\\3e";
  --fa--fa: "\\3e\\3e"; }

.fa-person-swimming {
  --fa: "\\f5c4";
  --fa--fa: "\\f5c4\\f5c4"; }

.fa-swimmer {
  --fa: "\\f5c4";
  --fa--fa: "\\f5c4\\f5c4"; }

.fa-arrow-down {
  --fa: "\\f063";
  --fa--fa: "\\f063\\f063"; }

.fa-droplet {
  --fa: "\\f043";
  --fa--fa: "\\f043\\f043"; }

.fa-tint {
  --fa: "\\f043";
  --fa--fa: "\\f043\\f043"; }

.fa-eraser {
  --fa: "\\f12d";
  --fa--fa: "\\f12d\\f12d"; }

.fa-earth-americas {
  --fa: "\\f57d";
  --fa--fa: "\\f57d\\f57d"; }

.fa-earth {
  --fa: "\\f57d";
  --fa--fa: "\\f57d\\f57d"; }

.fa-earth-america {
  --fa: "\\f57d";
  --fa--fa: "\\f57d\\f57d"; }

.fa-globe-americas {
  --fa: "\\f57d";
  --fa--fa: "\\f57d\\f57d"; }

.fa-person-burst {
  --fa: "\\e53b";
  --fa--fa: "\\e53b\\e53b"; }

.fa-dove {
  --fa: "\\f4ba";
  --fa--fa: "\\f4ba\\f4ba"; }

.fa-battery-empty {
  --fa: "\\f244";
  --fa--fa: "\\f244\\f244"; }

.fa-battery-0 {
  --fa: "\\f244";
  --fa--fa: "\\f244\\f244"; }

.fa-socks {
  --fa: "\\f696";
  --fa--fa: "\\f696\\f696"; }

.fa-inbox {
  --fa: "\\f01c";
  --fa--fa: "\\f01c\\f01c"; }

.fa-section {
  --fa: "\\e447";
  --fa--fa: "\\e447\\e447"; }

.fa-gauge-high {
  --fa: "\\f625";
  --fa--fa: "\\f625\\f625"; }

.fa-tachometer-alt {
  --fa: "\\f625";
  --fa--fa: "\\f625\\f625"; }

.fa-tachometer-alt-fast {
  --fa: "\\f625";
  --fa--fa: "\\f625\\f625"; }

.fa-envelope-open-text {
  --fa: "\\f658";
  --fa--fa: "\\f658\\f658"; }

.fa-hospital {
  --fa: "\\f0f8";
  --fa--fa: "\\f0f8\\f0f8"; }

.fa-hospital-alt {
  --fa: "\\f0f8";
  --fa--fa: "\\f0f8\\f0f8"; }

.fa-hospital-wide {
  --fa: "\\f0f8";
  --fa--fa: "\\f0f8\\f0f8"; }

.fa-wine-bottle {
  --fa: "\\f72f";
  --fa--fa: "\\f72f\\f72f"; }

.fa-chess-rook {
  --fa: "\\f447";
  --fa--fa: "\\f447\\f447"; }

.fa-bars-staggered {
  --fa: "\\f550";
  --fa--fa: "\\f550\\f550"; }

.fa-reorder {
  --fa: "\\f550";
  --fa--fa: "\\f550\\f550"; }

.fa-stream {
  --fa: "\\f550";
  --fa--fa: "\\f550\\f550"; }

.fa-dharmachakra {
  --fa: "\\f655";
  --fa--fa: "\\f655\\f655"; }

.fa-hotdog {
  --fa: "\\f80f";
  --fa--fa: "\\f80f\\f80f"; }

.fa-person-walking-with-cane {
  --fa: "\\f29d";
  --fa--fa: "\\f29d\\f29d"; }

.fa-blind {
  --fa: "\\f29d";
  --fa--fa: "\\f29d\\f29d"; }

.fa-drum {
  --fa: "\\f569";
  --fa--fa: "\\f569\\f569"; }

.fa-ice-cream {
  --fa: "\\f810";
  --fa--fa: "\\f810\\f810"; }

.fa-heart-circle-bolt {
  --fa: "\\e4fc";
  --fa--fa: "\\e4fc\\e4fc"; }

.fa-fax {
  --fa: "\\f1ac";
  --fa--fa: "\\f1ac\\f1ac"; }

.fa-paragraph {
  --fa: "\\f1dd";
  --fa--fa: "\\f1dd\\f1dd"; }

.fa-check-to-slot {
  --fa: "\\f772";
  --fa--fa: "\\f772\\f772"; }

.fa-vote-yea {
  --fa: "\\f772";
  --fa--fa: "\\f772\\f772"; }

.fa-star-half {
  --fa: "\\f089";
  --fa--fa: "\\f089\\f089"; }

.fa-boxes-stacked {
  --fa: "\\f468";
  --fa--fa: "\\f468\\f468"; }

.fa-boxes {
  --fa: "\\f468";
  --fa--fa: "\\f468\\f468"; }

.fa-boxes-alt {
  --fa: "\\f468";
  --fa--fa: "\\f468\\f468"; }

.fa-link {
  --fa: "\\f0c1";
  --fa--fa: "\\f0c1\\f0c1"; }

.fa-chain {
  --fa: "\\f0c1";
  --fa--fa: "\\f0c1\\f0c1"; }

.fa-ear-listen {
  --fa: "\\f2a2";
  --fa--fa: "\\f2a2\\f2a2"; }

.fa-assistive-listening-systems {
  --fa: "\\f2a2";
  --fa--fa: "\\f2a2\\f2a2"; }

.fa-tree-city {
  --fa: "\\e587";
  --fa--fa: "\\e587\\e587"; }

.fa-play {
  --fa: "\\f04b";
  --fa--fa: "\\f04b\\f04b"; }

.fa-font {
  --fa: "\\f031";
  --fa--fa: "\\f031\\f031"; }

.fa-table-cells-row-lock {
  --fa: "\\e67a";
  --fa--fa: "\\e67a\\e67a"; }

.fa-rupiah-sign {
  --fa: "\\e23d";
  --fa--fa: "\\e23d\\e23d"; }

.fa-magnifying-glass {
  --fa: "\\f002";
  --fa--fa: "\\f002\\f002"; }

.fa-search {
  --fa: "\\f002";
  --fa--fa: "\\f002\\f002"; }

.fa-table-tennis-paddle-ball {
  --fa: "\\f45d";
  --fa--fa: "\\f45d\\f45d"; }

.fa-ping-pong-paddle-ball {
  --fa: "\\f45d";
  --fa--fa: "\\f45d\\f45d"; }

.fa-table-tennis {
  --fa: "\\f45d";
  --fa--fa: "\\f45d\\f45d"; }

.fa-person-dots-from-line {
  --fa: "\\f470";
  --fa--fa: "\\f470\\f470"; }

.fa-diagnoses {
  --fa: "\\f470";
  --fa--fa: "\\f470\\f470"; }

.fa-trash-can-arrow-up {
  --fa: "\\f82a";
  --fa--fa: "\\f82a\\f82a"; }

.fa-trash-restore-alt {
  --fa: "\\f82a";
  --fa--fa: "\\f82a\\f82a"; }

.fa-naira-sign {
  --fa: "\\e1f6";
  --fa--fa: "\\e1f6\\e1f6"; }

.fa-cart-arrow-down {
  --fa: "\\f218";
  --fa--fa: "\\f218\\f218"; }

.fa-walkie-talkie {
  --fa: "\\f8ef";
  --fa--fa: "\\f8ef\\f8ef"; }

.fa-file-pen {
  --fa: "\\f31c";
  --fa--fa: "\\f31c\\f31c"; }

.fa-file-edit {
  --fa: "\\f31c";
  --fa--fa: "\\f31c\\f31c"; }

.fa-receipt {
  --fa: "\\f543";
  --fa--fa: "\\f543\\f543"; }

.fa-square-pen {
  --fa: "\\f14b";
  --fa--fa: "\\f14b\\f14b"; }

.fa-pen-square {
  --fa: "\\f14b";
  --fa--fa: "\\f14b\\f14b"; }

.fa-pencil-square {
  --fa: "\\f14b";
  --fa--fa: "\\f14b\\f14b"; }

.fa-suitcase-rolling {
  --fa: "\\f5c1";
  --fa--fa: "\\f5c1\\f5c1"; }

.fa-person-circle-exclamation {
  --fa: "\\e53f";
  --fa--fa: "\\e53f\\e53f"; }

.fa-chevron-down {
  --fa: "\\f078";
  --fa--fa: "\\f078\\f078"; }

.fa-battery-full {
  --fa: "\\f240";
  --fa--fa: "\\f240\\f240"; }

.fa-battery {
  --fa: "\\f240";
  --fa--fa: "\\f240\\f240"; }

.fa-battery-5 {
  --fa: "\\f240";
  --fa--fa: "\\f240\\f240"; }

.fa-skull-crossbones {
  --fa: "\\f714";
  --fa--fa: "\\f714\\f714"; }

.fa-code-compare {
  --fa: "\\e13a";
  --fa--fa: "\\e13a\\e13a"; }

.fa-list-ul {
  --fa: "\\f0ca";
  --fa--fa: "\\f0ca\\f0ca"; }

.fa-list-dots {
  --fa: "\\f0ca";
  --fa--fa: "\\f0ca\\f0ca"; }

.fa-school-lock {
  --fa: "\\e56f";
  --fa--fa: "\\e56f\\e56f"; }

.fa-tower-cell {
  --fa: "\\e585";
  --fa--fa: "\\e585\\e585"; }

.fa-down-long {
  --fa: "\\f309";
  --fa--fa: "\\f309\\f309"; }

.fa-long-arrow-alt-down {
  --fa: "\\f309";
  --fa--fa: "\\f309\\f309"; }

.fa-ranking-star {
  --fa: "\\e561";
  --fa--fa: "\\e561\\e561"; }

.fa-chess-king {
  --fa: "\\f43f";
  --fa--fa: "\\f43f\\f43f"; }

.fa-person-harassing {
  --fa: "\\e549";
  --fa--fa: "\\e549\\e549"; }

.fa-brazilian-real-sign {
  --fa: "\\e46c";
  --fa--fa: "\\e46c\\e46c"; }

.fa-landmark-dome {
  --fa: "\\f752";
  --fa--fa: "\\f752\\f752"; }

.fa-landmark-alt {
  --fa: "\\f752";
  --fa--fa: "\\f752\\f752"; }

.fa-arrow-up {
  --fa: "\\f062";
  --fa--fa: "\\f062\\f062"; }

.fa-tv {
  --fa: "\\f26c";
  --fa--fa: "\\f26c\\f26c"; }

.fa-television {
  --fa: "\\f26c";
  --fa--fa: "\\f26c\\f26c"; }

.fa-tv-alt {
  --fa: "\\f26c";
  --fa--fa: "\\f26c\\f26c"; }

.fa-shrimp {
  --fa: "\\e448";
  --fa--fa: "\\e448\\e448"; }

.fa-list-check {
  --fa: "\\f0ae";
  --fa--fa: "\\f0ae\\f0ae"; }

.fa-tasks {
  --fa: "\\f0ae";
  --fa--fa: "\\f0ae\\f0ae"; }

.fa-jug-detergent {
  --fa: "\\e519";
  --fa--fa: "\\e519\\e519"; }

.fa-circle-user {
  --fa: "\\f2bd";
  --fa--fa: "\\f2bd\\f2bd"; }

.fa-user-circle {
  --fa: "\\f2bd";
  --fa--fa: "\\f2bd\\f2bd"; }

.fa-user-shield {
  --fa: "\\f505";
  --fa--fa: "\\f505\\f505"; }

.fa-wind {
  --fa: "\\f72e";
  --fa--fa: "\\f72e\\f72e"; }

.fa-car-burst {
  --fa: "\\f5e1";
  --fa--fa: "\\f5e1\\f5e1"; }

.fa-car-crash {
  --fa: "\\f5e1";
  --fa--fa: "\\f5e1\\f5e1"; }

.fa-y {
  --fa: "\\59";
  --fa--fa: "\\59\\59"; }

.fa-person-snowboarding {
  --fa: "\\f7ce";
  --fa--fa: "\\f7ce\\f7ce"; }

.fa-snowboarding {
  --fa: "\\f7ce";
  --fa--fa: "\\f7ce\\f7ce"; }

.fa-truck-fast {
  --fa: "\\f48b";
  --fa--fa: "\\f48b\\f48b"; }

.fa-shipping-fast {
  --fa: "\\f48b";
  --fa--fa: "\\f48b\\f48b"; }

.fa-fish {
  --fa: "\\f578";
  --fa--fa: "\\f578\\f578"; }

.fa-user-graduate {
  --fa: "\\f501";
  --fa--fa: "\\f501\\f501"; }

.fa-circle-half-stroke {
  --fa: "\\f042";
  --fa--fa: "\\f042\\f042"; }

.fa-adjust {
  --fa: "\\f042";
  --fa--fa: "\\f042\\f042"; }

.fa-clapperboard {
  --fa: "\\e131";
  --fa--fa: "\\e131\\e131"; }

.fa-circle-radiation {
  --fa: "\\f7ba";
  --fa--fa: "\\f7ba\\f7ba"; }

.fa-radiation-alt {
  --fa: "\\f7ba";
  --fa--fa: "\\f7ba\\f7ba"; }

.fa-baseball {
  --fa: "\\f433";
  --fa--fa: "\\f433\\f433"; }

.fa-baseball-ball {
  --fa: "\\f433";
  --fa--fa: "\\f433\\f433"; }

.fa-jet-fighter-up {
  --fa: "\\e518";
  --fa--fa: "\\e518\\e518"; }

.fa-diagram-project {
  --fa: "\\f542";
  --fa--fa: "\\f542\\f542"; }

.fa-project-diagram {
  --fa: "\\f542";
  --fa--fa: "\\f542\\f542"; }

.fa-copy {
  --fa: "\\f0c5";
  --fa--fa: "\\f0c5\\f0c5"; }

.fa-volume-xmark {
  --fa: "\\f6a9";
  --fa--fa: "\\f6a9\\f6a9"; }

.fa-volume-mute {
  --fa: "\\f6a9";
  --fa--fa: "\\f6a9\\f6a9"; }

.fa-volume-times {
  --fa: "\\f6a9";
  --fa--fa: "\\f6a9\\f6a9"; }

.fa-hand-sparkles {
  --fa: "\\e05d";
  --fa--fa: "\\e05d\\e05d"; }

.fa-grip {
  --fa: "\\f58d";
  --fa--fa: "\\f58d\\f58d"; }

.fa-grip-horizontal {
  --fa: "\\f58d";
  --fa--fa: "\\f58d\\f58d"; }

.fa-share-from-square {
  --fa: "\\f14d";
  --fa--fa: "\\f14d\\f14d"; }

.fa-share-square {
  --fa: "\\f14d";
  --fa--fa: "\\f14d\\f14d"; }

.fa-child-combatant {
  --fa: "\\e4e0";
  --fa--fa: "\\e4e0\\e4e0"; }

.fa-child-rifle {
  --fa: "\\e4e0";
  --fa--fa: "\\e4e0\\e4e0"; }

.fa-gun {
  --fa: "\\e19b";
  --fa--fa: "\\e19b\\e19b"; }

.fa-square-phone {
  --fa: "\\f098";
  --fa--fa: "\\f098\\f098"; }

.fa-phone-square {
  --fa: "\\f098";
  --fa--fa: "\\f098\\f098"; }

.fa-plus {
  --fa: "\\2b";
  --fa--fa: "\\2b\\2b"; }

.fa-add {
  --fa: "\\2b";
  --fa--fa: "\\2b\\2b"; }

.fa-expand {
  --fa: "\\f065";
  --fa--fa: "\\f065\\f065"; }

.fa-computer {
  --fa: "\\e4e5";
  --fa--fa: "\\e4e5\\e4e5"; }

.fa-xmark {
  --fa: "\\f00d";
  --fa--fa: "\\f00d\\f00d"; }

.fa-close {
  --fa: "\\f00d";
  --fa--fa: "\\f00d\\f00d"; }

.fa-multiply {
  --fa: "\\f00d";
  --fa--fa: "\\f00d\\f00d"; }

.fa-remove {
  --fa: "\\f00d";
  --fa--fa: "\\f00d\\f00d"; }

.fa-times {
  --fa: "\\f00d";
  --fa--fa: "\\f00d\\f00d"; }

.fa-arrows-up-down-left-right {
  --fa: "\\f047";
  --fa--fa: "\\f047\\f047"; }

.fa-arrows {
  --fa: "\\f047";
  --fa--fa: "\\f047\\f047"; }

.fa-chalkboard-user {
  --fa: "\\f51c";
  --fa--fa: "\\f51c\\f51c"; }

.fa-chalkboard-teacher {
  --fa: "\\f51c";
  --fa--fa: "\\f51c\\f51c"; }

.fa-peso-sign {
  --fa: "\\e222";
  --fa--fa: "\\e222\\e222"; }

.fa-building-shield {
  --fa: "\\e4d8";
  --fa--fa: "\\e4d8\\e4d8"; }

.fa-baby {
  --fa: "\\f77c";
  --fa--fa: "\\f77c\\f77c"; }

.fa-users-line {
  --fa: "\\e592";
  --fa--fa: "\\e592\\e592"; }

.fa-quote-left {
  --fa: "\\f10d";
  --fa--fa: "\\f10d\\f10d"; }

.fa-quote-left-alt {
  --fa: "\\f10d";
  --fa--fa: "\\f10d\\f10d"; }

.fa-tractor {
  --fa: "\\f722";
  --fa--fa: "\\f722\\f722"; }

.fa-trash-arrow-up {
  --fa: "\\f829";
  --fa--fa: "\\f829\\f829"; }

.fa-trash-restore {
  --fa: "\\f829";
  --fa--fa: "\\f829\\f829"; }

.fa-arrow-down-up-lock {
  --fa: "\\e4b0";
  --fa--fa: "\\e4b0\\e4b0"; }

.fa-lines-leaning {
  --fa: "\\e51e";
  --fa--fa: "\\e51e\\e51e"; }

.fa-ruler-combined {
  --fa: "\\f546";
  --fa--fa: "\\f546\\f546"; }

.fa-copyright {
  --fa: "\\f1f9";
  --fa--fa: "\\f1f9\\f1f9"; }

.fa-equals {
  --fa: "\\3d";
  --fa--fa: "\\3d\\3d"; }

.fa-blender {
  --fa: "\\f517";
  --fa--fa: "\\f517\\f517"; }

.fa-teeth {
  --fa: "\\f62e";
  --fa--fa: "\\f62e\\f62e"; }

.fa-shekel-sign {
  --fa: "\\f20b";
  --fa--fa: "\\f20b\\f20b"; }

.fa-ils {
  --fa: "\\f20b";
  --fa--fa: "\\f20b\\f20b"; }

.fa-shekel {
  --fa: "\\f20b";
  --fa--fa: "\\f20b\\f20b"; }

.fa-sheqel {
  --fa: "\\f20b";
  --fa--fa: "\\f20b\\f20b"; }

.fa-sheqel-sign {
  --fa: "\\f20b";
  --fa--fa: "\\f20b\\f20b"; }

.fa-map {
  --fa: "\\f279";
  --fa--fa: "\\f279\\f279"; }

.fa-rocket {
  --fa: "\\f135";
  --fa--fa: "\\f135\\f135"; }

.fa-photo-film {
  --fa: "\\f87c";
  --fa--fa: "\\f87c\\f87c"; }

.fa-photo-video {
  --fa: "\\f87c";
  --fa--fa: "\\f87c\\f87c"; }

.fa-folder-minus {
  --fa: "\\f65d";
  --fa--fa: "\\f65d\\f65d"; }

.fa-hexagon-nodes-bolt {
  --fa: "\\e69a";
  --fa--fa: "\\e69a\\e69a"; }

.fa-store {
  --fa: "\\f54e";
  --fa--fa: "\\f54e\\f54e"; }

.fa-arrow-trend-up {
  --fa: "\\e098";
  --fa--fa: "\\e098\\e098"; }

.fa-plug-circle-minus {
  --fa: "\\e55e";
  --fa--fa: "\\e55e\\e55e"; }

.fa-sign-hanging {
  --fa: "\\f4d9";
  --fa--fa: "\\f4d9\\f4d9"; }

.fa-sign {
  --fa: "\\f4d9";
  --fa--fa: "\\f4d9\\f4d9"; }

.fa-bezier-curve {
  --fa: "\\f55b";
  --fa--fa: "\\f55b\\f55b"; }

.fa-bell-slash {
  --fa: "\\f1f6";
  --fa--fa: "\\f1f6\\f1f6"; }

.fa-tablet {
  --fa: "\\f3fb";
  --fa--fa: "\\f3fb\\f3fb"; }

.fa-tablet-android {
  --fa: "\\f3fb";
  --fa--fa: "\\f3fb\\f3fb"; }

.fa-school-flag {
  --fa: "\\e56e";
  --fa--fa: "\\e56e\\e56e"; }

.fa-fill {
  --fa: "\\f575";
  --fa--fa: "\\f575\\f575"; }

.fa-angle-up {
  --fa: "\\f106";
  --fa--fa: "\\f106\\f106"; }

.fa-drumstick-bite {
  --fa: "\\f6d7";
  --fa--fa: "\\f6d7\\f6d7"; }

.fa-holly-berry {
  --fa: "\\f7aa";
  --fa--fa: "\\f7aa\\f7aa"; }

.fa-chevron-left {
  --fa: "\\f053";
  --fa--fa: "\\f053\\f053"; }

.fa-bacteria {
  --fa: "\\e059";
  --fa--fa: "\\e059\\e059"; }

.fa-hand-lizard {
  --fa: "\\f258";
  --fa--fa: "\\f258\\f258"; }

.fa-notdef {
  --fa: "\\e1fe";
  --fa--fa: "\\e1fe\\e1fe"; }

.fa-disease {
  --fa: "\\f7fa";
  --fa--fa: "\\f7fa\\f7fa"; }

.fa-briefcase-medical {
  --fa: "\\f469";
  --fa--fa: "\\f469\\f469"; }

.fa-genderless {
  --fa: "\\f22d";
  --fa--fa: "\\f22d\\f22d"; }

.fa-chevron-right {
  --fa: "\\f054";
  --fa--fa: "\\f054\\f054"; }

.fa-retweet {
  --fa: "\\f079";
  --fa--fa: "\\f079\\f079"; }

.fa-car-rear {
  --fa: "\\f5de";
  --fa--fa: "\\f5de\\f5de"; }

.fa-car-alt {
  --fa: "\\f5de";
  --fa--fa: "\\f5de\\f5de"; }

.fa-pump-soap {
  --fa: "\\e06b";
  --fa--fa: "\\e06b\\e06b"; }

.fa-video-slash {
  --fa: "\\f4e2";
  --fa--fa: "\\f4e2\\f4e2"; }

.fa-battery-quarter {
  --fa: "\\f243";
  --fa--fa: "\\f243\\f243"; }

.fa-battery-2 {
  --fa: "\\f243";
  --fa--fa: "\\f243\\f243"; }

.fa-radio {
  --fa: "\\f8d7";
  --fa--fa: "\\f8d7\\f8d7"; }

.fa-baby-carriage {
  --fa: "\\f77d";
  --fa--fa: "\\f77d\\f77d"; }

.fa-carriage-baby {
  --fa: "\\f77d";
  --fa--fa: "\\f77d\\f77d"; }

.fa-traffic-light {
  --fa: "\\f637";
  --fa--fa: "\\f637\\f637"; }

.fa-thermometer {
  --fa: "\\f491";
  --fa--fa: "\\f491\\f491"; }

.fa-vr-cardboard {
  --fa: "\\f729";
  --fa--fa: "\\f729\\f729"; }

.fa-hand-middle-finger {
  --fa: "\\f806";
  --fa--fa: "\\f806\\f806"; }

.fa-percent {
  --fa: "\\25";
  --fa--fa: "\\25\\25"; }

.fa-percentage {
  --fa: "\\25";
  --fa--fa: "\\25\\25"; }

.fa-truck-moving {
  --fa: "\\f4df";
  --fa--fa: "\\f4df\\f4df"; }

.fa-glass-water-droplet {
  --fa: "\\e4f5";
  --fa--fa: "\\e4f5\\e4f5"; }

.fa-display {
  --fa: "\\e163";
  --fa--fa: "\\e163\\e163"; }

.fa-face-smile {
  --fa: "\\f118";
  --fa--fa: "\\f118\\f118"; }

.fa-smile {
  --fa: "\\f118";
  --fa--fa: "\\f118\\f118"; }

.fa-thumbtack {
  --fa: "\\f08d";
  --fa--fa: "\\f08d\\f08d"; }

.fa-thumb-tack {
  --fa: "\\f08d";
  --fa--fa: "\\f08d\\f08d"; }

.fa-trophy {
  --fa: "\\f091";
  --fa--fa: "\\f091\\f091"; }

.fa-person-praying {
  --fa: "\\f683";
  --fa--fa: "\\f683\\f683"; }

.fa-pray {
  --fa: "\\f683";
  --fa--fa: "\\f683\\f683"; }

.fa-hammer {
  --fa: "\\f6e3";
  --fa--fa: "\\f6e3\\f6e3"; }

.fa-hand-peace {
  --fa: "\\f25b";
  --fa--fa: "\\f25b\\f25b"; }

.fa-rotate {
  --fa: "\\f2f1";
  --fa--fa: "\\f2f1\\f2f1"; }

.fa-sync-alt {
  --fa: "\\f2f1";
  --fa--fa: "\\f2f1\\f2f1"; }

.fa-spinner {
  --fa: "\\f110";
  --fa--fa: "\\f110\\f110"; }

.fa-robot {
  --fa: "\\f544";
  --fa--fa: "\\f544\\f544"; }

.fa-peace {
  --fa: "\\f67c";
  --fa--fa: "\\f67c\\f67c"; }

.fa-gears {
  --fa: "\\f085";
  --fa--fa: "\\f085\\f085"; }

.fa-cogs {
  --fa: "\\f085";
  --fa--fa: "\\f085\\f085"; }

.fa-warehouse {
  --fa: "\\f494";
  --fa--fa: "\\f494\\f494"; }

.fa-arrow-up-right-dots {
  --fa: "\\e4b7";
  --fa--fa: "\\e4b7\\e4b7"; }

.fa-splotch {
  --fa: "\\f5bc";
  --fa--fa: "\\f5bc\\f5bc"; }

.fa-face-grin-hearts {
  --fa: "\\f584";
  --fa--fa: "\\f584\\f584"; }

.fa-grin-hearts {
  --fa: "\\f584";
  --fa--fa: "\\f584\\f584"; }

.fa-dice-four {
  --fa: "\\f524";
  --fa--fa: "\\f524\\f524"; }

.fa-sim-card {
  --fa: "\\f7c4";
  --fa--fa: "\\f7c4\\f7c4"; }

.fa-transgender {
  --fa: "\\f225";
  --fa--fa: "\\f225\\f225"; }

.fa-transgender-alt {
  --fa: "\\f225";
  --fa--fa: "\\f225\\f225"; }

.fa-mercury {
  --fa: "\\f223";
  --fa--fa: "\\f223\\f223"; }

.fa-arrow-turn-down {
  --fa: "\\f149";
  --fa--fa: "\\f149\\f149"; }

.fa-level-down {
  --fa: "\\f149";
  --fa--fa: "\\f149\\f149"; }

.fa-person-falling-burst {
  --fa: "\\e547";
  --fa--fa: "\\e547\\e547"; }

.fa-award {
  --fa: "\\f559";
  --fa--fa: "\\f559\\f559"; }

.fa-ticket-simple {
  --fa: "\\f3ff";
  --fa--fa: "\\f3ff\\f3ff"; }

.fa-ticket-alt {
  --fa: "\\f3ff";
  --fa--fa: "\\f3ff\\f3ff"; }

.fa-building {
  --fa: "\\f1ad";
  --fa--fa: "\\f1ad\\f1ad"; }

.fa-angles-left {
  --fa: "\\f100";
  --fa--fa: "\\f100\\f100"; }

.fa-angle-double-left {
  --fa: "\\f100";
  --fa--fa: "\\f100\\f100"; }

.fa-qrcode {
  --fa: "\\f029";
  --fa--fa: "\\f029\\f029"; }

.fa-clock-rotate-left {
  --fa: "\\f1da";
  --fa--fa: "\\f1da\\f1da"; }

.fa-history {
  --fa: "\\f1da";
  --fa--fa: "\\f1da\\f1da"; }

.fa-face-grin-beam-sweat {
  --fa: "\\f583";
  --fa--fa: "\\f583\\f583"; }

.fa-grin-beam-sweat {
  --fa: "\\f583";
  --fa--fa: "\\f583\\f583"; }

.fa-file-export {
  --fa: "\\f56e";
  --fa--fa: "\\f56e\\f56e"; }

.fa-arrow-right-from-file {
  --fa: "\\f56e";
  --fa--fa: "\\f56e\\f56e"; }

.fa-shield {
  --fa: "\\f132";
  --fa--fa: "\\f132\\f132"; }

.fa-shield-blank {
  --fa: "\\f132";
  --fa--fa: "\\f132\\f132"; }

.fa-arrow-up-short-wide {
  --fa: "\\f885";
  --fa--fa: "\\f885\\f885"; }

.fa-sort-amount-up-alt {
  --fa: "\\f885";
  --fa--fa: "\\f885\\f885"; }

.fa-comment-nodes {
  --fa: "\\e696";
  --fa--fa: "\\e696\\e696"; }

.fa-house-medical {
  --fa: "\\e3b2";
  --fa--fa: "\\e3b2\\e3b2"; }

.fa-golf-ball-tee {
  --fa: "\\f450";
  --fa--fa: "\\f450\\f450"; }

.fa-golf-ball {
  --fa: "\\f450";
  --fa--fa: "\\f450\\f450"; }

.fa-circle-chevron-left {
  --fa: "\\f137";
  --fa--fa: "\\f137\\f137"; }

.fa-chevron-circle-left {
  --fa: "\\f137";
  --fa--fa: "\\f137\\f137"; }

.fa-house-chimney-window {
  --fa: "\\e00d";
  --fa--fa: "\\e00d\\e00d"; }

.fa-pen-nib {
  --fa: "\\f5ad";
  --fa--fa: "\\f5ad\\f5ad"; }

.fa-tent-arrow-turn-left {
  --fa: "\\e580";
  --fa--fa: "\\e580\\e580"; }

.fa-tents {
  --fa: "\\e582";
  --fa--fa: "\\e582\\e582"; }

.fa-wand-magic {
  --fa: "\\f0d0";
  --fa--fa: "\\f0d0\\f0d0"; }

.fa-magic {
  --fa: "\\f0d0";
  --fa--fa: "\\f0d0\\f0d0"; }

.fa-dog {
  --fa: "\\f6d3";
  --fa--fa: "\\f6d3\\f6d3"; }

.fa-carrot {
  --fa: "\\f787";
  --fa--fa: "\\f787\\f787"; }

.fa-moon {
  --fa: "\\f186";
  --fa--fa: "\\f186\\f186"; }

.fa-wine-glass-empty {
  --fa: "\\f5ce";
  --fa--fa: "\\f5ce\\f5ce"; }

.fa-wine-glass-alt {
  --fa: "\\f5ce";
  --fa--fa: "\\f5ce\\f5ce"; }

.fa-cheese {
  --fa: "\\f7ef";
  --fa--fa: "\\f7ef\\f7ef"; }

.fa-yin-yang {
  --fa: "\\f6ad";
  --fa--fa: "\\f6ad\\f6ad"; }

.fa-music {
  --fa: "\\f001";
  --fa--fa: "\\f001\\f001"; }

.fa-code-commit {
  --fa: "\\f386";
  --fa--fa: "\\f386\\f386"; }

.fa-temperature-low {
  --fa: "\\f76b";
  --fa--fa: "\\f76b\\f76b"; }

.fa-person-biking {
  --fa: "\\f84a";
  --fa--fa: "\\f84a\\f84a"; }

.fa-biking {
  --fa: "\\f84a";
  --fa--fa: "\\f84a\\f84a"; }

.fa-broom {
  --fa: "\\f51a";
  --fa--fa: "\\f51a\\f51a"; }

.fa-shield-heart {
  --fa: "\\e574";
  --fa--fa: "\\e574\\e574"; }

.fa-gopuram {
  --fa: "\\f664";
  --fa--fa: "\\f664\\f664"; }

.fa-earth-oceania {
  --fa: "\\e47b";
  --fa--fa: "\\e47b\\e47b"; }

.fa-globe-oceania {
  --fa: "\\e47b";
  --fa--fa: "\\e47b\\e47b"; }

.fa-square-xmark {
  --fa: "\\f2d3";
  --fa--fa: "\\f2d3\\f2d3"; }

.fa-times-square {
  --fa: "\\f2d3";
  --fa--fa: "\\f2d3\\f2d3"; }

.fa-xmark-square {
  --fa: "\\f2d3";
  --fa--fa: "\\f2d3\\f2d3"; }

.fa-hashtag {
  --fa: "\\23";
  --fa--fa: "\\23\\23"; }

.fa-up-right-and-down-left-from-center {
  --fa: "\\f424";
  --fa--fa: "\\f424\\f424"; }

.fa-expand-alt {
  --fa: "\\f424";
  --fa--fa: "\\f424\\f424"; }

.fa-oil-can {
  --fa: "\\f613";
  --fa--fa: "\\f613\\f613"; }

.fa-t {
  --fa: "\\54";
  --fa--fa: "\\54\\54"; }

.fa-hippo {
  --fa: "\\f6ed";
  --fa--fa: "\\f6ed\\f6ed"; }

.fa-chart-column {
  --fa: "\\e0e3";
  --fa--fa: "\\e0e3\\e0e3"; }

.fa-infinity {
  --fa: "\\f534";
  --fa--fa: "\\f534\\f534"; }

.fa-vial-circle-check {
  --fa: "\\e596";
  --fa--fa: "\\e596\\e596"; }

.fa-person-arrow-down-to-line {
  --fa: "\\e538";
  --fa--fa: "\\e538\\e538"; }

.fa-voicemail {
  --fa: "\\f897";
  --fa--fa: "\\f897\\f897"; }

.fa-fan {
  --fa: "\\f863";
  --fa--fa: "\\f863\\f863"; }

.fa-person-walking-luggage {
  --fa: "\\e554";
  --fa--fa: "\\e554\\e554"; }

.fa-up-down {
  --fa: "\\f338";
  --fa--fa: "\\f338\\f338"; }

.fa-arrows-alt-v {
  --fa: "\\f338";
  --fa--fa: "\\f338\\f338"; }

.fa-cloud-moon-rain {
  --fa: "\\f73c";
  --fa--fa: "\\f73c\\f73c"; }

.fa-calendar {
  --fa: "\\f133";
  --fa--fa: "\\f133\\f133"; }

.fa-trailer {
  --fa: "\\e041";
  --fa--fa: "\\e041\\e041"; }

.fa-bahai {
  --fa: "\\f666";
  --fa--fa: "\\f666\\f666"; }

.fa-haykal {
  --fa: "\\f666";
  --fa--fa: "\\f666\\f666"; }

.fa-sd-card {
  --fa: "\\f7c2";
  --fa--fa: "\\f7c2\\f7c2"; }

.fa-dragon {
  --fa: "\\f6d5";
  --fa--fa: "\\f6d5\\f6d5"; }

.fa-shoe-prints {
  --fa: "\\f54b";
  --fa--fa: "\\f54b\\f54b"; }

.fa-circle-plus {
  --fa: "\\f055";
  --fa--fa: "\\f055\\f055"; }

.fa-plus-circle {
  --fa: "\\f055";
  --fa--fa: "\\f055\\f055"; }

.fa-face-grin-tongue-wink {
  --fa: "\\f58b";
  --fa--fa: "\\f58b\\f58b"; }

.fa-grin-tongue-wink {
  --fa: "\\f58b";
  --fa--fa: "\\f58b\\f58b"; }

.fa-hand-holding {
  --fa: "\\f4bd";
  --fa--fa: "\\f4bd\\f4bd"; }

.fa-plug-circle-exclamation {
  --fa: "\\e55d";
  --fa--fa: "\\e55d\\e55d"; }

.fa-link-slash {
  --fa: "\\f127";
  --fa--fa: "\\f127\\f127"; }

.fa-chain-broken {
  --fa: "\\f127";
  --fa--fa: "\\f127\\f127"; }

.fa-chain-slash {
  --fa: "\\f127";
  --fa--fa: "\\f127\\f127"; }

.fa-unlink {
  --fa: "\\f127";
  --fa--fa: "\\f127\\f127"; }

.fa-clone {
  --fa: "\\f24d";
  --fa--fa: "\\f24d\\f24d"; }

.fa-person-walking-arrow-loop-left {
  --fa: "\\e551";
  --fa--fa: "\\e551\\e551"; }

.fa-arrow-up-z-a {
  --fa: "\\f882";
  --fa--fa: "\\f882\\f882"; }

.fa-sort-alpha-up-alt {
  --fa: "\\f882";
  --fa--fa: "\\f882\\f882"; }

.fa-fire-flame-curved {
  --fa: "\\f7e4";
  --fa--fa: "\\f7e4\\f7e4"; }

.fa-fire-alt {
  --fa: "\\f7e4";
  --fa--fa: "\\f7e4\\f7e4"; }

.fa-tornado {
  --fa: "\\f76f";
  --fa--fa: "\\f76f\\f76f"; }

.fa-file-circle-plus {
  --fa: "\\e494";
  --fa--fa: "\\e494\\e494"; }

.fa-book-quran {
  --fa: "\\f687";
  --fa--fa: "\\f687\\f687"; }

.fa-quran {
  --fa: "\\f687";
  --fa--fa: "\\f687\\f687"; }

.fa-anchor {
  --fa: "\\f13d";
  --fa--fa: "\\f13d\\f13d"; }

.fa-border-all {
  --fa: "\\f84c";
  --fa--fa: "\\f84c\\f84c"; }

.fa-face-angry {
  --fa: "\\f556";
  --fa--fa: "\\f556\\f556"; }

.fa-angry {
  --fa: "\\f556";
  --fa--fa: "\\f556\\f556"; }

.fa-cookie-bite {
  --fa: "\\f564";
  --fa--fa: "\\f564\\f564"; }

.fa-arrow-trend-down {
  --fa: "\\e097";
  --fa--fa: "\\e097\\e097"; }

.fa-rss {
  --fa: "\\f09e";
  --fa--fa: "\\f09e\\f09e"; }

.fa-feed {
  --fa: "\\f09e";
  --fa--fa: "\\f09e\\f09e"; }

.fa-draw-polygon {
  --fa: "\\f5ee";
  --fa--fa: "\\f5ee\\f5ee"; }

.fa-scale-balanced {
  --fa: "\\f24e";
  --fa--fa: "\\f24e\\f24e"; }

.fa-balance-scale {
  --fa: "\\f24e";
  --fa--fa: "\\f24e\\f24e"; }

.fa-gauge-simple-high {
  --fa: "\\f62a";
  --fa--fa: "\\f62a\\f62a"; }

.fa-tachometer {
  --fa: "\\f62a";
  --fa--fa: "\\f62a\\f62a"; }

.fa-tachometer-fast {
  --fa: "\\f62a";
  --fa--fa: "\\f62a\\f62a"; }

.fa-shower {
  --fa: "\\f2cc";
  --fa--fa: "\\f2cc\\f2cc"; }

.fa-desktop {
  --fa: "\\f390";
  --fa--fa: "\\f390\\f390"; }

.fa-desktop-alt {
  --fa: "\\f390";
  --fa--fa: "\\f390\\f390"; }

.fa-m {
  --fa: "\\4d";
  --fa--fa: "\\4d\\4d"; }

.fa-table-list {
  --fa: "\\f00b";
  --fa--fa: "\\f00b\\f00b"; }

.fa-th-list {
  --fa: "\\f00b";
  --fa--fa: "\\f00b\\f00b"; }

.fa-comment-sms {
  --fa: "\\f7cd";
  --fa--fa: "\\f7cd\\f7cd"; }

.fa-sms {
  --fa: "\\f7cd";
  --fa--fa: "\\f7cd\\f7cd"; }

.fa-book {
  --fa: "\\f02d";
  --fa--fa: "\\f02d\\f02d"; }

.fa-user-plus {
  --fa: "\\f234";
  --fa--fa: "\\f234\\f234"; }

.fa-check {
  --fa: "\\f00c";
  --fa--fa: "\\f00c\\f00c"; }

.fa-battery-three-quarters {
  --fa: "\\f241";
  --fa--fa: "\\f241\\f241"; }

.fa-battery-4 {
  --fa: "\\f241";
  --fa--fa: "\\f241\\f241"; }

.fa-house-circle-check {
  --fa: "\\e509";
  --fa--fa: "\\e509\\e509"; }

.fa-angle-left {
  --fa: "\\f104";
  --fa--fa: "\\f104\\f104"; }

.fa-diagram-successor {
  --fa: "\\e47a";
  --fa--fa: "\\e47a\\e47a"; }

.fa-truck-arrow-right {
  --fa: "\\e58b";
  --fa--fa: "\\e58b\\e58b"; }

.fa-arrows-split-up-and-left {
  --fa: "\\e4bc";
  --fa--fa: "\\e4bc\\e4bc"; }

.fa-hand-fist {
  --fa: "\\f6de";
  --fa--fa: "\\f6de\\f6de"; }

.fa-fist-raised {
  --fa: "\\f6de";
  --fa--fa: "\\f6de\\f6de"; }

.fa-cloud-moon {
  --fa: "\\f6c3";
  --fa--fa: "\\f6c3\\f6c3"; }

.fa-briefcase {
  --fa: "\\f0b1";
  --fa--fa: "\\f0b1\\f0b1"; }

.fa-person-falling {
  --fa: "\\e546";
  --fa--fa: "\\e546\\e546"; }

.fa-image-portrait {
  --fa: "\\f3e0";
  --fa--fa: "\\f3e0\\f3e0"; }

.fa-portrait {
  --fa: "\\f3e0";
  --fa--fa: "\\f3e0\\f3e0"; }

.fa-user-tag {
  --fa: "\\f507";
  --fa--fa: "\\f507\\f507"; }

.fa-rug {
  --fa: "\\e569";
  --fa--fa: "\\e569\\e569"; }

.fa-earth-europe {
  --fa: "\\f7a2";
  --fa--fa: "\\f7a2\\f7a2"; }

.fa-globe-europe {
  --fa: "\\f7a2";
  --fa--fa: "\\f7a2\\f7a2"; }

.fa-cart-flatbed-suitcase {
  --fa: "\\f59d";
  --fa--fa: "\\f59d\\f59d"; }

.fa-luggage-cart {
  --fa: "\\f59d";
  --fa--fa: "\\f59d\\f59d"; }

.fa-rectangle-xmark {
  --fa: "\\f410";
  --fa--fa: "\\f410\\f410"; }

.fa-rectangle-times {
  --fa: "\\f410";
  --fa--fa: "\\f410\\f410"; }

.fa-times-rectangle {
  --fa: "\\f410";
  --fa--fa: "\\f410\\f410"; }

.fa-window-close {
  --fa: "\\f410";
  --fa--fa: "\\f410\\f410"; }

.fa-baht-sign {
  --fa: "\\e0ac";
  --fa--fa: "\\e0ac\\e0ac"; }

.fa-book-open {
  --fa: "\\f518";
  --fa--fa: "\\f518\\f518"; }

.fa-book-journal-whills {
  --fa: "\\f66a";
  --fa--fa: "\\f66a\\f66a"; }

.fa-journal-whills {
  --fa: "\\f66a";
  --fa--fa: "\\f66a\\f66a"; }

.fa-handcuffs {
  --fa: "\\e4f8";
  --fa--fa: "\\e4f8\\e4f8"; }

.fa-triangle-exclamation {
  --fa: "\\f071";
  --fa--fa: "\\f071\\f071"; }

.fa-exclamation-triangle {
  --fa: "\\f071";
  --fa--fa: "\\f071\\f071"; }

.fa-warning {
  --fa: "\\f071";
  --fa--fa: "\\f071\\f071"; }

.fa-database {
  --fa: "\\f1c0";
  --fa--fa: "\\f1c0\\f1c0"; }

.fa-share {
  --fa: "\\f064";
  --fa--fa: "\\f064\\f064"; }

.fa-mail-forward {
  --fa: "\\f064";
  --fa--fa: "\\f064\\f064"; }

.fa-bottle-droplet {
  --fa: "\\e4c4";
  --fa--fa: "\\e4c4\\e4c4"; }

.fa-mask-face {
  --fa: "\\e1d7";
  --fa--fa: "\\e1d7\\e1d7"; }

.fa-hill-rockslide {
  --fa: "\\e508";
  --fa--fa: "\\e508\\e508"; }

.fa-right-left {
  --fa: "\\f362";
  --fa--fa: "\\f362\\f362"; }

.fa-exchange-alt {
  --fa: "\\f362";
  --fa--fa: "\\f362\\f362"; }

.fa-paper-plane {
  --fa: "\\f1d8";
  --fa--fa: "\\f1d8\\f1d8"; }

.fa-road-circle-exclamation {
  --fa: "\\e565";
  --fa--fa: "\\e565\\e565"; }

.fa-dungeon {
  --fa: "\\f6d9";
  --fa--fa: "\\f6d9\\f6d9"; }

.fa-align-right {
  --fa: "\\f038";
  --fa--fa: "\\f038\\f038"; }

.fa-money-bill-1-wave {
  --fa: "\\f53b";
  --fa--fa: "\\f53b\\f53b"; }

.fa-money-bill-wave-alt {
  --fa: "\\f53b";
  --fa--fa: "\\f53b\\f53b"; }

.fa-life-ring {
  --fa: "\\f1cd";
  --fa--fa: "\\f1cd\\f1cd"; }

.fa-hands {
  --fa: "\\f2a7";
  --fa--fa: "\\f2a7\\f2a7"; }

.fa-sign-language {
  --fa: "\\f2a7";
  --fa--fa: "\\f2a7\\f2a7"; }

.fa-signing {
  --fa: "\\f2a7";
  --fa--fa: "\\f2a7\\f2a7"; }

.fa-calendar-day {
  --fa: "\\f783";
  --fa--fa: "\\f783\\f783"; }

.fa-water-ladder {
  --fa: "\\f5c5";
  --fa--fa: "\\f5c5\\f5c5"; }

.fa-ladder-water {
  --fa: "\\f5c5";
  --fa--fa: "\\f5c5\\f5c5"; }

.fa-swimming-pool {
  --fa: "\\f5c5";
  --fa--fa: "\\f5c5\\f5c5"; }

.fa-arrows-up-down {
  --fa: "\\f07d";
  --fa--fa: "\\f07d\\f07d"; }

.fa-arrows-v {
  --fa: "\\f07d";
  --fa--fa: "\\f07d\\f07d"; }

.fa-face-grimace {
  --fa: "\\f57f";
  --fa--fa: "\\f57f\\f57f"; }

.fa-grimace {
  --fa: "\\f57f";
  --fa--fa: "\\f57f\\f57f"; }

.fa-wheelchair-move {
  --fa: "\\e2ce";
  --fa--fa: "\\e2ce\\e2ce"; }

.fa-wheelchair-alt {
  --fa: "\\e2ce";
  --fa--fa: "\\e2ce\\e2ce"; }

.fa-turn-down {
  --fa: "\\f3be";
  --fa--fa: "\\f3be\\f3be"; }

.fa-level-down-alt {
  --fa: "\\f3be";
  --fa--fa: "\\f3be\\f3be"; }

.fa-person-walking-arrow-right {
  --fa: "\\e552";
  --fa--fa: "\\e552\\e552"; }

.fa-square-envelope {
  --fa: "\\f199";
  --fa--fa: "\\f199\\f199"; }

.fa-envelope-square {
  --fa: "\\f199";
  --fa--fa: "\\f199\\f199"; }

.fa-dice {
  --fa: "\\f522";
  --fa--fa: "\\f522\\f522"; }

.fa-bowling-ball {
  --fa: "\\f436";
  --fa--fa: "\\f436\\f436"; }

.fa-brain {
  --fa: "\\f5dc";
  --fa--fa: "\\f5dc\\f5dc"; }

.fa-bandage {
  --fa: "\\f462";
  --fa--fa: "\\f462\\f462"; }

.fa-band-aid {
  --fa: "\\f462";
  --fa--fa: "\\f462\\f462"; }

.fa-calendar-minus {
  --fa: "\\f272";
  --fa--fa: "\\f272\\f272"; }

.fa-circle-xmark {
  --fa: "\\f057";
  --fa--fa: "\\f057\\f057"; }

.fa-times-circle {
  --fa: "\\f057";
  --fa--fa: "\\f057\\f057"; }

.fa-xmark-circle {
  --fa: "\\f057";
  --fa--fa: "\\f057\\f057"; }

.fa-gifts {
  --fa: "\\f79c";
  --fa--fa: "\\f79c\\f79c"; }

.fa-hotel {
  --fa: "\\f594";
  --fa--fa: "\\f594\\f594"; }

.fa-earth-asia {
  --fa: "\\f57e";
  --fa--fa: "\\f57e\\f57e"; }

.fa-globe-asia {
  --fa: "\\f57e";
  --fa--fa: "\\f57e\\f57e"; }

.fa-id-card-clip {
  --fa: "\\f47f";
  --fa--fa: "\\f47f\\f47f"; }

.fa-id-card-alt {
  --fa: "\\f47f";
  --fa--fa: "\\f47f\\f47f"; }

.fa-magnifying-glass-plus {
  --fa: "\\f00e";
  --fa--fa: "\\f00e\\f00e"; }

.fa-search-plus {
  --fa: "\\f00e";
  --fa--fa: "\\f00e\\f00e"; }

.fa-thumbs-up {
  --fa: "\\f164";
  --fa--fa: "\\f164\\f164"; }

.fa-user-clock {
  --fa: "\\f4fd";
  --fa--fa: "\\f4fd\\f4fd"; }

.fa-hand-dots {
  --fa: "\\f461";
  --fa--fa: "\\f461\\f461"; }

.fa-allergies {
  --fa: "\\f461";
  --fa--fa: "\\f461\\f461"; }

.fa-file-invoice {
  --fa: "\\f570";
  --fa--fa: "\\f570\\f570"; }

.fa-window-minimize {
  --fa: "\\f2d1";
  --fa--fa: "\\f2d1\\f2d1"; }

.fa-mug-saucer {
  --fa: "\\f0f4";
  --fa--fa: "\\f0f4\\f0f4"; }

.fa-coffee {
  --fa: "\\f0f4";
  --fa--fa: "\\f0f4\\f0f4"; }

.fa-brush {
  --fa: "\\f55d";
  --fa--fa: "\\f55d\\f55d"; }

.fa-file-half-dashed {
  --fa: "\\e698";
  --fa--fa: "\\e698\\e698"; }

.fa-mask {
  --fa: "\\f6fa";
  --fa--fa: "\\f6fa\\f6fa"; }

.fa-magnifying-glass-minus {
  --fa: "\\f010";
  --fa--fa: "\\f010\\f010"; }

.fa-search-minus {
  --fa: "\\f010";
  --fa--fa: "\\f010\\f010"; }

.fa-ruler-vertical {
  --fa: "\\f548";
  --fa--fa: "\\f548\\f548"; }

.fa-user-large {
  --fa: "\\f406";
  --fa--fa: "\\f406\\f406"; }

.fa-user-alt {
  --fa: "\\f406";
  --fa--fa: "\\f406\\f406"; }

.fa-train-tram {
  --fa: "\\e5b4";
  --fa--fa: "\\e5b4\\e5b4"; }

.fa-user-nurse {
  --fa: "\\f82f";
  --fa--fa: "\\f82f\\f82f"; }

.fa-syringe {
  --fa: "\\f48e";
  --fa--fa: "\\f48e\\f48e"; }

.fa-cloud-sun {
  --fa: "\\f6c4";
  --fa--fa: "\\f6c4\\f6c4"; }

.fa-stopwatch-20 {
  --fa: "\\e06f";
  --fa--fa: "\\e06f\\e06f"; }

.fa-square-full {
  --fa: "\\f45c";
  --fa--fa: "\\f45c\\f45c"; }

.fa-magnet {
  --fa: "\\f076";
  --fa--fa: "\\f076\\f076"; }

.fa-jar {
  --fa: "\\e516";
  --fa--fa: "\\e516\\e516"; }

.fa-note-sticky {
  --fa: "\\f249";
  --fa--fa: "\\f249\\f249"; }

.fa-sticky-note {
  --fa: "\\f249";
  --fa--fa: "\\f249\\f249"; }

.fa-bug-slash {
  --fa: "\\e490";
  --fa--fa: "\\e490\\e490"; }

.fa-arrow-up-from-water-pump {
  --fa: "\\e4b6";
  --fa--fa: "\\e4b6\\e4b6"; }

.fa-bone {
  --fa: "\\f5d7";
  --fa--fa: "\\f5d7\\f5d7"; }

.fa-table-cells-row-unlock {
  --fa: "\\e691";
  --fa--fa: "\\e691\\e691"; }

.fa-user-injured {
  --fa: "\\f728";
  --fa--fa: "\\f728\\f728"; }

.fa-face-sad-tear {
  --fa: "\\f5b4";
  --fa--fa: "\\f5b4\\f5b4"; }

.fa-sad-tear {
  --fa: "\\f5b4";
  --fa--fa: "\\f5b4\\f5b4"; }

.fa-plane {
  --fa: "\\f072";
  --fa--fa: "\\f072\\f072"; }

.fa-tent-arrows-down {
  --fa: "\\e581";
  --fa--fa: "\\e581\\e581"; }

.fa-exclamation {
  --fa: "\\21";
  --fa--fa: "\\21\\21"; }

.fa-arrows-spin {
  --fa: "\\e4bb";
  --fa--fa: "\\e4bb\\e4bb"; }

.fa-print {
  --fa: "\\f02f";
  --fa--fa: "\\f02f\\f02f"; }

.fa-turkish-lira-sign {
  --fa: "\\e2bb";
  --fa--fa: "\\e2bb\\e2bb"; }

.fa-try {
  --fa: "\\e2bb";
  --fa--fa: "\\e2bb\\e2bb"; }

.fa-turkish-lira {
  --fa: "\\e2bb";
  --fa--fa: "\\e2bb\\e2bb"; }

.fa-dollar-sign {
  --fa: "\\24";
  --fa--fa: "\\24\\24"; }

.fa-dollar {
  --fa: "\\24";
  --fa--fa: "\\24\\24"; }

.fa-usd {
  --fa: "\\24";
  --fa--fa: "\\24\\24"; }

.fa-x {
  --fa: "\\58";
  --fa--fa: "\\58\\58"; }

.fa-magnifying-glass-dollar {
  --fa: "\\f688";
  --fa--fa: "\\f688\\f688"; }

.fa-search-dollar {
  --fa: "\\f688";
  --fa--fa: "\\f688\\f688"; }

.fa-users-gear {
  --fa: "\\f509";
  --fa--fa: "\\f509\\f509"; }

.fa-users-cog {
  --fa: "\\f509";
  --fa--fa: "\\f509\\f509"; }

.fa-person-military-pointing {
  --fa: "\\e54a";
  --fa--fa: "\\e54a\\e54a"; }

.fa-building-columns {
  --fa: "\\f19c";
  --fa--fa: "\\f19c\\f19c"; }

.fa-bank {
  --fa: "\\f19c";
  --fa--fa: "\\f19c\\f19c"; }

.fa-institution {
  --fa: "\\f19c";
  --fa--fa: "\\f19c\\f19c"; }

.fa-museum {
  --fa: "\\f19c";
  --fa--fa: "\\f19c\\f19c"; }

.fa-university {
  --fa: "\\f19c";
  --fa--fa: "\\f19c\\f19c"; }

.fa-umbrella {
  --fa: "\\f0e9";
  --fa--fa: "\\f0e9\\f0e9"; }

.fa-trowel {
  --fa: "\\e589";
  --fa--fa: "\\e589\\e589"; }

.fa-d {
  --fa: "\\44";
  --fa--fa: "\\44\\44"; }

.fa-stapler {
  --fa: "\\e5af";
  --fa--fa: "\\e5af\\e5af"; }

.fa-masks-theater {
  --fa: "\\f630";
  --fa--fa: "\\f630\\f630"; }

.fa-theater-masks {
  --fa: "\\f630";
  --fa--fa: "\\f630\\f630"; }

.fa-kip-sign {
  --fa: "\\e1c4";
  --fa--fa: "\\e1c4\\e1c4"; }

.fa-hand-point-left {
  --fa: "\\f0a5";
  --fa--fa: "\\f0a5\\f0a5"; }

.fa-handshake-simple {
  --fa: "\\f4c6";
  --fa--fa: "\\f4c6\\f4c6"; }

.fa-handshake-alt {
  --fa: "\\f4c6";
  --fa--fa: "\\f4c6\\f4c6"; }

.fa-jet-fighter {
  --fa: "\\f0fb";
  --fa--fa: "\\f0fb\\f0fb"; }

.fa-fighter-jet {
  --fa: "\\f0fb";
  --fa--fa: "\\f0fb\\f0fb"; }

.fa-square-share-nodes {
  --fa: "\\f1e1";
  --fa--fa: "\\f1e1\\f1e1"; }

.fa-share-alt-square {
  --fa: "\\f1e1";
  --fa--fa: "\\f1e1\\f1e1"; }

.fa-barcode {
  --fa: "\\f02a";
  --fa--fa: "\\f02a\\f02a"; }

.fa-plus-minus {
  --fa: "\\e43c";
  --fa--fa: "\\e43c\\e43c"; }

.fa-video {
  --fa: "\\f03d";
  --fa--fa: "\\f03d\\f03d"; }

.fa-video-camera {
  --fa: "\\f03d";
  --fa--fa: "\\f03d\\f03d"; }

.fa-graduation-cap {
  --fa: "\\f19d";
  --fa--fa: "\\f19d\\f19d"; }

.fa-mortar-board {
  --fa: "\\f19d";
  --fa--fa: "\\f19d\\f19d"; }

.fa-hand-holding-medical {
  --fa: "\\e05c";
  --fa--fa: "\\e05c\\e05c"; }

.fa-person-circle-check {
  --fa: "\\e53e";
  --fa--fa: "\\e53e\\e53e"; }

.fa-turn-up {
  --fa: "\\f3bf";
  --fa--fa: "\\f3bf\\f3bf"; }

.fa-level-up-alt {
  --fa: "\\f3bf";
  --fa--fa: "\\f3bf\\f3bf"; }

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0; }

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0; }
:root, :host {
  --fa-style-family-brands: 'Font Awesome 6 Brands';
  --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands'; }

@font-face {
  font-family: 'Font Awesome 6 Brands';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"); }

.fab,
.fa-brands {
  font-weight: 400; }

.fa-monero {
  --fa: "\\f3d0"; }

.fa-hooli {
  --fa: "\\f427"; }

.fa-yelp {
  --fa: "\\f1e9"; }

.fa-cc-visa {
  --fa: "\\f1f0"; }

.fa-lastfm {
  --fa: "\\f202"; }

.fa-shopware {
  --fa: "\\f5b5"; }

.fa-creative-commons-nc {
  --fa: "\\f4e8"; }

.fa-aws {
  --fa: "\\f375"; }

.fa-redhat {
  --fa: "\\f7bc"; }

.fa-yoast {
  --fa: "\\f2b1"; }

.fa-cloudflare {
  --fa: "\\e07d"; }

.fa-ups {
  --fa: "\\f7e0"; }

.fa-pixiv {
  --fa: "\\e640"; }

.fa-wpexplorer {
  --fa: "\\f2de"; }

.fa-dyalog {
  --fa: "\\f399"; }

.fa-bity {
  --fa: "\\f37a"; }

.fa-stackpath {
  --fa: "\\f842"; }

.fa-buysellads {
  --fa: "\\f20d"; }

.fa-first-order {
  --fa: "\\f2b0"; }

.fa-modx {
  --fa: "\\f285"; }

.fa-guilded {
  --fa: "\\e07e"; }

.fa-vnv {
  --fa: "\\f40b"; }

.fa-square-js {
  --fa: "\\f3b9"; }

.fa-js-square {
  --fa: "\\f3b9"; }

.fa-microsoft {
  --fa: "\\f3ca"; }

.fa-qq {
  --fa: "\\f1d6"; }

.fa-orcid {
  --fa: "\\f8d2"; }

.fa-java {
  --fa: "\\f4e4"; }

.fa-invision {
  --fa: "\\f7b0"; }

.fa-creative-commons-pd-alt {
  --fa: "\\f4ed"; }

.fa-centercode {
  --fa: "\\f380"; }

.fa-glide-g {
  --fa: "\\f2a6"; }

.fa-drupal {
  --fa: "\\f1a9"; }

.fa-jxl {
  --fa: "\\e67b"; }

.fa-dart-lang {
  --fa: "\\e693"; }

.fa-hire-a-helper {
  --fa: "\\f3b0"; }

.fa-creative-commons-by {
  --fa: "\\f4e7"; }

.fa-unity {
  --fa: "\\e049"; }

.fa-whmcs {
  --fa: "\\f40d"; }

.fa-rocketchat {
  --fa: "\\f3e8"; }

.fa-vk {
  --fa: "\\f189"; }

.fa-untappd {
  --fa: "\\f405"; }

.fa-mailchimp {
  --fa: "\\f59e"; }

.fa-css3-alt {
  --fa: "\\f38b"; }

.fa-square-reddit {
  --fa: "\\f1a2"; }

.fa-reddit-square {
  --fa: "\\f1a2"; }

.fa-vimeo-v {
  --fa: "\\f27d"; }

.fa-contao {
  --fa: "\\f26d"; }

.fa-square-font-awesome {
  --fa: "\\e5ad"; }

.fa-deskpro {
  --fa: "\\f38f"; }

.fa-brave {
  --fa: "\\e63c"; }

.fa-sistrix {
  --fa: "\\f3ee"; }

.fa-square-instagram {
  --fa: "\\e055"; }

.fa-instagram-square {
  --fa: "\\e055"; }

.fa-battle-net {
  --fa: "\\f835"; }

.fa-the-red-yeti {
  --fa: "\\f69d"; }

.fa-square-hacker-news {
  --fa: "\\f3af"; }

.fa-hacker-news-square {
  --fa: "\\f3af"; }

.fa-edge {
  --fa: "\\f282"; }

.fa-threads {
  --fa: "\\e618"; }

.fa-napster {
  --fa: "\\f3d2"; }

.fa-square-snapchat {
  --fa: "\\f2ad"; }

.fa-snapchat-square {
  --fa: "\\f2ad"; }

.fa-google-plus-g {
  --fa: "\\f0d5"; }

.fa-artstation {
  --fa: "\\f77a"; }

.fa-markdown {
  --fa: "\\f60f"; }

.fa-sourcetree {
  --fa: "\\f7d3"; }

.fa-google-plus {
  --fa: "\\f2b3"; }

.fa-diaspora {
  --fa: "\\f791"; }

.fa-foursquare {
  --fa: "\\f180"; }

.fa-stack-overflow {
  --fa: "\\f16c"; }

.fa-github-alt {
  --fa: "\\f113"; }

.fa-phoenix-squadron {
  --fa: "\\f511"; }

.fa-pagelines {
  --fa: "\\f18c"; }

.fa-algolia {
  --fa: "\\f36c"; }

.fa-red-river {
  --fa: "\\f3e3"; }

.fa-creative-commons-sa {
  --fa: "\\f4ef"; }

.fa-safari {
  --fa: "\\f267"; }

.fa-google {
  --fa: "\\f1a0"; }

.fa-square-font-awesome-stroke {
  --fa: "\\f35c"; }

.fa-font-awesome-alt {
  --fa: "\\f35c"; }

.fa-atlassian {
  --fa: "\\f77b"; }

.fa-linkedin-in {
  --fa: "\\f0e1"; }

.fa-digital-ocean {
  --fa: "\\f391"; }

.fa-nimblr {
  --fa: "\\f5a8"; }

.fa-chromecast {
  --fa: "\\f838"; }

.fa-evernote {
  --fa: "\\f839"; }

.fa-hacker-news {
  --fa: "\\f1d4"; }

.fa-creative-commons-sampling {
  --fa: "\\f4f0"; }

.fa-adversal {
  --fa: "\\f36a"; }

.fa-creative-commons {
  --fa: "\\f25e"; }

.fa-watchman-monitoring {
  --fa: "\\e087"; }

.fa-fonticons {
  --fa: "\\f280"; }

.fa-weixin {
  --fa: "\\f1d7"; }

.fa-shirtsinbulk {
  --fa: "\\f214"; }

.fa-codepen {
  --fa: "\\f1cb"; }

.fa-git-alt {
  --fa: "\\f841"; }

.fa-lyft {
  --fa: "\\f3c3"; }

.fa-rev {
  --fa: "\\f5b2"; }

.fa-windows {
  --fa: "\\f17a"; }

.fa-wizards-of-the-coast {
  --fa: "\\f730"; }

.fa-square-viadeo {
  --fa: "\\f2aa"; }

.fa-viadeo-square {
  --fa: "\\f2aa"; }

.fa-meetup {
  --fa: "\\f2e0"; }

.fa-centos {
  --fa: "\\f789"; }

.fa-adn {
  --fa: "\\f170"; }

.fa-cloudsmith {
  --fa: "\\f384"; }

.fa-opensuse {
  --fa: "\\e62b"; }

.fa-pied-piper-alt {
  --fa: "\\f1a8"; }

.fa-square-dribbble {
  --fa: "\\f397"; }

.fa-dribbble-square {
  --fa: "\\f397"; }

.fa-codiepie {
  --fa: "\\f284"; }

.fa-node {
  --fa: "\\f419"; }

.fa-mix {
  --fa: "\\f3cb"; }

.fa-steam {
  --fa: "\\f1b6"; }

.fa-cc-apple-pay {
  --fa: "\\f416"; }

.fa-scribd {
  --fa: "\\f28a"; }

.fa-debian {
  --fa: "\\e60b"; }

.fa-openid {
  --fa: "\\f19b"; }

.fa-instalod {
  --fa: "\\e081"; }

.fa-files-pinwheel {
  --fa: "\\e69f"; }

.fa-expeditedssl {
  --fa: "\\f23e"; }

.fa-sellcast {
  --fa: "\\f2da"; }

.fa-square-twitter {
  --fa: "\\f081"; }

.fa-twitter-square {
  --fa: "\\f081"; }

.fa-r-project {
  --fa: "\\f4f7"; }

.fa-delicious {
  --fa: "\\f1a5"; }

.fa-freebsd {
  --fa: "\\f3a4"; }

.fa-vuejs {
  --fa: "\\f41f"; }

.fa-accusoft {
  --fa: "\\f369"; }

.fa-ioxhost {
  --fa: "\\f208"; }

.fa-fonticons-fi {
  --fa: "\\f3a2"; }

.fa-app-store {
  --fa: "\\f36f"; }

.fa-cc-mastercard {
  --fa: "\\f1f1"; }

.fa-itunes-note {
  --fa: "\\f3b5"; }

.fa-golang {
  --fa: "\\e40f"; }

.fa-kickstarter {
  --fa: "\\f3bb"; }

.fa-square-kickstarter {
  --fa: "\\f3bb"; }

.fa-grav {
  --fa: "\\f2d6"; }

.fa-weibo {
  --fa: "\\f18a"; }

.fa-uncharted {
  --fa: "\\e084"; }

.fa-firstdraft {
  --fa: "\\f3a1"; }

.fa-square-youtube {
  --fa: "\\f431"; }

.fa-youtube-square {
  --fa: "\\f431"; }

.fa-wikipedia-w {
  --fa: "\\f266"; }

.fa-wpressr {
  --fa: "\\f3e4"; }

.fa-rendact {
  --fa: "\\f3e4"; }

.fa-angellist {
  --fa: "\\f209"; }

.fa-galactic-republic {
  --fa: "\\f50c"; }

.fa-nfc-directional {
  --fa: "\\e530"; }

.fa-skype {
  --fa: "\\f17e"; }

.fa-joget {
  --fa: "\\f3b7"; }

.fa-fedora {
  --fa: "\\f798"; }

.fa-stripe-s {
  --fa: "\\f42a"; }

.fa-meta {
  --fa: "\\e49b"; }

.fa-laravel {
  --fa: "\\f3bd"; }

.fa-hotjar {
  --fa: "\\f3b1"; }

.fa-bluetooth-b {
  --fa: "\\f294"; }

.fa-square-letterboxd {
  --fa: "\\e62e"; }

.fa-sticker-mule {
  --fa: "\\f3f7"; }

.fa-creative-commons-zero {
  --fa: "\\f4f3"; }

.fa-hips {
  --fa: "\\f452"; }

.fa-css {
  --fa: "\\e6a2"; }

.fa-behance {
  --fa: "\\f1b4"; }

.fa-reddit {
  --fa: "\\f1a1"; }

.fa-discord {
  --fa: "\\f392"; }

.fa-chrome {
  --fa: "\\f268"; }

.fa-app-store-ios {
  --fa: "\\f370"; }

.fa-cc-discover {
  --fa: "\\f1f2"; }

.fa-wpbeginner {
  --fa: "\\f297"; }

.fa-confluence {
  --fa: "\\f78d"; }

.fa-shoelace {
  --fa: "\\e60c"; }

.fa-mdb {
  --fa: "\\f8ca"; }

.fa-dochub {
  --fa: "\\f394"; }

.fa-accessible-icon {
  --fa: "\\f368"; }

.fa-ebay {
  --fa: "\\f4f4"; }

.fa-amazon {
  --fa: "\\f270"; }

.fa-unsplash {
  --fa: "\\e07c"; }

.fa-yarn {
  --fa: "\\f7e3"; }

.fa-square-steam {
  --fa: "\\f1b7"; }

.fa-steam-square {
  --fa: "\\f1b7"; }

.fa-500px {
  --fa: "\\f26e"; }

.fa-square-vimeo {
  --fa: "\\f194"; }

.fa-vimeo-square {
  --fa: "\\f194"; }

.fa-asymmetrik {
  --fa: "\\f372"; }

.fa-font-awesome {
  --fa: "\\f2b4"; }

.fa-font-awesome-flag {
  --fa: "\\f2b4"; }

.fa-font-awesome-logo-full {
  --fa: "\\f2b4"; }

.fa-gratipay {
  --fa: "\\f184"; }

.fa-apple {
  --fa: "\\f179"; }

.fa-hive {
  --fa: "\\e07f"; }

.fa-gitkraken {
  --fa: "\\f3a6"; }

.fa-keybase {
  --fa: "\\f4f5"; }

.fa-apple-pay {
  --fa: "\\f415"; }

.fa-padlet {
  --fa: "\\e4a0"; }

.fa-amazon-pay {
  --fa: "\\f42c"; }

.fa-square-github {
  --fa: "\\f092"; }

.fa-github-square {
  --fa: "\\f092"; }

.fa-stumbleupon {
  --fa: "\\f1a4"; }

.fa-fedex {
  --fa: "\\f797"; }

.fa-phoenix-framework {
  --fa: "\\f3dc"; }

.fa-shopify {
  --fa: "\\e057"; }

.fa-neos {
  --fa: "\\f612"; }

.fa-square-threads {
  --fa: "\\e619"; }

.fa-hackerrank {
  --fa: "\\f5f7"; }

.fa-researchgate {
  --fa: "\\f4f8"; }

.fa-swift {
  --fa: "\\f8e1"; }

.fa-angular {
  --fa: "\\f420"; }

.fa-speakap {
  --fa: "\\f3f3"; }

.fa-angrycreative {
  --fa: "\\f36e"; }

.fa-y-combinator {
  --fa: "\\f23b"; }

.fa-empire {
  --fa: "\\f1d1"; }

.fa-envira {
  --fa: "\\f299"; }

.fa-google-scholar {
  --fa: "\\e63b"; }

.fa-square-gitlab {
  --fa: "\\e5ae"; }

.fa-gitlab-square {
  --fa: "\\e5ae"; }

.fa-studiovinari {
  --fa: "\\f3f8"; }

.fa-pied-piper {
  --fa: "\\f2ae"; }

.fa-wordpress {
  --fa: "\\f19a"; }

.fa-product-hunt {
  --fa: "\\f288"; }

.fa-firefox {
  --fa: "\\f269"; }

.fa-linode {
  --fa: "\\f2b8"; }

.fa-goodreads {
  --fa: "\\f3a8"; }

.fa-square-odnoklassniki {
  --fa: "\\f264"; }

.fa-odnoklassniki-square {
  --fa: "\\f264"; }

.fa-jsfiddle {
  --fa: "\\f1cc"; }

.fa-sith {
  --fa: "\\f512"; }

.fa-themeisle {
  --fa: "\\f2b2"; }

.fa-page4 {
  --fa: "\\f3d7"; }

.fa-hashnode {
  --fa: "\\e499"; }

.fa-react {
  --fa: "\\f41b"; }

.fa-cc-paypal {
  --fa: "\\f1f4"; }

.fa-squarespace {
  --fa: "\\f5be"; }

.fa-cc-stripe {
  --fa: "\\f1f5"; }

.fa-creative-commons-share {
  --fa: "\\f4f2"; }

.fa-bitcoin {
  --fa: "\\f379"; }

.fa-keycdn {
  --fa: "\\f3ba"; }

.fa-opera {
  --fa: "\\f26a"; }

.fa-itch-io {
  --fa: "\\f83a"; }

.fa-umbraco {
  --fa: "\\f8e8"; }

.fa-galactic-senate {
  --fa: "\\f50d"; }

.fa-ubuntu {
  --fa: "\\f7df"; }

.fa-draft2digital {
  --fa: "\\f396"; }

.fa-stripe {
  --fa: "\\f429"; }

.fa-houzz {
  --fa: "\\f27c"; }

.fa-gg {
  --fa: "\\f260"; }

.fa-dhl {
  --fa: "\\f790"; }

.fa-square-pinterest {
  --fa: "\\f0d3"; }

.fa-pinterest-square {
  --fa: "\\f0d3"; }

.fa-xing {
  --fa: "\\f168"; }

.fa-blackberry {
  --fa: "\\f37b"; }

.fa-creative-commons-pd {
  --fa: "\\f4ec"; }

.fa-playstation {
  --fa: "\\f3df"; }

.fa-quinscape {
  --fa: "\\f459"; }

.fa-less {
  --fa: "\\f41d"; }

.fa-blogger-b {
  --fa: "\\f37d"; }

.fa-opencart {
  --fa: "\\f23d"; }

.fa-vine {
  --fa: "\\f1ca"; }

.fa-signal-messenger {
  --fa: "\\e663"; }

.fa-paypal {
  --fa: "\\f1ed"; }

.fa-gitlab {
  --fa: "\\f296"; }

.fa-typo3 {
  --fa: "\\f42b"; }

.fa-reddit-alien {
  --fa: "\\f281"; }

.fa-yahoo {
  --fa: "\\f19e"; }

.fa-dailymotion {
  --fa: "\\e052"; }

.fa-affiliatetheme {
  --fa: "\\f36b"; }

.fa-pied-piper-pp {
  --fa: "\\f1a7"; }

.fa-bootstrap {
  --fa: "\\f836"; }

.fa-odnoklassniki {
  --fa: "\\f263"; }

.fa-nfc-symbol {
  --fa: "\\e531"; }

.fa-mintbit {
  --fa: "\\e62f"; }

.fa-ethereum {
  --fa: "\\f42e"; }

.fa-speaker-deck {
  --fa: "\\f83c"; }

.fa-creative-commons-nc-eu {
  --fa: "\\f4e9"; }

.fa-patreon {
  --fa: "\\f3d9"; }

.fa-avianex {
  --fa: "\\f374"; }

.fa-ello {
  --fa: "\\f5f1"; }

.fa-gofore {
  --fa: "\\f3a7"; }

.fa-bimobject {
  --fa: "\\f378"; }

.fa-brave-reverse {
  --fa: "\\e63d"; }

.fa-facebook-f {
  --fa: "\\f39e"; }

.fa-square-google-plus {
  --fa: "\\f0d4"; }

.fa-google-plus-square {
  --fa: "\\f0d4"; }

.fa-web-awesome {
  --fa: "\\e682"; }

.fa-mandalorian {
  --fa: "\\f50f"; }

.fa-first-order-alt {
  --fa: "\\f50a"; }

.fa-osi {
  --fa: "\\f41a"; }

.fa-google-wallet {
  --fa: "\\f1ee"; }

.fa-d-and-d-beyond {
  --fa: "\\f6ca"; }

.fa-periscope {
  --fa: "\\f3da"; }

.fa-fulcrum {
  --fa: "\\f50b"; }

.fa-cloudscale {
  --fa: "\\f383"; }

.fa-forumbee {
  --fa: "\\f211"; }

.fa-mizuni {
  --fa: "\\f3cc"; }

.fa-schlix {
  --fa: "\\f3ea"; }

.fa-square-xing {
  --fa: "\\f169"; }

.fa-xing-square {
  --fa: "\\f169"; }

.fa-bandcamp {
  --fa: "\\f2d5"; }

.fa-wpforms {
  --fa: "\\f298"; }

.fa-cloudversify {
  --fa: "\\f385"; }

.fa-usps {
  --fa: "\\f7e1"; }

.fa-megaport {
  --fa: "\\f5a3"; }

.fa-magento {
  --fa: "\\f3c4"; }

.fa-spotify {
  --fa: "\\f1bc"; }

.fa-optin-monster {
  --fa: "\\f23c"; }

.fa-fly {
  --fa: "\\f417"; }

.fa-square-bluesky {
  --fa: "\\e6a3"; }

.fa-aviato {
  --fa: "\\f421"; }

.fa-itunes {
  --fa: "\\f3b4"; }

.fa-cuttlefish {
  --fa: "\\f38c"; }

.fa-blogger {
  --fa: "\\f37c"; }

.fa-flickr {
  --fa: "\\f16e"; }

.fa-viber {
  --fa: "\\f409"; }

.fa-soundcloud {
  --fa: "\\f1be"; }

.fa-digg {
  --fa: "\\f1a6"; }

.fa-tencent-weibo {
  --fa: "\\f1d5"; }

.fa-letterboxd {
  --fa: "\\e62d"; }

.fa-symfony {
  --fa: "\\f83d"; }

.fa-maxcdn {
  --fa: "\\f136"; }

.fa-etsy {
  --fa: "\\f2d7"; }

.fa-facebook-messenger {
  --fa: "\\f39f"; }

.fa-audible {
  --fa: "\\f373"; }

.fa-think-peaks {
  --fa: "\\f731"; }

.fa-bilibili {
  --fa: "\\e3d9"; }

.fa-erlang {
  --fa: "\\f39d"; }

.fa-x-twitter {
  --fa: "\\e61b"; }

.fa-cotton-bureau {
  --fa: "\\f89e"; }

.fa-dashcube {
  --fa: "\\f210"; }

.fa-42-group {
  --fa: "\\e080"; }

.fa-innosoft {
  --fa: "\\e080"; }

.fa-stack-exchange {
  --fa: "\\f18d"; }

.fa-elementor {
  --fa: "\\f430"; }

.fa-square-pied-piper {
  --fa: "\\e01e"; }

.fa-pied-piper-square {
  --fa: "\\e01e"; }

.fa-creative-commons-nd {
  --fa: "\\f4eb"; }

.fa-palfed {
  --fa: "\\f3d8"; }

.fa-superpowers {
  --fa: "\\f2dd"; }

.fa-resolving {
  --fa: "\\f3e7"; }

.fa-xbox {
  --fa: "\\f412"; }

.fa-square-web-awesome-stroke {
  --fa: "\\e684"; }

.fa-searchengin {
  --fa: "\\f3eb"; }

.fa-tiktok {
  --fa: "\\e07b"; }

.fa-square-facebook {
  --fa: "\\f082"; }

.fa-facebook-square {
  --fa: "\\f082"; }

.fa-renren {
  --fa: "\\f18b"; }

.fa-linux {
  --fa: "\\f17c"; }

.fa-glide {
  --fa: "\\f2a5"; }

.fa-linkedin {
  --fa: "\\f08c"; }

.fa-hubspot {
  --fa: "\\f3b2"; }

.fa-deploydog {
  --fa: "\\f38e"; }

.fa-twitch {
  --fa: "\\f1e8"; }

.fa-flutter {
  --fa: "\\e694"; }

.fa-ravelry {
  --fa: "\\f2d9"; }

.fa-mixer {
  --fa: "\\e056"; }

.fa-square-lastfm {
  --fa: "\\f203"; }

.fa-lastfm-square {
  --fa: "\\f203"; }

.fa-vimeo {
  --fa: "\\f40a"; }

.fa-mendeley {
  --fa: "\\f7b3"; }

.fa-uniregistry {
  --fa: "\\f404"; }

.fa-figma {
  --fa: "\\f799"; }

.fa-creative-commons-remix {
  --fa: "\\f4ee"; }

.fa-cc-amazon-pay {
  --fa: "\\f42d"; }

.fa-dropbox {
  --fa: "\\f16b"; }

.fa-instagram {
  --fa: "\\f16d"; }

.fa-cmplid {
  --fa: "\\e360"; }

.fa-upwork {
  --fa: "\\e641"; }

.fa-facebook {
  --fa: "\\f09a"; }

.fa-gripfire {
  --fa: "\\f3ac"; }

.fa-jedi-order {
  --fa: "\\f50e"; }

.fa-uikit {
  --fa: "\\f403"; }

.fa-fort-awesome-alt {
  --fa: "\\f3a3"; }

.fa-phabricator {
  --fa: "\\f3db"; }

.fa-ussunnah {
  --fa: "\\f407"; }

.fa-earlybirds {
  --fa: "\\f39a"; }

.fa-trade-federation {
  --fa: "\\f513"; }

.fa-autoprefixer {
  --fa: "\\f41c"; }

.fa-whatsapp {
  --fa: "\\f232"; }

.fa-square-upwork {
  --fa: "\\e67c"; }

.fa-slideshare {
  --fa: "\\f1e7"; }

.fa-google-play {
  --fa: "\\f3ab"; }

.fa-viadeo {
  --fa: "\\f2a9"; }

.fa-line {
  --fa: "\\f3c0"; }

.fa-google-drive {
  --fa: "\\f3aa"; }

.fa-servicestack {
  --fa: "\\f3ec"; }

.fa-simplybuilt {
  --fa: "\\f215"; }

.fa-bitbucket {
  --fa: "\\f171"; }

.fa-imdb {
  --fa: "\\f2d8"; }

.fa-deezer {
  --fa: "\\e077"; }

.fa-raspberry-pi {
  --fa: "\\f7bb"; }

.fa-jira {
  --fa: "\\f7b1"; }

.fa-docker {
  --fa: "\\f395"; }

.fa-screenpal {
  --fa: "\\e570"; }

.fa-bluetooth {
  --fa: "\\f293"; }

.fa-gitter {
  --fa: "\\f426"; }

.fa-d-and-d {
  --fa: "\\f38d"; }

.fa-microblog {
  --fa: "\\e01a"; }

.fa-cc-diners-club {
  --fa: "\\f24c"; }

.fa-gg-circle {
  --fa: "\\f261"; }

.fa-pied-piper-hat {
  --fa: "\\f4e5"; }

.fa-kickstarter-k {
  --fa: "\\f3bc"; }

.fa-yandex {
  --fa: "\\f413"; }

.fa-readme {
  --fa: "\\f4d5"; }

.fa-html5 {
  --fa: "\\f13b"; }

.fa-sellsy {
  --fa: "\\f213"; }

.fa-square-web-awesome {
  --fa: "\\e683"; }

.fa-sass {
  --fa: "\\f41e"; }

.fa-wirsindhandwerk {
  --fa: "\\e2d0"; }

.fa-wsh {
  --fa: "\\e2d0"; }

.fa-buromobelexperte {
  --fa: "\\f37f"; }

.fa-salesforce {
  --fa: "\\f83b"; }

.fa-octopus-deploy {
  --fa: "\\e082"; }

.fa-medapps {
  --fa: "\\f3c6"; }

.fa-ns8 {
  --fa: "\\f3d5"; }

.fa-pinterest-p {
  --fa: "\\f231"; }

.fa-apper {
  --fa: "\\f371"; }

.fa-fort-awesome {
  --fa: "\\f286"; }

.fa-waze {
  --fa: "\\f83f"; }

.fa-bluesky {
  --fa: "\\e671"; }

.fa-cc-jcb {
  --fa: "\\f24b"; }

.fa-snapchat {
  --fa: "\\f2ab"; }

.fa-snapchat-ghost {
  --fa: "\\f2ab"; }

.fa-fantasy-flight-games {
  --fa: "\\f6dc"; }

.fa-rust {
  --fa: "\\e07a"; }

.fa-wix {
  --fa: "\\f5cf"; }

.fa-square-behance {
  --fa: "\\f1b5"; }

.fa-behance-square {
  --fa: "\\f1b5"; }

.fa-supple {
  --fa: "\\f3f9"; }

.fa-webflow {
  --fa: "\\e65c"; }

.fa-rebel {
  --fa: "\\f1d0"; }

.fa-css3 {
  --fa: "\\f13c"; }

.fa-staylinked {
  --fa: "\\f3f5"; }

.fa-kaggle {
  --fa: "\\f5fa"; }

.fa-space-awesome {
  --fa: "\\e5ac"; }

.fa-deviantart {
  --fa: "\\f1bd"; }

.fa-cpanel {
  --fa: "\\f388"; }

.fa-goodreads-g {
  --fa: "\\f3a9"; }

.fa-square-git {
  --fa: "\\f1d2"; }

.fa-git-square {
  --fa: "\\f1d2"; }

.fa-square-tumblr {
  --fa: "\\f174"; }

.fa-tumblr-square {
  --fa: "\\f174"; }

.fa-trello {
  --fa: "\\f181"; }

.fa-creative-commons-nc-jp {
  --fa: "\\f4ea"; }

.fa-get-pocket {
  --fa: "\\f265"; }

.fa-perbyte {
  --fa: "\\e083"; }

.fa-grunt {
  --fa: "\\f3ad"; }

.fa-weebly {
  --fa: "\\f5cc"; }

.fa-connectdevelop {
  --fa: "\\f20e"; }

.fa-leanpub {
  --fa: "\\f212"; }

.fa-black-tie {
  --fa: "\\f27e"; }

.fa-themeco {
  --fa: "\\f5c6"; }

.fa-python {
  --fa: "\\f3e2"; }

.fa-android {
  --fa: "\\f17b"; }

.fa-bots {
  --fa: "\\e340"; }

.fa-free-code-camp {
  --fa: "\\f2c5"; }

.fa-hornbill {
  --fa: "\\f592"; }

.fa-js {
  --fa: "\\f3b8"; }

.fa-ideal {
  --fa: "\\e013"; }

.fa-git {
  --fa: "\\f1d3"; }

.fa-dev {
  --fa: "\\f6cc"; }

.fa-sketch {
  --fa: "\\f7c6"; }

.fa-yandex-international {
  --fa: "\\f414"; }

.fa-cc-amex {
  --fa: "\\f1f3"; }

.fa-uber {
  --fa: "\\f402"; }

.fa-github {
  --fa: "\\f09b"; }

.fa-php {
  --fa: "\\f457"; }

.fa-alipay {
  --fa: "\\f642"; }

.fa-youtube {
  --fa: "\\f167"; }

.fa-skyatlas {
  --fa: "\\f216"; }

.fa-firefox-browser {
  --fa: "\\e007"; }

.fa-replyd {
  --fa: "\\f3e6"; }

.fa-suse {
  --fa: "\\f7d6"; }

.fa-jenkins {
  --fa: "\\f3b6"; }

.fa-twitter {
  --fa: "\\f099"; }

.fa-rockrms {
  --fa: "\\f3e9"; }

.fa-pinterest {
  --fa: "\\f0d2"; }

.fa-buffer {
  --fa: "\\f837"; }

.fa-npm {
  --fa: "\\f3d4"; }

.fa-yammer {
  --fa: "\\f840"; }

.fa-btc {
  --fa: "\\f15a"; }

.fa-dribbble {
  --fa: "\\f17d"; }

.fa-stumbleupon-circle {
  --fa: "\\f1a3"; }

.fa-internet-explorer {
  --fa: "\\f26b"; }

.fa-stubber {
  --fa: "\\e5c7"; }

.fa-telegram {
  --fa: "\\f2c6"; }

.fa-telegram-plane {
  --fa: "\\f2c6"; }

.fa-old-republic {
  --fa: "\\f510"; }

.fa-odysee {
  --fa: "\\e5c6"; }

.fa-square-whatsapp {
  --fa: "\\f40c"; }

.fa-whatsapp-square {
  --fa: "\\f40c"; }

.fa-node-js {
  --fa: "\\f3d3"; }

.fa-edge-legacy {
  --fa: "\\e078"; }

.fa-slack {
  --fa: "\\f198"; }

.fa-slack-hash {
  --fa: "\\f198"; }

.fa-medrt {
  --fa: "\\f3c8"; }

.fa-usb {
  --fa: "\\f287"; }

.fa-tumblr {
  --fa: "\\f173"; }

.fa-vaadin {
  --fa: "\\f408"; }

.fa-quora {
  --fa: "\\f2c4"; }

.fa-square-x-twitter {
  --fa: "\\e61a"; }

.fa-reacteurope {
  --fa: "\\f75d"; }

.fa-medium {
  --fa: "\\f23a"; }

.fa-medium-m {
  --fa: "\\f23a"; }

.fa-amilia {
  --fa: "\\f36d"; }

.fa-mixcloud {
  --fa: "\\f289"; }

.fa-flipboard {
  --fa: "\\f44d"; }

.fa-viacoin {
  --fa: "\\f237"; }

.fa-critical-role {
  --fa: "\\f6c9"; }

.fa-sitrox {
  --fa: "\\e44a"; }

.fa-discourse {
  --fa: "\\f393"; }

.fa-joomla {
  --fa: "\\f1aa"; }

.fa-mastodon {
  --fa: "\\f4f6"; }

.fa-airbnb {
  --fa: "\\f834"; }

.fa-wolf-pack-battalion {
  --fa: "\\f514"; }

.fa-buy-n-large {
  --fa: "\\f8a6"; }

.fa-gulp {
  --fa: "\\f3ae"; }

.fa-creative-commons-sampling-plus {
  --fa: "\\f4f1"; }

.fa-strava {
  --fa: "\\f428"; }

.fa-ember {
  --fa: "\\f423"; }

.fa-canadian-maple-leaf {
  --fa: "\\f785"; }

.fa-teamspeak {
  --fa: "\\f4f9"; }

.fa-pushed {
  --fa: "\\f3e1"; }

.fa-wordpress-simple {
  --fa: "\\f411"; }

.fa-nutritionix {
  --fa: "\\f3d6"; }

.fa-wodu {
  --fa: "\\e088"; }

.fa-google-pay {
  --fa: "\\e079"; }

.fa-intercom {
  --fa: "\\f7af"; }

.fa-zhihu {
  --fa: "\\f63f"; }

.fa-korvue {
  --fa: "\\f42f"; }

.fa-pix {
  --fa: "\\e43a"; }

.fa-steam-symbol {
  --fa: "\\f3f6"; }
:root, :host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free'; }

@font-face {
  font-family: 'Font Awesome 6 Free';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"); }

.far,
.fa-regular {
  font-weight: 400; }
:root, :host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free'; }

@font-face {
  font-family: 'Font Awesome 6 Free';
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"); }

.fas,
.fa-solid {
  font-weight: 900; }
@font-face {
  font-family: 'Font Awesome 5 Brands';
  font-display: block;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"); }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-display: block;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"); }

@font-face {
  font-family: 'Font Awesome 5 Free';
  font-display: block;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"); }
@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"); }

@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"); }

@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  unicode-range: U+F003,U+F006,U+F014,U+F016-F017,U+F01A-F01B,U+F01D,U+F022,U+F03E,U+F044,U+F046,U+F05C-F05D,U+F06E,U+F070,U+F087-F088,U+F08A,U+F094,U+F096-F097,U+F09D,U+F0A0,U+F0A2,U+F0A4-F0A7,U+F0C5,U+F0C7,U+F0E5-F0E6,U+F0EB,U+F0F6-F0F8,U+F10C,U+F114-F115,U+F118-F11A,U+F11C-F11D,U+F133,U+F147,U+F14E,U+F150-F152,U+F185-F186,U+F18E,U+F190-F192,U+F196,U+F1C1-F1C9,U+F1D9,U+F1DB,U+F1E3,U+F1EA,U+F1F7,U+F1F9,U+F20A,U+F247-F248,U+F24A,U+F24D,U+F255-F25B,U+F25D,U+F271-F274,U+F278,U+F27B,U+F28C,U+F28E,U+F29C,U+F2B5,U+F2B7,U+F2BA,U+F2BC,U+F2BE,U+F2C0-F2C1,U+F2C3,U+F2D0,U+F2D2,U+F2D4,U+F2DC; }

@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  unicode-range: U+F041,U+F047,U+F065-F066,U+F07D-F07E,U+F080,U+F08B,U+F08E,U+F090,U+F09A,U+F0AC,U+F0AE,U+F0B2,U+F0D0,U+F0D6,U+F0E4,U+F0EC,U+F10A-F10B,U+F123,U+F13E,U+F148-F149,U+F14C,U+F156,U+F15E,U+F160-F161,U+F163,U+F175-F178,U+F195,U+F1F8,U+F219,U+F27A; }
`, "",{"version":3,"sources":["webpack://./assets/font-awesome/css/all.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,0DAA0D;EAC1D,iCAAiC,EAAE;;AAErC;;;;;;;EAOE,kCAAkC;EAClC,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,oBAAoB,EAAE;;AAExB;;;;;;;EAOE,kBAAkB,EAAE;;AAEtB;;;;;EAKE,kCAAkC,EAAE;;AAEtC;;EAEE,oCAAoC,EAAE;;AAExC;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB,EAAE;;AAE3B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB,EAAE;;AAE7B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB,EAAE;;AAE5B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB,EAAE;;AAE5B;EACE,cAAc;EACd,sBAAsB;EACtB,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,aAAa,EAAE;;AAEjB;EACE,qBAAqB;EACrB,uCAAuC;EACvC,eAAe,EAAE;EACjB;IACE,kBAAkB,EAAE;;AAExB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB,EAAE;;AAExB;EACE,0CAA0C;EAC1C,6CAA6C;EAC7C,2CAA2C;EAC3C,4CAA4C;EAC5C,sDAAsD,EAAE;;AAE1D;EACE,WAAW;EACX,0CAA0C,EAAE;;AAE9C;EACE,YAAY;EACZ,yCAAyC,EAAE;;AAE7C;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,kEAAkE,EAAE;;AAEtE;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,wFAAwF,EAAE;;AAE5F;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,mFAAmF,EAAE;;AAEvF;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,mFAAmF,EAAE;;AAEvF;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,kEAAkE,EAAE;;AAEtE;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,6DAA6D,EAAE;;AAEjE;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,6DAA6D,EAAE;;AAEjE;EACE,iCAAiC,EAAE;;AAErC;;EAEE,uBAAuB;EACvB,0DAA0D;EAC1D,oDAAoD;EACpD,wEAAwE;EACxE,+DAA+D,EAAE;;AAEnE;EACE;;;;;;;;;IASE,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;IACpB,uBAAuB,EAAE,EAAE;;AAE/B;EACE;IACE,mBAAmB,EAAE;EACvB;IACE,4CAA4C,EAAE,EAAE;;AAEpD;EACE;IACE,oCAAoC,EAAE;EACxC;IACE,wGAAwG,EAAE;EAC5G;IACE,oIAAoI,EAAE;EACxI;IACE,wGAAwG,EAAE;EAC5G;IACE,qEAAqE,EAAE;EACzE;IACE,oCAAoC,EAAE;EACxC;IACE,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,oCAAoC,EAAE,EAAE;;AAE5C;EACE;IACE,yCAAyC;IACzC,mBAAmB,EAAE;EACvB;IACE,UAAU;IACV,kDAAkD,EAAE,EAAE;;AAE1D;EACE;IACE,iHAAiH,EAAE,EAAE;;AAEzH;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,wBAAwB,EAAE;EAC5B;IACE,yBAAyB,EAAE;EAC7B;IACE,wBAAwB,EAAE;EAC5B;IACE,yBAAyB,EAAE;EAC7B;IACE,wBAAwB,EAAE;EAC5B;IACE,yBAAyB,EAAE;EAC7B;IACE,wBAAwB,EAAE;EAC5B;IACE,uBAAuB,EAAE,EAAE;;AAE/B;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE,wBAAwB,EAAE;;AAE5B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,wBAAwB,EAAE;;AAE5B;EACE,4CAA4C,EAAE;;AAEhD;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAE;;AAEhB;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,sCAAsC,EAAE;;AAE1C;EACE,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,8BAA8B,EAAE;;AAElC;gEACgE;;AAEhE;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe,EAAE;;AAEnB;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe,EAAE;AACnB;EACE,iDAAiD;EACjD,0DAA0D,EAAE;;AAE9D;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wHAAoH,EAAE;;AAExH;;EAEE,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;AACjB;EACE,gDAAgD;EAChD,yDAAyD,EAAE;;AAE7D;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wHAAsH,EAAE;;AAE1H;;EAEE,gBAAgB,EAAE;AACpB;EACE,gDAAgD;EAChD,uDAAuD,EAAE;;AAE3D;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wHAAkH,EAAE;;AAEtH;;EAEE,gBAAgB,EAAE;AACpB;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,wHAAoH,EAAE;;AAExH;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,wHAAkH,EAAE;;AAEtH;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,wHAAsH,EAAE;AAC1H;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wHAAkH,EAAE;;AAEtH;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wHAAoH,EAAE;;AAExH;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wHAAsH;EACtH,ykBAAykB,EAAE;;AAE7kB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wHAA8H;EAC9H,8PAA8P,EAAE","sourcesContent":["/*!\r\n * Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com\r\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\r\n * Copyright 2024 Fonticons, Inc.\r\n */\r\n.fa {\r\n  font-family: var(--fa-style-family, \"Font Awesome 6 Free\");\r\n  font-weight: var(--fa-style, 900); }\r\n\r\n.fas,\r\n.far,\r\n.fab,\r\n.fa-solid,\r\n.fa-regular,\r\n.fa-brands,\r\n.fa {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: var(--fa-display, inline-block);\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  line-height: 1;\r\n  text-rendering: auto; }\r\n\r\n.fas::before,\r\n.far::before,\r\n.fab::before,\r\n.fa-solid::before,\r\n.fa-regular::before,\r\n.fa-brands::before,\r\n.fa::before {\r\n  content: var(--fa); }\r\n\r\n.fa-classic,\r\n.fas,\r\n.fa-solid,\r\n.far,\r\n.fa-regular {\r\n  font-family: 'Font Awesome 6 Free'; }\r\n\r\n.fa-brands,\r\n.fab {\r\n  font-family: 'Font Awesome 6 Brands'; }\r\n\r\n.fa-1x {\r\n  font-size: 1em; }\r\n\r\n.fa-2x {\r\n  font-size: 2em; }\r\n\r\n.fa-3x {\r\n  font-size: 3em; }\r\n\r\n.fa-4x {\r\n  font-size: 4em; }\r\n\r\n.fa-5x {\r\n  font-size: 5em; }\r\n\r\n.fa-6x {\r\n  font-size: 6em; }\r\n\r\n.fa-7x {\r\n  font-size: 7em; }\r\n\r\n.fa-8x {\r\n  font-size: 8em; }\r\n\r\n.fa-9x {\r\n  font-size: 9em; }\r\n\r\n.fa-10x {\r\n  font-size: 10em; }\r\n\r\n.fa-2xs {\r\n  font-size: 0.625em;\r\n  line-height: 0.1em;\r\n  vertical-align: 0.225em; }\r\n\r\n.fa-xs {\r\n  font-size: 0.75em;\r\n  line-height: 0.08333em;\r\n  vertical-align: 0.125em; }\r\n\r\n.fa-sm {\r\n  font-size: 0.875em;\r\n  line-height: 0.07143em;\r\n  vertical-align: 0.05357em; }\r\n\r\n.fa-lg {\r\n  font-size: 1.25em;\r\n  line-height: 0.05em;\r\n  vertical-align: -0.075em; }\r\n\r\n.fa-xl {\r\n  font-size: 1.5em;\r\n  line-height: 0.04167em;\r\n  vertical-align: -0.125em; }\r\n\r\n.fa-2xl {\r\n  font-size: 2em;\r\n  line-height: 0.03125em;\r\n  vertical-align: -0.1875em; }\r\n\r\n.fa-fw {\r\n  text-align: center;\r\n  width: 1.25em; }\r\n\r\n.fa-ul {\r\n  list-style-type: none;\r\n  margin-left: var(--fa-li-margin, 2.5em);\r\n  padding-left: 0; }\r\n  .fa-ul > li {\r\n    position: relative; }\r\n\r\n.fa-li {\r\n  left: calc(-1 * var(--fa-li-width, 2em));\r\n  position: absolute;\r\n  text-align: center;\r\n  width: var(--fa-li-width, 2em);\r\n  line-height: inherit; }\r\n\r\n.fa-border {\r\n  border-color: var(--fa-border-color, #eee);\r\n  border-radius: var(--fa-border-radius, 0.1em);\r\n  border-style: var(--fa-border-style, solid);\r\n  border-width: var(--fa-border-width, 0.08em);\r\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em); }\r\n\r\n.fa-pull-left {\r\n  float: left;\r\n  margin-right: var(--fa-pull-margin, 0.3em); }\r\n\r\n.fa-pull-right {\r\n  float: right;\r\n  margin-left: var(--fa-pull-margin, 0.3em); }\r\n\r\n.fa-beat {\r\n  animation-name: fa-beat;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, ease-in-out); }\r\n\r\n.fa-bounce {\r\n  animation-name: fa-bounce;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1)); }\r\n\r\n.fa-fade {\r\n  animation-name: fa-fade;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }\r\n\r\n.fa-beat-fade {\r\n  animation-name: fa-beat-fade;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }\r\n\r\n.fa-flip {\r\n  animation-name: fa-flip;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, ease-in-out); }\r\n\r\n.fa-shake {\r\n  animation-name: fa-shake;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, linear); }\r\n\r\n.fa-spin {\r\n  animation-name: fa-spin;\r\n  animation-delay: var(--fa-animation-delay, 0s);\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 2s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, linear); }\r\n\r\n.fa-spin-reverse {\r\n  --fa-animation-direction: reverse; }\r\n\r\n.fa-pulse,\r\n.fa-spin-pulse {\r\n  animation-name: fa-spin;\r\n  animation-direction: var(--fa-animation-direction, normal);\r\n  animation-duration: var(--fa-animation-duration, 1s);\r\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\r\n  animation-timing-function: var(--fa-animation-timing, steps(8)); }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .fa-beat,\r\n  .fa-bounce,\r\n  .fa-fade,\r\n  .fa-beat-fade,\r\n  .fa-flip,\r\n  .fa-pulse,\r\n  .fa-shake,\r\n  .fa-spin,\r\n  .fa-spin-pulse {\r\n    animation-delay: -1ms;\r\n    animation-duration: 1ms;\r\n    animation-iteration-count: 1;\r\n    transition-delay: 0s;\r\n    transition-duration: 0s; } }\r\n\r\n@keyframes fa-beat {\r\n  0%, 90% {\r\n    transform: scale(1); }\r\n  45% {\r\n    transform: scale(var(--fa-beat-scale, 1.25)); } }\r\n\r\n@keyframes fa-bounce {\r\n  0% {\r\n    transform: scale(1, 1) translateY(0); }\r\n  10% {\r\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0); }\r\n  30% {\r\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em)); }\r\n  50% {\r\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0); }\r\n  57% {\r\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em)); }\r\n  64% {\r\n    transform: scale(1, 1) translateY(0); }\r\n  100% {\r\n    transform: scale(1, 1) translateY(0); } }\r\n\r\n@keyframes fa-fade {\r\n  50% {\r\n    opacity: var(--fa-fade-opacity, 0.4); } }\r\n\r\n@keyframes fa-beat-fade {\r\n  0%, 100% {\r\n    opacity: var(--fa-beat-fade-opacity, 0.4);\r\n    transform: scale(1); }\r\n  50% {\r\n    opacity: 1;\r\n    transform: scale(var(--fa-beat-fade-scale, 1.125)); } }\r\n\r\n@keyframes fa-flip {\r\n  50% {\r\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg)); } }\r\n\r\n@keyframes fa-shake {\r\n  0% {\r\n    transform: rotate(-15deg); }\r\n  4% {\r\n    transform: rotate(15deg); }\r\n  8%, 24% {\r\n    transform: rotate(-18deg); }\r\n  12%, 28% {\r\n    transform: rotate(18deg); }\r\n  16% {\r\n    transform: rotate(-22deg); }\r\n  20% {\r\n    transform: rotate(22deg); }\r\n  32% {\r\n    transform: rotate(-12deg); }\r\n  36% {\r\n    transform: rotate(12deg); }\r\n  40%, 100% {\r\n    transform: rotate(0deg); } }\r\n\r\n@keyframes fa-spin {\r\n  0% {\r\n    transform: rotate(0deg); }\r\n  100% {\r\n    transform: rotate(360deg); } }\r\n\r\n.fa-rotate-90 {\r\n  transform: rotate(90deg); }\r\n\r\n.fa-rotate-180 {\r\n  transform: rotate(180deg); }\r\n\r\n.fa-rotate-270 {\r\n  transform: rotate(270deg); }\r\n\r\n.fa-flip-horizontal {\r\n  transform: scale(-1, 1); }\r\n\r\n.fa-flip-vertical {\r\n  transform: scale(1, -1); }\r\n\r\n.fa-flip-both,\r\n.fa-flip-horizontal.fa-flip-vertical {\r\n  transform: scale(-1, -1); }\r\n\r\n.fa-rotate-by {\r\n  transform: rotate(var(--fa-rotate-angle, 0)); }\r\n\r\n.fa-stack {\r\n  display: inline-block;\r\n  height: 2em;\r\n  line-height: 2em;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 2.5em; }\r\n\r\n.fa-stack-1x,\r\n.fa-stack-2x {\r\n  left: 0;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 100%;\r\n  z-index: var(--fa-stack-z-index, auto); }\r\n\r\n.fa-stack-1x {\r\n  line-height: inherit; }\r\n\r\n.fa-stack-2x {\r\n  font-size: 2em; }\r\n\r\n.fa-inverse {\r\n  color: var(--fa-inverse, #fff); }\r\n\r\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\r\nreaders do not read off random characters that represent icons */\r\n\r\n.fa-0 {\r\n  --fa: \"\\30\";\r\n  --fa--fa: \"\\30\\30\"; }\r\n\r\n.fa-1 {\r\n  --fa: \"\\31\";\r\n  --fa--fa: \"\\31\\31\"; }\r\n\r\n.fa-2 {\r\n  --fa: \"\\32\";\r\n  --fa--fa: \"\\32\\32\"; }\r\n\r\n.fa-3 {\r\n  --fa: \"\\33\";\r\n  --fa--fa: \"\\33\\33\"; }\r\n\r\n.fa-4 {\r\n  --fa: \"\\34\";\r\n  --fa--fa: \"\\34\\34\"; }\r\n\r\n.fa-5 {\r\n  --fa: \"\\35\";\r\n  --fa--fa: \"\\35\\35\"; }\r\n\r\n.fa-6 {\r\n  --fa: \"\\36\";\r\n  --fa--fa: \"\\36\\36\"; }\r\n\r\n.fa-7 {\r\n  --fa: \"\\37\";\r\n  --fa--fa: \"\\37\\37\"; }\r\n\r\n.fa-8 {\r\n  --fa: \"\\38\";\r\n  --fa--fa: \"\\38\\38\"; }\r\n\r\n.fa-9 {\r\n  --fa: \"\\39\";\r\n  --fa--fa: \"\\39\\39\"; }\r\n\r\n.fa-fill-drip {\r\n  --fa: \"\\f576\";\r\n  --fa--fa: \"\\f576\\f576\"; }\r\n\r\n.fa-arrows-to-circle {\r\n  --fa: \"\\e4bd\";\r\n  --fa--fa: \"\\e4bd\\e4bd\"; }\r\n\r\n.fa-circle-chevron-right {\r\n  --fa: \"\\f138\";\r\n  --fa--fa: \"\\f138\\f138\"; }\r\n\r\n.fa-chevron-circle-right {\r\n  --fa: \"\\f138\";\r\n  --fa--fa: \"\\f138\\f138\"; }\r\n\r\n.fa-at {\r\n  --fa: \"\\40\";\r\n  --fa--fa: \"\\40\\40\"; }\r\n\r\n.fa-trash-can {\r\n  --fa: \"\\f2ed\";\r\n  --fa--fa: \"\\f2ed\\f2ed\"; }\r\n\r\n.fa-trash-alt {\r\n  --fa: \"\\f2ed\";\r\n  --fa--fa: \"\\f2ed\\f2ed\"; }\r\n\r\n.fa-text-height {\r\n  --fa: \"\\f034\";\r\n  --fa--fa: \"\\f034\\f034\"; }\r\n\r\n.fa-user-xmark {\r\n  --fa: \"\\f235\";\r\n  --fa--fa: \"\\f235\\f235\"; }\r\n\r\n.fa-user-times {\r\n  --fa: \"\\f235\";\r\n  --fa--fa: \"\\f235\\f235\"; }\r\n\r\n.fa-stethoscope {\r\n  --fa: \"\\f0f1\";\r\n  --fa--fa: \"\\f0f1\\f0f1\"; }\r\n\r\n.fa-message {\r\n  --fa: \"\\f27a\";\r\n  --fa--fa: \"\\f27a\\f27a\"; }\r\n\r\n.fa-comment-alt {\r\n  --fa: \"\\f27a\";\r\n  --fa--fa: \"\\f27a\\f27a\"; }\r\n\r\n.fa-info {\r\n  --fa: \"\\f129\";\r\n  --fa--fa: \"\\f129\\f129\"; }\r\n\r\n.fa-down-left-and-up-right-to-center {\r\n  --fa: \"\\f422\";\r\n  --fa--fa: \"\\f422\\f422\"; }\r\n\r\n.fa-compress-alt {\r\n  --fa: \"\\f422\";\r\n  --fa--fa: \"\\f422\\f422\"; }\r\n\r\n.fa-explosion {\r\n  --fa: \"\\e4e9\";\r\n  --fa--fa: \"\\e4e9\\e4e9\"; }\r\n\r\n.fa-file-lines {\r\n  --fa: \"\\f15c\";\r\n  --fa--fa: \"\\f15c\\f15c\"; }\r\n\r\n.fa-file-alt {\r\n  --fa: \"\\f15c\";\r\n  --fa--fa: \"\\f15c\\f15c\"; }\r\n\r\n.fa-file-text {\r\n  --fa: \"\\f15c\";\r\n  --fa--fa: \"\\f15c\\f15c\"; }\r\n\r\n.fa-wave-square {\r\n  --fa: \"\\f83e\";\r\n  --fa--fa: \"\\f83e\\f83e\"; }\r\n\r\n.fa-ring {\r\n  --fa: \"\\f70b\";\r\n  --fa--fa: \"\\f70b\\f70b\"; }\r\n\r\n.fa-building-un {\r\n  --fa: \"\\e4d9\";\r\n  --fa--fa: \"\\e4d9\\e4d9\"; }\r\n\r\n.fa-dice-three {\r\n  --fa: \"\\f527\";\r\n  --fa--fa: \"\\f527\\f527\"; }\r\n\r\n.fa-calendar-days {\r\n  --fa: \"\\f073\";\r\n  --fa--fa: \"\\f073\\f073\"; }\r\n\r\n.fa-calendar-alt {\r\n  --fa: \"\\f073\";\r\n  --fa--fa: \"\\f073\\f073\"; }\r\n\r\n.fa-anchor-circle-check {\r\n  --fa: \"\\e4aa\";\r\n  --fa--fa: \"\\e4aa\\e4aa\"; }\r\n\r\n.fa-building-circle-arrow-right {\r\n  --fa: \"\\e4d1\";\r\n  --fa--fa: \"\\e4d1\\e4d1\"; }\r\n\r\n.fa-volleyball {\r\n  --fa: \"\\f45f\";\r\n  --fa--fa: \"\\f45f\\f45f\"; }\r\n\r\n.fa-volleyball-ball {\r\n  --fa: \"\\f45f\";\r\n  --fa--fa: \"\\f45f\\f45f\"; }\r\n\r\n.fa-arrows-up-to-line {\r\n  --fa: \"\\e4c2\";\r\n  --fa--fa: \"\\e4c2\\e4c2\"; }\r\n\r\n.fa-sort-down {\r\n  --fa: \"\\f0dd\";\r\n  --fa--fa: \"\\f0dd\\f0dd\"; }\r\n\r\n.fa-sort-desc {\r\n  --fa: \"\\f0dd\";\r\n  --fa--fa: \"\\f0dd\\f0dd\"; }\r\n\r\n.fa-circle-minus {\r\n  --fa: \"\\f056\";\r\n  --fa--fa: \"\\f056\\f056\"; }\r\n\r\n.fa-minus-circle {\r\n  --fa: \"\\f056\";\r\n  --fa--fa: \"\\f056\\f056\"; }\r\n\r\n.fa-door-open {\r\n  --fa: \"\\f52b\";\r\n  --fa--fa: \"\\f52b\\f52b\"; }\r\n\r\n.fa-right-from-bracket {\r\n  --fa: \"\\f2f5\";\r\n  --fa--fa: \"\\f2f5\\f2f5\"; }\r\n\r\n.fa-sign-out-alt {\r\n  --fa: \"\\f2f5\";\r\n  --fa--fa: \"\\f2f5\\f2f5\"; }\r\n\r\n.fa-atom {\r\n  --fa: \"\\f5d2\";\r\n  --fa--fa: \"\\f5d2\\f5d2\"; }\r\n\r\n.fa-soap {\r\n  --fa: \"\\e06e\";\r\n  --fa--fa: \"\\e06e\\e06e\"; }\r\n\r\n.fa-icons {\r\n  --fa: \"\\f86d\";\r\n  --fa--fa: \"\\f86d\\f86d\"; }\r\n\r\n.fa-heart-music-camera-bolt {\r\n  --fa: \"\\f86d\";\r\n  --fa--fa: \"\\f86d\\f86d\"; }\r\n\r\n.fa-microphone-lines-slash {\r\n  --fa: \"\\f539\";\r\n  --fa--fa: \"\\f539\\f539\"; }\r\n\r\n.fa-microphone-alt-slash {\r\n  --fa: \"\\f539\";\r\n  --fa--fa: \"\\f539\\f539\"; }\r\n\r\n.fa-bridge-circle-check {\r\n  --fa: \"\\e4c9\";\r\n  --fa--fa: \"\\e4c9\\e4c9\"; }\r\n\r\n.fa-pump-medical {\r\n  --fa: \"\\e06a\";\r\n  --fa--fa: \"\\e06a\\e06a\"; }\r\n\r\n.fa-fingerprint {\r\n  --fa: \"\\f577\";\r\n  --fa--fa: \"\\f577\\f577\"; }\r\n\r\n.fa-hand-point-right {\r\n  --fa: \"\\f0a4\";\r\n  --fa--fa: \"\\f0a4\\f0a4\"; }\r\n\r\n.fa-magnifying-glass-location {\r\n  --fa: \"\\f689\";\r\n  --fa--fa: \"\\f689\\f689\"; }\r\n\r\n.fa-search-location {\r\n  --fa: \"\\f689\";\r\n  --fa--fa: \"\\f689\\f689\"; }\r\n\r\n.fa-forward-step {\r\n  --fa: \"\\f051\";\r\n  --fa--fa: \"\\f051\\f051\"; }\r\n\r\n.fa-step-forward {\r\n  --fa: \"\\f051\";\r\n  --fa--fa: \"\\f051\\f051\"; }\r\n\r\n.fa-face-smile-beam {\r\n  --fa: \"\\f5b8\";\r\n  --fa--fa: \"\\f5b8\\f5b8\"; }\r\n\r\n.fa-smile-beam {\r\n  --fa: \"\\f5b8\";\r\n  --fa--fa: \"\\f5b8\\f5b8\"; }\r\n\r\n.fa-flag-checkered {\r\n  --fa: \"\\f11e\";\r\n  --fa--fa: \"\\f11e\\f11e\"; }\r\n\r\n.fa-football {\r\n  --fa: \"\\f44e\";\r\n  --fa--fa: \"\\f44e\\f44e\"; }\r\n\r\n.fa-football-ball {\r\n  --fa: \"\\f44e\";\r\n  --fa--fa: \"\\f44e\\f44e\"; }\r\n\r\n.fa-school-circle-exclamation {\r\n  --fa: \"\\e56c\";\r\n  --fa--fa: \"\\e56c\\e56c\"; }\r\n\r\n.fa-crop {\r\n  --fa: \"\\f125\";\r\n  --fa--fa: \"\\f125\\f125\"; }\r\n\r\n.fa-angles-down {\r\n  --fa: \"\\f103\";\r\n  --fa--fa: \"\\f103\\f103\"; }\r\n\r\n.fa-angle-double-down {\r\n  --fa: \"\\f103\";\r\n  --fa--fa: \"\\f103\\f103\"; }\r\n\r\n.fa-users-rectangle {\r\n  --fa: \"\\e594\";\r\n  --fa--fa: \"\\e594\\e594\"; }\r\n\r\n.fa-people-roof {\r\n  --fa: \"\\e537\";\r\n  --fa--fa: \"\\e537\\e537\"; }\r\n\r\n.fa-people-line {\r\n  --fa: \"\\e534\";\r\n  --fa--fa: \"\\e534\\e534\"; }\r\n\r\n.fa-beer-mug-empty {\r\n  --fa: \"\\f0fc\";\r\n  --fa--fa: \"\\f0fc\\f0fc\"; }\r\n\r\n.fa-beer {\r\n  --fa: \"\\f0fc\";\r\n  --fa--fa: \"\\f0fc\\f0fc\"; }\r\n\r\n.fa-diagram-predecessor {\r\n  --fa: \"\\e477\";\r\n  --fa--fa: \"\\e477\\e477\"; }\r\n\r\n.fa-arrow-up-long {\r\n  --fa: \"\\f176\";\r\n  --fa--fa: \"\\f176\\f176\"; }\r\n\r\n.fa-long-arrow-up {\r\n  --fa: \"\\f176\";\r\n  --fa--fa: \"\\f176\\f176\"; }\r\n\r\n.fa-fire-flame-simple {\r\n  --fa: \"\\f46a\";\r\n  --fa--fa: \"\\f46a\\f46a\"; }\r\n\r\n.fa-burn {\r\n  --fa: \"\\f46a\";\r\n  --fa--fa: \"\\f46a\\f46a\"; }\r\n\r\n.fa-person {\r\n  --fa: \"\\f183\";\r\n  --fa--fa: \"\\f183\\f183\"; }\r\n\r\n.fa-male {\r\n  --fa: \"\\f183\";\r\n  --fa--fa: \"\\f183\\f183\"; }\r\n\r\n.fa-laptop {\r\n  --fa: \"\\f109\";\r\n  --fa--fa: \"\\f109\\f109\"; }\r\n\r\n.fa-file-csv {\r\n  --fa: \"\\f6dd\";\r\n  --fa--fa: \"\\f6dd\\f6dd\"; }\r\n\r\n.fa-menorah {\r\n  --fa: \"\\f676\";\r\n  --fa--fa: \"\\f676\\f676\"; }\r\n\r\n.fa-truck-plane {\r\n  --fa: \"\\e58f\";\r\n  --fa--fa: \"\\e58f\\e58f\"; }\r\n\r\n.fa-record-vinyl {\r\n  --fa: \"\\f8d9\";\r\n  --fa--fa: \"\\f8d9\\f8d9\"; }\r\n\r\n.fa-face-grin-stars {\r\n  --fa: \"\\f587\";\r\n  --fa--fa: \"\\f587\\f587\"; }\r\n\r\n.fa-grin-stars {\r\n  --fa: \"\\f587\";\r\n  --fa--fa: \"\\f587\\f587\"; }\r\n\r\n.fa-bong {\r\n  --fa: \"\\f55c\";\r\n  --fa--fa: \"\\f55c\\f55c\"; }\r\n\r\n.fa-spaghetti-monster-flying {\r\n  --fa: \"\\f67b\";\r\n  --fa--fa: \"\\f67b\\f67b\"; }\r\n\r\n.fa-pastafarianism {\r\n  --fa: \"\\f67b\";\r\n  --fa--fa: \"\\f67b\\f67b\"; }\r\n\r\n.fa-arrow-down-up-across-line {\r\n  --fa: \"\\e4af\";\r\n  --fa--fa: \"\\e4af\\e4af\"; }\r\n\r\n.fa-spoon {\r\n  --fa: \"\\f2e5\";\r\n  --fa--fa: \"\\f2e5\\f2e5\"; }\r\n\r\n.fa-utensil-spoon {\r\n  --fa: \"\\f2e5\";\r\n  --fa--fa: \"\\f2e5\\f2e5\"; }\r\n\r\n.fa-jar-wheat {\r\n  --fa: \"\\e517\";\r\n  --fa--fa: \"\\e517\\e517\"; }\r\n\r\n.fa-envelopes-bulk {\r\n  --fa: \"\\f674\";\r\n  --fa--fa: \"\\f674\\f674\"; }\r\n\r\n.fa-mail-bulk {\r\n  --fa: \"\\f674\";\r\n  --fa--fa: \"\\f674\\f674\"; }\r\n\r\n.fa-file-circle-exclamation {\r\n  --fa: \"\\e4eb\";\r\n  --fa--fa: \"\\e4eb\\e4eb\"; }\r\n\r\n.fa-circle-h {\r\n  --fa: \"\\f47e\";\r\n  --fa--fa: \"\\f47e\\f47e\"; }\r\n\r\n.fa-hospital-symbol {\r\n  --fa: \"\\f47e\";\r\n  --fa--fa: \"\\f47e\\f47e\"; }\r\n\r\n.fa-pager {\r\n  --fa: \"\\f815\";\r\n  --fa--fa: \"\\f815\\f815\"; }\r\n\r\n.fa-address-book {\r\n  --fa: \"\\f2b9\";\r\n  --fa--fa: \"\\f2b9\\f2b9\"; }\r\n\r\n.fa-contact-book {\r\n  --fa: \"\\f2b9\";\r\n  --fa--fa: \"\\f2b9\\f2b9\"; }\r\n\r\n.fa-strikethrough {\r\n  --fa: \"\\f0cc\";\r\n  --fa--fa: \"\\f0cc\\f0cc\"; }\r\n\r\n.fa-k {\r\n  --fa: \"\\4b\";\r\n  --fa--fa: \"\\4b\\4b\"; }\r\n\r\n.fa-landmark-flag {\r\n  --fa: \"\\e51c\";\r\n  --fa--fa: \"\\e51c\\e51c\"; }\r\n\r\n.fa-pencil {\r\n  --fa: \"\\f303\";\r\n  --fa--fa: \"\\f303\\f303\"; }\r\n\r\n.fa-pencil-alt {\r\n  --fa: \"\\f303\";\r\n  --fa--fa: \"\\f303\\f303\"; }\r\n\r\n.fa-backward {\r\n  --fa: \"\\f04a\";\r\n  --fa--fa: \"\\f04a\\f04a\"; }\r\n\r\n.fa-caret-right {\r\n  --fa: \"\\f0da\";\r\n  --fa--fa: \"\\f0da\\f0da\"; }\r\n\r\n.fa-comments {\r\n  --fa: \"\\f086\";\r\n  --fa--fa: \"\\f086\\f086\"; }\r\n\r\n.fa-paste {\r\n  --fa: \"\\f0ea\";\r\n  --fa--fa: \"\\f0ea\\f0ea\"; }\r\n\r\n.fa-file-clipboard {\r\n  --fa: \"\\f0ea\";\r\n  --fa--fa: \"\\f0ea\\f0ea\"; }\r\n\r\n.fa-code-pull-request {\r\n  --fa: \"\\e13c\";\r\n  --fa--fa: \"\\e13c\\e13c\"; }\r\n\r\n.fa-clipboard-list {\r\n  --fa: \"\\f46d\";\r\n  --fa--fa: \"\\f46d\\f46d\"; }\r\n\r\n.fa-truck-ramp-box {\r\n  --fa: \"\\f4de\";\r\n  --fa--fa: \"\\f4de\\f4de\"; }\r\n\r\n.fa-truck-loading {\r\n  --fa: \"\\f4de\";\r\n  --fa--fa: \"\\f4de\\f4de\"; }\r\n\r\n.fa-user-check {\r\n  --fa: \"\\f4fc\";\r\n  --fa--fa: \"\\f4fc\\f4fc\"; }\r\n\r\n.fa-vial-virus {\r\n  --fa: \"\\e597\";\r\n  --fa--fa: \"\\e597\\e597\"; }\r\n\r\n.fa-sheet-plastic {\r\n  --fa: \"\\e571\";\r\n  --fa--fa: \"\\e571\\e571\"; }\r\n\r\n.fa-blog {\r\n  --fa: \"\\f781\";\r\n  --fa--fa: \"\\f781\\f781\"; }\r\n\r\n.fa-user-ninja {\r\n  --fa: \"\\f504\";\r\n  --fa--fa: \"\\f504\\f504\"; }\r\n\r\n.fa-person-arrow-up-from-line {\r\n  --fa: \"\\e539\";\r\n  --fa--fa: \"\\e539\\e539\"; }\r\n\r\n.fa-scroll-torah {\r\n  --fa: \"\\f6a0\";\r\n  --fa--fa: \"\\f6a0\\f6a0\"; }\r\n\r\n.fa-torah {\r\n  --fa: \"\\f6a0\";\r\n  --fa--fa: \"\\f6a0\\f6a0\"; }\r\n\r\n.fa-broom-ball {\r\n  --fa: \"\\f458\";\r\n  --fa--fa: \"\\f458\\f458\"; }\r\n\r\n.fa-quidditch {\r\n  --fa: \"\\f458\";\r\n  --fa--fa: \"\\f458\\f458\"; }\r\n\r\n.fa-quidditch-broom-ball {\r\n  --fa: \"\\f458\";\r\n  --fa--fa: \"\\f458\\f458\"; }\r\n\r\n.fa-toggle-off {\r\n  --fa: \"\\f204\";\r\n  --fa--fa: \"\\f204\\f204\"; }\r\n\r\n.fa-box-archive {\r\n  --fa: \"\\f187\";\r\n  --fa--fa: \"\\f187\\f187\"; }\r\n\r\n.fa-archive {\r\n  --fa: \"\\f187\";\r\n  --fa--fa: \"\\f187\\f187\"; }\r\n\r\n.fa-person-drowning {\r\n  --fa: \"\\e545\";\r\n  --fa--fa: \"\\e545\\e545\"; }\r\n\r\n.fa-arrow-down-9-1 {\r\n  --fa: \"\\f886\";\r\n  --fa--fa: \"\\f886\\f886\"; }\r\n\r\n.fa-sort-numeric-desc {\r\n  --fa: \"\\f886\";\r\n  --fa--fa: \"\\f886\\f886\"; }\r\n\r\n.fa-sort-numeric-down-alt {\r\n  --fa: \"\\f886\";\r\n  --fa--fa: \"\\f886\\f886\"; }\r\n\r\n.fa-face-grin-tongue-squint {\r\n  --fa: \"\\f58a\";\r\n  --fa--fa: \"\\f58a\\f58a\"; }\r\n\r\n.fa-grin-tongue-squint {\r\n  --fa: \"\\f58a\";\r\n  --fa--fa: \"\\f58a\\f58a\"; }\r\n\r\n.fa-spray-can {\r\n  --fa: \"\\f5bd\";\r\n  --fa--fa: \"\\f5bd\\f5bd\"; }\r\n\r\n.fa-truck-monster {\r\n  --fa: \"\\f63b\";\r\n  --fa--fa: \"\\f63b\\f63b\"; }\r\n\r\n.fa-w {\r\n  --fa: \"\\57\";\r\n  --fa--fa: \"\\57\\57\"; }\r\n\r\n.fa-earth-africa {\r\n  --fa: \"\\f57c\";\r\n  --fa--fa: \"\\f57c\\f57c\"; }\r\n\r\n.fa-globe-africa {\r\n  --fa: \"\\f57c\";\r\n  --fa--fa: \"\\f57c\\f57c\"; }\r\n\r\n.fa-rainbow {\r\n  --fa: \"\\f75b\";\r\n  --fa--fa: \"\\f75b\\f75b\"; }\r\n\r\n.fa-circle-notch {\r\n  --fa: \"\\f1ce\";\r\n  --fa--fa: \"\\f1ce\\f1ce\"; }\r\n\r\n.fa-tablet-screen-button {\r\n  --fa: \"\\f3fa\";\r\n  --fa--fa: \"\\f3fa\\f3fa\"; }\r\n\r\n.fa-tablet-alt {\r\n  --fa: \"\\f3fa\";\r\n  --fa--fa: \"\\f3fa\\f3fa\"; }\r\n\r\n.fa-paw {\r\n  --fa: \"\\f1b0\";\r\n  --fa--fa: \"\\f1b0\\f1b0\"; }\r\n\r\n.fa-cloud {\r\n  --fa: \"\\f0c2\";\r\n  --fa--fa: \"\\f0c2\\f0c2\"; }\r\n\r\n.fa-trowel-bricks {\r\n  --fa: \"\\e58a\";\r\n  --fa--fa: \"\\e58a\\e58a\"; }\r\n\r\n.fa-face-flushed {\r\n  --fa: \"\\f579\";\r\n  --fa--fa: \"\\f579\\f579\"; }\r\n\r\n.fa-flushed {\r\n  --fa: \"\\f579\";\r\n  --fa--fa: \"\\f579\\f579\"; }\r\n\r\n.fa-hospital-user {\r\n  --fa: \"\\f80d\";\r\n  --fa--fa: \"\\f80d\\f80d\"; }\r\n\r\n.fa-tent-arrow-left-right {\r\n  --fa: \"\\e57f\";\r\n  --fa--fa: \"\\e57f\\e57f\"; }\r\n\r\n.fa-gavel {\r\n  --fa: \"\\f0e3\";\r\n  --fa--fa: \"\\f0e3\\f0e3\"; }\r\n\r\n.fa-legal {\r\n  --fa: \"\\f0e3\";\r\n  --fa--fa: \"\\f0e3\\f0e3\"; }\r\n\r\n.fa-binoculars {\r\n  --fa: \"\\f1e5\";\r\n  --fa--fa: \"\\f1e5\\f1e5\"; }\r\n\r\n.fa-microphone-slash {\r\n  --fa: \"\\f131\";\r\n  --fa--fa: \"\\f131\\f131\"; }\r\n\r\n.fa-box-tissue {\r\n  --fa: \"\\e05b\";\r\n  --fa--fa: \"\\e05b\\e05b\"; }\r\n\r\n.fa-motorcycle {\r\n  --fa: \"\\f21c\";\r\n  --fa--fa: \"\\f21c\\f21c\"; }\r\n\r\n.fa-bell-concierge {\r\n  --fa: \"\\f562\";\r\n  --fa--fa: \"\\f562\\f562\"; }\r\n\r\n.fa-concierge-bell {\r\n  --fa: \"\\f562\";\r\n  --fa--fa: \"\\f562\\f562\"; }\r\n\r\n.fa-pen-ruler {\r\n  --fa: \"\\f5ae\";\r\n  --fa--fa: \"\\f5ae\\f5ae\"; }\r\n\r\n.fa-pencil-ruler {\r\n  --fa: \"\\f5ae\";\r\n  --fa--fa: \"\\f5ae\\f5ae\"; }\r\n\r\n.fa-people-arrows {\r\n  --fa: \"\\e068\";\r\n  --fa--fa: \"\\e068\\e068\"; }\r\n\r\n.fa-people-arrows-left-right {\r\n  --fa: \"\\e068\";\r\n  --fa--fa: \"\\e068\\e068\"; }\r\n\r\n.fa-mars-and-venus-burst {\r\n  --fa: \"\\e523\";\r\n  --fa--fa: \"\\e523\\e523\"; }\r\n\r\n.fa-square-caret-right {\r\n  --fa: \"\\f152\";\r\n  --fa--fa: \"\\f152\\f152\"; }\r\n\r\n.fa-caret-square-right {\r\n  --fa: \"\\f152\";\r\n  --fa--fa: \"\\f152\\f152\"; }\r\n\r\n.fa-scissors {\r\n  --fa: \"\\f0c4\";\r\n  --fa--fa: \"\\f0c4\\f0c4\"; }\r\n\r\n.fa-cut {\r\n  --fa: \"\\f0c4\";\r\n  --fa--fa: \"\\f0c4\\f0c4\"; }\r\n\r\n.fa-sun-plant-wilt {\r\n  --fa: \"\\e57a\";\r\n  --fa--fa: \"\\e57a\\e57a\"; }\r\n\r\n.fa-toilets-portable {\r\n  --fa: \"\\e584\";\r\n  --fa--fa: \"\\e584\\e584\"; }\r\n\r\n.fa-hockey-puck {\r\n  --fa: \"\\f453\";\r\n  --fa--fa: \"\\f453\\f453\"; }\r\n\r\n.fa-table {\r\n  --fa: \"\\f0ce\";\r\n  --fa--fa: \"\\f0ce\\f0ce\"; }\r\n\r\n.fa-magnifying-glass-arrow-right {\r\n  --fa: \"\\e521\";\r\n  --fa--fa: \"\\e521\\e521\"; }\r\n\r\n.fa-tachograph-digital {\r\n  --fa: \"\\f566\";\r\n  --fa--fa: \"\\f566\\f566\"; }\r\n\r\n.fa-digital-tachograph {\r\n  --fa: \"\\f566\";\r\n  --fa--fa: \"\\f566\\f566\"; }\r\n\r\n.fa-users-slash {\r\n  --fa: \"\\e073\";\r\n  --fa--fa: \"\\e073\\e073\"; }\r\n\r\n.fa-clover {\r\n  --fa: \"\\e139\";\r\n  --fa--fa: \"\\e139\\e139\"; }\r\n\r\n.fa-reply {\r\n  --fa: \"\\f3e5\";\r\n  --fa--fa: \"\\f3e5\\f3e5\"; }\r\n\r\n.fa-mail-reply {\r\n  --fa: \"\\f3e5\";\r\n  --fa--fa: \"\\f3e5\\f3e5\"; }\r\n\r\n.fa-star-and-crescent {\r\n  --fa: \"\\f699\";\r\n  --fa--fa: \"\\f699\\f699\"; }\r\n\r\n.fa-house-fire {\r\n  --fa: \"\\e50c\";\r\n  --fa--fa: \"\\e50c\\e50c\"; }\r\n\r\n.fa-square-minus {\r\n  --fa: \"\\f146\";\r\n  --fa--fa: \"\\f146\\f146\"; }\r\n\r\n.fa-minus-square {\r\n  --fa: \"\\f146\";\r\n  --fa--fa: \"\\f146\\f146\"; }\r\n\r\n.fa-helicopter {\r\n  --fa: \"\\f533\";\r\n  --fa--fa: \"\\f533\\f533\"; }\r\n\r\n.fa-compass {\r\n  --fa: \"\\f14e\";\r\n  --fa--fa: \"\\f14e\\f14e\"; }\r\n\r\n.fa-square-caret-down {\r\n  --fa: \"\\f150\";\r\n  --fa--fa: \"\\f150\\f150\"; }\r\n\r\n.fa-caret-square-down {\r\n  --fa: \"\\f150\";\r\n  --fa--fa: \"\\f150\\f150\"; }\r\n\r\n.fa-file-circle-question {\r\n  --fa: \"\\e4ef\";\r\n  --fa--fa: \"\\e4ef\\e4ef\"; }\r\n\r\n.fa-laptop-code {\r\n  --fa: \"\\f5fc\";\r\n  --fa--fa: \"\\f5fc\\f5fc\"; }\r\n\r\n.fa-swatchbook {\r\n  --fa: \"\\f5c3\";\r\n  --fa--fa: \"\\f5c3\\f5c3\"; }\r\n\r\n.fa-prescription-bottle {\r\n  --fa: \"\\f485\";\r\n  --fa--fa: \"\\f485\\f485\"; }\r\n\r\n.fa-bars {\r\n  --fa: \"\\f0c9\";\r\n  --fa--fa: \"\\f0c9\\f0c9\"; }\r\n\r\n.fa-navicon {\r\n  --fa: \"\\f0c9\";\r\n  --fa--fa: \"\\f0c9\\f0c9\"; }\r\n\r\n.fa-people-group {\r\n  --fa: \"\\e533\";\r\n  --fa--fa: \"\\e533\\e533\"; }\r\n\r\n.fa-hourglass-end {\r\n  --fa: \"\\f253\";\r\n  --fa--fa: \"\\f253\\f253\"; }\r\n\r\n.fa-hourglass-3 {\r\n  --fa: \"\\f253\";\r\n  --fa--fa: \"\\f253\\f253\"; }\r\n\r\n.fa-heart-crack {\r\n  --fa: \"\\f7a9\";\r\n  --fa--fa: \"\\f7a9\\f7a9\"; }\r\n\r\n.fa-heart-broken {\r\n  --fa: \"\\f7a9\";\r\n  --fa--fa: \"\\f7a9\\f7a9\"; }\r\n\r\n.fa-square-up-right {\r\n  --fa: \"\\f360\";\r\n  --fa--fa: \"\\f360\\f360\"; }\r\n\r\n.fa-external-link-square-alt {\r\n  --fa: \"\\f360\";\r\n  --fa--fa: \"\\f360\\f360\"; }\r\n\r\n.fa-face-kiss-beam {\r\n  --fa: \"\\f597\";\r\n  --fa--fa: \"\\f597\\f597\"; }\r\n\r\n.fa-kiss-beam {\r\n  --fa: \"\\f597\";\r\n  --fa--fa: \"\\f597\\f597\"; }\r\n\r\n.fa-film {\r\n  --fa: \"\\f008\";\r\n  --fa--fa: \"\\f008\\f008\"; }\r\n\r\n.fa-ruler-horizontal {\r\n  --fa: \"\\f547\";\r\n  --fa--fa: \"\\f547\\f547\"; }\r\n\r\n.fa-people-robbery {\r\n  --fa: \"\\e536\";\r\n  --fa--fa: \"\\e536\\e536\"; }\r\n\r\n.fa-lightbulb {\r\n  --fa: \"\\f0eb\";\r\n  --fa--fa: \"\\f0eb\\f0eb\"; }\r\n\r\n.fa-caret-left {\r\n  --fa: \"\\f0d9\";\r\n  --fa--fa: \"\\f0d9\\f0d9\"; }\r\n\r\n.fa-circle-exclamation {\r\n  --fa: \"\\f06a\";\r\n  --fa--fa: \"\\f06a\\f06a\"; }\r\n\r\n.fa-exclamation-circle {\r\n  --fa: \"\\f06a\";\r\n  --fa--fa: \"\\f06a\\f06a\"; }\r\n\r\n.fa-school-circle-xmark {\r\n  --fa: \"\\e56d\";\r\n  --fa--fa: \"\\e56d\\e56d\"; }\r\n\r\n.fa-arrow-right-from-bracket {\r\n  --fa: \"\\f08b\";\r\n  --fa--fa: \"\\f08b\\f08b\"; }\r\n\r\n.fa-sign-out {\r\n  --fa: \"\\f08b\";\r\n  --fa--fa: \"\\f08b\\f08b\"; }\r\n\r\n.fa-circle-chevron-down {\r\n  --fa: \"\\f13a\";\r\n  --fa--fa: \"\\f13a\\f13a\"; }\r\n\r\n.fa-chevron-circle-down {\r\n  --fa: \"\\f13a\";\r\n  --fa--fa: \"\\f13a\\f13a\"; }\r\n\r\n.fa-unlock-keyhole {\r\n  --fa: \"\\f13e\";\r\n  --fa--fa: \"\\f13e\\f13e\"; }\r\n\r\n.fa-unlock-alt {\r\n  --fa: \"\\f13e\";\r\n  --fa--fa: \"\\f13e\\f13e\"; }\r\n\r\n.fa-cloud-showers-heavy {\r\n  --fa: \"\\f740\";\r\n  --fa--fa: \"\\f740\\f740\"; }\r\n\r\n.fa-headphones-simple {\r\n  --fa: \"\\f58f\";\r\n  --fa--fa: \"\\f58f\\f58f\"; }\r\n\r\n.fa-headphones-alt {\r\n  --fa: \"\\f58f\";\r\n  --fa--fa: \"\\f58f\\f58f\"; }\r\n\r\n.fa-sitemap {\r\n  --fa: \"\\f0e8\";\r\n  --fa--fa: \"\\f0e8\\f0e8\"; }\r\n\r\n.fa-circle-dollar-to-slot {\r\n  --fa: \"\\f4b9\";\r\n  --fa--fa: \"\\f4b9\\f4b9\"; }\r\n\r\n.fa-donate {\r\n  --fa: \"\\f4b9\";\r\n  --fa--fa: \"\\f4b9\\f4b9\"; }\r\n\r\n.fa-memory {\r\n  --fa: \"\\f538\";\r\n  --fa--fa: \"\\f538\\f538\"; }\r\n\r\n.fa-road-spikes {\r\n  --fa: \"\\e568\";\r\n  --fa--fa: \"\\e568\\e568\"; }\r\n\r\n.fa-fire-burner {\r\n  --fa: \"\\e4f1\";\r\n  --fa--fa: \"\\e4f1\\e4f1\"; }\r\n\r\n.fa-flag {\r\n  --fa: \"\\f024\";\r\n  --fa--fa: \"\\f024\\f024\"; }\r\n\r\n.fa-hanukiah {\r\n  --fa: \"\\f6e6\";\r\n  --fa--fa: \"\\f6e6\\f6e6\"; }\r\n\r\n.fa-feather {\r\n  --fa: \"\\f52d\";\r\n  --fa--fa: \"\\f52d\\f52d\"; }\r\n\r\n.fa-volume-low {\r\n  --fa: \"\\f027\";\r\n  --fa--fa: \"\\f027\\f027\"; }\r\n\r\n.fa-volume-down {\r\n  --fa: \"\\f027\";\r\n  --fa--fa: \"\\f027\\f027\"; }\r\n\r\n.fa-comment-slash {\r\n  --fa: \"\\f4b3\";\r\n  --fa--fa: \"\\f4b3\\f4b3\"; }\r\n\r\n.fa-cloud-sun-rain {\r\n  --fa: \"\\f743\";\r\n  --fa--fa: \"\\f743\\f743\"; }\r\n\r\n.fa-compress {\r\n  --fa: \"\\f066\";\r\n  --fa--fa: \"\\f066\\f066\"; }\r\n\r\n.fa-wheat-awn {\r\n  --fa: \"\\e2cd\";\r\n  --fa--fa: \"\\e2cd\\e2cd\"; }\r\n\r\n.fa-wheat-alt {\r\n  --fa: \"\\e2cd\";\r\n  --fa--fa: \"\\e2cd\\e2cd\"; }\r\n\r\n.fa-ankh {\r\n  --fa: \"\\f644\";\r\n  --fa--fa: \"\\f644\\f644\"; }\r\n\r\n.fa-hands-holding-child {\r\n  --fa: \"\\e4fa\";\r\n  --fa--fa: \"\\e4fa\\e4fa\"; }\r\n\r\n.fa-asterisk {\r\n  --fa: \"\\2a\";\r\n  --fa--fa: \"\\2a\\2a\"; }\r\n\r\n.fa-square-check {\r\n  --fa: \"\\f14a\";\r\n  --fa--fa: \"\\f14a\\f14a\"; }\r\n\r\n.fa-check-square {\r\n  --fa: \"\\f14a\";\r\n  --fa--fa: \"\\f14a\\f14a\"; }\r\n\r\n.fa-peseta-sign {\r\n  --fa: \"\\e221\";\r\n  --fa--fa: \"\\e221\\e221\"; }\r\n\r\n.fa-heading {\r\n  --fa: \"\\f1dc\";\r\n  --fa--fa: \"\\f1dc\\f1dc\"; }\r\n\r\n.fa-header {\r\n  --fa: \"\\f1dc\";\r\n  --fa--fa: \"\\f1dc\\f1dc\"; }\r\n\r\n.fa-ghost {\r\n  --fa: \"\\f6e2\";\r\n  --fa--fa: \"\\f6e2\\f6e2\"; }\r\n\r\n.fa-list {\r\n  --fa: \"\\f03a\";\r\n  --fa--fa: \"\\f03a\\f03a\"; }\r\n\r\n.fa-list-squares {\r\n  --fa: \"\\f03a\";\r\n  --fa--fa: \"\\f03a\\f03a\"; }\r\n\r\n.fa-square-phone-flip {\r\n  --fa: \"\\f87b\";\r\n  --fa--fa: \"\\f87b\\f87b\"; }\r\n\r\n.fa-phone-square-alt {\r\n  --fa: \"\\f87b\";\r\n  --fa--fa: \"\\f87b\\f87b\"; }\r\n\r\n.fa-cart-plus {\r\n  --fa: \"\\f217\";\r\n  --fa--fa: \"\\f217\\f217\"; }\r\n\r\n.fa-gamepad {\r\n  --fa: \"\\f11b\";\r\n  --fa--fa: \"\\f11b\\f11b\"; }\r\n\r\n.fa-circle-dot {\r\n  --fa: \"\\f192\";\r\n  --fa--fa: \"\\f192\\f192\"; }\r\n\r\n.fa-dot-circle {\r\n  --fa: \"\\f192\";\r\n  --fa--fa: \"\\f192\\f192\"; }\r\n\r\n.fa-face-dizzy {\r\n  --fa: \"\\f567\";\r\n  --fa--fa: \"\\f567\\f567\"; }\r\n\r\n.fa-dizzy {\r\n  --fa: \"\\f567\";\r\n  --fa--fa: \"\\f567\\f567\"; }\r\n\r\n.fa-egg {\r\n  --fa: \"\\f7fb\";\r\n  --fa--fa: \"\\f7fb\\f7fb\"; }\r\n\r\n.fa-house-medical-circle-xmark {\r\n  --fa: \"\\e513\";\r\n  --fa--fa: \"\\e513\\e513\"; }\r\n\r\n.fa-campground {\r\n  --fa: \"\\f6bb\";\r\n  --fa--fa: \"\\f6bb\\f6bb\"; }\r\n\r\n.fa-folder-plus {\r\n  --fa: \"\\f65e\";\r\n  --fa--fa: \"\\f65e\\f65e\"; }\r\n\r\n.fa-futbol {\r\n  --fa: \"\\f1e3\";\r\n  --fa--fa: \"\\f1e3\\f1e3\"; }\r\n\r\n.fa-futbol-ball {\r\n  --fa: \"\\f1e3\";\r\n  --fa--fa: \"\\f1e3\\f1e3\"; }\r\n\r\n.fa-soccer-ball {\r\n  --fa: \"\\f1e3\";\r\n  --fa--fa: \"\\f1e3\\f1e3\"; }\r\n\r\n.fa-paintbrush {\r\n  --fa: \"\\f1fc\";\r\n  --fa--fa: \"\\f1fc\\f1fc\"; }\r\n\r\n.fa-paint-brush {\r\n  --fa: \"\\f1fc\";\r\n  --fa--fa: \"\\f1fc\\f1fc\"; }\r\n\r\n.fa-lock {\r\n  --fa: \"\\f023\";\r\n  --fa--fa: \"\\f023\\f023\"; }\r\n\r\n.fa-gas-pump {\r\n  --fa: \"\\f52f\";\r\n  --fa--fa: \"\\f52f\\f52f\"; }\r\n\r\n.fa-hot-tub-person {\r\n  --fa: \"\\f593\";\r\n  --fa--fa: \"\\f593\\f593\"; }\r\n\r\n.fa-hot-tub {\r\n  --fa: \"\\f593\";\r\n  --fa--fa: \"\\f593\\f593\"; }\r\n\r\n.fa-map-location {\r\n  --fa: \"\\f59f\";\r\n  --fa--fa: \"\\f59f\\f59f\"; }\r\n\r\n.fa-map-marked {\r\n  --fa: \"\\f59f\";\r\n  --fa--fa: \"\\f59f\\f59f\"; }\r\n\r\n.fa-house-flood-water {\r\n  --fa: \"\\e50e\";\r\n  --fa--fa: \"\\e50e\\e50e\"; }\r\n\r\n.fa-tree {\r\n  --fa: \"\\f1bb\";\r\n  --fa--fa: \"\\f1bb\\f1bb\"; }\r\n\r\n.fa-bridge-lock {\r\n  --fa: \"\\e4cc\";\r\n  --fa--fa: \"\\e4cc\\e4cc\"; }\r\n\r\n.fa-sack-dollar {\r\n  --fa: \"\\f81d\";\r\n  --fa--fa: \"\\f81d\\f81d\"; }\r\n\r\n.fa-pen-to-square {\r\n  --fa: \"\\f044\";\r\n  --fa--fa: \"\\f044\\f044\"; }\r\n\r\n.fa-edit {\r\n  --fa: \"\\f044\";\r\n  --fa--fa: \"\\f044\\f044\"; }\r\n\r\n.fa-car-side {\r\n  --fa: \"\\f5e4\";\r\n  --fa--fa: \"\\f5e4\\f5e4\"; }\r\n\r\n.fa-share-nodes {\r\n  --fa: \"\\f1e0\";\r\n  --fa--fa: \"\\f1e0\\f1e0\"; }\r\n\r\n.fa-share-alt {\r\n  --fa: \"\\f1e0\";\r\n  --fa--fa: \"\\f1e0\\f1e0\"; }\r\n\r\n.fa-heart-circle-minus {\r\n  --fa: \"\\e4ff\";\r\n  --fa--fa: \"\\e4ff\\e4ff\"; }\r\n\r\n.fa-hourglass-half {\r\n  --fa: \"\\f252\";\r\n  --fa--fa: \"\\f252\\f252\"; }\r\n\r\n.fa-hourglass-2 {\r\n  --fa: \"\\f252\";\r\n  --fa--fa: \"\\f252\\f252\"; }\r\n\r\n.fa-microscope {\r\n  --fa: \"\\f610\";\r\n  --fa--fa: \"\\f610\\f610\"; }\r\n\r\n.fa-sink {\r\n  --fa: \"\\e06d\";\r\n  --fa--fa: \"\\e06d\\e06d\"; }\r\n\r\n.fa-bag-shopping {\r\n  --fa: \"\\f290\";\r\n  --fa--fa: \"\\f290\\f290\"; }\r\n\r\n.fa-shopping-bag {\r\n  --fa: \"\\f290\";\r\n  --fa--fa: \"\\f290\\f290\"; }\r\n\r\n.fa-arrow-down-z-a {\r\n  --fa: \"\\f881\";\r\n  --fa--fa: \"\\f881\\f881\"; }\r\n\r\n.fa-sort-alpha-desc {\r\n  --fa: \"\\f881\";\r\n  --fa--fa: \"\\f881\\f881\"; }\r\n\r\n.fa-sort-alpha-down-alt {\r\n  --fa: \"\\f881\";\r\n  --fa--fa: \"\\f881\\f881\"; }\r\n\r\n.fa-mitten {\r\n  --fa: \"\\f7b5\";\r\n  --fa--fa: \"\\f7b5\\f7b5\"; }\r\n\r\n.fa-person-rays {\r\n  --fa: \"\\e54d\";\r\n  --fa--fa: \"\\e54d\\e54d\"; }\r\n\r\n.fa-users {\r\n  --fa: \"\\f0c0\";\r\n  --fa--fa: \"\\f0c0\\f0c0\"; }\r\n\r\n.fa-eye-slash {\r\n  --fa: \"\\f070\";\r\n  --fa--fa: \"\\f070\\f070\"; }\r\n\r\n.fa-flask-vial {\r\n  --fa: \"\\e4f3\";\r\n  --fa--fa: \"\\e4f3\\e4f3\"; }\r\n\r\n.fa-hand {\r\n  --fa: \"\\f256\";\r\n  --fa--fa: \"\\f256\\f256\"; }\r\n\r\n.fa-hand-paper {\r\n  --fa: \"\\f256\";\r\n  --fa--fa: \"\\f256\\f256\"; }\r\n\r\n.fa-om {\r\n  --fa: \"\\f679\";\r\n  --fa--fa: \"\\f679\\f679\"; }\r\n\r\n.fa-worm {\r\n  --fa: \"\\e599\";\r\n  --fa--fa: \"\\e599\\e599\"; }\r\n\r\n.fa-house-circle-xmark {\r\n  --fa: \"\\e50b\";\r\n  --fa--fa: \"\\e50b\\e50b\"; }\r\n\r\n.fa-plug {\r\n  --fa: \"\\f1e6\";\r\n  --fa--fa: \"\\f1e6\\f1e6\"; }\r\n\r\n.fa-chevron-up {\r\n  --fa: \"\\f077\";\r\n  --fa--fa: \"\\f077\\f077\"; }\r\n\r\n.fa-hand-spock {\r\n  --fa: \"\\f259\";\r\n  --fa--fa: \"\\f259\\f259\"; }\r\n\r\n.fa-stopwatch {\r\n  --fa: \"\\f2f2\";\r\n  --fa--fa: \"\\f2f2\\f2f2\"; }\r\n\r\n.fa-face-kiss {\r\n  --fa: \"\\f596\";\r\n  --fa--fa: \"\\f596\\f596\"; }\r\n\r\n.fa-kiss {\r\n  --fa: \"\\f596\";\r\n  --fa--fa: \"\\f596\\f596\"; }\r\n\r\n.fa-bridge-circle-xmark {\r\n  --fa: \"\\e4cb\";\r\n  --fa--fa: \"\\e4cb\\e4cb\"; }\r\n\r\n.fa-face-grin-tongue {\r\n  --fa: \"\\f589\";\r\n  --fa--fa: \"\\f589\\f589\"; }\r\n\r\n.fa-grin-tongue {\r\n  --fa: \"\\f589\";\r\n  --fa--fa: \"\\f589\\f589\"; }\r\n\r\n.fa-chess-bishop {\r\n  --fa: \"\\f43a\";\r\n  --fa--fa: \"\\f43a\\f43a\"; }\r\n\r\n.fa-face-grin-wink {\r\n  --fa: \"\\f58c\";\r\n  --fa--fa: \"\\f58c\\f58c\"; }\r\n\r\n.fa-grin-wink {\r\n  --fa: \"\\f58c\";\r\n  --fa--fa: \"\\f58c\\f58c\"; }\r\n\r\n.fa-ear-deaf {\r\n  --fa: \"\\f2a4\";\r\n  --fa--fa: \"\\f2a4\\f2a4\"; }\r\n\r\n.fa-deaf {\r\n  --fa: \"\\f2a4\";\r\n  --fa--fa: \"\\f2a4\\f2a4\"; }\r\n\r\n.fa-deafness {\r\n  --fa: \"\\f2a4\";\r\n  --fa--fa: \"\\f2a4\\f2a4\"; }\r\n\r\n.fa-hard-of-hearing {\r\n  --fa: \"\\f2a4\";\r\n  --fa--fa: \"\\f2a4\\f2a4\"; }\r\n\r\n.fa-road-circle-check {\r\n  --fa: \"\\e564\";\r\n  --fa--fa: \"\\e564\\e564\"; }\r\n\r\n.fa-dice-five {\r\n  --fa: \"\\f523\";\r\n  --fa--fa: \"\\f523\\f523\"; }\r\n\r\n.fa-square-rss {\r\n  --fa: \"\\f143\";\r\n  --fa--fa: \"\\f143\\f143\"; }\r\n\r\n.fa-rss-square {\r\n  --fa: \"\\f143\";\r\n  --fa--fa: \"\\f143\\f143\"; }\r\n\r\n.fa-land-mine-on {\r\n  --fa: \"\\e51b\";\r\n  --fa--fa: \"\\e51b\\e51b\"; }\r\n\r\n.fa-i-cursor {\r\n  --fa: \"\\f246\";\r\n  --fa--fa: \"\\f246\\f246\"; }\r\n\r\n.fa-stamp {\r\n  --fa: \"\\f5bf\";\r\n  --fa--fa: \"\\f5bf\\f5bf\"; }\r\n\r\n.fa-stairs {\r\n  --fa: \"\\e289\";\r\n  --fa--fa: \"\\e289\\e289\"; }\r\n\r\n.fa-i {\r\n  --fa: \"\\49\";\r\n  --fa--fa: \"\\49\\49\"; }\r\n\r\n.fa-hryvnia-sign {\r\n  --fa: \"\\f6f2\";\r\n  --fa--fa: \"\\f6f2\\f6f2\"; }\r\n\r\n.fa-hryvnia {\r\n  --fa: \"\\f6f2\";\r\n  --fa--fa: \"\\f6f2\\f6f2\"; }\r\n\r\n.fa-pills {\r\n  --fa: \"\\f484\";\r\n  --fa--fa: \"\\f484\\f484\"; }\r\n\r\n.fa-face-grin-wide {\r\n  --fa: \"\\f581\";\r\n  --fa--fa: \"\\f581\\f581\"; }\r\n\r\n.fa-grin-alt {\r\n  --fa: \"\\f581\";\r\n  --fa--fa: \"\\f581\\f581\"; }\r\n\r\n.fa-tooth {\r\n  --fa: \"\\f5c9\";\r\n  --fa--fa: \"\\f5c9\\f5c9\"; }\r\n\r\n.fa-v {\r\n  --fa: \"\\56\";\r\n  --fa--fa: \"\\56\\56\"; }\r\n\r\n.fa-bangladeshi-taka-sign {\r\n  --fa: \"\\e2e6\";\r\n  --fa--fa: \"\\e2e6\\e2e6\"; }\r\n\r\n.fa-bicycle {\r\n  --fa: \"\\f206\";\r\n  --fa--fa: \"\\f206\\f206\"; }\r\n\r\n.fa-staff-snake {\r\n  --fa: \"\\e579\";\r\n  --fa--fa: \"\\e579\\e579\"; }\r\n\r\n.fa-rod-asclepius {\r\n  --fa: \"\\e579\";\r\n  --fa--fa: \"\\e579\\e579\"; }\r\n\r\n.fa-rod-snake {\r\n  --fa: \"\\e579\";\r\n  --fa--fa: \"\\e579\\e579\"; }\r\n\r\n.fa-staff-aesculapius {\r\n  --fa: \"\\e579\";\r\n  --fa--fa: \"\\e579\\e579\"; }\r\n\r\n.fa-head-side-cough-slash {\r\n  --fa: \"\\e062\";\r\n  --fa--fa: \"\\e062\\e062\"; }\r\n\r\n.fa-truck-medical {\r\n  --fa: \"\\f0f9\";\r\n  --fa--fa: \"\\f0f9\\f0f9\"; }\r\n\r\n.fa-ambulance {\r\n  --fa: \"\\f0f9\";\r\n  --fa--fa: \"\\f0f9\\f0f9\"; }\r\n\r\n.fa-wheat-awn-circle-exclamation {\r\n  --fa: \"\\e598\";\r\n  --fa--fa: \"\\e598\\e598\"; }\r\n\r\n.fa-snowman {\r\n  --fa: \"\\f7d0\";\r\n  --fa--fa: \"\\f7d0\\f7d0\"; }\r\n\r\n.fa-mortar-pestle {\r\n  --fa: \"\\f5a7\";\r\n  --fa--fa: \"\\f5a7\\f5a7\"; }\r\n\r\n.fa-road-barrier {\r\n  --fa: \"\\e562\";\r\n  --fa--fa: \"\\e562\\e562\"; }\r\n\r\n.fa-school {\r\n  --fa: \"\\f549\";\r\n  --fa--fa: \"\\f549\\f549\"; }\r\n\r\n.fa-igloo {\r\n  --fa: \"\\f7ae\";\r\n  --fa--fa: \"\\f7ae\\f7ae\"; }\r\n\r\n.fa-joint {\r\n  --fa: \"\\f595\";\r\n  --fa--fa: \"\\f595\\f595\"; }\r\n\r\n.fa-angle-right {\r\n  --fa: \"\\f105\";\r\n  --fa--fa: \"\\f105\\f105\"; }\r\n\r\n.fa-horse {\r\n  --fa: \"\\f6f0\";\r\n  --fa--fa: \"\\f6f0\\f6f0\"; }\r\n\r\n.fa-q {\r\n  --fa: \"\\51\";\r\n  --fa--fa: \"\\51\\51\"; }\r\n\r\n.fa-g {\r\n  --fa: \"\\47\";\r\n  --fa--fa: \"\\47\\47\"; }\r\n\r\n.fa-notes-medical {\r\n  --fa: \"\\f481\";\r\n  --fa--fa: \"\\f481\\f481\"; }\r\n\r\n.fa-temperature-half {\r\n  --fa: \"\\f2c9\";\r\n  --fa--fa: \"\\f2c9\\f2c9\"; }\r\n\r\n.fa-temperature-2 {\r\n  --fa: \"\\f2c9\";\r\n  --fa--fa: \"\\f2c9\\f2c9\"; }\r\n\r\n.fa-thermometer-2 {\r\n  --fa: \"\\f2c9\";\r\n  --fa--fa: \"\\f2c9\\f2c9\"; }\r\n\r\n.fa-thermometer-half {\r\n  --fa: \"\\f2c9\";\r\n  --fa--fa: \"\\f2c9\\f2c9\"; }\r\n\r\n.fa-dong-sign {\r\n  --fa: \"\\e169\";\r\n  --fa--fa: \"\\e169\\e169\"; }\r\n\r\n.fa-capsules {\r\n  --fa: \"\\f46b\";\r\n  --fa--fa: \"\\f46b\\f46b\"; }\r\n\r\n.fa-poo-storm {\r\n  --fa: \"\\f75a\";\r\n  --fa--fa: \"\\f75a\\f75a\"; }\r\n\r\n.fa-poo-bolt {\r\n  --fa: \"\\f75a\";\r\n  --fa--fa: \"\\f75a\\f75a\"; }\r\n\r\n.fa-face-frown-open {\r\n  --fa: \"\\f57a\";\r\n  --fa--fa: \"\\f57a\\f57a\"; }\r\n\r\n.fa-frown-open {\r\n  --fa: \"\\f57a\";\r\n  --fa--fa: \"\\f57a\\f57a\"; }\r\n\r\n.fa-hand-point-up {\r\n  --fa: \"\\f0a6\";\r\n  --fa--fa: \"\\f0a6\\f0a6\"; }\r\n\r\n.fa-money-bill {\r\n  --fa: \"\\f0d6\";\r\n  --fa--fa: \"\\f0d6\\f0d6\"; }\r\n\r\n.fa-bookmark {\r\n  --fa: \"\\f02e\";\r\n  --fa--fa: \"\\f02e\\f02e\"; }\r\n\r\n.fa-align-justify {\r\n  --fa: \"\\f039\";\r\n  --fa--fa: \"\\f039\\f039\"; }\r\n\r\n.fa-umbrella-beach {\r\n  --fa: \"\\f5ca\";\r\n  --fa--fa: \"\\f5ca\\f5ca\"; }\r\n\r\n.fa-helmet-un {\r\n  --fa: \"\\e503\";\r\n  --fa--fa: \"\\e503\\e503\"; }\r\n\r\n.fa-bullseye {\r\n  --fa: \"\\f140\";\r\n  --fa--fa: \"\\f140\\f140\"; }\r\n\r\n.fa-bacon {\r\n  --fa: \"\\f7e5\";\r\n  --fa--fa: \"\\f7e5\\f7e5\"; }\r\n\r\n.fa-hand-point-down {\r\n  --fa: \"\\f0a7\";\r\n  --fa--fa: \"\\f0a7\\f0a7\"; }\r\n\r\n.fa-arrow-up-from-bracket {\r\n  --fa: \"\\e09a\";\r\n  --fa--fa: \"\\e09a\\e09a\"; }\r\n\r\n.fa-folder {\r\n  --fa: \"\\f07b\";\r\n  --fa--fa: \"\\f07b\\f07b\"; }\r\n\r\n.fa-folder-blank {\r\n  --fa: \"\\f07b\";\r\n  --fa--fa: \"\\f07b\\f07b\"; }\r\n\r\n.fa-file-waveform {\r\n  --fa: \"\\f478\";\r\n  --fa--fa: \"\\f478\\f478\"; }\r\n\r\n.fa-file-medical-alt {\r\n  --fa: \"\\f478\";\r\n  --fa--fa: \"\\f478\\f478\"; }\r\n\r\n.fa-radiation {\r\n  --fa: \"\\f7b9\";\r\n  --fa--fa: \"\\f7b9\\f7b9\"; }\r\n\r\n.fa-chart-simple {\r\n  --fa: \"\\e473\";\r\n  --fa--fa: \"\\e473\\e473\"; }\r\n\r\n.fa-mars-stroke {\r\n  --fa: \"\\f229\";\r\n  --fa--fa: \"\\f229\\f229\"; }\r\n\r\n.fa-vial {\r\n  --fa: \"\\f492\";\r\n  --fa--fa: \"\\f492\\f492\"; }\r\n\r\n.fa-gauge {\r\n  --fa: \"\\f624\";\r\n  --fa--fa: \"\\f624\\f624\"; }\r\n\r\n.fa-dashboard {\r\n  --fa: \"\\f624\";\r\n  --fa--fa: \"\\f624\\f624\"; }\r\n\r\n.fa-gauge-med {\r\n  --fa: \"\\f624\";\r\n  --fa--fa: \"\\f624\\f624\"; }\r\n\r\n.fa-tachometer-alt-average {\r\n  --fa: \"\\f624\";\r\n  --fa--fa: \"\\f624\\f624\"; }\r\n\r\n.fa-wand-magic-sparkles {\r\n  --fa: \"\\e2ca\";\r\n  --fa--fa: \"\\e2ca\\e2ca\"; }\r\n\r\n.fa-magic-wand-sparkles {\r\n  --fa: \"\\e2ca\";\r\n  --fa--fa: \"\\e2ca\\e2ca\"; }\r\n\r\n.fa-e {\r\n  --fa: \"\\45\";\r\n  --fa--fa: \"\\45\\45\"; }\r\n\r\n.fa-pen-clip {\r\n  --fa: \"\\f305\";\r\n  --fa--fa: \"\\f305\\f305\"; }\r\n\r\n.fa-pen-alt {\r\n  --fa: \"\\f305\";\r\n  --fa--fa: \"\\f305\\f305\"; }\r\n\r\n.fa-bridge-circle-exclamation {\r\n  --fa: \"\\e4ca\";\r\n  --fa--fa: \"\\e4ca\\e4ca\"; }\r\n\r\n.fa-user {\r\n  --fa: \"\\f007\";\r\n  --fa--fa: \"\\f007\\f007\"; }\r\n\r\n.fa-school-circle-check {\r\n  --fa: \"\\e56b\";\r\n  --fa--fa: \"\\e56b\\e56b\"; }\r\n\r\n.fa-dumpster {\r\n  --fa: \"\\f793\";\r\n  --fa--fa: \"\\f793\\f793\"; }\r\n\r\n.fa-van-shuttle {\r\n  --fa: \"\\f5b6\";\r\n  --fa--fa: \"\\f5b6\\f5b6\"; }\r\n\r\n.fa-shuttle-van {\r\n  --fa: \"\\f5b6\";\r\n  --fa--fa: \"\\f5b6\\f5b6\"; }\r\n\r\n.fa-building-user {\r\n  --fa: \"\\e4da\";\r\n  --fa--fa: \"\\e4da\\e4da\"; }\r\n\r\n.fa-square-caret-left {\r\n  --fa: \"\\f191\";\r\n  --fa--fa: \"\\f191\\f191\"; }\r\n\r\n.fa-caret-square-left {\r\n  --fa: \"\\f191\";\r\n  --fa--fa: \"\\f191\\f191\"; }\r\n\r\n.fa-highlighter {\r\n  --fa: \"\\f591\";\r\n  --fa--fa: \"\\f591\\f591\"; }\r\n\r\n.fa-key {\r\n  --fa: \"\\f084\";\r\n  --fa--fa: \"\\f084\\f084\"; }\r\n\r\n.fa-bullhorn {\r\n  --fa: \"\\f0a1\";\r\n  --fa--fa: \"\\f0a1\\f0a1\"; }\r\n\r\n.fa-globe {\r\n  --fa: \"\\f0ac\";\r\n  --fa--fa: \"\\f0ac\\f0ac\"; }\r\n\r\n.fa-synagogue {\r\n  --fa: \"\\f69b\";\r\n  --fa--fa: \"\\f69b\\f69b\"; }\r\n\r\n.fa-person-half-dress {\r\n  --fa: \"\\e548\";\r\n  --fa--fa: \"\\e548\\e548\"; }\r\n\r\n.fa-road-bridge {\r\n  --fa: \"\\e563\";\r\n  --fa--fa: \"\\e563\\e563\"; }\r\n\r\n.fa-location-arrow {\r\n  --fa: \"\\f124\";\r\n  --fa--fa: \"\\f124\\f124\"; }\r\n\r\n.fa-c {\r\n  --fa: \"\\43\";\r\n  --fa--fa: \"\\43\\43\"; }\r\n\r\n.fa-tablet-button {\r\n  --fa: \"\\f10a\";\r\n  --fa--fa: \"\\f10a\\f10a\"; }\r\n\r\n.fa-building-lock {\r\n  --fa: \"\\e4d6\";\r\n  --fa--fa: \"\\e4d6\\e4d6\"; }\r\n\r\n.fa-pizza-slice {\r\n  --fa: \"\\f818\";\r\n  --fa--fa: \"\\f818\\f818\"; }\r\n\r\n.fa-money-bill-wave {\r\n  --fa: \"\\f53a\";\r\n  --fa--fa: \"\\f53a\\f53a\"; }\r\n\r\n.fa-chart-area {\r\n  --fa: \"\\f1fe\";\r\n  --fa--fa: \"\\f1fe\\f1fe\"; }\r\n\r\n.fa-area-chart {\r\n  --fa: \"\\f1fe\";\r\n  --fa--fa: \"\\f1fe\\f1fe\"; }\r\n\r\n.fa-house-flag {\r\n  --fa: \"\\e50d\";\r\n  --fa--fa: \"\\e50d\\e50d\"; }\r\n\r\n.fa-person-circle-minus {\r\n  --fa: \"\\e540\";\r\n  --fa--fa: \"\\e540\\e540\"; }\r\n\r\n.fa-ban {\r\n  --fa: \"\\f05e\";\r\n  --fa--fa: \"\\f05e\\f05e\"; }\r\n\r\n.fa-cancel {\r\n  --fa: \"\\f05e\";\r\n  --fa--fa: \"\\f05e\\f05e\"; }\r\n\r\n.fa-camera-rotate {\r\n  --fa: \"\\e0d8\";\r\n  --fa--fa: \"\\e0d8\\e0d8\"; }\r\n\r\n.fa-spray-can-sparkles {\r\n  --fa: \"\\f5d0\";\r\n  --fa--fa: \"\\f5d0\\f5d0\"; }\r\n\r\n.fa-air-freshener {\r\n  --fa: \"\\f5d0\";\r\n  --fa--fa: \"\\f5d0\\f5d0\"; }\r\n\r\n.fa-star {\r\n  --fa: \"\\f005\";\r\n  --fa--fa: \"\\f005\\f005\"; }\r\n\r\n.fa-repeat {\r\n  --fa: \"\\f363\";\r\n  --fa--fa: \"\\f363\\f363\"; }\r\n\r\n.fa-cross {\r\n  --fa: \"\\f654\";\r\n  --fa--fa: \"\\f654\\f654\"; }\r\n\r\n.fa-box {\r\n  --fa: \"\\f466\";\r\n  --fa--fa: \"\\f466\\f466\"; }\r\n\r\n.fa-venus-mars {\r\n  --fa: \"\\f228\";\r\n  --fa--fa: \"\\f228\\f228\"; }\r\n\r\n.fa-arrow-pointer {\r\n  --fa: \"\\f245\";\r\n  --fa--fa: \"\\f245\\f245\"; }\r\n\r\n.fa-mouse-pointer {\r\n  --fa: \"\\f245\";\r\n  --fa--fa: \"\\f245\\f245\"; }\r\n\r\n.fa-maximize {\r\n  --fa: \"\\f31e\";\r\n  --fa--fa: \"\\f31e\\f31e\"; }\r\n\r\n.fa-expand-arrows-alt {\r\n  --fa: \"\\f31e\";\r\n  --fa--fa: \"\\f31e\\f31e\"; }\r\n\r\n.fa-charging-station {\r\n  --fa: \"\\f5e7\";\r\n  --fa--fa: \"\\f5e7\\f5e7\"; }\r\n\r\n.fa-shapes {\r\n  --fa: \"\\f61f\";\r\n  --fa--fa: \"\\f61f\\f61f\"; }\r\n\r\n.fa-triangle-circle-square {\r\n  --fa: \"\\f61f\";\r\n  --fa--fa: \"\\f61f\\f61f\"; }\r\n\r\n.fa-shuffle {\r\n  --fa: \"\\f074\";\r\n  --fa--fa: \"\\f074\\f074\"; }\r\n\r\n.fa-random {\r\n  --fa: \"\\f074\";\r\n  --fa--fa: \"\\f074\\f074\"; }\r\n\r\n.fa-person-running {\r\n  --fa: \"\\f70c\";\r\n  --fa--fa: \"\\f70c\\f70c\"; }\r\n\r\n.fa-running {\r\n  --fa: \"\\f70c\";\r\n  --fa--fa: \"\\f70c\\f70c\"; }\r\n\r\n.fa-mobile-retro {\r\n  --fa: \"\\e527\";\r\n  --fa--fa: \"\\e527\\e527\"; }\r\n\r\n.fa-grip-lines-vertical {\r\n  --fa: \"\\f7a5\";\r\n  --fa--fa: \"\\f7a5\\f7a5\"; }\r\n\r\n.fa-spider {\r\n  --fa: \"\\f717\";\r\n  --fa--fa: \"\\f717\\f717\"; }\r\n\r\n.fa-hands-bound {\r\n  --fa: \"\\e4f9\";\r\n  --fa--fa: \"\\e4f9\\e4f9\"; }\r\n\r\n.fa-file-invoice-dollar {\r\n  --fa: \"\\f571\";\r\n  --fa--fa: \"\\f571\\f571\"; }\r\n\r\n.fa-plane-circle-exclamation {\r\n  --fa: \"\\e556\";\r\n  --fa--fa: \"\\e556\\e556\"; }\r\n\r\n.fa-x-ray {\r\n  --fa: \"\\f497\";\r\n  --fa--fa: \"\\f497\\f497\"; }\r\n\r\n.fa-spell-check {\r\n  --fa: \"\\f891\";\r\n  --fa--fa: \"\\f891\\f891\"; }\r\n\r\n.fa-slash {\r\n  --fa: \"\\f715\";\r\n  --fa--fa: \"\\f715\\f715\"; }\r\n\r\n.fa-computer-mouse {\r\n  --fa: \"\\f8cc\";\r\n  --fa--fa: \"\\f8cc\\f8cc\"; }\r\n\r\n.fa-mouse {\r\n  --fa: \"\\f8cc\";\r\n  --fa--fa: \"\\f8cc\\f8cc\"; }\r\n\r\n.fa-arrow-right-to-bracket {\r\n  --fa: \"\\f090\";\r\n  --fa--fa: \"\\f090\\f090\"; }\r\n\r\n.fa-sign-in {\r\n  --fa: \"\\f090\";\r\n  --fa--fa: \"\\f090\\f090\"; }\r\n\r\n.fa-shop-slash {\r\n  --fa: \"\\e070\";\r\n  --fa--fa: \"\\e070\\e070\"; }\r\n\r\n.fa-store-alt-slash {\r\n  --fa: \"\\e070\";\r\n  --fa--fa: \"\\e070\\e070\"; }\r\n\r\n.fa-server {\r\n  --fa: \"\\f233\";\r\n  --fa--fa: \"\\f233\\f233\"; }\r\n\r\n.fa-virus-covid-slash {\r\n  --fa: \"\\e4a9\";\r\n  --fa--fa: \"\\e4a9\\e4a9\"; }\r\n\r\n.fa-shop-lock {\r\n  --fa: \"\\e4a5\";\r\n  --fa--fa: \"\\e4a5\\e4a5\"; }\r\n\r\n.fa-hourglass-start {\r\n  --fa: \"\\f251\";\r\n  --fa--fa: \"\\f251\\f251\"; }\r\n\r\n.fa-hourglass-1 {\r\n  --fa: \"\\f251\";\r\n  --fa--fa: \"\\f251\\f251\"; }\r\n\r\n.fa-blender-phone {\r\n  --fa: \"\\f6b6\";\r\n  --fa--fa: \"\\f6b6\\f6b6\"; }\r\n\r\n.fa-building-wheat {\r\n  --fa: \"\\e4db\";\r\n  --fa--fa: \"\\e4db\\e4db\"; }\r\n\r\n.fa-person-breastfeeding {\r\n  --fa: \"\\e53a\";\r\n  --fa--fa: \"\\e53a\\e53a\"; }\r\n\r\n.fa-right-to-bracket {\r\n  --fa: \"\\f2f6\";\r\n  --fa--fa: \"\\f2f6\\f2f6\"; }\r\n\r\n.fa-sign-in-alt {\r\n  --fa: \"\\f2f6\";\r\n  --fa--fa: \"\\f2f6\\f2f6\"; }\r\n\r\n.fa-venus {\r\n  --fa: \"\\f221\";\r\n  --fa--fa: \"\\f221\\f221\"; }\r\n\r\n.fa-passport {\r\n  --fa: \"\\f5ab\";\r\n  --fa--fa: \"\\f5ab\\f5ab\"; }\r\n\r\n.fa-thumbtack-slash {\r\n  --fa: \"\\e68f\";\r\n  --fa--fa: \"\\e68f\\e68f\"; }\r\n\r\n.fa-thumb-tack-slash {\r\n  --fa: \"\\e68f\";\r\n  --fa--fa: \"\\e68f\\e68f\"; }\r\n\r\n.fa-heart-pulse {\r\n  --fa: \"\\f21e\";\r\n  --fa--fa: \"\\f21e\\f21e\"; }\r\n\r\n.fa-heartbeat {\r\n  --fa: \"\\f21e\";\r\n  --fa--fa: \"\\f21e\\f21e\"; }\r\n\r\n.fa-people-carry-box {\r\n  --fa: \"\\f4ce\";\r\n  --fa--fa: \"\\f4ce\\f4ce\"; }\r\n\r\n.fa-people-carry {\r\n  --fa: \"\\f4ce\";\r\n  --fa--fa: \"\\f4ce\\f4ce\"; }\r\n\r\n.fa-temperature-high {\r\n  --fa: \"\\f769\";\r\n  --fa--fa: \"\\f769\\f769\"; }\r\n\r\n.fa-microchip {\r\n  --fa: \"\\f2db\";\r\n  --fa--fa: \"\\f2db\\f2db\"; }\r\n\r\n.fa-crown {\r\n  --fa: \"\\f521\";\r\n  --fa--fa: \"\\f521\\f521\"; }\r\n\r\n.fa-weight-hanging {\r\n  --fa: \"\\f5cd\";\r\n  --fa--fa: \"\\f5cd\\f5cd\"; }\r\n\r\n.fa-xmarks-lines {\r\n  --fa: \"\\e59a\";\r\n  --fa--fa: \"\\e59a\\e59a\"; }\r\n\r\n.fa-file-prescription {\r\n  --fa: \"\\f572\";\r\n  --fa--fa: \"\\f572\\f572\"; }\r\n\r\n.fa-weight-scale {\r\n  --fa: \"\\f496\";\r\n  --fa--fa: \"\\f496\\f496\"; }\r\n\r\n.fa-weight {\r\n  --fa: \"\\f496\";\r\n  --fa--fa: \"\\f496\\f496\"; }\r\n\r\n.fa-user-group {\r\n  --fa: \"\\f500\";\r\n  --fa--fa: \"\\f500\\f500\"; }\r\n\r\n.fa-user-friends {\r\n  --fa: \"\\f500\";\r\n  --fa--fa: \"\\f500\\f500\"; }\r\n\r\n.fa-arrow-up-a-z {\r\n  --fa: \"\\f15e\";\r\n  --fa--fa: \"\\f15e\\f15e\"; }\r\n\r\n.fa-sort-alpha-up {\r\n  --fa: \"\\f15e\";\r\n  --fa--fa: \"\\f15e\\f15e\"; }\r\n\r\n.fa-chess-knight {\r\n  --fa: \"\\f441\";\r\n  --fa--fa: \"\\f441\\f441\"; }\r\n\r\n.fa-face-laugh-squint {\r\n  --fa: \"\\f59b\";\r\n  --fa--fa: \"\\f59b\\f59b\"; }\r\n\r\n.fa-laugh-squint {\r\n  --fa: \"\\f59b\";\r\n  --fa--fa: \"\\f59b\\f59b\"; }\r\n\r\n.fa-wheelchair {\r\n  --fa: \"\\f193\";\r\n  --fa--fa: \"\\f193\\f193\"; }\r\n\r\n.fa-circle-arrow-up {\r\n  --fa: \"\\f0aa\";\r\n  --fa--fa: \"\\f0aa\\f0aa\"; }\r\n\r\n.fa-arrow-circle-up {\r\n  --fa: \"\\f0aa\";\r\n  --fa--fa: \"\\f0aa\\f0aa\"; }\r\n\r\n.fa-toggle-on {\r\n  --fa: \"\\f205\";\r\n  --fa--fa: \"\\f205\\f205\"; }\r\n\r\n.fa-person-walking {\r\n  --fa: \"\\f554\";\r\n  --fa--fa: \"\\f554\\f554\"; }\r\n\r\n.fa-walking {\r\n  --fa: \"\\f554\";\r\n  --fa--fa: \"\\f554\\f554\"; }\r\n\r\n.fa-l {\r\n  --fa: \"\\4c\";\r\n  --fa--fa: \"\\4c\\4c\"; }\r\n\r\n.fa-fire {\r\n  --fa: \"\\f06d\";\r\n  --fa--fa: \"\\f06d\\f06d\"; }\r\n\r\n.fa-bed-pulse {\r\n  --fa: \"\\f487\";\r\n  --fa--fa: \"\\f487\\f487\"; }\r\n\r\n.fa-procedures {\r\n  --fa: \"\\f487\";\r\n  --fa--fa: \"\\f487\\f487\"; }\r\n\r\n.fa-shuttle-space {\r\n  --fa: \"\\f197\";\r\n  --fa--fa: \"\\f197\\f197\"; }\r\n\r\n.fa-space-shuttle {\r\n  --fa: \"\\f197\";\r\n  --fa--fa: \"\\f197\\f197\"; }\r\n\r\n.fa-face-laugh {\r\n  --fa: \"\\f599\";\r\n  --fa--fa: \"\\f599\\f599\"; }\r\n\r\n.fa-laugh {\r\n  --fa: \"\\f599\";\r\n  --fa--fa: \"\\f599\\f599\"; }\r\n\r\n.fa-folder-open {\r\n  --fa: \"\\f07c\";\r\n  --fa--fa: \"\\f07c\\f07c\"; }\r\n\r\n.fa-heart-circle-plus {\r\n  --fa: \"\\e500\";\r\n  --fa--fa: \"\\e500\\e500\"; }\r\n\r\n.fa-code-fork {\r\n  --fa: \"\\e13b\";\r\n  --fa--fa: \"\\e13b\\e13b\"; }\r\n\r\n.fa-city {\r\n  --fa: \"\\f64f\";\r\n  --fa--fa: \"\\f64f\\f64f\"; }\r\n\r\n.fa-microphone-lines {\r\n  --fa: \"\\f3c9\";\r\n  --fa--fa: \"\\f3c9\\f3c9\"; }\r\n\r\n.fa-microphone-alt {\r\n  --fa: \"\\f3c9\";\r\n  --fa--fa: \"\\f3c9\\f3c9\"; }\r\n\r\n.fa-pepper-hot {\r\n  --fa: \"\\f816\";\r\n  --fa--fa: \"\\f816\\f816\"; }\r\n\r\n.fa-unlock {\r\n  --fa: \"\\f09c\";\r\n  --fa--fa: \"\\f09c\\f09c\"; }\r\n\r\n.fa-colon-sign {\r\n  --fa: \"\\e140\";\r\n  --fa--fa: \"\\e140\\e140\"; }\r\n\r\n.fa-headset {\r\n  --fa: \"\\f590\";\r\n  --fa--fa: \"\\f590\\f590\"; }\r\n\r\n.fa-store-slash {\r\n  --fa: \"\\e071\";\r\n  --fa--fa: \"\\e071\\e071\"; }\r\n\r\n.fa-road-circle-xmark {\r\n  --fa: \"\\e566\";\r\n  --fa--fa: \"\\e566\\e566\"; }\r\n\r\n.fa-user-minus {\r\n  --fa: \"\\f503\";\r\n  --fa--fa: \"\\f503\\f503\"; }\r\n\r\n.fa-mars-stroke-up {\r\n  --fa: \"\\f22a\";\r\n  --fa--fa: \"\\f22a\\f22a\"; }\r\n\r\n.fa-mars-stroke-v {\r\n  --fa: \"\\f22a\";\r\n  --fa--fa: \"\\f22a\\f22a\"; }\r\n\r\n.fa-champagne-glasses {\r\n  --fa: \"\\f79f\";\r\n  --fa--fa: \"\\f79f\\f79f\"; }\r\n\r\n.fa-glass-cheers {\r\n  --fa: \"\\f79f\";\r\n  --fa--fa: \"\\f79f\\f79f\"; }\r\n\r\n.fa-clipboard {\r\n  --fa: \"\\f328\";\r\n  --fa--fa: \"\\f328\\f328\"; }\r\n\r\n.fa-house-circle-exclamation {\r\n  --fa: \"\\e50a\";\r\n  --fa--fa: \"\\e50a\\e50a\"; }\r\n\r\n.fa-file-arrow-up {\r\n  --fa: \"\\f574\";\r\n  --fa--fa: \"\\f574\\f574\"; }\r\n\r\n.fa-file-upload {\r\n  --fa: \"\\f574\";\r\n  --fa--fa: \"\\f574\\f574\"; }\r\n\r\n.fa-wifi {\r\n  --fa: \"\\f1eb\";\r\n  --fa--fa: \"\\f1eb\\f1eb\"; }\r\n\r\n.fa-wifi-3 {\r\n  --fa: \"\\f1eb\";\r\n  --fa--fa: \"\\f1eb\\f1eb\"; }\r\n\r\n.fa-wifi-strong {\r\n  --fa: \"\\f1eb\";\r\n  --fa--fa: \"\\f1eb\\f1eb\"; }\r\n\r\n.fa-bath {\r\n  --fa: \"\\f2cd\";\r\n  --fa--fa: \"\\f2cd\\f2cd\"; }\r\n\r\n.fa-bathtub {\r\n  --fa: \"\\f2cd\";\r\n  --fa--fa: \"\\f2cd\\f2cd\"; }\r\n\r\n.fa-underline {\r\n  --fa: \"\\f0cd\";\r\n  --fa--fa: \"\\f0cd\\f0cd\"; }\r\n\r\n.fa-user-pen {\r\n  --fa: \"\\f4ff\";\r\n  --fa--fa: \"\\f4ff\\f4ff\"; }\r\n\r\n.fa-user-edit {\r\n  --fa: \"\\f4ff\";\r\n  --fa--fa: \"\\f4ff\\f4ff\"; }\r\n\r\n.fa-signature {\r\n  --fa: \"\\f5b7\";\r\n  --fa--fa: \"\\f5b7\\f5b7\"; }\r\n\r\n.fa-stroopwafel {\r\n  --fa: \"\\f551\";\r\n  --fa--fa: \"\\f551\\f551\"; }\r\n\r\n.fa-bold {\r\n  --fa: \"\\f032\";\r\n  --fa--fa: \"\\f032\\f032\"; }\r\n\r\n.fa-anchor-lock {\r\n  --fa: \"\\e4ad\";\r\n  --fa--fa: \"\\e4ad\\e4ad\"; }\r\n\r\n.fa-building-ngo {\r\n  --fa: \"\\e4d7\";\r\n  --fa--fa: \"\\e4d7\\e4d7\"; }\r\n\r\n.fa-manat-sign {\r\n  --fa: \"\\e1d5\";\r\n  --fa--fa: \"\\e1d5\\e1d5\"; }\r\n\r\n.fa-not-equal {\r\n  --fa: \"\\f53e\";\r\n  --fa--fa: \"\\f53e\\f53e\"; }\r\n\r\n.fa-border-top-left {\r\n  --fa: \"\\f853\";\r\n  --fa--fa: \"\\f853\\f853\"; }\r\n\r\n.fa-border-style {\r\n  --fa: \"\\f853\";\r\n  --fa--fa: \"\\f853\\f853\"; }\r\n\r\n.fa-map-location-dot {\r\n  --fa: \"\\f5a0\";\r\n  --fa--fa: \"\\f5a0\\f5a0\"; }\r\n\r\n.fa-map-marked-alt {\r\n  --fa: \"\\f5a0\";\r\n  --fa--fa: \"\\f5a0\\f5a0\"; }\r\n\r\n.fa-jedi {\r\n  --fa: \"\\f669\";\r\n  --fa--fa: \"\\f669\\f669\"; }\r\n\r\n.fa-square-poll-vertical {\r\n  --fa: \"\\f681\";\r\n  --fa--fa: \"\\f681\\f681\"; }\r\n\r\n.fa-poll {\r\n  --fa: \"\\f681\";\r\n  --fa--fa: \"\\f681\\f681\"; }\r\n\r\n.fa-mug-hot {\r\n  --fa: \"\\f7b6\";\r\n  --fa--fa: \"\\f7b6\\f7b6\"; }\r\n\r\n.fa-car-battery {\r\n  --fa: \"\\f5df\";\r\n  --fa--fa: \"\\f5df\\f5df\"; }\r\n\r\n.fa-battery-car {\r\n  --fa: \"\\f5df\";\r\n  --fa--fa: \"\\f5df\\f5df\"; }\r\n\r\n.fa-gift {\r\n  --fa: \"\\f06b\";\r\n  --fa--fa: \"\\f06b\\f06b\"; }\r\n\r\n.fa-dice-two {\r\n  --fa: \"\\f528\";\r\n  --fa--fa: \"\\f528\\f528\"; }\r\n\r\n.fa-chess-queen {\r\n  --fa: \"\\f445\";\r\n  --fa--fa: \"\\f445\\f445\"; }\r\n\r\n.fa-glasses {\r\n  --fa: \"\\f530\";\r\n  --fa--fa: \"\\f530\\f530\"; }\r\n\r\n.fa-chess-board {\r\n  --fa: \"\\f43c\";\r\n  --fa--fa: \"\\f43c\\f43c\"; }\r\n\r\n.fa-building-circle-check {\r\n  --fa: \"\\e4d2\";\r\n  --fa--fa: \"\\e4d2\\e4d2\"; }\r\n\r\n.fa-person-chalkboard {\r\n  --fa: \"\\e53d\";\r\n  --fa--fa: \"\\e53d\\e53d\"; }\r\n\r\n.fa-mars-stroke-right {\r\n  --fa: \"\\f22b\";\r\n  --fa--fa: \"\\f22b\\f22b\"; }\r\n\r\n.fa-mars-stroke-h {\r\n  --fa: \"\\f22b\";\r\n  --fa--fa: \"\\f22b\\f22b\"; }\r\n\r\n.fa-hand-back-fist {\r\n  --fa: \"\\f255\";\r\n  --fa--fa: \"\\f255\\f255\"; }\r\n\r\n.fa-hand-rock {\r\n  --fa: \"\\f255\";\r\n  --fa--fa: \"\\f255\\f255\"; }\r\n\r\n.fa-square-caret-up {\r\n  --fa: \"\\f151\";\r\n  --fa--fa: \"\\f151\\f151\"; }\r\n\r\n.fa-caret-square-up {\r\n  --fa: \"\\f151\";\r\n  --fa--fa: \"\\f151\\f151\"; }\r\n\r\n.fa-cloud-showers-water {\r\n  --fa: \"\\e4e4\";\r\n  --fa--fa: \"\\e4e4\\e4e4\"; }\r\n\r\n.fa-chart-bar {\r\n  --fa: \"\\f080\";\r\n  --fa--fa: \"\\f080\\f080\"; }\r\n\r\n.fa-bar-chart {\r\n  --fa: \"\\f080\";\r\n  --fa--fa: \"\\f080\\f080\"; }\r\n\r\n.fa-hands-bubbles {\r\n  --fa: \"\\e05e\";\r\n  --fa--fa: \"\\e05e\\e05e\"; }\r\n\r\n.fa-hands-wash {\r\n  --fa: \"\\e05e\";\r\n  --fa--fa: \"\\e05e\\e05e\"; }\r\n\r\n.fa-less-than-equal {\r\n  --fa: \"\\f537\";\r\n  --fa--fa: \"\\f537\\f537\"; }\r\n\r\n.fa-train {\r\n  --fa: \"\\f238\";\r\n  --fa--fa: \"\\f238\\f238\"; }\r\n\r\n.fa-eye-low-vision {\r\n  --fa: \"\\f2a8\";\r\n  --fa--fa: \"\\f2a8\\f2a8\"; }\r\n\r\n.fa-low-vision {\r\n  --fa: \"\\f2a8\";\r\n  --fa--fa: \"\\f2a8\\f2a8\"; }\r\n\r\n.fa-crow {\r\n  --fa: \"\\f520\";\r\n  --fa--fa: \"\\f520\\f520\"; }\r\n\r\n.fa-sailboat {\r\n  --fa: \"\\e445\";\r\n  --fa--fa: \"\\e445\\e445\"; }\r\n\r\n.fa-window-restore {\r\n  --fa: \"\\f2d2\";\r\n  --fa--fa: \"\\f2d2\\f2d2\"; }\r\n\r\n.fa-square-plus {\r\n  --fa: \"\\f0fe\";\r\n  --fa--fa: \"\\f0fe\\f0fe\"; }\r\n\r\n.fa-plus-square {\r\n  --fa: \"\\f0fe\";\r\n  --fa--fa: \"\\f0fe\\f0fe\"; }\r\n\r\n.fa-torii-gate {\r\n  --fa: \"\\f6a1\";\r\n  --fa--fa: \"\\f6a1\\f6a1\"; }\r\n\r\n.fa-frog {\r\n  --fa: \"\\f52e\";\r\n  --fa--fa: \"\\f52e\\f52e\"; }\r\n\r\n.fa-bucket {\r\n  --fa: \"\\e4cf\";\r\n  --fa--fa: \"\\e4cf\\e4cf\"; }\r\n\r\n.fa-image {\r\n  --fa: \"\\f03e\";\r\n  --fa--fa: \"\\f03e\\f03e\"; }\r\n\r\n.fa-microphone {\r\n  --fa: \"\\f130\";\r\n  --fa--fa: \"\\f130\\f130\"; }\r\n\r\n.fa-cow {\r\n  --fa: \"\\f6c8\";\r\n  --fa--fa: \"\\f6c8\\f6c8\"; }\r\n\r\n.fa-caret-up {\r\n  --fa: \"\\f0d8\";\r\n  --fa--fa: \"\\f0d8\\f0d8\"; }\r\n\r\n.fa-screwdriver {\r\n  --fa: \"\\f54a\";\r\n  --fa--fa: \"\\f54a\\f54a\"; }\r\n\r\n.fa-folder-closed {\r\n  --fa: \"\\e185\";\r\n  --fa--fa: \"\\e185\\e185\"; }\r\n\r\n.fa-house-tsunami {\r\n  --fa: \"\\e515\";\r\n  --fa--fa: \"\\e515\\e515\"; }\r\n\r\n.fa-square-nfi {\r\n  --fa: \"\\e576\";\r\n  --fa--fa: \"\\e576\\e576\"; }\r\n\r\n.fa-arrow-up-from-ground-water {\r\n  --fa: \"\\e4b5\";\r\n  --fa--fa: \"\\e4b5\\e4b5\"; }\r\n\r\n.fa-martini-glass {\r\n  --fa: \"\\f57b\";\r\n  --fa--fa: \"\\f57b\\f57b\"; }\r\n\r\n.fa-glass-martini-alt {\r\n  --fa: \"\\f57b\";\r\n  --fa--fa: \"\\f57b\\f57b\"; }\r\n\r\n.fa-square-binary {\r\n  --fa: \"\\e69b\";\r\n  --fa--fa: \"\\e69b\\e69b\"; }\r\n\r\n.fa-rotate-left {\r\n  --fa: \"\\f2ea\";\r\n  --fa--fa: \"\\f2ea\\f2ea\"; }\r\n\r\n.fa-rotate-back {\r\n  --fa: \"\\f2ea\";\r\n  --fa--fa: \"\\f2ea\\f2ea\"; }\r\n\r\n.fa-rotate-backward {\r\n  --fa: \"\\f2ea\";\r\n  --fa--fa: \"\\f2ea\\f2ea\"; }\r\n\r\n.fa-undo-alt {\r\n  --fa: \"\\f2ea\";\r\n  --fa--fa: \"\\f2ea\\f2ea\"; }\r\n\r\n.fa-table-columns {\r\n  --fa: \"\\f0db\";\r\n  --fa--fa: \"\\f0db\\f0db\"; }\r\n\r\n.fa-columns {\r\n  --fa: \"\\f0db\";\r\n  --fa--fa: \"\\f0db\\f0db\"; }\r\n\r\n.fa-lemon {\r\n  --fa: \"\\f094\";\r\n  --fa--fa: \"\\f094\\f094\"; }\r\n\r\n.fa-head-side-mask {\r\n  --fa: \"\\e063\";\r\n  --fa--fa: \"\\e063\\e063\"; }\r\n\r\n.fa-handshake {\r\n  --fa: \"\\f2b5\";\r\n  --fa--fa: \"\\f2b5\\f2b5\"; }\r\n\r\n.fa-gem {\r\n  --fa: \"\\f3a5\";\r\n  --fa--fa: \"\\f3a5\\f3a5\"; }\r\n\r\n.fa-dolly {\r\n  --fa: \"\\f472\";\r\n  --fa--fa: \"\\f472\\f472\"; }\r\n\r\n.fa-dolly-box {\r\n  --fa: \"\\f472\";\r\n  --fa--fa: \"\\f472\\f472\"; }\r\n\r\n.fa-smoking {\r\n  --fa: \"\\f48d\";\r\n  --fa--fa: \"\\f48d\\f48d\"; }\r\n\r\n.fa-minimize {\r\n  --fa: \"\\f78c\";\r\n  --fa--fa: \"\\f78c\\f78c\"; }\r\n\r\n.fa-compress-arrows-alt {\r\n  --fa: \"\\f78c\";\r\n  --fa--fa: \"\\f78c\\f78c\"; }\r\n\r\n.fa-monument {\r\n  --fa: \"\\f5a6\";\r\n  --fa--fa: \"\\f5a6\\f5a6\"; }\r\n\r\n.fa-snowplow {\r\n  --fa: \"\\f7d2\";\r\n  --fa--fa: \"\\f7d2\\f7d2\"; }\r\n\r\n.fa-angles-right {\r\n  --fa: \"\\f101\";\r\n  --fa--fa: \"\\f101\\f101\"; }\r\n\r\n.fa-angle-double-right {\r\n  --fa: \"\\f101\";\r\n  --fa--fa: \"\\f101\\f101\"; }\r\n\r\n.fa-cannabis {\r\n  --fa: \"\\f55f\";\r\n  --fa--fa: \"\\f55f\\f55f\"; }\r\n\r\n.fa-circle-play {\r\n  --fa: \"\\f144\";\r\n  --fa--fa: \"\\f144\\f144\"; }\r\n\r\n.fa-play-circle {\r\n  --fa: \"\\f144\";\r\n  --fa--fa: \"\\f144\\f144\"; }\r\n\r\n.fa-tablets {\r\n  --fa: \"\\f490\";\r\n  --fa--fa: \"\\f490\\f490\"; }\r\n\r\n.fa-ethernet {\r\n  --fa: \"\\f796\";\r\n  --fa--fa: \"\\f796\\f796\"; }\r\n\r\n.fa-euro-sign {\r\n  --fa: \"\\f153\";\r\n  --fa--fa: \"\\f153\\f153\"; }\r\n\r\n.fa-eur {\r\n  --fa: \"\\f153\";\r\n  --fa--fa: \"\\f153\\f153\"; }\r\n\r\n.fa-euro {\r\n  --fa: \"\\f153\";\r\n  --fa--fa: \"\\f153\\f153\"; }\r\n\r\n.fa-chair {\r\n  --fa: \"\\f6c0\";\r\n  --fa--fa: \"\\f6c0\\f6c0\"; }\r\n\r\n.fa-circle-check {\r\n  --fa: \"\\f058\";\r\n  --fa--fa: \"\\f058\\f058\"; }\r\n\r\n.fa-check-circle {\r\n  --fa: \"\\f058\";\r\n  --fa--fa: \"\\f058\\f058\"; }\r\n\r\n.fa-circle-stop {\r\n  --fa: \"\\f28d\";\r\n  --fa--fa: \"\\f28d\\f28d\"; }\r\n\r\n.fa-stop-circle {\r\n  --fa: \"\\f28d\";\r\n  --fa--fa: \"\\f28d\\f28d\"; }\r\n\r\n.fa-compass-drafting {\r\n  --fa: \"\\f568\";\r\n  --fa--fa: \"\\f568\\f568\"; }\r\n\r\n.fa-drafting-compass {\r\n  --fa: \"\\f568\";\r\n  --fa--fa: \"\\f568\\f568\"; }\r\n\r\n.fa-plate-wheat {\r\n  --fa: \"\\e55a\";\r\n  --fa--fa: \"\\e55a\\e55a\"; }\r\n\r\n.fa-icicles {\r\n  --fa: \"\\f7ad\";\r\n  --fa--fa: \"\\f7ad\\f7ad\"; }\r\n\r\n.fa-person-shelter {\r\n  --fa: \"\\e54f\";\r\n  --fa--fa: \"\\e54f\\e54f\"; }\r\n\r\n.fa-neuter {\r\n  --fa: \"\\f22c\";\r\n  --fa--fa: \"\\f22c\\f22c\"; }\r\n\r\n.fa-id-badge {\r\n  --fa: \"\\f2c1\";\r\n  --fa--fa: \"\\f2c1\\f2c1\"; }\r\n\r\n.fa-marker {\r\n  --fa: \"\\f5a1\";\r\n  --fa--fa: \"\\f5a1\\f5a1\"; }\r\n\r\n.fa-face-laugh-beam {\r\n  --fa: \"\\f59a\";\r\n  --fa--fa: \"\\f59a\\f59a\"; }\r\n\r\n.fa-laugh-beam {\r\n  --fa: \"\\f59a\";\r\n  --fa--fa: \"\\f59a\\f59a\"; }\r\n\r\n.fa-helicopter-symbol {\r\n  --fa: \"\\e502\";\r\n  --fa--fa: \"\\e502\\e502\"; }\r\n\r\n.fa-universal-access {\r\n  --fa: \"\\f29a\";\r\n  --fa--fa: \"\\f29a\\f29a\"; }\r\n\r\n.fa-circle-chevron-up {\r\n  --fa: \"\\f139\";\r\n  --fa--fa: \"\\f139\\f139\"; }\r\n\r\n.fa-chevron-circle-up {\r\n  --fa: \"\\f139\";\r\n  --fa--fa: \"\\f139\\f139\"; }\r\n\r\n.fa-lari-sign {\r\n  --fa: \"\\e1c8\";\r\n  --fa--fa: \"\\e1c8\\e1c8\"; }\r\n\r\n.fa-volcano {\r\n  --fa: \"\\f770\";\r\n  --fa--fa: \"\\f770\\f770\"; }\r\n\r\n.fa-person-walking-dashed-line-arrow-right {\r\n  --fa: \"\\e553\";\r\n  --fa--fa: \"\\e553\\e553\"; }\r\n\r\n.fa-sterling-sign {\r\n  --fa: \"\\f154\";\r\n  --fa--fa: \"\\f154\\f154\"; }\r\n\r\n.fa-gbp {\r\n  --fa: \"\\f154\";\r\n  --fa--fa: \"\\f154\\f154\"; }\r\n\r\n.fa-pound-sign {\r\n  --fa: \"\\f154\";\r\n  --fa--fa: \"\\f154\\f154\"; }\r\n\r\n.fa-viruses {\r\n  --fa: \"\\e076\";\r\n  --fa--fa: \"\\e076\\e076\"; }\r\n\r\n.fa-square-person-confined {\r\n  --fa: \"\\e577\";\r\n  --fa--fa: \"\\e577\\e577\"; }\r\n\r\n.fa-user-tie {\r\n  --fa: \"\\f508\";\r\n  --fa--fa: \"\\f508\\f508\"; }\r\n\r\n.fa-arrow-down-long {\r\n  --fa: \"\\f175\";\r\n  --fa--fa: \"\\f175\\f175\"; }\r\n\r\n.fa-long-arrow-down {\r\n  --fa: \"\\f175\";\r\n  --fa--fa: \"\\f175\\f175\"; }\r\n\r\n.fa-tent-arrow-down-to-line {\r\n  --fa: \"\\e57e\";\r\n  --fa--fa: \"\\e57e\\e57e\"; }\r\n\r\n.fa-certificate {\r\n  --fa: \"\\f0a3\";\r\n  --fa--fa: \"\\f0a3\\f0a3\"; }\r\n\r\n.fa-reply-all {\r\n  --fa: \"\\f122\";\r\n  --fa--fa: \"\\f122\\f122\"; }\r\n\r\n.fa-mail-reply-all {\r\n  --fa: \"\\f122\";\r\n  --fa--fa: \"\\f122\\f122\"; }\r\n\r\n.fa-suitcase {\r\n  --fa: \"\\f0f2\";\r\n  --fa--fa: \"\\f0f2\\f0f2\"; }\r\n\r\n.fa-person-skating {\r\n  --fa: \"\\f7c5\";\r\n  --fa--fa: \"\\f7c5\\f7c5\"; }\r\n\r\n.fa-skating {\r\n  --fa: \"\\f7c5\";\r\n  --fa--fa: \"\\f7c5\\f7c5\"; }\r\n\r\n.fa-filter-circle-dollar {\r\n  --fa: \"\\f662\";\r\n  --fa--fa: \"\\f662\\f662\"; }\r\n\r\n.fa-funnel-dollar {\r\n  --fa: \"\\f662\";\r\n  --fa--fa: \"\\f662\\f662\"; }\r\n\r\n.fa-camera-retro {\r\n  --fa: \"\\f083\";\r\n  --fa--fa: \"\\f083\\f083\"; }\r\n\r\n.fa-circle-arrow-down {\r\n  --fa: \"\\f0ab\";\r\n  --fa--fa: \"\\f0ab\\f0ab\"; }\r\n\r\n.fa-arrow-circle-down {\r\n  --fa: \"\\f0ab\";\r\n  --fa--fa: \"\\f0ab\\f0ab\"; }\r\n\r\n.fa-file-import {\r\n  --fa: \"\\f56f\";\r\n  --fa--fa: \"\\f56f\\f56f\"; }\r\n\r\n.fa-arrow-right-to-file {\r\n  --fa: \"\\f56f\";\r\n  --fa--fa: \"\\f56f\\f56f\"; }\r\n\r\n.fa-square-arrow-up-right {\r\n  --fa: \"\\f14c\";\r\n  --fa--fa: \"\\f14c\\f14c\"; }\r\n\r\n.fa-external-link-square {\r\n  --fa: \"\\f14c\";\r\n  --fa--fa: \"\\f14c\\f14c\"; }\r\n\r\n.fa-box-open {\r\n  --fa: \"\\f49e\";\r\n  --fa--fa: \"\\f49e\\f49e\"; }\r\n\r\n.fa-scroll {\r\n  --fa: \"\\f70e\";\r\n  --fa--fa: \"\\f70e\\f70e\"; }\r\n\r\n.fa-spa {\r\n  --fa: \"\\f5bb\";\r\n  --fa--fa: \"\\f5bb\\f5bb\"; }\r\n\r\n.fa-location-pin-lock {\r\n  --fa: \"\\e51f\";\r\n  --fa--fa: \"\\e51f\\e51f\"; }\r\n\r\n.fa-pause {\r\n  --fa: \"\\f04c\";\r\n  --fa--fa: \"\\f04c\\f04c\"; }\r\n\r\n.fa-hill-avalanche {\r\n  --fa: \"\\e507\";\r\n  --fa--fa: \"\\e507\\e507\"; }\r\n\r\n.fa-temperature-empty {\r\n  --fa: \"\\f2cb\";\r\n  --fa--fa: \"\\f2cb\\f2cb\"; }\r\n\r\n.fa-temperature-0 {\r\n  --fa: \"\\f2cb\";\r\n  --fa--fa: \"\\f2cb\\f2cb\"; }\r\n\r\n.fa-thermometer-0 {\r\n  --fa: \"\\f2cb\";\r\n  --fa--fa: \"\\f2cb\\f2cb\"; }\r\n\r\n.fa-thermometer-empty {\r\n  --fa: \"\\f2cb\";\r\n  --fa--fa: \"\\f2cb\\f2cb\"; }\r\n\r\n.fa-bomb {\r\n  --fa: \"\\f1e2\";\r\n  --fa--fa: \"\\f1e2\\f1e2\"; }\r\n\r\n.fa-registered {\r\n  --fa: \"\\f25d\";\r\n  --fa--fa: \"\\f25d\\f25d\"; }\r\n\r\n.fa-address-card {\r\n  --fa: \"\\f2bb\";\r\n  --fa--fa: \"\\f2bb\\f2bb\"; }\r\n\r\n.fa-contact-card {\r\n  --fa: \"\\f2bb\";\r\n  --fa--fa: \"\\f2bb\\f2bb\"; }\r\n\r\n.fa-vcard {\r\n  --fa: \"\\f2bb\";\r\n  --fa--fa: \"\\f2bb\\f2bb\"; }\r\n\r\n.fa-scale-unbalanced-flip {\r\n  --fa: \"\\f516\";\r\n  --fa--fa: \"\\f516\\f516\"; }\r\n\r\n.fa-balance-scale-right {\r\n  --fa: \"\\f516\";\r\n  --fa--fa: \"\\f516\\f516\"; }\r\n\r\n.fa-subscript {\r\n  --fa: \"\\f12c\";\r\n  --fa--fa: \"\\f12c\\f12c\"; }\r\n\r\n.fa-diamond-turn-right {\r\n  --fa: \"\\f5eb\";\r\n  --fa--fa: \"\\f5eb\\f5eb\"; }\r\n\r\n.fa-directions {\r\n  --fa: \"\\f5eb\";\r\n  --fa--fa: \"\\f5eb\\f5eb\"; }\r\n\r\n.fa-burst {\r\n  --fa: \"\\e4dc\";\r\n  --fa--fa: \"\\e4dc\\e4dc\"; }\r\n\r\n.fa-house-laptop {\r\n  --fa: \"\\e066\";\r\n  --fa--fa: \"\\e066\\e066\"; }\r\n\r\n.fa-laptop-house {\r\n  --fa: \"\\e066\";\r\n  --fa--fa: \"\\e066\\e066\"; }\r\n\r\n.fa-face-tired {\r\n  --fa: \"\\f5c8\";\r\n  --fa--fa: \"\\f5c8\\f5c8\"; }\r\n\r\n.fa-tired {\r\n  --fa: \"\\f5c8\";\r\n  --fa--fa: \"\\f5c8\\f5c8\"; }\r\n\r\n.fa-money-bills {\r\n  --fa: \"\\e1f3\";\r\n  --fa--fa: \"\\e1f3\\e1f3\"; }\r\n\r\n.fa-smog {\r\n  --fa: \"\\f75f\";\r\n  --fa--fa: \"\\f75f\\f75f\"; }\r\n\r\n.fa-crutch {\r\n  --fa: \"\\f7f7\";\r\n  --fa--fa: \"\\f7f7\\f7f7\"; }\r\n\r\n.fa-cloud-arrow-up {\r\n  --fa: \"\\f0ee\";\r\n  --fa--fa: \"\\f0ee\\f0ee\"; }\r\n\r\n.fa-cloud-upload {\r\n  --fa: \"\\f0ee\";\r\n  --fa--fa: \"\\f0ee\\f0ee\"; }\r\n\r\n.fa-cloud-upload-alt {\r\n  --fa: \"\\f0ee\";\r\n  --fa--fa: \"\\f0ee\\f0ee\"; }\r\n\r\n.fa-palette {\r\n  --fa: \"\\f53f\";\r\n  --fa--fa: \"\\f53f\\f53f\"; }\r\n\r\n.fa-arrows-turn-right {\r\n  --fa: \"\\e4c0\";\r\n  --fa--fa: \"\\e4c0\\e4c0\"; }\r\n\r\n.fa-vest {\r\n  --fa: \"\\e085\";\r\n  --fa--fa: \"\\e085\\e085\"; }\r\n\r\n.fa-ferry {\r\n  --fa: \"\\e4ea\";\r\n  --fa--fa: \"\\e4ea\\e4ea\"; }\r\n\r\n.fa-arrows-down-to-people {\r\n  --fa: \"\\e4b9\";\r\n  --fa--fa: \"\\e4b9\\e4b9\"; }\r\n\r\n.fa-seedling {\r\n  --fa: \"\\f4d8\";\r\n  --fa--fa: \"\\f4d8\\f4d8\"; }\r\n\r\n.fa-sprout {\r\n  --fa: \"\\f4d8\";\r\n  --fa--fa: \"\\f4d8\\f4d8\"; }\r\n\r\n.fa-left-right {\r\n  --fa: \"\\f337\";\r\n  --fa--fa: \"\\f337\\f337\"; }\r\n\r\n.fa-arrows-alt-h {\r\n  --fa: \"\\f337\";\r\n  --fa--fa: \"\\f337\\f337\"; }\r\n\r\n.fa-boxes-packing {\r\n  --fa: \"\\e4c7\";\r\n  --fa--fa: \"\\e4c7\\e4c7\"; }\r\n\r\n.fa-circle-arrow-left {\r\n  --fa: \"\\f0a8\";\r\n  --fa--fa: \"\\f0a8\\f0a8\"; }\r\n\r\n.fa-arrow-circle-left {\r\n  --fa: \"\\f0a8\";\r\n  --fa--fa: \"\\f0a8\\f0a8\"; }\r\n\r\n.fa-group-arrows-rotate {\r\n  --fa: \"\\e4f6\";\r\n  --fa--fa: \"\\e4f6\\e4f6\"; }\r\n\r\n.fa-bowl-food {\r\n  --fa: \"\\e4c6\";\r\n  --fa--fa: \"\\e4c6\\e4c6\"; }\r\n\r\n.fa-candy-cane {\r\n  --fa: \"\\f786\";\r\n  --fa--fa: \"\\f786\\f786\"; }\r\n\r\n.fa-arrow-down-wide-short {\r\n  --fa: \"\\f160\";\r\n  --fa--fa: \"\\f160\\f160\"; }\r\n\r\n.fa-sort-amount-asc {\r\n  --fa: \"\\f160\";\r\n  --fa--fa: \"\\f160\\f160\"; }\r\n\r\n.fa-sort-amount-down {\r\n  --fa: \"\\f160\";\r\n  --fa--fa: \"\\f160\\f160\"; }\r\n\r\n.fa-cloud-bolt {\r\n  --fa: \"\\f76c\";\r\n  --fa--fa: \"\\f76c\\f76c\"; }\r\n\r\n.fa-thunderstorm {\r\n  --fa: \"\\f76c\";\r\n  --fa--fa: \"\\f76c\\f76c\"; }\r\n\r\n.fa-text-slash {\r\n  --fa: \"\\f87d\";\r\n  --fa--fa: \"\\f87d\\f87d\"; }\r\n\r\n.fa-remove-format {\r\n  --fa: \"\\f87d\";\r\n  --fa--fa: \"\\f87d\\f87d\"; }\r\n\r\n.fa-face-smile-wink {\r\n  --fa: \"\\f4da\";\r\n  --fa--fa: \"\\f4da\\f4da\"; }\r\n\r\n.fa-smile-wink {\r\n  --fa: \"\\f4da\";\r\n  --fa--fa: \"\\f4da\\f4da\"; }\r\n\r\n.fa-file-word {\r\n  --fa: \"\\f1c2\";\r\n  --fa--fa: \"\\f1c2\\f1c2\"; }\r\n\r\n.fa-file-powerpoint {\r\n  --fa: \"\\f1c4\";\r\n  --fa--fa: \"\\f1c4\\f1c4\"; }\r\n\r\n.fa-arrows-left-right {\r\n  --fa: \"\\f07e\";\r\n  --fa--fa: \"\\f07e\\f07e\"; }\r\n\r\n.fa-arrows-h {\r\n  --fa: \"\\f07e\";\r\n  --fa--fa: \"\\f07e\\f07e\"; }\r\n\r\n.fa-house-lock {\r\n  --fa: \"\\e510\";\r\n  --fa--fa: \"\\e510\\e510\"; }\r\n\r\n.fa-cloud-arrow-down {\r\n  --fa: \"\\f0ed\";\r\n  --fa--fa: \"\\f0ed\\f0ed\"; }\r\n\r\n.fa-cloud-download {\r\n  --fa: \"\\f0ed\";\r\n  --fa--fa: \"\\f0ed\\f0ed\"; }\r\n\r\n.fa-cloud-download-alt {\r\n  --fa: \"\\f0ed\";\r\n  --fa--fa: \"\\f0ed\\f0ed\"; }\r\n\r\n.fa-children {\r\n  --fa: \"\\e4e1\";\r\n  --fa--fa: \"\\e4e1\\e4e1\"; }\r\n\r\n.fa-chalkboard {\r\n  --fa: \"\\f51b\";\r\n  --fa--fa: \"\\f51b\\f51b\"; }\r\n\r\n.fa-blackboard {\r\n  --fa: \"\\f51b\";\r\n  --fa--fa: \"\\f51b\\f51b\"; }\r\n\r\n.fa-user-large-slash {\r\n  --fa: \"\\f4fa\";\r\n  --fa--fa: \"\\f4fa\\f4fa\"; }\r\n\r\n.fa-user-alt-slash {\r\n  --fa: \"\\f4fa\";\r\n  --fa--fa: \"\\f4fa\\f4fa\"; }\r\n\r\n.fa-envelope-open {\r\n  --fa: \"\\f2b6\";\r\n  --fa--fa: \"\\f2b6\\f2b6\"; }\r\n\r\n.fa-handshake-simple-slash {\r\n  --fa: \"\\e05f\";\r\n  --fa--fa: \"\\e05f\\e05f\"; }\r\n\r\n.fa-handshake-alt-slash {\r\n  --fa: \"\\e05f\";\r\n  --fa--fa: \"\\e05f\\e05f\"; }\r\n\r\n.fa-mattress-pillow {\r\n  --fa: \"\\e525\";\r\n  --fa--fa: \"\\e525\\e525\"; }\r\n\r\n.fa-guarani-sign {\r\n  --fa: \"\\e19a\";\r\n  --fa--fa: \"\\e19a\\e19a\"; }\r\n\r\n.fa-arrows-rotate {\r\n  --fa: \"\\f021\";\r\n  --fa--fa: \"\\f021\\f021\"; }\r\n\r\n.fa-refresh {\r\n  --fa: \"\\f021\";\r\n  --fa--fa: \"\\f021\\f021\"; }\r\n\r\n.fa-sync {\r\n  --fa: \"\\f021\";\r\n  --fa--fa: \"\\f021\\f021\"; }\r\n\r\n.fa-fire-extinguisher {\r\n  --fa: \"\\f134\";\r\n  --fa--fa: \"\\f134\\f134\"; }\r\n\r\n.fa-cruzeiro-sign {\r\n  --fa: \"\\e152\";\r\n  --fa--fa: \"\\e152\\e152\"; }\r\n\r\n.fa-greater-than-equal {\r\n  --fa: \"\\f532\";\r\n  --fa--fa: \"\\f532\\f532\"; }\r\n\r\n.fa-shield-halved {\r\n  --fa: \"\\f3ed\";\r\n  --fa--fa: \"\\f3ed\\f3ed\"; }\r\n\r\n.fa-shield-alt {\r\n  --fa: \"\\f3ed\";\r\n  --fa--fa: \"\\f3ed\\f3ed\"; }\r\n\r\n.fa-book-atlas {\r\n  --fa: \"\\f558\";\r\n  --fa--fa: \"\\f558\\f558\"; }\r\n\r\n.fa-atlas {\r\n  --fa: \"\\f558\";\r\n  --fa--fa: \"\\f558\\f558\"; }\r\n\r\n.fa-virus {\r\n  --fa: \"\\e074\";\r\n  --fa--fa: \"\\e074\\e074\"; }\r\n\r\n.fa-envelope-circle-check {\r\n  --fa: \"\\e4e8\";\r\n  --fa--fa: \"\\e4e8\\e4e8\"; }\r\n\r\n.fa-layer-group {\r\n  --fa: \"\\f5fd\";\r\n  --fa--fa: \"\\f5fd\\f5fd\"; }\r\n\r\n.fa-arrows-to-dot {\r\n  --fa: \"\\e4be\";\r\n  --fa--fa: \"\\e4be\\e4be\"; }\r\n\r\n.fa-archway {\r\n  --fa: \"\\f557\";\r\n  --fa--fa: \"\\f557\\f557\"; }\r\n\r\n.fa-heart-circle-check {\r\n  --fa: \"\\e4fd\";\r\n  --fa--fa: \"\\e4fd\\e4fd\"; }\r\n\r\n.fa-house-chimney-crack {\r\n  --fa: \"\\f6f1\";\r\n  --fa--fa: \"\\f6f1\\f6f1\"; }\r\n\r\n.fa-house-damage {\r\n  --fa: \"\\f6f1\";\r\n  --fa--fa: \"\\f6f1\\f6f1\"; }\r\n\r\n.fa-file-zipper {\r\n  --fa: \"\\f1c6\";\r\n  --fa--fa: \"\\f1c6\\f1c6\"; }\r\n\r\n.fa-file-archive {\r\n  --fa: \"\\f1c6\";\r\n  --fa--fa: \"\\f1c6\\f1c6\"; }\r\n\r\n.fa-square {\r\n  --fa: \"\\f0c8\";\r\n  --fa--fa: \"\\f0c8\\f0c8\"; }\r\n\r\n.fa-martini-glass-empty {\r\n  --fa: \"\\f000\";\r\n  --fa--fa: \"\\f000\\f000\"; }\r\n\r\n.fa-glass-martini {\r\n  --fa: \"\\f000\";\r\n  --fa--fa: \"\\f000\\f000\"; }\r\n\r\n.fa-couch {\r\n  --fa: \"\\f4b8\";\r\n  --fa--fa: \"\\f4b8\\f4b8\"; }\r\n\r\n.fa-cedi-sign {\r\n  --fa: \"\\e0df\";\r\n  --fa--fa: \"\\e0df\\e0df\"; }\r\n\r\n.fa-italic {\r\n  --fa: \"\\f033\";\r\n  --fa--fa: \"\\f033\\f033\"; }\r\n\r\n.fa-table-cells-column-lock {\r\n  --fa: \"\\e678\";\r\n  --fa--fa: \"\\e678\\e678\"; }\r\n\r\n.fa-church {\r\n  --fa: \"\\f51d\";\r\n  --fa--fa: \"\\f51d\\f51d\"; }\r\n\r\n.fa-comments-dollar {\r\n  --fa: \"\\f653\";\r\n  --fa--fa: \"\\f653\\f653\"; }\r\n\r\n.fa-democrat {\r\n  --fa: \"\\f747\";\r\n  --fa--fa: \"\\f747\\f747\"; }\r\n\r\n.fa-z {\r\n  --fa: \"\\5a\";\r\n  --fa--fa: \"\\5a\\5a\"; }\r\n\r\n.fa-person-skiing {\r\n  --fa: \"\\f7c9\";\r\n  --fa--fa: \"\\f7c9\\f7c9\"; }\r\n\r\n.fa-skiing {\r\n  --fa: \"\\f7c9\";\r\n  --fa--fa: \"\\f7c9\\f7c9\"; }\r\n\r\n.fa-road-lock {\r\n  --fa: \"\\e567\";\r\n  --fa--fa: \"\\e567\\e567\"; }\r\n\r\n.fa-a {\r\n  --fa: \"\\41\";\r\n  --fa--fa: \"\\41\\41\"; }\r\n\r\n.fa-temperature-arrow-down {\r\n  --fa: \"\\e03f\";\r\n  --fa--fa: \"\\e03f\\e03f\"; }\r\n\r\n.fa-temperature-down {\r\n  --fa: \"\\e03f\";\r\n  --fa--fa: \"\\e03f\\e03f\"; }\r\n\r\n.fa-feather-pointed {\r\n  --fa: \"\\f56b\";\r\n  --fa--fa: \"\\f56b\\f56b\"; }\r\n\r\n.fa-feather-alt {\r\n  --fa: \"\\f56b\";\r\n  --fa--fa: \"\\f56b\\f56b\"; }\r\n\r\n.fa-p {\r\n  --fa: \"\\50\";\r\n  --fa--fa: \"\\50\\50\"; }\r\n\r\n.fa-snowflake {\r\n  --fa: \"\\f2dc\";\r\n  --fa--fa: \"\\f2dc\\f2dc\"; }\r\n\r\n.fa-newspaper {\r\n  --fa: \"\\f1ea\";\r\n  --fa--fa: \"\\f1ea\\f1ea\"; }\r\n\r\n.fa-rectangle-ad {\r\n  --fa: \"\\f641\";\r\n  --fa--fa: \"\\f641\\f641\"; }\r\n\r\n.fa-ad {\r\n  --fa: \"\\f641\";\r\n  --fa--fa: \"\\f641\\f641\"; }\r\n\r\n.fa-circle-arrow-right {\r\n  --fa: \"\\f0a9\";\r\n  --fa--fa: \"\\f0a9\\f0a9\"; }\r\n\r\n.fa-arrow-circle-right {\r\n  --fa: \"\\f0a9\";\r\n  --fa--fa: \"\\f0a9\\f0a9\"; }\r\n\r\n.fa-filter-circle-xmark {\r\n  --fa: \"\\e17b\";\r\n  --fa--fa: \"\\e17b\\e17b\"; }\r\n\r\n.fa-locust {\r\n  --fa: \"\\e520\";\r\n  --fa--fa: \"\\e520\\e520\"; }\r\n\r\n.fa-sort {\r\n  --fa: \"\\f0dc\";\r\n  --fa--fa: \"\\f0dc\\f0dc\"; }\r\n\r\n.fa-unsorted {\r\n  --fa: \"\\f0dc\";\r\n  --fa--fa: \"\\f0dc\\f0dc\"; }\r\n\r\n.fa-list-ol {\r\n  --fa: \"\\f0cb\";\r\n  --fa--fa: \"\\f0cb\\f0cb\"; }\r\n\r\n.fa-list-1-2 {\r\n  --fa: \"\\f0cb\";\r\n  --fa--fa: \"\\f0cb\\f0cb\"; }\r\n\r\n.fa-list-numeric {\r\n  --fa: \"\\f0cb\";\r\n  --fa--fa: \"\\f0cb\\f0cb\"; }\r\n\r\n.fa-person-dress-burst {\r\n  --fa: \"\\e544\";\r\n  --fa--fa: \"\\e544\\e544\"; }\r\n\r\n.fa-money-check-dollar {\r\n  --fa: \"\\f53d\";\r\n  --fa--fa: \"\\f53d\\f53d\"; }\r\n\r\n.fa-money-check-alt {\r\n  --fa: \"\\f53d\";\r\n  --fa--fa: \"\\f53d\\f53d\"; }\r\n\r\n.fa-vector-square {\r\n  --fa: \"\\f5cb\";\r\n  --fa--fa: \"\\f5cb\\f5cb\"; }\r\n\r\n.fa-bread-slice {\r\n  --fa: \"\\f7ec\";\r\n  --fa--fa: \"\\f7ec\\f7ec\"; }\r\n\r\n.fa-language {\r\n  --fa: \"\\f1ab\";\r\n  --fa--fa: \"\\f1ab\\f1ab\"; }\r\n\r\n.fa-face-kiss-wink-heart {\r\n  --fa: \"\\f598\";\r\n  --fa--fa: \"\\f598\\f598\"; }\r\n\r\n.fa-kiss-wink-heart {\r\n  --fa: \"\\f598\";\r\n  --fa--fa: \"\\f598\\f598\"; }\r\n\r\n.fa-filter {\r\n  --fa: \"\\f0b0\";\r\n  --fa--fa: \"\\f0b0\\f0b0\"; }\r\n\r\n.fa-question {\r\n  --fa: \"\\3f\";\r\n  --fa--fa: \"\\3f\\3f\"; }\r\n\r\n.fa-file-signature {\r\n  --fa: \"\\f573\";\r\n  --fa--fa: \"\\f573\\f573\"; }\r\n\r\n.fa-up-down-left-right {\r\n  --fa: \"\\f0b2\";\r\n  --fa--fa: \"\\f0b2\\f0b2\"; }\r\n\r\n.fa-arrows-alt {\r\n  --fa: \"\\f0b2\";\r\n  --fa--fa: \"\\f0b2\\f0b2\"; }\r\n\r\n.fa-house-chimney-user {\r\n  --fa: \"\\e065\";\r\n  --fa--fa: \"\\e065\\e065\"; }\r\n\r\n.fa-hand-holding-heart {\r\n  --fa: \"\\f4be\";\r\n  --fa--fa: \"\\f4be\\f4be\"; }\r\n\r\n.fa-puzzle-piece {\r\n  --fa: \"\\f12e\";\r\n  --fa--fa: \"\\f12e\\f12e\"; }\r\n\r\n.fa-money-check {\r\n  --fa: \"\\f53c\";\r\n  --fa--fa: \"\\f53c\\f53c\"; }\r\n\r\n.fa-star-half-stroke {\r\n  --fa: \"\\f5c0\";\r\n  --fa--fa: \"\\f5c0\\f5c0\"; }\r\n\r\n.fa-star-half-alt {\r\n  --fa: \"\\f5c0\";\r\n  --fa--fa: \"\\f5c0\\f5c0\"; }\r\n\r\n.fa-code {\r\n  --fa: \"\\f121\";\r\n  --fa--fa: \"\\f121\\f121\"; }\r\n\r\n.fa-whiskey-glass {\r\n  --fa: \"\\f7a0\";\r\n  --fa--fa: \"\\f7a0\\f7a0\"; }\r\n\r\n.fa-glass-whiskey {\r\n  --fa: \"\\f7a0\";\r\n  --fa--fa: \"\\f7a0\\f7a0\"; }\r\n\r\n.fa-building-circle-exclamation {\r\n  --fa: \"\\e4d3\";\r\n  --fa--fa: \"\\e4d3\\e4d3\"; }\r\n\r\n.fa-magnifying-glass-chart {\r\n  --fa: \"\\e522\";\r\n  --fa--fa: \"\\e522\\e522\"; }\r\n\r\n.fa-arrow-up-right-from-square {\r\n  --fa: \"\\f08e\";\r\n  --fa--fa: \"\\f08e\\f08e\"; }\r\n\r\n.fa-external-link {\r\n  --fa: \"\\f08e\";\r\n  --fa--fa: \"\\f08e\\f08e\"; }\r\n\r\n.fa-cubes-stacked {\r\n  --fa: \"\\e4e6\";\r\n  --fa--fa: \"\\e4e6\\e4e6\"; }\r\n\r\n.fa-won-sign {\r\n  --fa: \"\\f159\";\r\n  --fa--fa: \"\\f159\\f159\"; }\r\n\r\n.fa-krw {\r\n  --fa: \"\\f159\";\r\n  --fa--fa: \"\\f159\\f159\"; }\r\n\r\n.fa-won {\r\n  --fa: \"\\f159\";\r\n  --fa--fa: \"\\f159\\f159\"; }\r\n\r\n.fa-virus-covid {\r\n  --fa: \"\\e4a8\";\r\n  --fa--fa: \"\\e4a8\\e4a8\"; }\r\n\r\n.fa-austral-sign {\r\n  --fa: \"\\e0a9\";\r\n  --fa--fa: \"\\e0a9\\e0a9\"; }\r\n\r\n.fa-f {\r\n  --fa: \"\\46\";\r\n  --fa--fa: \"\\46\\46\"; }\r\n\r\n.fa-leaf {\r\n  --fa: \"\\f06c\";\r\n  --fa--fa: \"\\f06c\\f06c\"; }\r\n\r\n.fa-road {\r\n  --fa: \"\\f018\";\r\n  --fa--fa: \"\\f018\\f018\"; }\r\n\r\n.fa-taxi {\r\n  --fa: \"\\f1ba\";\r\n  --fa--fa: \"\\f1ba\\f1ba\"; }\r\n\r\n.fa-cab {\r\n  --fa: \"\\f1ba\";\r\n  --fa--fa: \"\\f1ba\\f1ba\"; }\r\n\r\n.fa-person-circle-plus {\r\n  --fa: \"\\e541\";\r\n  --fa--fa: \"\\e541\\e541\"; }\r\n\r\n.fa-chart-pie {\r\n  --fa: \"\\f200\";\r\n  --fa--fa: \"\\f200\\f200\"; }\r\n\r\n.fa-pie-chart {\r\n  --fa: \"\\f200\";\r\n  --fa--fa: \"\\f200\\f200\"; }\r\n\r\n.fa-bolt-lightning {\r\n  --fa: \"\\e0b7\";\r\n  --fa--fa: \"\\e0b7\\e0b7\"; }\r\n\r\n.fa-sack-xmark {\r\n  --fa: \"\\e56a\";\r\n  --fa--fa: \"\\e56a\\e56a\"; }\r\n\r\n.fa-file-excel {\r\n  --fa: \"\\f1c3\";\r\n  --fa--fa: \"\\f1c3\\f1c3\"; }\r\n\r\n.fa-file-contract {\r\n  --fa: \"\\f56c\";\r\n  --fa--fa: \"\\f56c\\f56c\"; }\r\n\r\n.fa-fish-fins {\r\n  --fa: \"\\e4f2\";\r\n  --fa--fa: \"\\e4f2\\e4f2\"; }\r\n\r\n.fa-building-flag {\r\n  --fa: \"\\e4d5\";\r\n  --fa--fa: \"\\e4d5\\e4d5\"; }\r\n\r\n.fa-face-grin-beam {\r\n  --fa: \"\\f582\";\r\n  --fa--fa: \"\\f582\\f582\"; }\r\n\r\n.fa-grin-beam {\r\n  --fa: \"\\f582\";\r\n  --fa--fa: \"\\f582\\f582\"; }\r\n\r\n.fa-object-ungroup {\r\n  --fa: \"\\f248\";\r\n  --fa--fa: \"\\f248\\f248\"; }\r\n\r\n.fa-poop {\r\n  --fa: \"\\f619\";\r\n  --fa--fa: \"\\f619\\f619\"; }\r\n\r\n.fa-location-pin {\r\n  --fa: \"\\f041\";\r\n  --fa--fa: \"\\f041\\f041\"; }\r\n\r\n.fa-map-marker {\r\n  --fa: \"\\f041\";\r\n  --fa--fa: \"\\f041\\f041\"; }\r\n\r\n.fa-kaaba {\r\n  --fa: \"\\f66b\";\r\n  --fa--fa: \"\\f66b\\f66b\"; }\r\n\r\n.fa-toilet-paper {\r\n  --fa: \"\\f71e\";\r\n  --fa--fa: \"\\f71e\\f71e\"; }\r\n\r\n.fa-helmet-safety {\r\n  --fa: \"\\f807\";\r\n  --fa--fa: \"\\f807\\f807\"; }\r\n\r\n.fa-hard-hat {\r\n  --fa: \"\\f807\";\r\n  --fa--fa: \"\\f807\\f807\"; }\r\n\r\n.fa-hat-hard {\r\n  --fa: \"\\f807\";\r\n  --fa--fa: \"\\f807\\f807\"; }\r\n\r\n.fa-eject {\r\n  --fa: \"\\f052\";\r\n  --fa--fa: \"\\f052\\f052\"; }\r\n\r\n.fa-circle-right {\r\n  --fa: \"\\f35a\";\r\n  --fa--fa: \"\\f35a\\f35a\"; }\r\n\r\n.fa-arrow-alt-circle-right {\r\n  --fa: \"\\f35a\";\r\n  --fa--fa: \"\\f35a\\f35a\"; }\r\n\r\n.fa-plane-circle-check {\r\n  --fa: \"\\e555\";\r\n  --fa--fa: \"\\e555\\e555\"; }\r\n\r\n.fa-face-rolling-eyes {\r\n  --fa: \"\\f5a5\";\r\n  --fa--fa: \"\\f5a5\\f5a5\"; }\r\n\r\n.fa-meh-rolling-eyes {\r\n  --fa: \"\\f5a5\";\r\n  --fa--fa: \"\\f5a5\\f5a5\"; }\r\n\r\n.fa-object-group {\r\n  --fa: \"\\f247\";\r\n  --fa--fa: \"\\f247\\f247\"; }\r\n\r\n.fa-chart-line {\r\n  --fa: \"\\f201\";\r\n  --fa--fa: \"\\f201\\f201\"; }\r\n\r\n.fa-line-chart {\r\n  --fa: \"\\f201\";\r\n  --fa--fa: \"\\f201\\f201\"; }\r\n\r\n.fa-mask-ventilator {\r\n  --fa: \"\\e524\";\r\n  --fa--fa: \"\\e524\\e524\"; }\r\n\r\n.fa-arrow-right {\r\n  --fa: \"\\f061\";\r\n  --fa--fa: \"\\f061\\f061\"; }\r\n\r\n.fa-signs-post {\r\n  --fa: \"\\f277\";\r\n  --fa--fa: \"\\f277\\f277\"; }\r\n\r\n.fa-map-signs {\r\n  --fa: \"\\f277\";\r\n  --fa--fa: \"\\f277\\f277\"; }\r\n\r\n.fa-cash-register {\r\n  --fa: \"\\f788\";\r\n  --fa--fa: \"\\f788\\f788\"; }\r\n\r\n.fa-person-circle-question {\r\n  --fa: \"\\e542\";\r\n  --fa--fa: \"\\e542\\e542\"; }\r\n\r\n.fa-h {\r\n  --fa: \"\\48\";\r\n  --fa--fa: \"\\48\\48\"; }\r\n\r\n.fa-tarp {\r\n  --fa: \"\\e57b\";\r\n  --fa--fa: \"\\e57b\\e57b\"; }\r\n\r\n.fa-screwdriver-wrench {\r\n  --fa: \"\\f7d9\";\r\n  --fa--fa: \"\\f7d9\\f7d9\"; }\r\n\r\n.fa-tools {\r\n  --fa: \"\\f7d9\";\r\n  --fa--fa: \"\\f7d9\\f7d9\"; }\r\n\r\n.fa-arrows-to-eye {\r\n  --fa: \"\\e4bf\";\r\n  --fa--fa: \"\\e4bf\\e4bf\"; }\r\n\r\n.fa-plug-circle-bolt {\r\n  --fa: \"\\e55b\";\r\n  --fa--fa: \"\\e55b\\e55b\"; }\r\n\r\n.fa-heart {\r\n  --fa: \"\\f004\";\r\n  --fa--fa: \"\\f004\\f004\"; }\r\n\r\n.fa-mars-and-venus {\r\n  --fa: \"\\f224\";\r\n  --fa--fa: \"\\f224\\f224\"; }\r\n\r\n.fa-house-user {\r\n  --fa: \"\\e1b0\";\r\n  --fa--fa: \"\\e1b0\\e1b0\"; }\r\n\r\n.fa-home-user {\r\n  --fa: \"\\e1b0\";\r\n  --fa--fa: \"\\e1b0\\e1b0\"; }\r\n\r\n.fa-dumpster-fire {\r\n  --fa: \"\\f794\";\r\n  --fa--fa: \"\\f794\\f794\"; }\r\n\r\n.fa-house-crack {\r\n  --fa: \"\\e3b1\";\r\n  --fa--fa: \"\\e3b1\\e3b1\"; }\r\n\r\n.fa-martini-glass-citrus {\r\n  --fa: \"\\f561\";\r\n  --fa--fa: \"\\f561\\f561\"; }\r\n\r\n.fa-cocktail {\r\n  --fa: \"\\f561\";\r\n  --fa--fa: \"\\f561\\f561\"; }\r\n\r\n.fa-face-surprise {\r\n  --fa: \"\\f5c2\";\r\n  --fa--fa: \"\\f5c2\\f5c2\"; }\r\n\r\n.fa-surprise {\r\n  --fa: \"\\f5c2\";\r\n  --fa--fa: \"\\f5c2\\f5c2\"; }\r\n\r\n.fa-bottle-water {\r\n  --fa: \"\\e4c5\";\r\n  --fa--fa: \"\\e4c5\\e4c5\"; }\r\n\r\n.fa-circle-pause {\r\n  --fa: \"\\f28b\";\r\n  --fa--fa: \"\\f28b\\f28b\"; }\r\n\r\n.fa-pause-circle {\r\n  --fa: \"\\f28b\";\r\n  --fa--fa: \"\\f28b\\f28b\"; }\r\n\r\n.fa-toilet-paper-slash {\r\n  --fa: \"\\e072\";\r\n  --fa--fa: \"\\e072\\e072\"; }\r\n\r\n.fa-apple-whole {\r\n  --fa: \"\\f5d1\";\r\n  --fa--fa: \"\\f5d1\\f5d1\"; }\r\n\r\n.fa-apple-alt {\r\n  --fa: \"\\f5d1\";\r\n  --fa--fa: \"\\f5d1\\f5d1\"; }\r\n\r\n.fa-kitchen-set {\r\n  --fa: \"\\e51a\";\r\n  --fa--fa: \"\\e51a\\e51a\"; }\r\n\r\n.fa-r {\r\n  --fa: \"\\52\";\r\n  --fa--fa: \"\\52\\52\"; }\r\n\r\n.fa-temperature-quarter {\r\n  --fa: \"\\f2ca\";\r\n  --fa--fa: \"\\f2ca\\f2ca\"; }\r\n\r\n.fa-temperature-1 {\r\n  --fa: \"\\f2ca\";\r\n  --fa--fa: \"\\f2ca\\f2ca\"; }\r\n\r\n.fa-thermometer-1 {\r\n  --fa: \"\\f2ca\";\r\n  --fa--fa: \"\\f2ca\\f2ca\"; }\r\n\r\n.fa-thermometer-quarter {\r\n  --fa: \"\\f2ca\";\r\n  --fa--fa: \"\\f2ca\\f2ca\"; }\r\n\r\n.fa-cube {\r\n  --fa: \"\\f1b2\";\r\n  --fa--fa: \"\\f1b2\\f1b2\"; }\r\n\r\n.fa-bitcoin-sign {\r\n  --fa: \"\\e0b4\";\r\n  --fa--fa: \"\\e0b4\\e0b4\"; }\r\n\r\n.fa-shield-dog {\r\n  --fa: \"\\e573\";\r\n  --fa--fa: \"\\e573\\e573\"; }\r\n\r\n.fa-solar-panel {\r\n  --fa: \"\\f5ba\";\r\n  --fa--fa: \"\\f5ba\\f5ba\"; }\r\n\r\n.fa-lock-open {\r\n  --fa: \"\\f3c1\";\r\n  --fa--fa: \"\\f3c1\\f3c1\"; }\r\n\r\n.fa-elevator {\r\n  --fa: \"\\e16d\";\r\n  --fa--fa: \"\\e16d\\e16d\"; }\r\n\r\n.fa-money-bill-transfer {\r\n  --fa: \"\\e528\";\r\n  --fa--fa: \"\\e528\\e528\"; }\r\n\r\n.fa-money-bill-trend-up {\r\n  --fa: \"\\e529\";\r\n  --fa--fa: \"\\e529\\e529\"; }\r\n\r\n.fa-house-flood-water-circle-arrow-right {\r\n  --fa: \"\\e50f\";\r\n  --fa--fa: \"\\e50f\\e50f\"; }\r\n\r\n.fa-square-poll-horizontal {\r\n  --fa: \"\\f682\";\r\n  --fa--fa: \"\\f682\\f682\"; }\r\n\r\n.fa-poll-h {\r\n  --fa: \"\\f682\";\r\n  --fa--fa: \"\\f682\\f682\"; }\r\n\r\n.fa-circle {\r\n  --fa: \"\\f111\";\r\n  --fa--fa: \"\\f111\\f111\"; }\r\n\r\n.fa-backward-fast {\r\n  --fa: \"\\f049\";\r\n  --fa--fa: \"\\f049\\f049\"; }\r\n\r\n.fa-fast-backward {\r\n  --fa: \"\\f049\";\r\n  --fa--fa: \"\\f049\\f049\"; }\r\n\r\n.fa-recycle {\r\n  --fa: \"\\f1b8\";\r\n  --fa--fa: \"\\f1b8\\f1b8\"; }\r\n\r\n.fa-user-astronaut {\r\n  --fa: \"\\f4fb\";\r\n  --fa--fa: \"\\f4fb\\f4fb\"; }\r\n\r\n.fa-plane-slash {\r\n  --fa: \"\\e069\";\r\n  --fa--fa: \"\\e069\\e069\"; }\r\n\r\n.fa-trademark {\r\n  --fa: \"\\f25c\";\r\n  --fa--fa: \"\\f25c\\f25c\"; }\r\n\r\n.fa-basketball {\r\n  --fa: \"\\f434\";\r\n  --fa--fa: \"\\f434\\f434\"; }\r\n\r\n.fa-basketball-ball {\r\n  --fa: \"\\f434\";\r\n  --fa--fa: \"\\f434\\f434\"; }\r\n\r\n.fa-satellite-dish {\r\n  --fa: \"\\f7c0\";\r\n  --fa--fa: \"\\f7c0\\f7c0\"; }\r\n\r\n.fa-circle-up {\r\n  --fa: \"\\f35b\";\r\n  --fa--fa: \"\\f35b\\f35b\"; }\r\n\r\n.fa-arrow-alt-circle-up {\r\n  --fa: \"\\f35b\";\r\n  --fa--fa: \"\\f35b\\f35b\"; }\r\n\r\n.fa-mobile-screen-button {\r\n  --fa: \"\\f3cd\";\r\n  --fa--fa: \"\\f3cd\\f3cd\"; }\r\n\r\n.fa-mobile-alt {\r\n  --fa: \"\\f3cd\";\r\n  --fa--fa: \"\\f3cd\\f3cd\"; }\r\n\r\n.fa-volume-high {\r\n  --fa: \"\\f028\";\r\n  --fa--fa: \"\\f028\\f028\"; }\r\n\r\n.fa-volume-up {\r\n  --fa: \"\\f028\";\r\n  --fa--fa: \"\\f028\\f028\"; }\r\n\r\n.fa-users-rays {\r\n  --fa: \"\\e593\";\r\n  --fa--fa: \"\\e593\\e593\"; }\r\n\r\n.fa-wallet {\r\n  --fa: \"\\f555\";\r\n  --fa--fa: \"\\f555\\f555\"; }\r\n\r\n.fa-clipboard-check {\r\n  --fa: \"\\f46c\";\r\n  --fa--fa: \"\\f46c\\f46c\"; }\r\n\r\n.fa-file-audio {\r\n  --fa: \"\\f1c7\";\r\n  --fa--fa: \"\\f1c7\\f1c7\"; }\r\n\r\n.fa-burger {\r\n  --fa: \"\\f805\";\r\n  --fa--fa: \"\\f805\\f805\"; }\r\n\r\n.fa-hamburger {\r\n  --fa: \"\\f805\";\r\n  --fa--fa: \"\\f805\\f805\"; }\r\n\r\n.fa-wrench {\r\n  --fa: \"\\f0ad\";\r\n  --fa--fa: \"\\f0ad\\f0ad\"; }\r\n\r\n.fa-bugs {\r\n  --fa: \"\\e4d0\";\r\n  --fa--fa: \"\\e4d0\\e4d0\"; }\r\n\r\n.fa-rupee-sign {\r\n  --fa: \"\\f156\";\r\n  --fa--fa: \"\\f156\\f156\"; }\r\n\r\n.fa-rupee {\r\n  --fa: \"\\f156\";\r\n  --fa--fa: \"\\f156\\f156\"; }\r\n\r\n.fa-file-image {\r\n  --fa: \"\\f1c5\";\r\n  --fa--fa: \"\\f1c5\\f1c5\"; }\r\n\r\n.fa-circle-question {\r\n  --fa: \"\\f059\";\r\n  --fa--fa: \"\\f059\\f059\"; }\r\n\r\n.fa-question-circle {\r\n  --fa: \"\\f059\";\r\n  --fa--fa: \"\\f059\\f059\"; }\r\n\r\n.fa-plane-departure {\r\n  --fa: \"\\f5b0\";\r\n  --fa--fa: \"\\f5b0\\f5b0\"; }\r\n\r\n.fa-handshake-slash {\r\n  --fa: \"\\e060\";\r\n  --fa--fa: \"\\e060\\e060\"; }\r\n\r\n.fa-book-bookmark {\r\n  --fa: \"\\e0bb\";\r\n  --fa--fa: \"\\e0bb\\e0bb\"; }\r\n\r\n.fa-code-branch {\r\n  --fa: \"\\f126\";\r\n  --fa--fa: \"\\f126\\f126\"; }\r\n\r\n.fa-hat-cowboy {\r\n  --fa: \"\\f8c0\";\r\n  --fa--fa: \"\\f8c0\\f8c0\"; }\r\n\r\n.fa-bridge {\r\n  --fa: \"\\e4c8\";\r\n  --fa--fa: \"\\e4c8\\e4c8\"; }\r\n\r\n.fa-phone-flip {\r\n  --fa: \"\\f879\";\r\n  --fa--fa: \"\\f879\\f879\"; }\r\n\r\n.fa-phone-alt {\r\n  --fa: \"\\f879\";\r\n  --fa--fa: \"\\f879\\f879\"; }\r\n\r\n.fa-truck-front {\r\n  --fa: \"\\e2b7\";\r\n  --fa--fa: \"\\e2b7\\e2b7\"; }\r\n\r\n.fa-cat {\r\n  --fa: \"\\f6be\";\r\n  --fa--fa: \"\\f6be\\f6be\"; }\r\n\r\n.fa-anchor-circle-exclamation {\r\n  --fa: \"\\e4ab\";\r\n  --fa--fa: \"\\e4ab\\e4ab\"; }\r\n\r\n.fa-truck-field {\r\n  --fa: \"\\e58d\";\r\n  --fa--fa: \"\\e58d\\e58d\"; }\r\n\r\n.fa-route {\r\n  --fa: \"\\f4d7\";\r\n  --fa--fa: \"\\f4d7\\f4d7\"; }\r\n\r\n.fa-clipboard-question {\r\n  --fa: \"\\e4e3\";\r\n  --fa--fa: \"\\e4e3\\e4e3\"; }\r\n\r\n.fa-panorama {\r\n  --fa: \"\\e209\";\r\n  --fa--fa: \"\\e209\\e209\"; }\r\n\r\n.fa-comment-medical {\r\n  --fa: \"\\f7f5\";\r\n  --fa--fa: \"\\f7f5\\f7f5\"; }\r\n\r\n.fa-teeth-open {\r\n  --fa: \"\\f62f\";\r\n  --fa--fa: \"\\f62f\\f62f\"; }\r\n\r\n.fa-file-circle-minus {\r\n  --fa: \"\\e4ed\";\r\n  --fa--fa: \"\\e4ed\\e4ed\"; }\r\n\r\n.fa-tags {\r\n  --fa: \"\\f02c\";\r\n  --fa--fa: \"\\f02c\\f02c\"; }\r\n\r\n.fa-wine-glass {\r\n  --fa: \"\\f4e3\";\r\n  --fa--fa: \"\\f4e3\\f4e3\"; }\r\n\r\n.fa-forward-fast {\r\n  --fa: \"\\f050\";\r\n  --fa--fa: \"\\f050\\f050\"; }\r\n\r\n.fa-fast-forward {\r\n  --fa: \"\\f050\";\r\n  --fa--fa: \"\\f050\\f050\"; }\r\n\r\n.fa-face-meh-blank {\r\n  --fa: \"\\f5a4\";\r\n  --fa--fa: \"\\f5a4\\f5a4\"; }\r\n\r\n.fa-meh-blank {\r\n  --fa: \"\\f5a4\";\r\n  --fa--fa: \"\\f5a4\\f5a4\"; }\r\n\r\n.fa-square-parking {\r\n  --fa: \"\\f540\";\r\n  --fa--fa: \"\\f540\\f540\"; }\r\n\r\n.fa-parking {\r\n  --fa: \"\\f540\";\r\n  --fa--fa: \"\\f540\\f540\"; }\r\n\r\n.fa-house-signal {\r\n  --fa: \"\\e012\";\r\n  --fa--fa: \"\\e012\\e012\"; }\r\n\r\n.fa-bars-progress {\r\n  --fa: \"\\f828\";\r\n  --fa--fa: \"\\f828\\f828\"; }\r\n\r\n.fa-tasks-alt {\r\n  --fa: \"\\f828\";\r\n  --fa--fa: \"\\f828\\f828\"; }\r\n\r\n.fa-faucet-drip {\r\n  --fa: \"\\e006\";\r\n  --fa--fa: \"\\e006\\e006\"; }\r\n\r\n.fa-cart-flatbed {\r\n  --fa: \"\\f474\";\r\n  --fa--fa: \"\\f474\\f474\"; }\r\n\r\n.fa-dolly-flatbed {\r\n  --fa: \"\\f474\";\r\n  --fa--fa: \"\\f474\\f474\"; }\r\n\r\n.fa-ban-smoking {\r\n  --fa: \"\\f54d\";\r\n  --fa--fa: \"\\f54d\\f54d\"; }\r\n\r\n.fa-smoking-ban {\r\n  --fa: \"\\f54d\";\r\n  --fa--fa: \"\\f54d\\f54d\"; }\r\n\r\n.fa-terminal {\r\n  --fa: \"\\f120\";\r\n  --fa--fa: \"\\f120\\f120\"; }\r\n\r\n.fa-mobile-button {\r\n  --fa: \"\\f10b\";\r\n  --fa--fa: \"\\f10b\\f10b\"; }\r\n\r\n.fa-house-medical-flag {\r\n  --fa: \"\\e514\";\r\n  --fa--fa: \"\\e514\\e514\"; }\r\n\r\n.fa-basket-shopping {\r\n  --fa: \"\\f291\";\r\n  --fa--fa: \"\\f291\\f291\"; }\r\n\r\n.fa-shopping-basket {\r\n  --fa: \"\\f291\";\r\n  --fa--fa: \"\\f291\\f291\"; }\r\n\r\n.fa-tape {\r\n  --fa: \"\\f4db\";\r\n  --fa--fa: \"\\f4db\\f4db\"; }\r\n\r\n.fa-bus-simple {\r\n  --fa: \"\\f55e\";\r\n  --fa--fa: \"\\f55e\\f55e\"; }\r\n\r\n.fa-bus-alt {\r\n  --fa: \"\\f55e\";\r\n  --fa--fa: \"\\f55e\\f55e\"; }\r\n\r\n.fa-eye {\r\n  --fa: \"\\f06e\";\r\n  --fa--fa: \"\\f06e\\f06e\"; }\r\n\r\n.fa-face-sad-cry {\r\n  --fa: \"\\f5b3\";\r\n  --fa--fa: \"\\f5b3\\f5b3\"; }\r\n\r\n.fa-sad-cry {\r\n  --fa: \"\\f5b3\";\r\n  --fa--fa: \"\\f5b3\\f5b3\"; }\r\n\r\n.fa-audio-description {\r\n  --fa: \"\\f29e\";\r\n  --fa--fa: \"\\f29e\\f29e\"; }\r\n\r\n.fa-person-military-to-person {\r\n  --fa: \"\\e54c\";\r\n  --fa--fa: \"\\e54c\\e54c\"; }\r\n\r\n.fa-file-shield {\r\n  --fa: \"\\e4f0\";\r\n  --fa--fa: \"\\e4f0\\e4f0\"; }\r\n\r\n.fa-user-slash {\r\n  --fa: \"\\f506\";\r\n  --fa--fa: \"\\f506\\f506\"; }\r\n\r\n.fa-pen {\r\n  --fa: \"\\f304\";\r\n  --fa--fa: \"\\f304\\f304\"; }\r\n\r\n.fa-tower-observation {\r\n  --fa: \"\\e586\";\r\n  --fa--fa: \"\\e586\\e586\"; }\r\n\r\n.fa-file-code {\r\n  --fa: \"\\f1c9\";\r\n  --fa--fa: \"\\f1c9\\f1c9\"; }\r\n\r\n.fa-signal {\r\n  --fa: \"\\f012\";\r\n  --fa--fa: \"\\f012\\f012\"; }\r\n\r\n.fa-signal-5 {\r\n  --fa: \"\\f012\";\r\n  --fa--fa: \"\\f012\\f012\"; }\r\n\r\n.fa-signal-perfect {\r\n  --fa: \"\\f012\";\r\n  --fa--fa: \"\\f012\\f012\"; }\r\n\r\n.fa-bus {\r\n  --fa: \"\\f207\";\r\n  --fa--fa: \"\\f207\\f207\"; }\r\n\r\n.fa-heart-circle-xmark {\r\n  --fa: \"\\e501\";\r\n  --fa--fa: \"\\e501\\e501\"; }\r\n\r\n.fa-house-chimney {\r\n  --fa: \"\\e3af\";\r\n  --fa--fa: \"\\e3af\\e3af\"; }\r\n\r\n.fa-home-lg {\r\n  --fa: \"\\e3af\";\r\n  --fa--fa: \"\\e3af\\e3af\"; }\r\n\r\n.fa-window-maximize {\r\n  --fa: \"\\f2d0\";\r\n  --fa--fa: \"\\f2d0\\f2d0\"; }\r\n\r\n.fa-face-frown {\r\n  --fa: \"\\f119\";\r\n  --fa--fa: \"\\f119\\f119\"; }\r\n\r\n.fa-frown {\r\n  --fa: \"\\f119\";\r\n  --fa--fa: \"\\f119\\f119\"; }\r\n\r\n.fa-prescription {\r\n  --fa: \"\\f5b1\";\r\n  --fa--fa: \"\\f5b1\\f5b1\"; }\r\n\r\n.fa-shop {\r\n  --fa: \"\\f54f\";\r\n  --fa--fa: \"\\f54f\\f54f\"; }\r\n\r\n.fa-store-alt {\r\n  --fa: \"\\f54f\";\r\n  --fa--fa: \"\\f54f\\f54f\"; }\r\n\r\n.fa-floppy-disk {\r\n  --fa: \"\\f0c7\";\r\n  --fa--fa: \"\\f0c7\\f0c7\"; }\r\n\r\n.fa-save {\r\n  --fa: \"\\f0c7\";\r\n  --fa--fa: \"\\f0c7\\f0c7\"; }\r\n\r\n.fa-vihara {\r\n  --fa: \"\\f6a7\";\r\n  --fa--fa: \"\\f6a7\\f6a7\"; }\r\n\r\n.fa-scale-unbalanced {\r\n  --fa: \"\\f515\";\r\n  --fa--fa: \"\\f515\\f515\"; }\r\n\r\n.fa-balance-scale-left {\r\n  --fa: \"\\f515\";\r\n  --fa--fa: \"\\f515\\f515\"; }\r\n\r\n.fa-sort-up {\r\n  --fa: \"\\f0de\";\r\n  --fa--fa: \"\\f0de\\f0de\"; }\r\n\r\n.fa-sort-asc {\r\n  --fa: \"\\f0de\";\r\n  --fa--fa: \"\\f0de\\f0de\"; }\r\n\r\n.fa-comment-dots {\r\n  --fa: \"\\f4ad\";\r\n  --fa--fa: \"\\f4ad\\f4ad\"; }\r\n\r\n.fa-commenting {\r\n  --fa: \"\\f4ad\";\r\n  --fa--fa: \"\\f4ad\\f4ad\"; }\r\n\r\n.fa-plant-wilt {\r\n  --fa: \"\\e5aa\";\r\n  --fa--fa: \"\\e5aa\\e5aa\"; }\r\n\r\n.fa-diamond {\r\n  --fa: \"\\f219\";\r\n  --fa--fa: \"\\f219\\f219\"; }\r\n\r\n.fa-face-grin-squint {\r\n  --fa: \"\\f585\";\r\n  --fa--fa: \"\\f585\\f585\"; }\r\n\r\n.fa-grin-squint {\r\n  --fa: \"\\f585\";\r\n  --fa--fa: \"\\f585\\f585\"; }\r\n\r\n.fa-hand-holding-dollar {\r\n  --fa: \"\\f4c0\";\r\n  --fa--fa: \"\\f4c0\\f4c0\"; }\r\n\r\n.fa-hand-holding-usd {\r\n  --fa: \"\\f4c0\";\r\n  --fa--fa: \"\\f4c0\\f4c0\"; }\r\n\r\n.fa-chart-diagram {\r\n  --fa: \"\\e695\";\r\n  --fa--fa: \"\\e695\\e695\"; }\r\n\r\n.fa-bacterium {\r\n  --fa: \"\\e05a\";\r\n  --fa--fa: \"\\e05a\\e05a\"; }\r\n\r\n.fa-hand-pointer {\r\n  --fa: \"\\f25a\";\r\n  --fa--fa: \"\\f25a\\f25a\"; }\r\n\r\n.fa-drum-steelpan {\r\n  --fa: \"\\f56a\";\r\n  --fa--fa: \"\\f56a\\f56a\"; }\r\n\r\n.fa-hand-scissors {\r\n  --fa: \"\\f257\";\r\n  --fa--fa: \"\\f257\\f257\"; }\r\n\r\n.fa-hands-praying {\r\n  --fa: \"\\f684\";\r\n  --fa--fa: \"\\f684\\f684\"; }\r\n\r\n.fa-praying-hands {\r\n  --fa: \"\\f684\";\r\n  --fa--fa: \"\\f684\\f684\"; }\r\n\r\n.fa-arrow-rotate-right {\r\n  --fa: \"\\f01e\";\r\n  --fa--fa: \"\\f01e\\f01e\"; }\r\n\r\n.fa-arrow-right-rotate {\r\n  --fa: \"\\f01e\";\r\n  --fa--fa: \"\\f01e\\f01e\"; }\r\n\r\n.fa-arrow-rotate-forward {\r\n  --fa: \"\\f01e\";\r\n  --fa--fa: \"\\f01e\\f01e\"; }\r\n\r\n.fa-redo {\r\n  --fa: \"\\f01e\";\r\n  --fa--fa: \"\\f01e\\f01e\"; }\r\n\r\n.fa-biohazard {\r\n  --fa: \"\\f780\";\r\n  --fa--fa: \"\\f780\\f780\"; }\r\n\r\n.fa-location-crosshairs {\r\n  --fa: \"\\f601\";\r\n  --fa--fa: \"\\f601\\f601\"; }\r\n\r\n.fa-location {\r\n  --fa: \"\\f601\";\r\n  --fa--fa: \"\\f601\\f601\"; }\r\n\r\n.fa-mars-double {\r\n  --fa: \"\\f227\";\r\n  --fa--fa: \"\\f227\\f227\"; }\r\n\r\n.fa-child-dress {\r\n  --fa: \"\\e59c\";\r\n  --fa--fa: \"\\e59c\\e59c\"; }\r\n\r\n.fa-users-between-lines {\r\n  --fa: \"\\e591\";\r\n  --fa--fa: \"\\e591\\e591\"; }\r\n\r\n.fa-lungs-virus {\r\n  --fa: \"\\e067\";\r\n  --fa--fa: \"\\e067\\e067\"; }\r\n\r\n.fa-face-grin-tears {\r\n  --fa: \"\\f588\";\r\n  --fa--fa: \"\\f588\\f588\"; }\r\n\r\n.fa-grin-tears {\r\n  --fa: \"\\f588\";\r\n  --fa--fa: \"\\f588\\f588\"; }\r\n\r\n.fa-phone {\r\n  --fa: \"\\f095\";\r\n  --fa--fa: \"\\f095\\f095\"; }\r\n\r\n.fa-calendar-xmark {\r\n  --fa: \"\\f273\";\r\n  --fa--fa: \"\\f273\\f273\"; }\r\n\r\n.fa-calendar-times {\r\n  --fa: \"\\f273\";\r\n  --fa--fa: \"\\f273\\f273\"; }\r\n\r\n.fa-child-reaching {\r\n  --fa: \"\\e59d\";\r\n  --fa--fa: \"\\e59d\\e59d\"; }\r\n\r\n.fa-head-side-virus {\r\n  --fa: \"\\e064\";\r\n  --fa--fa: \"\\e064\\e064\"; }\r\n\r\n.fa-user-gear {\r\n  --fa: \"\\f4fe\";\r\n  --fa--fa: \"\\f4fe\\f4fe\"; }\r\n\r\n.fa-user-cog {\r\n  --fa: \"\\f4fe\";\r\n  --fa--fa: \"\\f4fe\\f4fe\"; }\r\n\r\n.fa-arrow-up-1-9 {\r\n  --fa: \"\\f163\";\r\n  --fa--fa: \"\\f163\\f163\"; }\r\n\r\n.fa-sort-numeric-up {\r\n  --fa: \"\\f163\";\r\n  --fa--fa: \"\\f163\\f163\"; }\r\n\r\n.fa-door-closed {\r\n  --fa: \"\\f52a\";\r\n  --fa--fa: \"\\f52a\\f52a\"; }\r\n\r\n.fa-shield-virus {\r\n  --fa: \"\\e06c\";\r\n  --fa--fa: \"\\e06c\\e06c\"; }\r\n\r\n.fa-dice-six {\r\n  --fa: \"\\f526\";\r\n  --fa--fa: \"\\f526\\f526\"; }\r\n\r\n.fa-mosquito-net {\r\n  --fa: \"\\e52c\";\r\n  --fa--fa: \"\\e52c\\e52c\"; }\r\n\r\n.fa-file-fragment {\r\n  --fa: \"\\e697\";\r\n  --fa--fa: \"\\e697\\e697\"; }\r\n\r\n.fa-bridge-water {\r\n  --fa: \"\\e4ce\";\r\n  --fa--fa: \"\\e4ce\\e4ce\"; }\r\n\r\n.fa-person-booth {\r\n  --fa: \"\\f756\";\r\n  --fa--fa: \"\\f756\\f756\"; }\r\n\r\n.fa-text-width {\r\n  --fa: \"\\f035\";\r\n  --fa--fa: \"\\f035\\f035\"; }\r\n\r\n.fa-hat-wizard {\r\n  --fa: \"\\f6e8\";\r\n  --fa--fa: \"\\f6e8\\f6e8\"; }\r\n\r\n.fa-pen-fancy {\r\n  --fa: \"\\f5ac\";\r\n  --fa--fa: \"\\f5ac\\f5ac\"; }\r\n\r\n.fa-person-digging {\r\n  --fa: \"\\f85e\";\r\n  --fa--fa: \"\\f85e\\f85e\"; }\r\n\r\n.fa-digging {\r\n  --fa: \"\\f85e\";\r\n  --fa--fa: \"\\f85e\\f85e\"; }\r\n\r\n.fa-trash {\r\n  --fa: \"\\f1f8\";\r\n  --fa--fa: \"\\f1f8\\f1f8\"; }\r\n\r\n.fa-gauge-simple {\r\n  --fa: \"\\f629\";\r\n  --fa--fa: \"\\f629\\f629\"; }\r\n\r\n.fa-gauge-simple-med {\r\n  --fa: \"\\f629\";\r\n  --fa--fa: \"\\f629\\f629\"; }\r\n\r\n.fa-tachometer-average {\r\n  --fa: \"\\f629\";\r\n  --fa--fa: \"\\f629\\f629\"; }\r\n\r\n.fa-book-medical {\r\n  --fa: \"\\f7e6\";\r\n  --fa--fa: \"\\f7e6\\f7e6\"; }\r\n\r\n.fa-poo {\r\n  --fa: \"\\f2fe\";\r\n  --fa--fa: \"\\f2fe\\f2fe\"; }\r\n\r\n.fa-quote-right {\r\n  --fa: \"\\f10e\";\r\n  --fa--fa: \"\\f10e\\f10e\"; }\r\n\r\n.fa-quote-right-alt {\r\n  --fa: \"\\f10e\";\r\n  --fa--fa: \"\\f10e\\f10e\"; }\r\n\r\n.fa-shirt {\r\n  --fa: \"\\f553\";\r\n  --fa--fa: \"\\f553\\f553\"; }\r\n\r\n.fa-t-shirt {\r\n  --fa: \"\\f553\";\r\n  --fa--fa: \"\\f553\\f553\"; }\r\n\r\n.fa-tshirt {\r\n  --fa: \"\\f553\";\r\n  --fa--fa: \"\\f553\\f553\"; }\r\n\r\n.fa-cubes {\r\n  --fa: \"\\f1b3\";\r\n  --fa--fa: \"\\f1b3\\f1b3\"; }\r\n\r\n.fa-divide {\r\n  --fa: \"\\f529\";\r\n  --fa--fa: \"\\f529\\f529\"; }\r\n\r\n.fa-tenge-sign {\r\n  --fa: \"\\f7d7\";\r\n  --fa--fa: \"\\f7d7\\f7d7\"; }\r\n\r\n.fa-tenge {\r\n  --fa: \"\\f7d7\";\r\n  --fa--fa: \"\\f7d7\\f7d7\"; }\r\n\r\n.fa-headphones {\r\n  --fa: \"\\f025\";\r\n  --fa--fa: \"\\f025\\f025\"; }\r\n\r\n.fa-hands-holding {\r\n  --fa: \"\\f4c2\";\r\n  --fa--fa: \"\\f4c2\\f4c2\"; }\r\n\r\n.fa-hands-clapping {\r\n  --fa: \"\\e1a8\";\r\n  --fa--fa: \"\\e1a8\\e1a8\"; }\r\n\r\n.fa-republican {\r\n  --fa: \"\\f75e\";\r\n  --fa--fa: \"\\f75e\\f75e\"; }\r\n\r\n.fa-arrow-left {\r\n  --fa: \"\\f060\";\r\n  --fa--fa: \"\\f060\\f060\"; }\r\n\r\n.fa-person-circle-xmark {\r\n  --fa: \"\\e543\";\r\n  --fa--fa: \"\\e543\\e543\"; }\r\n\r\n.fa-ruler {\r\n  --fa: \"\\f545\";\r\n  --fa--fa: \"\\f545\\f545\"; }\r\n\r\n.fa-align-left {\r\n  --fa: \"\\f036\";\r\n  --fa--fa: \"\\f036\\f036\"; }\r\n\r\n.fa-dice-d6 {\r\n  --fa: \"\\f6d1\";\r\n  --fa--fa: \"\\f6d1\\f6d1\"; }\r\n\r\n.fa-restroom {\r\n  --fa: \"\\f7bd\";\r\n  --fa--fa: \"\\f7bd\\f7bd\"; }\r\n\r\n.fa-j {\r\n  --fa: \"\\4a\";\r\n  --fa--fa: \"\\4a\\4a\"; }\r\n\r\n.fa-users-viewfinder {\r\n  --fa: \"\\e595\";\r\n  --fa--fa: \"\\e595\\e595\"; }\r\n\r\n.fa-file-video {\r\n  --fa: \"\\f1c8\";\r\n  --fa--fa: \"\\f1c8\\f1c8\"; }\r\n\r\n.fa-up-right-from-square {\r\n  --fa: \"\\f35d\";\r\n  --fa--fa: \"\\f35d\\f35d\"; }\r\n\r\n.fa-external-link-alt {\r\n  --fa: \"\\f35d\";\r\n  --fa--fa: \"\\f35d\\f35d\"; }\r\n\r\n.fa-table-cells {\r\n  --fa: \"\\f00a\";\r\n  --fa--fa: \"\\f00a\\f00a\"; }\r\n\r\n.fa-th {\r\n  --fa: \"\\f00a\";\r\n  --fa--fa: \"\\f00a\\f00a\"; }\r\n\r\n.fa-file-pdf {\r\n  --fa: \"\\f1c1\";\r\n  --fa--fa: \"\\f1c1\\f1c1\"; }\r\n\r\n.fa-book-bible {\r\n  --fa: \"\\f647\";\r\n  --fa--fa: \"\\f647\\f647\"; }\r\n\r\n.fa-bible {\r\n  --fa: \"\\f647\";\r\n  --fa--fa: \"\\f647\\f647\"; }\r\n\r\n.fa-o {\r\n  --fa: \"\\4f\";\r\n  --fa--fa: \"\\4f\\4f\"; }\r\n\r\n.fa-suitcase-medical {\r\n  --fa: \"\\f0fa\";\r\n  --fa--fa: \"\\f0fa\\f0fa\"; }\r\n\r\n.fa-medkit {\r\n  --fa: \"\\f0fa\";\r\n  --fa--fa: \"\\f0fa\\f0fa\"; }\r\n\r\n.fa-user-secret {\r\n  --fa: \"\\f21b\";\r\n  --fa--fa: \"\\f21b\\f21b\"; }\r\n\r\n.fa-otter {\r\n  --fa: \"\\f700\";\r\n  --fa--fa: \"\\f700\\f700\"; }\r\n\r\n.fa-person-dress {\r\n  --fa: \"\\f182\";\r\n  --fa--fa: \"\\f182\\f182\"; }\r\n\r\n.fa-female {\r\n  --fa: \"\\f182\";\r\n  --fa--fa: \"\\f182\\f182\"; }\r\n\r\n.fa-comment-dollar {\r\n  --fa: \"\\f651\";\r\n  --fa--fa: \"\\f651\\f651\"; }\r\n\r\n.fa-business-time {\r\n  --fa: \"\\f64a\";\r\n  --fa--fa: \"\\f64a\\f64a\"; }\r\n\r\n.fa-briefcase-clock {\r\n  --fa: \"\\f64a\";\r\n  --fa--fa: \"\\f64a\\f64a\"; }\r\n\r\n.fa-table-cells-large {\r\n  --fa: \"\\f009\";\r\n  --fa--fa: \"\\f009\\f009\"; }\r\n\r\n.fa-th-large {\r\n  --fa: \"\\f009\";\r\n  --fa--fa: \"\\f009\\f009\"; }\r\n\r\n.fa-book-tanakh {\r\n  --fa: \"\\f827\";\r\n  --fa--fa: \"\\f827\\f827\"; }\r\n\r\n.fa-tanakh {\r\n  --fa: \"\\f827\";\r\n  --fa--fa: \"\\f827\\f827\"; }\r\n\r\n.fa-phone-volume {\r\n  --fa: \"\\f2a0\";\r\n  --fa--fa: \"\\f2a0\\f2a0\"; }\r\n\r\n.fa-volume-control-phone {\r\n  --fa: \"\\f2a0\";\r\n  --fa--fa: \"\\f2a0\\f2a0\"; }\r\n\r\n.fa-hat-cowboy-side {\r\n  --fa: \"\\f8c1\";\r\n  --fa--fa: \"\\f8c1\\f8c1\"; }\r\n\r\n.fa-clipboard-user {\r\n  --fa: \"\\f7f3\";\r\n  --fa--fa: \"\\f7f3\\f7f3\"; }\r\n\r\n.fa-child {\r\n  --fa: \"\\f1ae\";\r\n  --fa--fa: \"\\f1ae\\f1ae\"; }\r\n\r\n.fa-lira-sign {\r\n  --fa: \"\\f195\";\r\n  --fa--fa: \"\\f195\\f195\"; }\r\n\r\n.fa-satellite {\r\n  --fa: \"\\f7bf\";\r\n  --fa--fa: \"\\f7bf\\f7bf\"; }\r\n\r\n.fa-plane-lock {\r\n  --fa: \"\\e558\";\r\n  --fa--fa: \"\\e558\\e558\"; }\r\n\r\n.fa-tag {\r\n  --fa: \"\\f02b\";\r\n  --fa--fa: \"\\f02b\\f02b\"; }\r\n\r\n.fa-comment {\r\n  --fa: \"\\f075\";\r\n  --fa--fa: \"\\f075\\f075\"; }\r\n\r\n.fa-cake-candles {\r\n  --fa: \"\\f1fd\";\r\n  --fa--fa: \"\\f1fd\\f1fd\"; }\r\n\r\n.fa-birthday-cake {\r\n  --fa: \"\\f1fd\";\r\n  --fa--fa: \"\\f1fd\\f1fd\"; }\r\n\r\n.fa-cake {\r\n  --fa: \"\\f1fd\";\r\n  --fa--fa: \"\\f1fd\\f1fd\"; }\r\n\r\n.fa-envelope {\r\n  --fa: \"\\f0e0\";\r\n  --fa--fa: \"\\f0e0\\f0e0\"; }\r\n\r\n.fa-angles-up {\r\n  --fa: \"\\f102\";\r\n  --fa--fa: \"\\f102\\f102\"; }\r\n\r\n.fa-angle-double-up {\r\n  --fa: \"\\f102\";\r\n  --fa--fa: \"\\f102\\f102\"; }\r\n\r\n.fa-paperclip {\r\n  --fa: \"\\f0c6\";\r\n  --fa--fa: \"\\f0c6\\f0c6\"; }\r\n\r\n.fa-arrow-right-to-city {\r\n  --fa: \"\\e4b3\";\r\n  --fa--fa: \"\\e4b3\\e4b3\"; }\r\n\r\n.fa-ribbon {\r\n  --fa: \"\\f4d6\";\r\n  --fa--fa: \"\\f4d6\\f4d6\"; }\r\n\r\n.fa-lungs {\r\n  --fa: \"\\f604\";\r\n  --fa--fa: \"\\f604\\f604\"; }\r\n\r\n.fa-arrow-up-9-1 {\r\n  --fa: \"\\f887\";\r\n  --fa--fa: \"\\f887\\f887\"; }\r\n\r\n.fa-sort-numeric-up-alt {\r\n  --fa: \"\\f887\";\r\n  --fa--fa: \"\\f887\\f887\"; }\r\n\r\n.fa-litecoin-sign {\r\n  --fa: \"\\e1d3\";\r\n  --fa--fa: \"\\e1d3\\e1d3\"; }\r\n\r\n.fa-border-none {\r\n  --fa: \"\\f850\";\r\n  --fa--fa: \"\\f850\\f850\"; }\r\n\r\n.fa-circle-nodes {\r\n  --fa: \"\\e4e2\";\r\n  --fa--fa: \"\\e4e2\\e4e2\"; }\r\n\r\n.fa-parachute-box {\r\n  --fa: \"\\f4cd\";\r\n  --fa--fa: \"\\f4cd\\f4cd\"; }\r\n\r\n.fa-indent {\r\n  --fa: \"\\f03c\";\r\n  --fa--fa: \"\\f03c\\f03c\"; }\r\n\r\n.fa-truck-field-un {\r\n  --fa: \"\\e58e\";\r\n  --fa--fa: \"\\e58e\\e58e\"; }\r\n\r\n.fa-hourglass {\r\n  --fa: \"\\f254\";\r\n  --fa--fa: \"\\f254\\f254\"; }\r\n\r\n.fa-hourglass-empty {\r\n  --fa: \"\\f254\";\r\n  --fa--fa: \"\\f254\\f254\"; }\r\n\r\n.fa-mountain {\r\n  --fa: \"\\f6fc\";\r\n  --fa--fa: \"\\f6fc\\f6fc\"; }\r\n\r\n.fa-user-doctor {\r\n  --fa: \"\\f0f0\";\r\n  --fa--fa: \"\\f0f0\\f0f0\"; }\r\n\r\n.fa-user-md {\r\n  --fa: \"\\f0f0\";\r\n  --fa--fa: \"\\f0f0\\f0f0\"; }\r\n\r\n.fa-circle-info {\r\n  --fa: \"\\f05a\";\r\n  --fa--fa: \"\\f05a\\f05a\"; }\r\n\r\n.fa-info-circle {\r\n  --fa: \"\\f05a\";\r\n  --fa--fa: \"\\f05a\\f05a\"; }\r\n\r\n.fa-cloud-meatball {\r\n  --fa: \"\\f73b\";\r\n  --fa--fa: \"\\f73b\\f73b\"; }\r\n\r\n.fa-camera {\r\n  --fa: \"\\f030\";\r\n  --fa--fa: \"\\f030\\f030\"; }\r\n\r\n.fa-camera-alt {\r\n  --fa: \"\\f030\";\r\n  --fa--fa: \"\\f030\\f030\"; }\r\n\r\n.fa-square-virus {\r\n  --fa: \"\\e578\";\r\n  --fa--fa: \"\\e578\\e578\"; }\r\n\r\n.fa-meteor {\r\n  --fa: \"\\f753\";\r\n  --fa--fa: \"\\f753\\f753\"; }\r\n\r\n.fa-car-on {\r\n  --fa: \"\\e4dd\";\r\n  --fa--fa: \"\\e4dd\\e4dd\"; }\r\n\r\n.fa-sleigh {\r\n  --fa: \"\\f7cc\";\r\n  --fa--fa: \"\\f7cc\\f7cc\"; }\r\n\r\n.fa-arrow-down-1-9 {\r\n  --fa: \"\\f162\";\r\n  --fa--fa: \"\\f162\\f162\"; }\r\n\r\n.fa-sort-numeric-asc {\r\n  --fa: \"\\f162\";\r\n  --fa--fa: \"\\f162\\f162\"; }\r\n\r\n.fa-sort-numeric-down {\r\n  --fa: \"\\f162\";\r\n  --fa--fa: \"\\f162\\f162\"; }\r\n\r\n.fa-hand-holding-droplet {\r\n  --fa: \"\\f4c1\";\r\n  --fa--fa: \"\\f4c1\\f4c1\"; }\r\n\r\n.fa-hand-holding-water {\r\n  --fa: \"\\f4c1\";\r\n  --fa--fa: \"\\f4c1\\f4c1\"; }\r\n\r\n.fa-water {\r\n  --fa: \"\\f773\";\r\n  --fa--fa: \"\\f773\\f773\"; }\r\n\r\n.fa-calendar-check {\r\n  --fa: \"\\f274\";\r\n  --fa--fa: \"\\f274\\f274\"; }\r\n\r\n.fa-braille {\r\n  --fa: \"\\f2a1\";\r\n  --fa--fa: \"\\f2a1\\f2a1\"; }\r\n\r\n.fa-prescription-bottle-medical {\r\n  --fa: \"\\f486\";\r\n  --fa--fa: \"\\f486\\f486\"; }\r\n\r\n.fa-prescription-bottle-alt {\r\n  --fa: \"\\f486\";\r\n  --fa--fa: \"\\f486\\f486\"; }\r\n\r\n.fa-landmark {\r\n  --fa: \"\\f66f\";\r\n  --fa--fa: \"\\f66f\\f66f\"; }\r\n\r\n.fa-truck {\r\n  --fa: \"\\f0d1\";\r\n  --fa--fa: \"\\f0d1\\f0d1\"; }\r\n\r\n.fa-crosshairs {\r\n  --fa: \"\\f05b\";\r\n  --fa--fa: \"\\f05b\\f05b\"; }\r\n\r\n.fa-person-cane {\r\n  --fa: \"\\e53c\";\r\n  --fa--fa: \"\\e53c\\e53c\"; }\r\n\r\n.fa-tent {\r\n  --fa: \"\\e57d\";\r\n  --fa--fa: \"\\e57d\\e57d\"; }\r\n\r\n.fa-vest-patches {\r\n  --fa: \"\\e086\";\r\n  --fa--fa: \"\\e086\\e086\"; }\r\n\r\n.fa-check-double {\r\n  --fa: \"\\f560\";\r\n  --fa--fa: \"\\f560\\f560\"; }\r\n\r\n.fa-arrow-down-a-z {\r\n  --fa: \"\\f15d\";\r\n  --fa--fa: \"\\f15d\\f15d\"; }\r\n\r\n.fa-sort-alpha-asc {\r\n  --fa: \"\\f15d\";\r\n  --fa--fa: \"\\f15d\\f15d\"; }\r\n\r\n.fa-sort-alpha-down {\r\n  --fa: \"\\f15d\";\r\n  --fa--fa: \"\\f15d\\f15d\"; }\r\n\r\n.fa-money-bill-wheat {\r\n  --fa: \"\\e52a\";\r\n  --fa--fa: \"\\e52a\\e52a\"; }\r\n\r\n.fa-cookie {\r\n  --fa: \"\\f563\";\r\n  --fa--fa: \"\\f563\\f563\"; }\r\n\r\n.fa-arrow-rotate-left {\r\n  --fa: \"\\f0e2\";\r\n  --fa--fa: \"\\f0e2\\f0e2\"; }\r\n\r\n.fa-arrow-left-rotate {\r\n  --fa: \"\\f0e2\";\r\n  --fa--fa: \"\\f0e2\\f0e2\"; }\r\n\r\n.fa-arrow-rotate-back {\r\n  --fa: \"\\f0e2\";\r\n  --fa--fa: \"\\f0e2\\f0e2\"; }\r\n\r\n.fa-arrow-rotate-backward {\r\n  --fa: \"\\f0e2\";\r\n  --fa--fa: \"\\f0e2\\f0e2\"; }\r\n\r\n.fa-undo {\r\n  --fa: \"\\f0e2\";\r\n  --fa--fa: \"\\f0e2\\f0e2\"; }\r\n\r\n.fa-hard-drive {\r\n  --fa: \"\\f0a0\";\r\n  --fa--fa: \"\\f0a0\\f0a0\"; }\r\n\r\n.fa-hdd {\r\n  --fa: \"\\f0a0\";\r\n  --fa--fa: \"\\f0a0\\f0a0\"; }\r\n\r\n.fa-face-grin-squint-tears {\r\n  --fa: \"\\f586\";\r\n  --fa--fa: \"\\f586\\f586\"; }\r\n\r\n.fa-grin-squint-tears {\r\n  --fa: \"\\f586\";\r\n  --fa--fa: \"\\f586\\f586\"; }\r\n\r\n.fa-dumbbell {\r\n  --fa: \"\\f44b\";\r\n  --fa--fa: \"\\f44b\\f44b\"; }\r\n\r\n.fa-rectangle-list {\r\n  --fa: \"\\f022\";\r\n  --fa--fa: \"\\f022\\f022\"; }\r\n\r\n.fa-list-alt {\r\n  --fa: \"\\f022\";\r\n  --fa--fa: \"\\f022\\f022\"; }\r\n\r\n.fa-tarp-droplet {\r\n  --fa: \"\\e57c\";\r\n  --fa--fa: \"\\e57c\\e57c\"; }\r\n\r\n.fa-house-medical-circle-check {\r\n  --fa: \"\\e511\";\r\n  --fa--fa: \"\\e511\\e511\"; }\r\n\r\n.fa-person-skiing-nordic {\r\n  --fa: \"\\f7ca\";\r\n  --fa--fa: \"\\f7ca\\f7ca\"; }\r\n\r\n.fa-skiing-nordic {\r\n  --fa: \"\\f7ca\";\r\n  --fa--fa: \"\\f7ca\\f7ca\"; }\r\n\r\n.fa-calendar-plus {\r\n  --fa: \"\\f271\";\r\n  --fa--fa: \"\\f271\\f271\"; }\r\n\r\n.fa-plane-arrival {\r\n  --fa: \"\\f5af\";\r\n  --fa--fa: \"\\f5af\\f5af\"; }\r\n\r\n.fa-circle-left {\r\n  --fa: \"\\f359\";\r\n  --fa--fa: \"\\f359\\f359\"; }\r\n\r\n.fa-arrow-alt-circle-left {\r\n  --fa: \"\\f359\";\r\n  --fa--fa: \"\\f359\\f359\"; }\r\n\r\n.fa-train-subway {\r\n  --fa: \"\\f239\";\r\n  --fa--fa: \"\\f239\\f239\"; }\r\n\r\n.fa-subway {\r\n  --fa: \"\\f239\";\r\n  --fa--fa: \"\\f239\\f239\"; }\r\n\r\n.fa-chart-gantt {\r\n  --fa: \"\\e0e4\";\r\n  --fa--fa: \"\\e0e4\\e0e4\"; }\r\n\r\n.fa-indian-rupee-sign {\r\n  --fa: \"\\e1bc\";\r\n  --fa--fa: \"\\e1bc\\e1bc\"; }\r\n\r\n.fa-indian-rupee {\r\n  --fa: \"\\e1bc\";\r\n  --fa--fa: \"\\e1bc\\e1bc\"; }\r\n\r\n.fa-inr {\r\n  --fa: \"\\e1bc\";\r\n  --fa--fa: \"\\e1bc\\e1bc\"; }\r\n\r\n.fa-crop-simple {\r\n  --fa: \"\\f565\";\r\n  --fa--fa: \"\\f565\\f565\"; }\r\n\r\n.fa-crop-alt {\r\n  --fa: \"\\f565\";\r\n  --fa--fa: \"\\f565\\f565\"; }\r\n\r\n.fa-money-bill-1 {\r\n  --fa: \"\\f3d1\";\r\n  --fa--fa: \"\\f3d1\\f3d1\"; }\r\n\r\n.fa-money-bill-alt {\r\n  --fa: \"\\f3d1\";\r\n  --fa--fa: \"\\f3d1\\f3d1\"; }\r\n\r\n.fa-left-long {\r\n  --fa: \"\\f30a\";\r\n  --fa--fa: \"\\f30a\\f30a\"; }\r\n\r\n.fa-long-arrow-alt-left {\r\n  --fa: \"\\f30a\";\r\n  --fa--fa: \"\\f30a\\f30a\"; }\r\n\r\n.fa-dna {\r\n  --fa: \"\\f471\";\r\n  --fa--fa: \"\\f471\\f471\"; }\r\n\r\n.fa-virus-slash {\r\n  --fa: \"\\e075\";\r\n  --fa--fa: \"\\e075\\e075\"; }\r\n\r\n.fa-minus {\r\n  --fa: \"\\f068\";\r\n  --fa--fa: \"\\f068\\f068\"; }\r\n\r\n.fa-subtract {\r\n  --fa: \"\\f068\";\r\n  --fa--fa: \"\\f068\\f068\"; }\r\n\r\n.fa-chess {\r\n  --fa: \"\\f439\";\r\n  --fa--fa: \"\\f439\\f439\"; }\r\n\r\n.fa-arrow-left-long {\r\n  --fa: \"\\f177\";\r\n  --fa--fa: \"\\f177\\f177\"; }\r\n\r\n.fa-long-arrow-left {\r\n  --fa: \"\\f177\";\r\n  --fa--fa: \"\\f177\\f177\"; }\r\n\r\n.fa-plug-circle-check {\r\n  --fa: \"\\e55c\";\r\n  --fa--fa: \"\\e55c\\e55c\"; }\r\n\r\n.fa-street-view {\r\n  --fa: \"\\f21d\";\r\n  --fa--fa: \"\\f21d\\f21d\"; }\r\n\r\n.fa-franc-sign {\r\n  --fa: \"\\e18f\";\r\n  --fa--fa: \"\\e18f\\e18f\"; }\r\n\r\n.fa-volume-off {\r\n  --fa: \"\\f026\";\r\n  --fa--fa: \"\\f026\\f026\"; }\r\n\r\n.fa-hands-asl-interpreting {\r\n  --fa: \"\\f2a3\";\r\n  --fa--fa: \"\\f2a3\\f2a3\"; }\r\n\r\n.fa-american-sign-language-interpreting {\r\n  --fa: \"\\f2a3\";\r\n  --fa--fa: \"\\f2a3\\f2a3\"; }\r\n\r\n.fa-asl-interpreting {\r\n  --fa: \"\\f2a3\";\r\n  --fa--fa: \"\\f2a3\\f2a3\"; }\r\n\r\n.fa-hands-american-sign-language-interpreting {\r\n  --fa: \"\\f2a3\";\r\n  --fa--fa: \"\\f2a3\\f2a3\"; }\r\n\r\n.fa-gear {\r\n  --fa: \"\\f013\";\r\n  --fa--fa: \"\\f013\\f013\"; }\r\n\r\n.fa-cog {\r\n  --fa: \"\\f013\";\r\n  --fa--fa: \"\\f013\\f013\"; }\r\n\r\n.fa-droplet-slash {\r\n  --fa: \"\\f5c7\";\r\n  --fa--fa: \"\\f5c7\\f5c7\"; }\r\n\r\n.fa-tint-slash {\r\n  --fa: \"\\f5c7\";\r\n  --fa--fa: \"\\f5c7\\f5c7\"; }\r\n\r\n.fa-mosque {\r\n  --fa: \"\\f678\";\r\n  --fa--fa: \"\\f678\\f678\"; }\r\n\r\n.fa-mosquito {\r\n  --fa: \"\\e52b\";\r\n  --fa--fa: \"\\e52b\\e52b\"; }\r\n\r\n.fa-star-of-david {\r\n  --fa: \"\\f69a\";\r\n  --fa--fa: \"\\f69a\\f69a\"; }\r\n\r\n.fa-person-military-rifle {\r\n  --fa: \"\\e54b\";\r\n  --fa--fa: \"\\e54b\\e54b\"; }\r\n\r\n.fa-cart-shopping {\r\n  --fa: \"\\f07a\";\r\n  --fa--fa: \"\\f07a\\f07a\"; }\r\n\r\n.fa-shopping-cart {\r\n  --fa: \"\\f07a\";\r\n  --fa--fa: \"\\f07a\\f07a\"; }\r\n\r\n.fa-vials {\r\n  --fa: \"\\f493\";\r\n  --fa--fa: \"\\f493\\f493\"; }\r\n\r\n.fa-plug-circle-plus {\r\n  --fa: \"\\e55f\";\r\n  --fa--fa: \"\\e55f\\e55f\"; }\r\n\r\n.fa-place-of-worship {\r\n  --fa: \"\\f67f\";\r\n  --fa--fa: \"\\f67f\\f67f\"; }\r\n\r\n.fa-grip-vertical {\r\n  --fa: \"\\f58e\";\r\n  --fa--fa: \"\\f58e\\f58e\"; }\r\n\r\n.fa-hexagon-nodes {\r\n  --fa: \"\\e699\";\r\n  --fa--fa: \"\\e699\\e699\"; }\r\n\r\n.fa-arrow-turn-up {\r\n  --fa: \"\\f148\";\r\n  --fa--fa: \"\\f148\\f148\"; }\r\n\r\n.fa-level-up {\r\n  --fa: \"\\f148\";\r\n  --fa--fa: \"\\f148\\f148\"; }\r\n\r\n.fa-u {\r\n  --fa: \"\\55\";\r\n  --fa--fa: \"\\55\\55\"; }\r\n\r\n.fa-square-root-variable {\r\n  --fa: \"\\f698\";\r\n  --fa--fa: \"\\f698\\f698\"; }\r\n\r\n.fa-square-root-alt {\r\n  --fa: \"\\f698\";\r\n  --fa--fa: \"\\f698\\f698\"; }\r\n\r\n.fa-clock {\r\n  --fa: \"\\f017\";\r\n  --fa--fa: \"\\f017\\f017\"; }\r\n\r\n.fa-clock-four {\r\n  --fa: \"\\f017\";\r\n  --fa--fa: \"\\f017\\f017\"; }\r\n\r\n.fa-backward-step {\r\n  --fa: \"\\f048\";\r\n  --fa--fa: \"\\f048\\f048\"; }\r\n\r\n.fa-step-backward {\r\n  --fa: \"\\f048\";\r\n  --fa--fa: \"\\f048\\f048\"; }\r\n\r\n.fa-pallet {\r\n  --fa: \"\\f482\";\r\n  --fa--fa: \"\\f482\\f482\"; }\r\n\r\n.fa-faucet {\r\n  --fa: \"\\e005\";\r\n  --fa--fa: \"\\e005\\e005\"; }\r\n\r\n.fa-baseball-bat-ball {\r\n  --fa: \"\\f432\";\r\n  --fa--fa: \"\\f432\\f432\"; }\r\n\r\n.fa-s {\r\n  --fa: \"\\53\";\r\n  --fa--fa: \"\\53\\53\"; }\r\n\r\n.fa-timeline {\r\n  --fa: \"\\e29c\";\r\n  --fa--fa: \"\\e29c\\e29c\"; }\r\n\r\n.fa-keyboard {\r\n  --fa: \"\\f11c\";\r\n  --fa--fa: \"\\f11c\\f11c\"; }\r\n\r\n.fa-caret-down {\r\n  --fa: \"\\f0d7\";\r\n  --fa--fa: \"\\f0d7\\f0d7\"; }\r\n\r\n.fa-house-chimney-medical {\r\n  --fa: \"\\f7f2\";\r\n  --fa--fa: \"\\f7f2\\f7f2\"; }\r\n\r\n.fa-clinic-medical {\r\n  --fa: \"\\f7f2\";\r\n  --fa--fa: \"\\f7f2\\f7f2\"; }\r\n\r\n.fa-temperature-three-quarters {\r\n  --fa: \"\\f2c8\";\r\n  --fa--fa: \"\\f2c8\\f2c8\"; }\r\n\r\n.fa-temperature-3 {\r\n  --fa: \"\\f2c8\";\r\n  --fa--fa: \"\\f2c8\\f2c8\"; }\r\n\r\n.fa-thermometer-3 {\r\n  --fa: \"\\f2c8\";\r\n  --fa--fa: \"\\f2c8\\f2c8\"; }\r\n\r\n.fa-thermometer-three-quarters {\r\n  --fa: \"\\f2c8\";\r\n  --fa--fa: \"\\f2c8\\f2c8\"; }\r\n\r\n.fa-mobile-screen {\r\n  --fa: \"\\f3cf\";\r\n  --fa--fa: \"\\f3cf\\f3cf\"; }\r\n\r\n.fa-mobile-android-alt {\r\n  --fa: \"\\f3cf\";\r\n  --fa--fa: \"\\f3cf\\f3cf\"; }\r\n\r\n.fa-plane-up {\r\n  --fa: \"\\e22d\";\r\n  --fa--fa: \"\\e22d\\e22d\"; }\r\n\r\n.fa-piggy-bank {\r\n  --fa: \"\\f4d3\";\r\n  --fa--fa: \"\\f4d3\\f4d3\"; }\r\n\r\n.fa-battery-half {\r\n  --fa: \"\\f242\";\r\n  --fa--fa: \"\\f242\\f242\"; }\r\n\r\n.fa-battery-3 {\r\n  --fa: \"\\f242\";\r\n  --fa--fa: \"\\f242\\f242\"; }\r\n\r\n.fa-mountain-city {\r\n  --fa: \"\\e52e\";\r\n  --fa--fa: \"\\e52e\\e52e\"; }\r\n\r\n.fa-coins {\r\n  --fa: \"\\f51e\";\r\n  --fa--fa: \"\\f51e\\f51e\"; }\r\n\r\n.fa-khanda {\r\n  --fa: \"\\f66d\";\r\n  --fa--fa: \"\\f66d\\f66d\"; }\r\n\r\n.fa-sliders {\r\n  --fa: \"\\f1de\";\r\n  --fa--fa: \"\\f1de\\f1de\"; }\r\n\r\n.fa-sliders-h {\r\n  --fa: \"\\f1de\";\r\n  --fa--fa: \"\\f1de\\f1de\"; }\r\n\r\n.fa-folder-tree {\r\n  --fa: \"\\f802\";\r\n  --fa--fa: \"\\f802\\f802\"; }\r\n\r\n.fa-network-wired {\r\n  --fa: \"\\f6ff\";\r\n  --fa--fa: \"\\f6ff\\f6ff\"; }\r\n\r\n.fa-map-pin {\r\n  --fa: \"\\f276\";\r\n  --fa--fa: \"\\f276\\f276\"; }\r\n\r\n.fa-hamsa {\r\n  --fa: \"\\f665\";\r\n  --fa--fa: \"\\f665\\f665\"; }\r\n\r\n.fa-cent-sign {\r\n  --fa: \"\\e3f5\";\r\n  --fa--fa: \"\\e3f5\\e3f5\"; }\r\n\r\n.fa-flask {\r\n  --fa: \"\\f0c3\";\r\n  --fa--fa: \"\\f0c3\\f0c3\"; }\r\n\r\n.fa-person-pregnant {\r\n  --fa: \"\\e31e\";\r\n  --fa--fa: \"\\e31e\\e31e\"; }\r\n\r\n.fa-wand-sparkles {\r\n  --fa: \"\\f72b\";\r\n  --fa--fa: \"\\f72b\\f72b\"; }\r\n\r\n.fa-ellipsis-vertical {\r\n  --fa: \"\\f142\";\r\n  --fa--fa: \"\\f142\\f142\"; }\r\n\r\n.fa-ellipsis-v {\r\n  --fa: \"\\f142\";\r\n  --fa--fa: \"\\f142\\f142\"; }\r\n\r\n.fa-ticket {\r\n  --fa: \"\\f145\";\r\n  --fa--fa: \"\\f145\\f145\"; }\r\n\r\n.fa-power-off {\r\n  --fa: \"\\f011\";\r\n  --fa--fa: \"\\f011\\f011\"; }\r\n\r\n.fa-right-long {\r\n  --fa: \"\\f30b\";\r\n  --fa--fa: \"\\f30b\\f30b\"; }\r\n\r\n.fa-long-arrow-alt-right {\r\n  --fa: \"\\f30b\";\r\n  --fa--fa: \"\\f30b\\f30b\"; }\r\n\r\n.fa-flag-usa {\r\n  --fa: \"\\f74d\";\r\n  --fa--fa: \"\\f74d\\f74d\"; }\r\n\r\n.fa-laptop-file {\r\n  --fa: \"\\e51d\";\r\n  --fa--fa: \"\\e51d\\e51d\"; }\r\n\r\n.fa-tty {\r\n  --fa: \"\\f1e4\";\r\n  --fa--fa: \"\\f1e4\\f1e4\"; }\r\n\r\n.fa-teletype {\r\n  --fa: \"\\f1e4\";\r\n  --fa--fa: \"\\f1e4\\f1e4\"; }\r\n\r\n.fa-diagram-next {\r\n  --fa: \"\\e476\";\r\n  --fa--fa: \"\\e476\\e476\"; }\r\n\r\n.fa-person-rifle {\r\n  --fa: \"\\e54e\";\r\n  --fa--fa: \"\\e54e\\e54e\"; }\r\n\r\n.fa-house-medical-circle-exclamation {\r\n  --fa: \"\\e512\";\r\n  --fa--fa: \"\\e512\\e512\"; }\r\n\r\n.fa-closed-captioning {\r\n  --fa: \"\\f20a\";\r\n  --fa--fa: \"\\f20a\\f20a\"; }\r\n\r\n.fa-person-hiking {\r\n  --fa: \"\\f6ec\";\r\n  --fa--fa: \"\\f6ec\\f6ec\"; }\r\n\r\n.fa-hiking {\r\n  --fa: \"\\f6ec\";\r\n  --fa--fa: \"\\f6ec\\f6ec\"; }\r\n\r\n.fa-venus-double {\r\n  --fa: \"\\f226\";\r\n  --fa--fa: \"\\f226\\f226\"; }\r\n\r\n.fa-images {\r\n  --fa: \"\\f302\";\r\n  --fa--fa: \"\\f302\\f302\"; }\r\n\r\n.fa-calculator {\r\n  --fa: \"\\f1ec\";\r\n  --fa--fa: \"\\f1ec\\f1ec\"; }\r\n\r\n.fa-people-pulling {\r\n  --fa: \"\\e535\";\r\n  --fa--fa: \"\\e535\\e535\"; }\r\n\r\n.fa-n {\r\n  --fa: \"\\4e\";\r\n  --fa--fa: \"\\4e\\4e\"; }\r\n\r\n.fa-cable-car {\r\n  --fa: \"\\f7da\";\r\n  --fa--fa: \"\\f7da\\f7da\"; }\r\n\r\n.fa-tram {\r\n  --fa: \"\\f7da\";\r\n  --fa--fa: \"\\f7da\\f7da\"; }\r\n\r\n.fa-cloud-rain {\r\n  --fa: \"\\f73d\";\r\n  --fa--fa: \"\\f73d\\f73d\"; }\r\n\r\n.fa-building-circle-xmark {\r\n  --fa: \"\\e4d4\";\r\n  --fa--fa: \"\\e4d4\\e4d4\"; }\r\n\r\n.fa-ship {\r\n  --fa: \"\\f21a\";\r\n  --fa--fa: \"\\f21a\\f21a\"; }\r\n\r\n.fa-arrows-down-to-line {\r\n  --fa: \"\\e4b8\";\r\n  --fa--fa: \"\\e4b8\\e4b8\"; }\r\n\r\n.fa-download {\r\n  --fa: \"\\f019\";\r\n  --fa--fa: \"\\f019\\f019\"; }\r\n\r\n.fa-face-grin {\r\n  --fa: \"\\f580\";\r\n  --fa--fa: \"\\f580\\f580\"; }\r\n\r\n.fa-grin {\r\n  --fa: \"\\f580\";\r\n  --fa--fa: \"\\f580\\f580\"; }\r\n\r\n.fa-delete-left {\r\n  --fa: \"\\f55a\";\r\n  --fa--fa: \"\\f55a\\f55a\"; }\r\n\r\n.fa-backspace {\r\n  --fa: \"\\f55a\";\r\n  --fa--fa: \"\\f55a\\f55a\"; }\r\n\r\n.fa-eye-dropper {\r\n  --fa: \"\\f1fb\";\r\n  --fa--fa: \"\\f1fb\\f1fb\"; }\r\n\r\n.fa-eye-dropper-empty {\r\n  --fa: \"\\f1fb\";\r\n  --fa--fa: \"\\f1fb\\f1fb\"; }\r\n\r\n.fa-eyedropper {\r\n  --fa: \"\\f1fb\";\r\n  --fa--fa: \"\\f1fb\\f1fb\"; }\r\n\r\n.fa-file-circle-check {\r\n  --fa: \"\\e5a0\";\r\n  --fa--fa: \"\\e5a0\\e5a0\"; }\r\n\r\n.fa-forward {\r\n  --fa: \"\\f04e\";\r\n  --fa--fa: \"\\f04e\\f04e\"; }\r\n\r\n.fa-mobile {\r\n  --fa: \"\\f3ce\";\r\n  --fa--fa: \"\\f3ce\\f3ce\"; }\r\n\r\n.fa-mobile-android {\r\n  --fa: \"\\f3ce\";\r\n  --fa--fa: \"\\f3ce\\f3ce\"; }\r\n\r\n.fa-mobile-phone {\r\n  --fa: \"\\f3ce\";\r\n  --fa--fa: \"\\f3ce\\f3ce\"; }\r\n\r\n.fa-face-meh {\r\n  --fa: \"\\f11a\";\r\n  --fa--fa: \"\\f11a\\f11a\"; }\r\n\r\n.fa-meh {\r\n  --fa: \"\\f11a\";\r\n  --fa--fa: \"\\f11a\\f11a\"; }\r\n\r\n.fa-align-center {\r\n  --fa: \"\\f037\";\r\n  --fa--fa: \"\\f037\\f037\"; }\r\n\r\n.fa-book-skull {\r\n  --fa: \"\\f6b7\";\r\n  --fa--fa: \"\\f6b7\\f6b7\"; }\r\n\r\n.fa-book-dead {\r\n  --fa: \"\\f6b7\";\r\n  --fa--fa: \"\\f6b7\\f6b7\"; }\r\n\r\n.fa-id-card {\r\n  --fa: \"\\f2c2\";\r\n  --fa--fa: \"\\f2c2\\f2c2\"; }\r\n\r\n.fa-drivers-license {\r\n  --fa: \"\\f2c2\";\r\n  --fa--fa: \"\\f2c2\\f2c2\"; }\r\n\r\n.fa-outdent {\r\n  --fa: \"\\f03b\";\r\n  --fa--fa: \"\\f03b\\f03b\"; }\r\n\r\n.fa-dedent {\r\n  --fa: \"\\f03b\";\r\n  --fa--fa: \"\\f03b\\f03b\"; }\r\n\r\n.fa-heart-circle-exclamation {\r\n  --fa: \"\\e4fe\";\r\n  --fa--fa: \"\\e4fe\\e4fe\"; }\r\n\r\n.fa-house {\r\n  --fa: \"\\f015\";\r\n  --fa--fa: \"\\f015\\f015\"; }\r\n\r\n.fa-home {\r\n  --fa: \"\\f015\";\r\n  --fa--fa: \"\\f015\\f015\"; }\r\n\r\n.fa-home-alt {\r\n  --fa: \"\\f015\";\r\n  --fa--fa: \"\\f015\\f015\"; }\r\n\r\n.fa-home-lg-alt {\r\n  --fa: \"\\f015\";\r\n  --fa--fa: \"\\f015\\f015\"; }\r\n\r\n.fa-calendar-week {\r\n  --fa: \"\\f784\";\r\n  --fa--fa: \"\\f784\\f784\"; }\r\n\r\n.fa-laptop-medical {\r\n  --fa: \"\\f812\";\r\n  --fa--fa: \"\\f812\\f812\"; }\r\n\r\n.fa-b {\r\n  --fa: \"\\42\";\r\n  --fa--fa: \"\\42\\42\"; }\r\n\r\n.fa-file-medical {\r\n  --fa: \"\\f477\";\r\n  --fa--fa: \"\\f477\\f477\"; }\r\n\r\n.fa-dice-one {\r\n  --fa: \"\\f525\";\r\n  --fa--fa: \"\\f525\\f525\"; }\r\n\r\n.fa-kiwi-bird {\r\n  --fa: \"\\f535\";\r\n  --fa--fa: \"\\f535\\f535\"; }\r\n\r\n.fa-arrow-right-arrow-left {\r\n  --fa: \"\\f0ec\";\r\n  --fa--fa: \"\\f0ec\\f0ec\"; }\r\n\r\n.fa-exchange {\r\n  --fa: \"\\f0ec\";\r\n  --fa--fa: \"\\f0ec\\f0ec\"; }\r\n\r\n.fa-rotate-right {\r\n  --fa: \"\\f2f9\";\r\n  --fa--fa: \"\\f2f9\\f2f9\"; }\r\n\r\n.fa-redo-alt {\r\n  --fa: \"\\f2f9\";\r\n  --fa--fa: \"\\f2f9\\f2f9\"; }\r\n\r\n.fa-rotate-forward {\r\n  --fa: \"\\f2f9\";\r\n  --fa--fa: \"\\f2f9\\f2f9\"; }\r\n\r\n.fa-utensils {\r\n  --fa: \"\\f2e7\";\r\n  --fa--fa: \"\\f2e7\\f2e7\"; }\r\n\r\n.fa-cutlery {\r\n  --fa: \"\\f2e7\";\r\n  --fa--fa: \"\\f2e7\\f2e7\"; }\r\n\r\n.fa-arrow-up-wide-short {\r\n  --fa: \"\\f161\";\r\n  --fa--fa: \"\\f161\\f161\"; }\r\n\r\n.fa-sort-amount-up {\r\n  --fa: \"\\f161\";\r\n  --fa--fa: \"\\f161\\f161\"; }\r\n\r\n.fa-mill-sign {\r\n  --fa: \"\\e1ed\";\r\n  --fa--fa: \"\\e1ed\\e1ed\"; }\r\n\r\n.fa-bowl-rice {\r\n  --fa: \"\\e2eb\";\r\n  --fa--fa: \"\\e2eb\\e2eb\"; }\r\n\r\n.fa-skull {\r\n  --fa: \"\\f54c\";\r\n  --fa--fa: \"\\f54c\\f54c\"; }\r\n\r\n.fa-tower-broadcast {\r\n  --fa: \"\\f519\";\r\n  --fa--fa: \"\\f519\\f519\"; }\r\n\r\n.fa-broadcast-tower {\r\n  --fa: \"\\f519\";\r\n  --fa--fa: \"\\f519\\f519\"; }\r\n\r\n.fa-truck-pickup {\r\n  --fa: \"\\f63c\";\r\n  --fa--fa: \"\\f63c\\f63c\"; }\r\n\r\n.fa-up-long {\r\n  --fa: \"\\f30c\";\r\n  --fa--fa: \"\\f30c\\f30c\"; }\r\n\r\n.fa-long-arrow-alt-up {\r\n  --fa: \"\\f30c\";\r\n  --fa--fa: \"\\f30c\\f30c\"; }\r\n\r\n.fa-stop {\r\n  --fa: \"\\f04d\";\r\n  --fa--fa: \"\\f04d\\f04d\"; }\r\n\r\n.fa-code-merge {\r\n  --fa: \"\\f387\";\r\n  --fa--fa: \"\\f387\\f387\"; }\r\n\r\n.fa-upload {\r\n  --fa: \"\\f093\";\r\n  --fa--fa: \"\\f093\\f093\"; }\r\n\r\n.fa-hurricane {\r\n  --fa: \"\\f751\";\r\n  --fa--fa: \"\\f751\\f751\"; }\r\n\r\n.fa-mound {\r\n  --fa: \"\\e52d\";\r\n  --fa--fa: \"\\e52d\\e52d\"; }\r\n\r\n.fa-toilet-portable {\r\n  --fa: \"\\e583\";\r\n  --fa--fa: \"\\e583\\e583\"; }\r\n\r\n.fa-compact-disc {\r\n  --fa: \"\\f51f\";\r\n  --fa--fa: \"\\f51f\\f51f\"; }\r\n\r\n.fa-file-arrow-down {\r\n  --fa: \"\\f56d\";\r\n  --fa--fa: \"\\f56d\\f56d\"; }\r\n\r\n.fa-file-download {\r\n  --fa: \"\\f56d\";\r\n  --fa--fa: \"\\f56d\\f56d\"; }\r\n\r\n.fa-caravan {\r\n  --fa: \"\\f8ff\";\r\n  --fa--fa: \"\\f8ff\\f8ff\"; }\r\n\r\n.fa-shield-cat {\r\n  --fa: \"\\e572\";\r\n  --fa--fa: \"\\e572\\e572\"; }\r\n\r\n.fa-bolt {\r\n  --fa: \"\\f0e7\";\r\n  --fa--fa: \"\\f0e7\\f0e7\"; }\r\n\r\n.fa-zap {\r\n  --fa: \"\\f0e7\";\r\n  --fa--fa: \"\\f0e7\\f0e7\"; }\r\n\r\n.fa-glass-water {\r\n  --fa: \"\\e4f4\";\r\n  --fa--fa: \"\\e4f4\\e4f4\"; }\r\n\r\n.fa-oil-well {\r\n  --fa: \"\\e532\";\r\n  --fa--fa: \"\\e532\\e532\"; }\r\n\r\n.fa-vault {\r\n  --fa: \"\\e2c5\";\r\n  --fa--fa: \"\\e2c5\\e2c5\"; }\r\n\r\n.fa-mars {\r\n  --fa: \"\\f222\";\r\n  --fa--fa: \"\\f222\\f222\"; }\r\n\r\n.fa-toilet {\r\n  --fa: \"\\f7d8\";\r\n  --fa--fa: \"\\f7d8\\f7d8\"; }\r\n\r\n.fa-plane-circle-xmark {\r\n  --fa: \"\\e557\";\r\n  --fa--fa: \"\\e557\\e557\"; }\r\n\r\n.fa-yen-sign {\r\n  --fa: \"\\f157\";\r\n  --fa--fa: \"\\f157\\f157\"; }\r\n\r\n.fa-cny {\r\n  --fa: \"\\f157\";\r\n  --fa--fa: \"\\f157\\f157\"; }\r\n\r\n.fa-jpy {\r\n  --fa: \"\\f157\";\r\n  --fa--fa: \"\\f157\\f157\"; }\r\n\r\n.fa-rmb {\r\n  --fa: \"\\f157\";\r\n  --fa--fa: \"\\f157\\f157\"; }\r\n\r\n.fa-yen {\r\n  --fa: \"\\f157\";\r\n  --fa--fa: \"\\f157\\f157\"; }\r\n\r\n.fa-ruble-sign {\r\n  --fa: \"\\f158\";\r\n  --fa--fa: \"\\f158\\f158\"; }\r\n\r\n.fa-rouble {\r\n  --fa: \"\\f158\";\r\n  --fa--fa: \"\\f158\\f158\"; }\r\n\r\n.fa-rub {\r\n  --fa: \"\\f158\";\r\n  --fa--fa: \"\\f158\\f158\"; }\r\n\r\n.fa-ruble {\r\n  --fa: \"\\f158\";\r\n  --fa--fa: \"\\f158\\f158\"; }\r\n\r\n.fa-sun {\r\n  --fa: \"\\f185\";\r\n  --fa--fa: \"\\f185\\f185\"; }\r\n\r\n.fa-guitar {\r\n  --fa: \"\\f7a6\";\r\n  --fa--fa: \"\\f7a6\\f7a6\"; }\r\n\r\n.fa-face-laugh-wink {\r\n  --fa: \"\\f59c\";\r\n  --fa--fa: \"\\f59c\\f59c\"; }\r\n\r\n.fa-laugh-wink {\r\n  --fa: \"\\f59c\";\r\n  --fa--fa: \"\\f59c\\f59c\"; }\r\n\r\n.fa-horse-head {\r\n  --fa: \"\\f7ab\";\r\n  --fa--fa: \"\\f7ab\\f7ab\"; }\r\n\r\n.fa-bore-hole {\r\n  --fa: \"\\e4c3\";\r\n  --fa--fa: \"\\e4c3\\e4c3\"; }\r\n\r\n.fa-industry {\r\n  --fa: \"\\f275\";\r\n  --fa--fa: \"\\f275\\f275\"; }\r\n\r\n.fa-circle-down {\r\n  --fa: \"\\f358\";\r\n  --fa--fa: \"\\f358\\f358\"; }\r\n\r\n.fa-arrow-alt-circle-down {\r\n  --fa: \"\\f358\";\r\n  --fa--fa: \"\\f358\\f358\"; }\r\n\r\n.fa-arrows-turn-to-dots {\r\n  --fa: \"\\e4c1\";\r\n  --fa--fa: \"\\e4c1\\e4c1\"; }\r\n\r\n.fa-florin-sign {\r\n  --fa: \"\\e184\";\r\n  --fa--fa: \"\\e184\\e184\"; }\r\n\r\n.fa-arrow-down-short-wide {\r\n  --fa: \"\\f884\";\r\n  --fa--fa: \"\\f884\\f884\"; }\r\n\r\n.fa-sort-amount-desc {\r\n  --fa: \"\\f884\";\r\n  --fa--fa: \"\\f884\\f884\"; }\r\n\r\n.fa-sort-amount-down-alt {\r\n  --fa: \"\\f884\";\r\n  --fa--fa: \"\\f884\\f884\"; }\r\n\r\n.fa-less-than {\r\n  --fa: \"\\3c\";\r\n  --fa--fa: \"\\3c\\3c\"; }\r\n\r\n.fa-angle-down {\r\n  --fa: \"\\f107\";\r\n  --fa--fa: \"\\f107\\f107\"; }\r\n\r\n.fa-car-tunnel {\r\n  --fa: \"\\e4de\";\r\n  --fa--fa: \"\\e4de\\e4de\"; }\r\n\r\n.fa-head-side-cough {\r\n  --fa: \"\\e061\";\r\n  --fa--fa: \"\\e061\\e061\"; }\r\n\r\n.fa-grip-lines {\r\n  --fa: \"\\f7a4\";\r\n  --fa--fa: \"\\f7a4\\f7a4\"; }\r\n\r\n.fa-thumbs-down {\r\n  --fa: \"\\f165\";\r\n  --fa--fa: \"\\f165\\f165\"; }\r\n\r\n.fa-user-lock {\r\n  --fa: \"\\f502\";\r\n  --fa--fa: \"\\f502\\f502\"; }\r\n\r\n.fa-arrow-right-long {\r\n  --fa: \"\\f178\";\r\n  --fa--fa: \"\\f178\\f178\"; }\r\n\r\n.fa-long-arrow-right {\r\n  --fa: \"\\f178\";\r\n  --fa--fa: \"\\f178\\f178\"; }\r\n\r\n.fa-anchor-circle-xmark {\r\n  --fa: \"\\e4ac\";\r\n  --fa--fa: \"\\e4ac\\e4ac\"; }\r\n\r\n.fa-ellipsis {\r\n  --fa: \"\\f141\";\r\n  --fa--fa: \"\\f141\\f141\"; }\r\n\r\n.fa-ellipsis-h {\r\n  --fa: \"\\f141\";\r\n  --fa--fa: \"\\f141\\f141\"; }\r\n\r\n.fa-chess-pawn {\r\n  --fa: \"\\f443\";\r\n  --fa--fa: \"\\f443\\f443\"; }\r\n\r\n.fa-kit-medical {\r\n  --fa: \"\\f479\";\r\n  --fa--fa: \"\\f479\\f479\"; }\r\n\r\n.fa-first-aid {\r\n  --fa: \"\\f479\";\r\n  --fa--fa: \"\\f479\\f479\"; }\r\n\r\n.fa-person-through-window {\r\n  --fa: \"\\e5a9\";\r\n  --fa--fa: \"\\e5a9\\e5a9\"; }\r\n\r\n.fa-toolbox {\r\n  --fa: \"\\f552\";\r\n  --fa--fa: \"\\f552\\f552\"; }\r\n\r\n.fa-hands-holding-circle {\r\n  --fa: \"\\e4fb\";\r\n  --fa--fa: \"\\e4fb\\e4fb\"; }\r\n\r\n.fa-bug {\r\n  --fa: \"\\f188\";\r\n  --fa--fa: \"\\f188\\f188\"; }\r\n\r\n.fa-credit-card {\r\n  --fa: \"\\f09d\";\r\n  --fa--fa: \"\\f09d\\f09d\"; }\r\n\r\n.fa-credit-card-alt {\r\n  --fa: \"\\f09d\";\r\n  --fa--fa: \"\\f09d\\f09d\"; }\r\n\r\n.fa-car {\r\n  --fa: \"\\f1b9\";\r\n  --fa--fa: \"\\f1b9\\f1b9\"; }\r\n\r\n.fa-automobile {\r\n  --fa: \"\\f1b9\";\r\n  --fa--fa: \"\\f1b9\\f1b9\"; }\r\n\r\n.fa-hand-holding-hand {\r\n  --fa: \"\\e4f7\";\r\n  --fa--fa: \"\\e4f7\\e4f7\"; }\r\n\r\n.fa-book-open-reader {\r\n  --fa: \"\\f5da\";\r\n  --fa--fa: \"\\f5da\\f5da\"; }\r\n\r\n.fa-book-reader {\r\n  --fa: \"\\f5da\";\r\n  --fa--fa: \"\\f5da\\f5da\"; }\r\n\r\n.fa-mountain-sun {\r\n  --fa: \"\\e52f\";\r\n  --fa--fa: \"\\e52f\\e52f\"; }\r\n\r\n.fa-arrows-left-right-to-line {\r\n  --fa: \"\\e4ba\";\r\n  --fa--fa: \"\\e4ba\\e4ba\"; }\r\n\r\n.fa-dice-d20 {\r\n  --fa: \"\\f6cf\";\r\n  --fa--fa: \"\\f6cf\\f6cf\"; }\r\n\r\n.fa-truck-droplet {\r\n  --fa: \"\\e58c\";\r\n  --fa--fa: \"\\e58c\\e58c\"; }\r\n\r\n.fa-file-circle-xmark {\r\n  --fa: \"\\e5a1\";\r\n  --fa--fa: \"\\e5a1\\e5a1\"; }\r\n\r\n.fa-temperature-arrow-up {\r\n  --fa: \"\\e040\";\r\n  --fa--fa: \"\\e040\\e040\"; }\r\n\r\n.fa-temperature-up {\r\n  --fa: \"\\e040\";\r\n  --fa--fa: \"\\e040\\e040\"; }\r\n\r\n.fa-medal {\r\n  --fa: \"\\f5a2\";\r\n  --fa--fa: \"\\f5a2\\f5a2\"; }\r\n\r\n.fa-bed {\r\n  --fa: \"\\f236\";\r\n  --fa--fa: \"\\f236\\f236\"; }\r\n\r\n.fa-square-h {\r\n  --fa: \"\\f0fd\";\r\n  --fa--fa: \"\\f0fd\\f0fd\"; }\r\n\r\n.fa-h-square {\r\n  --fa: \"\\f0fd\";\r\n  --fa--fa: \"\\f0fd\\f0fd\"; }\r\n\r\n.fa-podcast {\r\n  --fa: \"\\f2ce\";\r\n  --fa--fa: \"\\f2ce\\f2ce\"; }\r\n\r\n.fa-temperature-full {\r\n  --fa: \"\\f2c7\";\r\n  --fa--fa: \"\\f2c7\\f2c7\"; }\r\n\r\n.fa-temperature-4 {\r\n  --fa: \"\\f2c7\";\r\n  --fa--fa: \"\\f2c7\\f2c7\"; }\r\n\r\n.fa-thermometer-4 {\r\n  --fa: \"\\f2c7\";\r\n  --fa--fa: \"\\f2c7\\f2c7\"; }\r\n\r\n.fa-thermometer-full {\r\n  --fa: \"\\f2c7\";\r\n  --fa--fa: \"\\f2c7\\f2c7\"; }\r\n\r\n.fa-bell {\r\n  --fa: \"\\f0f3\";\r\n  --fa--fa: \"\\f0f3\\f0f3\"; }\r\n\r\n.fa-superscript {\r\n  --fa: \"\\f12b\";\r\n  --fa--fa: \"\\f12b\\f12b\"; }\r\n\r\n.fa-plug-circle-xmark {\r\n  --fa: \"\\e560\";\r\n  --fa--fa: \"\\e560\\e560\"; }\r\n\r\n.fa-star-of-life {\r\n  --fa: \"\\f621\";\r\n  --fa--fa: \"\\f621\\f621\"; }\r\n\r\n.fa-phone-slash {\r\n  --fa: \"\\f3dd\";\r\n  --fa--fa: \"\\f3dd\\f3dd\"; }\r\n\r\n.fa-paint-roller {\r\n  --fa: \"\\f5aa\";\r\n  --fa--fa: \"\\f5aa\\f5aa\"; }\r\n\r\n.fa-handshake-angle {\r\n  --fa: \"\\f4c4\";\r\n  --fa--fa: \"\\f4c4\\f4c4\"; }\r\n\r\n.fa-hands-helping {\r\n  --fa: \"\\f4c4\";\r\n  --fa--fa: \"\\f4c4\\f4c4\"; }\r\n\r\n.fa-location-dot {\r\n  --fa: \"\\f3c5\";\r\n  --fa--fa: \"\\f3c5\\f3c5\"; }\r\n\r\n.fa-map-marker-alt {\r\n  --fa: \"\\f3c5\";\r\n  --fa--fa: \"\\f3c5\\f3c5\"; }\r\n\r\n.fa-file {\r\n  --fa: \"\\f15b\";\r\n  --fa--fa: \"\\f15b\\f15b\"; }\r\n\r\n.fa-greater-than {\r\n  --fa: \"\\3e\";\r\n  --fa--fa: \"\\3e\\3e\"; }\r\n\r\n.fa-person-swimming {\r\n  --fa: \"\\f5c4\";\r\n  --fa--fa: \"\\f5c4\\f5c4\"; }\r\n\r\n.fa-swimmer {\r\n  --fa: \"\\f5c4\";\r\n  --fa--fa: \"\\f5c4\\f5c4\"; }\r\n\r\n.fa-arrow-down {\r\n  --fa: \"\\f063\";\r\n  --fa--fa: \"\\f063\\f063\"; }\r\n\r\n.fa-droplet {\r\n  --fa: \"\\f043\";\r\n  --fa--fa: \"\\f043\\f043\"; }\r\n\r\n.fa-tint {\r\n  --fa: \"\\f043\";\r\n  --fa--fa: \"\\f043\\f043\"; }\r\n\r\n.fa-eraser {\r\n  --fa: \"\\f12d\";\r\n  --fa--fa: \"\\f12d\\f12d\"; }\r\n\r\n.fa-earth-americas {\r\n  --fa: \"\\f57d\";\r\n  --fa--fa: \"\\f57d\\f57d\"; }\r\n\r\n.fa-earth {\r\n  --fa: \"\\f57d\";\r\n  --fa--fa: \"\\f57d\\f57d\"; }\r\n\r\n.fa-earth-america {\r\n  --fa: \"\\f57d\";\r\n  --fa--fa: \"\\f57d\\f57d\"; }\r\n\r\n.fa-globe-americas {\r\n  --fa: \"\\f57d\";\r\n  --fa--fa: \"\\f57d\\f57d\"; }\r\n\r\n.fa-person-burst {\r\n  --fa: \"\\e53b\";\r\n  --fa--fa: \"\\e53b\\e53b\"; }\r\n\r\n.fa-dove {\r\n  --fa: \"\\f4ba\";\r\n  --fa--fa: \"\\f4ba\\f4ba\"; }\r\n\r\n.fa-battery-empty {\r\n  --fa: \"\\f244\";\r\n  --fa--fa: \"\\f244\\f244\"; }\r\n\r\n.fa-battery-0 {\r\n  --fa: \"\\f244\";\r\n  --fa--fa: \"\\f244\\f244\"; }\r\n\r\n.fa-socks {\r\n  --fa: \"\\f696\";\r\n  --fa--fa: \"\\f696\\f696\"; }\r\n\r\n.fa-inbox {\r\n  --fa: \"\\f01c\";\r\n  --fa--fa: \"\\f01c\\f01c\"; }\r\n\r\n.fa-section {\r\n  --fa: \"\\e447\";\r\n  --fa--fa: \"\\e447\\e447\"; }\r\n\r\n.fa-gauge-high {\r\n  --fa: \"\\f625\";\r\n  --fa--fa: \"\\f625\\f625\"; }\r\n\r\n.fa-tachometer-alt {\r\n  --fa: \"\\f625\";\r\n  --fa--fa: \"\\f625\\f625\"; }\r\n\r\n.fa-tachometer-alt-fast {\r\n  --fa: \"\\f625\";\r\n  --fa--fa: \"\\f625\\f625\"; }\r\n\r\n.fa-envelope-open-text {\r\n  --fa: \"\\f658\";\r\n  --fa--fa: \"\\f658\\f658\"; }\r\n\r\n.fa-hospital {\r\n  --fa: \"\\f0f8\";\r\n  --fa--fa: \"\\f0f8\\f0f8\"; }\r\n\r\n.fa-hospital-alt {\r\n  --fa: \"\\f0f8\";\r\n  --fa--fa: \"\\f0f8\\f0f8\"; }\r\n\r\n.fa-hospital-wide {\r\n  --fa: \"\\f0f8\";\r\n  --fa--fa: \"\\f0f8\\f0f8\"; }\r\n\r\n.fa-wine-bottle {\r\n  --fa: \"\\f72f\";\r\n  --fa--fa: \"\\f72f\\f72f\"; }\r\n\r\n.fa-chess-rook {\r\n  --fa: \"\\f447\";\r\n  --fa--fa: \"\\f447\\f447\"; }\r\n\r\n.fa-bars-staggered {\r\n  --fa: \"\\f550\";\r\n  --fa--fa: \"\\f550\\f550\"; }\r\n\r\n.fa-reorder {\r\n  --fa: \"\\f550\";\r\n  --fa--fa: \"\\f550\\f550\"; }\r\n\r\n.fa-stream {\r\n  --fa: \"\\f550\";\r\n  --fa--fa: \"\\f550\\f550\"; }\r\n\r\n.fa-dharmachakra {\r\n  --fa: \"\\f655\";\r\n  --fa--fa: \"\\f655\\f655\"; }\r\n\r\n.fa-hotdog {\r\n  --fa: \"\\f80f\";\r\n  --fa--fa: \"\\f80f\\f80f\"; }\r\n\r\n.fa-person-walking-with-cane {\r\n  --fa: \"\\f29d\";\r\n  --fa--fa: \"\\f29d\\f29d\"; }\r\n\r\n.fa-blind {\r\n  --fa: \"\\f29d\";\r\n  --fa--fa: \"\\f29d\\f29d\"; }\r\n\r\n.fa-drum {\r\n  --fa: \"\\f569\";\r\n  --fa--fa: \"\\f569\\f569\"; }\r\n\r\n.fa-ice-cream {\r\n  --fa: \"\\f810\";\r\n  --fa--fa: \"\\f810\\f810\"; }\r\n\r\n.fa-heart-circle-bolt {\r\n  --fa: \"\\e4fc\";\r\n  --fa--fa: \"\\e4fc\\e4fc\"; }\r\n\r\n.fa-fax {\r\n  --fa: \"\\f1ac\";\r\n  --fa--fa: \"\\f1ac\\f1ac\"; }\r\n\r\n.fa-paragraph {\r\n  --fa: \"\\f1dd\";\r\n  --fa--fa: \"\\f1dd\\f1dd\"; }\r\n\r\n.fa-check-to-slot {\r\n  --fa: \"\\f772\";\r\n  --fa--fa: \"\\f772\\f772\"; }\r\n\r\n.fa-vote-yea {\r\n  --fa: \"\\f772\";\r\n  --fa--fa: \"\\f772\\f772\"; }\r\n\r\n.fa-star-half {\r\n  --fa: \"\\f089\";\r\n  --fa--fa: \"\\f089\\f089\"; }\r\n\r\n.fa-boxes-stacked {\r\n  --fa: \"\\f468\";\r\n  --fa--fa: \"\\f468\\f468\"; }\r\n\r\n.fa-boxes {\r\n  --fa: \"\\f468\";\r\n  --fa--fa: \"\\f468\\f468\"; }\r\n\r\n.fa-boxes-alt {\r\n  --fa: \"\\f468\";\r\n  --fa--fa: \"\\f468\\f468\"; }\r\n\r\n.fa-link {\r\n  --fa: \"\\f0c1\";\r\n  --fa--fa: \"\\f0c1\\f0c1\"; }\r\n\r\n.fa-chain {\r\n  --fa: \"\\f0c1\";\r\n  --fa--fa: \"\\f0c1\\f0c1\"; }\r\n\r\n.fa-ear-listen {\r\n  --fa: \"\\f2a2\";\r\n  --fa--fa: \"\\f2a2\\f2a2\"; }\r\n\r\n.fa-assistive-listening-systems {\r\n  --fa: \"\\f2a2\";\r\n  --fa--fa: \"\\f2a2\\f2a2\"; }\r\n\r\n.fa-tree-city {\r\n  --fa: \"\\e587\";\r\n  --fa--fa: \"\\e587\\e587\"; }\r\n\r\n.fa-play {\r\n  --fa: \"\\f04b\";\r\n  --fa--fa: \"\\f04b\\f04b\"; }\r\n\r\n.fa-font {\r\n  --fa: \"\\f031\";\r\n  --fa--fa: \"\\f031\\f031\"; }\r\n\r\n.fa-table-cells-row-lock {\r\n  --fa: \"\\e67a\";\r\n  --fa--fa: \"\\e67a\\e67a\"; }\r\n\r\n.fa-rupiah-sign {\r\n  --fa: \"\\e23d\";\r\n  --fa--fa: \"\\e23d\\e23d\"; }\r\n\r\n.fa-magnifying-glass {\r\n  --fa: \"\\f002\";\r\n  --fa--fa: \"\\f002\\f002\"; }\r\n\r\n.fa-search {\r\n  --fa: \"\\f002\";\r\n  --fa--fa: \"\\f002\\f002\"; }\r\n\r\n.fa-table-tennis-paddle-ball {\r\n  --fa: \"\\f45d\";\r\n  --fa--fa: \"\\f45d\\f45d\"; }\r\n\r\n.fa-ping-pong-paddle-ball {\r\n  --fa: \"\\f45d\";\r\n  --fa--fa: \"\\f45d\\f45d\"; }\r\n\r\n.fa-table-tennis {\r\n  --fa: \"\\f45d\";\r\n  --fa--fa: \"\\f45d\\f45d\"; }\r\n\r\n.fa-person-dots-from-line {\r\n  --fa: \"\\f470\";\r\n  --fa--fa: \"\\f470\\f470\"; }\r\n\r\n.fa-diagnoses {\r\n  --fa: \"\\f470\";\r\n  --fa--fa: \"\\f470\\f470\"; }\r\n\r\n.fa-trash-can-arrow-up {\r\n  --fa: \"\\f82a\";\r\n  --fa--fa: \"\\f82a\\f82a\"; }\r\n\r\n.fa-trash-restore-alt {\r\n  --fa: \"\\f82a\";\r\n  --fa--fa: \"\\f82a\\f82a\"; }\r\n\r\n.fa-naira-sign {\r\n  --fa: \"\\e1f6\";\r\n  --fa--fa: \"\\e1f6\\e1f6\"; }\r\n\r\n.fa-cart-arrow-down {\r\n  --fa: \"\\f218\";\r\n  --fa--fa: \"\\f218\\f218\"; }\r\n\r\n.fa-walkie-talkie {\r\n  --fa: \"\\f8ef\";\r\n  --fa--fa: \"\\f8ef\\f8ef\"; }\r\n\r\n.fa-file-pen {\r\n  --fa: \"\\f31c\";\r\n  --fa--fa: \"\\f31c\\f31c\"; }\r\n\r\n.fa-file-edit {\r\n  --fa: \"\\f31c\";\r\n  --fa--fa: \"\\f31c\\f31c\"; }\r\n\r\n.fa-receipt {\r\n  --fa: \"\\f543\";\r\n  --fa--fa: \"\\f543\\f543\"; }\r\n\r\n.fa-square-pen {\r\n  --fa: \"\\f14b\";\r\n  --fa--fa: \"\\f14b\\f14b\"; }\r\n\r\n.fa-pen-square {\r\n  --fa: \"\\f14b\";\r\n  --fa--fa: \"\\f14b\\f14b\"; }\r\n\r\n.fa-pencil-square {\r\n  --fa: \"\\f14b\";\r\n  --fa--fa: \"\\f14b\\f14b\"; }\r\n\r\n.fa-suitcase-rolling {\r\n  --fa: \"\\f5c1\";\r\n  --fa--fa: \"\\f5c1\\f5c1\"; }\r\n\r\n.fa-person-circle-exclamation {\r\n  --fa: \"\\e53f\";\r\n  --fa--fa: \"\\e53f\\e53f\"; }\r\n\r\n.fa-chevron-down {\r\n  --fa: \"\\f078\";\r\n  --fa--fa: \"\\f078\\f078\"; }\r\n\r\n.fa-battery-full {\r\n  --fa: \"\\f240\";\r\n  --fa--fa: \"\\f240\\f240\"; }\r\n\r\n.fa-battery {\r\n  --fa: \"\\f240\";\r\n  --fa--fa: \"\\f240\\f240\"; }\r\n\r\n.fa-battery-5 {\r\n  --fa: \"\\f240\";\r\n  --fa--fa: \"\\f240\\f240\"; }\r\n\r\n.fa-skull-crossbones {\r\n  --fa: \"\\f714\";\r\n  --fa--fa: \"\\f714\\f714\"; }\r\n\r\n.fa-code-compare {\r\n  --fa: \"\\e13a\";\r\n  --fa--fa: \"\\e13a\\e13a\"; }\r\n\r\n.fa-list-ul {\r\n  --fa: \"\\f0ca\";\r\n  --fa--fa: \"\\f0ca\\f0ca\"; }\r\n\r\n.fa-list-dots {\r\n  --fa: \"\\f0ca\";\r\n  --fa--fa: \"\\f0ca\\f0ca\"; }\r\n\r\n.fa-school-lock {\r\n  --fa: \"\\e56f\";\r\n  --fa--fa: \"\\e56f\\e56f\"; }\r\n\r\n.fa-tower-cell {\r\n  --fa: \"\\e585\";\r\n  --fa--fa: \"\\e585\\e585\"; }\r\n\r\n.fa-down-long {\r\n  --fa: \"\\f309\";\r\n  --fa--fa: \"\\f309\\f309\"; }\r\n\r\n.fa-long-arrow-alt-down {\r\n  --fa: \"\\f309\";\r\n  --fa--fa: \"\\f309\\f309\"; }\r\n\r\n.fa-ranking-star {\r\n  --fa: \"\\e561\";\r\n  --fa--fa: \"\\e561\\e561\"; }\r\n\r\n.fa-chess-king {\r\n  --fa: \"\\f43f\";\r\n  --fa--fa: \"\\f43f\\f43f\"; }\r\n\r\n.fa-person-harassing {\r\n  --fa: \"\\e549\";\r\n  --fa--fa: \"\\e549\\e549\"; }\r\n\r\n.fa-brazilian-real-sign {\r\n  --fa: \"\\e46c\";\r\n  --fa--fa: \"\\e46c\\e46c\"; }\r\n\r\n.fa-landmark-dome {\r\n  --fa: \"\\f752\";\r\n  --fa--fa: \"\\f752\\f752\"; }\r\n\r\n.fa-landmark-alt {\r\n  --fa: \"\\f752\";\r\n  --fa--fa: \"\\f752\\f752\"; }\r\n\r\n.fa-arrow-up {\r\n  --fa: \"\\f062\";\r\n  --fa--fa: \"\\f062\\f062\"; }\r\n\r\n.fa-tv {\r\n  --fa: \"\\f26c\";\r\n  --fa--fa: \"\\f26c\\f26c\"; }\r\n\r\n.fa-television {\r\n  --fa: \"\\f26c\";\r\n  --fa--fa: \"\\f26c\\f26c\"; }\r\n\r\n.fa-tv-alt {\r\n  --fa: \"\\f26c\";\r\n  --fa--fa: \"\\f26c\\f26c\"; }\r\n\r\n.fa-shrimp {\r\n  --fa: \"\\e448\";\r\n  --fa--fa: \"\\e448\\e448\"; }\r\n\r\n.fa-list-check {\r\n  --fa: \"\\f0ae\";\r\n  --fa--fa: \"\\f0ae\\f0ae\"; }\r\n\r\n.fa-tasks {\r\n  --fa: \"\\f0ae\";\r\n  --fa--fa: \"\\f0ae\\f0ae\"; }\r\n\r\n.fa-jug-detergent {\r\n  --fa: \"\\e519\";\r\n  --fa--fa: \"\\e519\\e519\"; }\r\n\r\n.fa-circle-user {\r\n  --fa: \"\\f2bd\";\r\n  --fa--fa: \"\\f2bd\\f2bd\"; }\r\n\r\n.fa-user-circle {\r\n  --fa: \"\\f2bd\";\r\n  --fa--fa: \"\\f2bd\\f2bd\"; }\r\n\r\n.fa-user-shield {\r\n  --fa: \"\\f505\";\r\n  --fa--fa: \"\\f505\\f505\"; }\r\n\r\n.fa-wind {\r\n  --fa: \"\\f72e\";\r\n  --fa--fa: \"\\f72e\\f72e\"; }\r\n\r\n.fa-car-burst {\r\n  --fa: \"\\f5e1\";\r\n  --fa--fa: \"\\f5e1\\f5e1\"; }\r\n\r\n.fa-car-crash {\r\n  --fa: \"\\f5e1\";\r\n  --fa--fa: \"\\f5e1\\f5e1\"; }\r\n\r\n.fa-y {\r\n  --fa: \"\\59\";\r\n  --fa--fa: \"\\59\\59\"; }\r\n\r\n.fa-person-snowboarding {\r\n  --fa: \"\\f7ce\";\r\n  --fa--fa: \"\\f7ce\\f7ce\"; }\r\n\r\n.fa-snowboarding {\r\n  --fa: \"\\f7ce\";\r\n  --fa--fa: \"\\f7ce\\f7ce\"; }\r\n\r\n.fa-truck-fast {\r\n  --fa: \"\\f48b\";\r\n  --fa--fa: \"\\f48b\\f48b\"; }\r\n\r\n.fa-shipping-fast {\r\n  --fa: \"\\f48b\";\r\n  --fa--fa: \"\\f48b\\f48b\"; }\r\n\r\n.fa-fish {\r\n  --fa: \"\\f578\";\r\n  --fa--fa: \"\\f578\\f578\"; }\r\n\r\n.fa-user-graduate {\r\n  --fa: \"\\f501\";\r\n  --fa--fa: \"\\f501\\f501\"; }\r\n\r\n.fa-circle-half-stroke {\r\n  --fa: \"\\f042\";\r\n  --fa--fa: \"\\f042\\f042\"; }\r\n\r\n.fa-adjust {\r\n  --fa: \"\\f042\";\r\n  --fa--fa: \"\\f042\\f042\"; }\r\n\r\n.fa-clapperboard {\r\n  --fa: \"\\e131\";\r\n  --fa--fa: \"\\e131\\e131\"; }\r\n\r\n.fa-circle-radiation {\r\n  --fa: \"\\f7ba\";\r\n  --fa--fa: \"\\f7ba\\f7ba\"; }\r\n\r\n.fa-radiation-alt {\r\n  --fa: \"\\f7ba\";\r\n  --fa--fa: \"\\f7ba\\f7ba\"; }\r\n\r\n.fa-baseball {\r\n  --fa: \"\\f433\";\r\n  --fa--fa: \"\\f433\\f433\"; }\r\n\r\n.fa-baseball-ball {\r\n  --fa: \"\\f433\";\r\n  --fa--fa: \"\\f433\\f433\"; }\r\n\r\n.fa-jet-fighter-up {\r\n  --fa: \"\\e518\";\r\n  --fa--fa: \"\\e518\\e518\"; }\r\n\r\n.fa-diagram-project {\r\n  --fa: \"\\f542\";\r\n  --fa--fa: \"\\f542\\f542\"; }\r\n\r\n.fa-project-diagram {\r\n  --fa: \"\\f542\";\r\n  --fa--fa: \"\\f542\\f542\"; }\r\n\r\n.fa-copy {\r\n  --fa: \"\\f0c5\";\r\n  --fa--fa: \"\\f0c5\\f0c5\"; }\r\n\r\n.fa-volume-xmark {\r\n  --fa: \"\\f6a9\";\r\n  --fa--fa: \"\\f6a9\\f6a9\"; }\r\n\r\n.fa-volume-mute {\r\n  --fa: \"\\f6a9\";\r\n  --fa--fa: \"\\f6a9\\f6a9\"; }\r\n\r\n.fa-volume-times {\r\n  --fa: \"\\f6a9\";\r\n  --fa--fa: \"\\f6a9\\f6a9\"; }\r\n\r\n.fa-hand-sparkles {\r\n  --fa: \"\\e05d\";\r\n  --fa--fa: \"\\e05d\\e05d\"; }\r\n\r\n.fa-grip {\r\n  --fa: \"\\f58d\";\r\n  --fa--fa: \"\\f58d\\f58d\"; }\r\n\r\n.fa-grip-horizontal {\r\n  --fa: \"\\f58d\";\r\n  --fa--fa: \"\\f58d\\f58d\"; }\r\n\r\n.fa-share-from-square {\r\n  --fa: \"\\f14d\";\r\n  --fa--fa: \"\\f14d\\f14d\"; }\r\n\r\n.fa-share-square {\r\n  --fa: \"\\f14d\";\r\n  --fa--fa: \"\\f14d\\f14d\"; }\r\n\r\n.fa-child-combatant {\r\n  --fa: \"\\e4e0\";\r\n  --fa--fa: \"\\e4e0\\e4e0\"; }\r\n\r\n.fa-child-rifle {\r\n  --fa: \"\\e4e0\";\r\n  --fa--fa: \"\\e4e0\\e4e0\"; }\r\n\r\n.fa-gun {\r\n  --fa: \"\\e19b\";\r\n  --fa--fa: \"\\e19b\\e19b\"; }\r\n\r\n.fa-square-phone {\r\n  --fa: \"\\f098\";\r\n  --fa--fa: \"\\f098\\f098\"; }\r\n\r\n.fa-phone-square {\r\n  --fa: \"\\f098\";\r\n  --fa--fa: \"\\f098\\f098\"; }\r\n\r\n.fa-plus {\r\n  --fa: \"\\2b\";\r\n  --fa--fa: \"\\2b\\2b\"; }\r\n\r\n.fa-add {\r\n  --fa: \"\\2b\";\r\n  --fa--fa: \"\\2b\\2b\"; }\r\n\r\n.fa-expand {\r\n  --fa: \"\\f065\";\r\n  --fa--fa: \"\\f065\\f065\"; }\r\n\r\n.fa-computer {\r\n  --fa: \"\\e4e5\";\r\n  --fa--fa: \"\\e4e5\\e4e5\"; }\r\n\r\n.fa-xmark {\r\n  --fa: \"\\f00d\";\r\n  --fa--fa: \"\\f00d\\f00d\"; }\r\n\r\n.fa-close {\r\n  --fa: \"\\f00d\";\r\n  --fa--fa: \"\\f00d\\f00d\"; }\r\n\r\n.fa-multiply {\r\n  --fa: \"\\f00d\";\r\n  --fa--fa: \"\\f00d\\f00d\"; }\r\n\r\n.fa-remove {\r\n  --fa: \"\\f00d\";\r\n  --fa--fa: \"\\f00d\\f00d\"; }\r\n\r\n.fa-times {\r\n  --fa: \"\\f00d\";\r\n  --fa--fa: \"\\f00d\\f00d\"; }\r\n\r\n.fa-arrows-up-down-left-right {\r\n  --fa: \"\\f047\";\r\n  --fa--fa: \"\\f047\\f047\"; }\r\n\r\n.fa-arrows {\r\n  --fa: \"\\f047\";\r\n  --fa--fa: \"\\f047\\f047\"; }\r\n\r\n.fa-chalkboard-user {\r\n  --fa: \"\\f51c\";\r\n  --fa--fa: \"\\f51c\\f51c\"; }\r\n\r\n.fa-chalkboard-teacher {\r\n  --fa: \"\\f51c\";\r\n  --fa--fa: \"\\f51c\\f51c\"; }\r\n\r\n.fa-peso-sign {\r\n  --fa: \"\\e222\";\r\n  --fa--fa: \"\\e222\\e222\"; }\r\n\r\n.fa-building-shield {\r\n  --fa: \"\\e4d8\";\r\n  --fa--fa: \"\\e4d8\\e4d8\"; }\r\n\r\n.fa-baby {\r\n  --fa: \"\\f77c\";\r\n  --fa--fa: \"\\f77c\\f77c\"; }\r\n\r\n.fa-users-line {\r\n  --fa: \"\\e592\";\r\n  --fa--fa: \"\\e592\\e592\"; }\r\n\r\n.fa-quote-left {\r\n  --fa: \"\\f10d\";\r\n  --fa--fa: \"\\f10d\\f10d\"; }\r\n\r\n.fa-quote-left-alt {\r\n  --fa: \"\\f10d\";\r\n  --fa--fa: \"\\f10d\\f10d\"; }\r\n\r\n.fa-tractor {\r\n  --fa: \"\\f722\";\r\n  --fa--fa: \"\\f722\\f722\"; }\r\n\r\n.fa-trash-arrow-up {\r\n  --fa: \"\\f829\";\r\n  --fa--fa: \"\\f829\\f829\"; }\r\n\r\n.fa-trash-restore {\r\n  --fa: \"\\f829\";\r\n  --fa--fa: \"\\f829\\f829\"; }\r\n\r\n.fa-arrow-down-up-lock {\r\n  --fa: \"\\e4b0\";\r\n  --fa--fa: \"\\e4b0\\e4b0\"; }\r\n\r\n.fa-lines-leaning {\r\n  --fa: \"\\e51e\";\r\n  --fa--fa: \"\\e51e\\e51e\"; }\r\n\r\n.fa-ruler-combined {\r\n  --fa: \"\\f546\";\r\n  --fa--fa: \"\\f546\\f546\"; }\r\n\r\n.fa-copyright {\r\n  --fa: \"\\f1f9\";\r\n  --fa--fa: \"\\f1f9\\f1f9\"; }\r\n\r\n.fa-equals {\r\n  --fa: \"\\3d\";\r\n  --fa--fa: \"\\3d\\3d\"; }\r\n\r\n.fa-blender {\r\n  --fa: \"\\f517\";\r\n  --fa--fa: \"\\f517\\f517\"; }\r\n\r\n.fa-teeth {\r\n  --fa: \"\\f62e\";\r\n  --fa--fa: \"\\f62e\\f62e\"; }\r\n\r\n.fa-shekel-sign {\r\n  --fa: \"\\f20b\";\r\n  --fa--fa: \"\\f20b\\f20b\"; }\r\n\r\n.fa-ils {\r\n  --fa: \"\\f20b\";\r\n  --fa--fa: \"\\f20b\\f20b\"; }\r\n\r\n.fa-shekel {\r\n  --fa: \"\\f20b\";\r\n  --fa--fa: \"\\f20b\\f20b\"; }\r\n\r\n.fa-sheqel {\r\n  --fa: \"\\f20b\";\r\n  --fa--fa: \"\\f20b\\f20b\"; }\r\n\r\n.fa-sheqel-sign {\r\n  --fa: \"\\f20b\";\r\n  --fa--fa: \"\\f20b\\f20b\"; }\r\n\r\n.fa-map {\r\n  --fa: \"\\f279\";\r\n  --fa--fa: \"\\f279\\f279\"; }\r\n\r\n.fa-rocket {\r\n  --fa: \"\\f135\";\r\n  --fa--fa: \"\\f135\\f135\"; }\r\n\r\n.fa-photo-film {\r\n  --fa: \"\\f87c\";\r\n  --fa--fa: \"\\f87c\\f87c\"; }\r\n\r\n.fa-photo-video {\r\n  --fa: \"\\f87c\";\r\n  --fa--fa: \"\\f87c\\f87c\"; }\r\n\r\n.fa-folder-minus {\r\n  --fa: \"\\f65d\";\r\n  --fa--fa: \"\\f65d\\f65d\"; }\r\n\r\n.fa-hexagon-nodes-bolt {\r\n  --fa: \"\\e69a\";\r\n  --fa--fa: \"\\e69a\\e69a\"; }\r\n\r\n.fa-store {\r\n  --fa: \"\\f54e\";\r\n  --fa--fa: \"\\f54e\\f54e\"; }\r\n\r\n.fa-arrow-trend-up {\r\n  --fa: \"\\e098\";\r\n  --fa--fa: \"\\e098\\e098\"; }\r\n\r\n.fa-plug-circle-minus {\r\n  --fa: \"\\e55e\";\r\n  --fa--fa: \"\\e55e\\e55e\"; }\r\n\r\n.fa-sign-hanging {\r\n  --fa: \"\\f4d9\";\r\n  --fa--fa: \"\\f4d9\\f4d9\"; }\r\n\r\n.fa-sign {\r\n  --fa: \"\\f4d9\";\r\n  --fa--fa: \"\\f4d9\\f4d9\"; }\r\n\r\n.fa-bezier-curve {\r\n  --fa: \"\\f55b\";\r\n  --fa--fa: \"\\f55b\\f55b\"; }\r\n\r\n.fa-bell-slash {\r\n  --fa: \"\\f1f6\";\r\n  --fa--fa: \"\\f1f6\\f1f6\"; }\r\n\r\n.fa-tablet {\r\n  --fa: \"\\f3fb\";\r\n  --fa--fa: \"\\f3fb\\f3fb\"; }\r\n\r\n.fa-tablet-android {\r\n  --fa: \"\\f3fb\";\r\n  --fa--fa: \"\\f3fb\\f3fb\"; }\r\n\r\n.fa-school-flag {\r\n  --fa: \"\\e56e\";\r\n  --fa--fa: \"\\e56e\\e56e\"; }\r\n\r\n.fa-fill {\r\n  --fa: \"\\f575\";\r\n  --fa--fa: \"\\f575\\f575\"; }\r\n\r\n.fa-angle-up {\r\n  --fa: \"\\f106\";\r\n  --fa--fa: \"\\f106\\f106\"; }\r\n\r\n.fa-drumstick-bite {\r\n  --fa: \"\\f6d7\";\r\n  --fa--fa: \"\\f6d7\\f6d7\"; }\r\n\r\n.fa-holly-berry {\r\n  --fa: \"\\f7aa\";\r\n  --fa--fa: \"\\f7aa\\f7aa\"; }\r\n\r\n.fa-chevron-left {\r\n  --fa: \"\\f053\";\r\n  --fa--fa: \"\\f053\\f053\"; }\r\n\r\n.fa-bacteria {\r\n  --fa: \"\\e059\";\r\n  --fa--fa: \"\\e059\\e059\"; }\r\n\r\n.fa-hand-lizard {\r\n  --fa: \"\\f258\";\r\n  --fa--fa: \"\\f258\\f258\"; }\r\n\r\n.fa-notdef {\r\n  --fa: \"\\e1fe\";\r\n  --fa--fa: \"\\e1fe\\e1fe\"; }\r\n\r\n.fa-disease {\r\n  --fa: \"\\f7fa\";\r\n  --fa--fa: \"\\f7fa\\f7fa\"; }\r\n\r\n.fa-briefcase-medical {\r\n  --fa: \"\\f469\";\r\n  --fa--fa: \"\\f469\\f469\"; }\r\n\r\n.fa-genderless {\r\n  --fa: \"\\f22d\";\r\n  --fa--fa: \"\\f22d\\f22d\"; }\r\n\r\n.fa-chevron-right {\r\n  --fa: \"\\f054\";\r\n  --fa--fa: \"\\f054\\f054\"; }\r\n\r\n.fa-retweet {\r\n  --fa: \"\\f079\";\r\n  --fa--fa: \"\\f079\\f079\"; }\r\n\r\n.fa-car-rear {\r\n  --fa: \"\\f5de\";\r\n  --fa--fa: \"\\f5de\\f5de\"; }\r\n\r\n.fa-car-alt {\r\n  --fa: \"\\f5de\";\r\n  --fa--fa: \"\\f5de\\f5de\"; }\r\n\r\n.fa-pump-soap {\r\n  --fa: \"\\e06b\";\r\n  --fa--fa: \"\\e06b\\e06b\"; }\r\n\r\n.fa-video-slash {\r\n  --fa: \"\\f4e2\";\r\n  --fa--fa: \"\\f4e2\\f4e2\"; }\r\n\r\n.fa-battery-quarter {\r\n  --fa: \"\\f243\";\r\n  --fa--fa: \"\\f243\\f243\"; }\r\n\r\n.fa-battery-2 {\r\n  --fa: \"\\f243\";\r\n  --fa--fa: \"\\f243\\f243\"; }\r\n\r\n.fa-radio {\r\n  --fa: \"\\f8d7\";\r\n  --fa--fa: \"\\f8d7\\f8d7\"; }\r\n\r\n.fa-baby-carriage {\r\n  --fa: \"\\f77d\";\r\n  --fa--fa: \"\\f77d\\f77d\"; }\r\n\r\n.fa-carriage-baby {\r\n  --fa: \"\\f77d\";\r\n  --fa--fa: \"\\f77d\\f77d\"; }\r\n\r\n.fa-traffic-light {\r\n  --fa: \"\\f637\";\r\n  --fa--fa: \"\\f637\\f637\"; }\r\n\r\n.fa-thermometer {\r\n  --fa: \"\\f491\";\r\n  --fa--fa: \"\\f491\\f491\"; }\r\n\r\n.fa-vr-cardboard {\r\n  --fa: \"\\f729\";\r\n  --fa--fa: \"\\f729\\f729\"; }\r\n\r\n.fa-hand-middle-finger {\r\n  --fa: \"\\f806\";\r\n  --fa--fa: \"\\f806\\f806\"; }\r\n\r\n.fa-percent {\r\n  --fa: \"\\25\";\r\n  --fa--fa: \"\\25\\25\"; }\r\n\r\n.fa-percentage {\r\n  --fa: \"\\25\";\r\n  --fa--fa: \"\\25\\25\"; }\r\n\r\n.fa-truck-moving {\r\n  --fa: \"\\f4df\";\r\n  --fa--fa: \"\\f4df\\f4df\"; }\r\n\r\n.fa-glass-water-droplet {\r\n  --fa: \"\\e4f5\";\r\n  --fa--fa: \"\\e4f5\\e4f5\"; }\r\n\r\n.fa-display {\r\n  --fa: \"\\e163\";\r\n  --fa--fa: \"\\e163\\e163\"; }\r\n\r\n.fa-face-smile {\r\n  --fa: \"\\f118\";\r\n  --fa--fa: \"\\f118\\f118\"; }\r\n\r\n.fa-smile {\r\n  --fa: \"\\f118\";\r\n  --fa--fa: \"\\f118\\f118\"; }\r\n\r\n.fa-thumbtack {\r\n  --fa: \"\\f08d\";\r\n  --fa--fa: \"\\f08d\\f08d\"; }\r\n\r\n.fa-thumb-tack {\r\n  --fa: \"\\f08d\";\r\n  --fa--fa: \"\\f08d\\f08d\"; }\r\n\r\n.fa-trophy {\r\n  --fa: \"\\f091\";\r\n  --fa--fa: \"\\f091\\f091\"; }\r\n\r\n.fa-person-praying {\r\n  --fa: \"\\f683\";\r\n  --fa--fa: \"\\f683\\f683\"; }\r\n\r\n.fa-pray {\r\n  --fa: \"\\f683\";\r\n  --fa--fa: \"\\f683\\f683\"; }\r\n\r\n.fa-hammer {\r\n  --fa: \"\\f6e3\";\r\n  --fa--fa: \"\\f6e3\\f6e3\"; }\r\n\r\n.fa-hand-peace {\r\n  --fa: \"\\f25b\";\r\n  --fa--fa: \"\\f25b\\f25b\"; }\r\n\r\n.fa-rotate {\r\n  --fa: \"\\f2f1\";\r\n  --fa--fa: \"\\f2f1\\f2f1\"; }\r\n\r\n.fa-sync-alt {\r\n  --fa: \"\\f2f1\";\r\n  --fa--fa: \"\\f2f1\\f2f1\"; }\r\n\r\n.fa-spinner {\r\n  --fa: \"\\f110\";\r\n  --fa--fa: \"\\f110\\f110\"; }\r\n\r\n.fa-robot {\r\n  --fa: \"\\f544\";\r\n  --fa--fa: \"\\f544\\f544\"; }\r\n\r\n.fa-peace {\r\n  --fa: \"\\f67c\";\r\n  --fa--fa: \"\\f67c\\f67c\"; }\r\n\r\n.fa-gears {\r\n  --fa: \"\\f085\";\r\n  --fa--fa: \"\\f085\\f085\"; }\r\n\r\n.fa-cogs {\r\n  --fa: \"\\f085\";\r\n  --fa--fa: \"\\f085\\f085\"; }\r\n\r\n.fa-warehouse {\r\n  --fa: \"\\f494\";\r\n  --fa--fa: \"\\f494\\f494\"; }\r\n\r\n.fa-arrow-up-right-dots {\r\n  --fa: \"\\e4b7\";\r\n  --fa--fa: \"\\e4b7\\e4b7\"; }\r\n\r\n.fa-splotch {\r\n  --fa: \"\\f5bc\";\r\n  --fa--fa: \"\\f5bc\\f5bc\"; }\r\n\r\n.fa-face-grin-hearts {\r\n  --fa: \"\\f584\";\r\n  --fa--fa: \"\\f584\\f584\"; }\r\n\r\n.fa-grin-hearts {\r\n  --fa: \"\\f584\";\r\n  --fa--fa: \"\\f584\\f584\"; }\r\n\r\n.fa-dice-four {\r\n  --fa: \"\\f524\";\r\n  --fa--fa: \"\\f524\\f524\"; }\r\n\r\n.fa-sim-card {\r\n  --fa: \"\\f7c4\";\r\n  --fa--fa: \"\\f7c4\\f7c4\"; }\r\n\r\n.fa-transgender {\r\n  --fa: \"\\f225\";\r\n  --fa--fa: \"\\f225\\f225\"; }\r\n\r\n.fa-transgender-alt {\r\n  --fa: \"\\f225\";\r\n  --fa--fa: \"\\f225\\f225\"; }\r\n\r\n.fa-mercury {\r\n  --fa: \"\\f223\";\r\n  --fa--fa: \"\\f223\\f223\"; }\r\n\r\n.fa-arrow-turn-down {\r\n  --fa: \"\\f149\";\r\n  --fa--fa: \"\\f149\\f149\"; }\r\n\r\n.fa-level-down {\r\n  --fa: \"\\f149\";\r\n  --fa--fa: \"\\f149\\f149\"; }\r\n\r\n.fa-person-falling-burst {\r\n  --fa: \"\\e547\";\r\n  --fa--fa: \"\\e547\\e547\"; }\r\n\r\n.fa-award {\r\n  --fa: \"\\f559\";\r\n  --fa--fa: \"\\f559\\f559\"; }\r\n\r\n.fa-ticket-simple {\r\n  --fa: \"\\f3ff\";\r\n  --fa--fa: \"\\f3ff\\f3ff\"; }\r\n\r\n.fa-ticket-alt {\r\n  --fa: \"\\f3ff\";\r\n  --fa--fa: \"\\f3ff\\f3ff\"; }\r\n\r\n.fa-building {\r\n  --fa: \"\\f1ad\";\r\n  --fa--fa: \"\\f1ad\\f1ad\"; }\r\n\r\n.fa-angles-left {\r\n  --fa: \"\\f100\";\r\n  --fa--fa: \"\\f100\\f100\"; }\r\n\r\n.fa-angle-double-left {\r\n  --fa: \"\\f100\";\r\n  --fa--fa: \"\\f100\\f100\"; }\r\n\r\n.fa-qrcode {\r\n  --fa: \"\\f029\";\r\n  --fa--fa: \"\\f029\\f029\"; }\r\n\r\n.fa-clock-rotate-left {\r\n  --fa: \"\\f1da\";\r\n  --fa--fa: \"\\f1da\\f1da\"; }\r\n\r\n.fa-history {\r\n  --fa: \"\\f1da\";\r\n  --fa--fa: \"\\f1da\\f1da\"; }\r\n\r\n.fa-face-grin-beam-sweat {\r\n  --fa: \"\\f583\";\r\n  --fa--fa: \"\\f583\\f583\"; }\r\n\r\n.fa-grin-beam-sweat {\r\n  --fa: \"\\f583\";\r\n  --fa--fa: \"\\f583\\f583\"; }\r\n\r\n.fa-file-export {\r\n  --fa: \"\\f56e\";\r\n  --fa--fa: \"\\f56e\\f56e\"; }\r\n\r\n.fa-arrow-right-from-file {\r\n  --fa: \"\\f56e\";\r\n  --fa--fa: \"\\f56e\\f56e\"; }\r\n\r\n.fa-shield {\r\n  --fa: \"\\f132\";\r\n  --fa--fa: \"\\f132\\f132\"; }\r\n\r\n.fa-shield-blank {\r\n  --fa: \"\\f132\";\r\n  --fa--fa: \"\\f132\\f132\"; }\r\n\r\n.fa-arrow-up-short-wide {\r\n  --fa: \"\\f885\";\r\n  --fa--fa: \"\\f885\\f885\"; }\r\n\r\n.fa-sort-amount-up-alt {\r\n  --fa: \"\\f885\";\r\n  --fa--fa: \"\\f885\\f885\"; }\r\n\r\n.fa-comment-nodes {\r\n  --fa: \"\\e696\";\r\n  --fa--fa: \"\\e696\\e696\"; }\r\n\r\n.fa-house-medical {\r\n  --fa: \"\\e3b2\";\r\n  --fa--fa: \"\\e3b2\\e3b2\"; }\r\n\r\n.fa-golf-ball-tee {\r\n  --fa: \"\\f450\";\r\n  --fa--fa: \"\\f450\\f450\"; }\r\n\r\n.fa-golf-ball {\r\n  --fa: \"\\f450\";\r\n  --fa--fa: \"\\f450\\f450\"; }\r\n\r\n.fa-circle-chevron-left {\r\n  --fa: \"\\f137\";\r\n  --fa--fa: \"\\f137\\f137\"; }\r\n\r\n.fa-chevron-circle-left {\r\n  --fa: \"\\f137\";\r\n  --fa--fa: \"\\f137\\f137\"; }\r\n\r\n.fa-house-chimney-window {\r\n  --fa: \"\\e00d\";\r\n  --fa--fa: \"\\e00d\\e00d\"; }\r\n\r\n.fa-pen-nib {\r\n  --fa: \"\\f5ad\";\r\n  --fa--fa: \"\\f5ad\\f5ad\"; }\r\n\r\n.fa-tent-arrow-turn-left {\r\n  --fa: \"\\e580\";\r\n  --fa--fa: \"\\e580\\e580\"; }\r\n\r\n.fa-tents {\r\n  --fa: \"\\e582\";\r\n  --fa--fa: \"\\e582\\e582\"; }\r\n\r\n.fa-wand-magic {\r\n  --fa: \"\\f0d0\";\r\n  --fa--fa: \"\\f0d0\\f0d0\"; }\r\n\r\n.fa-magic {\r\n  --fa: \"\\f0d0\";\r\n  --fa--fa: \"\\f0d0\\f0d0\"; }\r\n\r\n.fa-dog {\r\n  --fa: \"\\f6d3\";\r\n  --fa--fa: \"\\f6d3\\f6d3\"; }\r\n\r\n.fa-carrot {\r\n  --fa: \"\\f787\";\r\n  --fa--fa: \"\\f787\\f787\"; }\r\n\r\n.fa-moon {\r\n  --fa: \"\\f186\";\r\n  --fa--fa: \"\\f186\\f186\"; }\r\n\r\n.fa-wine-glass-empty {\r\n  --fa: \"\\f5ce\";\r\n  --fa--fa: \"\\f5ce\\f5ce\"; }\r\n\r\n.fa-wine-glass-alt {\r\n  --fa: \"\\f5ce\";\r\n  --fa--fa: \"\\f5ce\\f5ce\"; }\r\n\r\n.fa-cheese {\r\n  --fa: \"\\f7ef\";\r\n  --fa--fa: \"\\f7ef\\f7ef\"; }\r\n\r\n.fa-yin-yang {\r\n  --fa: \"\\f6ad\";\r\n  --fa--fa: \"\\f6ad\\f6ad\"; }\r\n\r\n.fa-music {\r\n  --fa: \"\\f001\";\r\n  --fa--fa: \"\\f001\\f001\"; }\r\n\r\n.fa-code-commit {\r\n  --fa: \"\\f386\";\r\n  --fa--fa: \"\\f386\\f386\"; }\r\n\r\n.fa-temperature-low {\r\n  --fa: \"\\f76b\";\r\n  --fa--fa: \"\\f76b\\f76b\"; }\r\n\r\n.fa-person-biking {\r\n  --fa: \"\\f84a\";\r\n  --fa--fa: \"\\f84a\\f84a\"; }\r\n\r\n.fa-biking {\r\n  --fa: \"\\f84a\";\r\n  --fa--fa: \"\\f84a\\f84a\"; }\r\n\r\n.fa-broom {\r\n  --fa: \"\\f51a\";\r\n  --fa--fa: \"\\f51a\\f51a\"; }\r\n\r\n.fa-shield-heart {\r\n  --fa: \"\\e574\";\r\n  --fa--fa: \"\\e574\\e574\"; }\r\n\r\n.fa-gopuram {\r\n  --fa: \"\\f664\";\r\n  --fa--fa: \"\\f664\\f664\"; }\r\n\r\n.fa-earth-oceania {\r\n  --fa: \"\\e47b\";\r\n  --fa--fa: \"\\e47b\\e47b\"; }\r\n\r\n.fa-globe-oceania {\r\n  --fa: \"\\e47b\";\r\n  --fa--fa: \"\\e47b\\e47b\"; }\r\n\r\n.fa-square-xmark {\r\n  --fa: \"\\f2d3\";\r\n  --fa--fa: \"\\f2d3\\f2d3\"; }\r\n\r\n.fa-times-square {\r\n  --fa: \"\\f2d3\";\r\n  --fa--fa: \"\\f2d3\\f2d3\"; }\r\n\r\n.fa-xmark-square {\r\n  --fa: \"\\f2d3\";\r\n  --fa--fa: \"\\f2d3\\f2d3\"; }\r\n\r\n.fa-hashtag {\r\n  --fa: \"\\23\";\r\n  --fa--fa: \"\\23\\23\"; }\r\n\r\n.fa-up-right-and-down-left-from-center {\r\n  --fa: \"\\f424\";\r\n  --fa--fa: \"\\f424\\f424\"; }\r\n\r\n.fa-expand-alt {\r\n  --fa: \"\\f424\";\r\n  --fa--fa: \"\\f424\\f424\"; }\r\n\r\n.fa-oil-can {\r\n  --fa: \"\\f613\";\r\n  --fa--fa: \"\\f613\\f613\"; }\r\n\r\n.fa-t {\r\n  --fa: \"\\54\";\r\n  --fa--fa: \"\\54\\54\"; }\r\n\r\n.fa-hippo {\r\n  --fa: \"\\f6ed\";\r\n  --fa--fa: \"\\f6ed\\f6ed\"; }\r\n\r\n.fa-chart-column {\r\n  --fa: \"\\e0e3\";\r\n  --fa--fa: \"\\e0e3\\e0e3\"; }\r\n\r\n.fa-infinity {\r\n  --fa: \"\\f534\";\r\n  --fa--fa: \"\\f534\\f534\"; }\r\n\r\n.fa-vial-circle-check {\r\n  --fa: \"\\e596\";\r\n  --fa--fa: \"\\e596\\e596\"; }\r\n\r\n.fa-person-arrow-down-to-line {\r\n  --fa: \"\\e538\";\r\n  --fa--fa: \"\\e538\\e538\"; }\r\n\r\n.fa-voicemail {\r\n  --fa: \"\\f897\";\r\n  --fa--fa: \"\\f897\\f897\"; }\r\n\r\n.fa-fan {\r\n  --fa: \"\\f863\";\r\n  --fa--fa: \"\\f863\\f863\"; }\r\n\r\n.fa-person-walking-luggage {\r\n  --fa: \"\\e554\";\r\n  --fa--fa: \"\\e554\\e554\"; }\r\n\r\n.fa-up-down {\r\n  --fa: \"\\f338\";\r\n  --fa--fa: \"\\f338\\f338\"; }\r\n\r\n.fa-arrows-alt-v {\r\n  --fa: \"\\f338\";\r\n  --fa--fa: \"\\f338\\f338\"; }\r\n\r\n.fa-cloud-moon-rain {\r\n  --fa: \"\\f73c\";\r\n  --fa--fa: \"\\f73c\\f73c\"; }\r\n\r\n.fa-calendar {\r\n  --fa: \"\\f133\";\r\n  --fa--fa: \"\\f133\\f133\"; }\r\n\r\n.fa-trailer {\r\n  --fa: \"\\e041\";\r\n  --fa--fa: \"\\e041\\e041\"; }\r\n\r\n.fa-bahai {\r\n  --fa: \"\\f666\";\r\n  --fa--fa: \"\\f666\\f666\"; }\r\n\r\n.fa-haykal {\r\n  --fa: \"\\f666\";\r\n  --fa--fa: \"\\f666\\f666\"; }\r\n\r\n.fa-sd-card {\r\n  --fa: \"\\f7c2\";\r\n  --fa--fa: \"\\f7c2\\f7c2\"; }\r\n\r\n.fa-dragon {\r\n  --fa: \"\\f6d5\";\r\n  --fa--fa: \"\\f6d5\\f6d5\"; }\r\n\r\n.fa-shoe-prints {\r\n  --fa: \"\\f54b\";\r\n  --fa--fa: \"\\f54b\\f54b\"; }\r\n\r\n.fa-circle-plus {\r\n  --fa: \"\\f055\";\r\n  --fa--fa: \"\\f055\\f055\"; }\r\n\r\n.fa-plus-circle {\r\n  --fa: \"\\f055\";\r\n  --fa--fa: \"\\f055\\f055\"; }\r\n\r\n.fa-face-grin-tongue-wink {\r\n  --fa: \"\\f58b\";\r\n  --fa--fa: \"\\f58b\\f58b\"; }\r\n\r\n.fa-grin-tongue-wink {\r\n  --fa: \"\\f58b\";\r\n  --fa--fa: \"\\f58b\\f58b\"; }\r\n\r\n.fa-hand-holding {\r\n  --fa: \"\\f4bd\";\r\n  --fa--fa: \"\\f4bd\\f4bd\"; }\r\n\r\n.fa-plug-circle-exclamation {\r\n  --fa: \"\\e55d\";\r\n  --fa--fa: \"\\e55d\\e55d\"; }\r\n\r\n.fa-link-slash {\r\n  --fa: \"\\f127\";\r\n  --fa--fa: \"\\f127\\f127\"; }\r\n\r\n.fa-chain-broken {\r\n  --fa: \"\\f127\";\r\n  --fa--fa: \"\\f127\\f127\"; }\r\n\r\n.fa-chain-slash {\r\n  --fa: \"\\f127\";\r\n  --fa--fa: \"\\f127\\f127\"; }\r\n\r\n.fa-unlink {\r\n  --fa: \"\\f127\";\r\n  --fa--fa: \"\\f127\\f127\"; }\r\n\r\n.fa-clone {\r\n  --fa: \"\\f24d\";\r\n  --fa--fa: \"\\f24d\\f24d\"; }\r\n\r\n.fa-person-walking-arrow-loop-left {\r\n  --fa: \"\\e551\";\r\n  --fa--fa: \"\\e551\\e551\"; }\r\n\r\n.fa-arrow-up-z-a {\r\n  --fa: \"\\f882\";\r\n  --fa--fa: \"\\f882\\f882\"; }\r\n\r\n.fa-sort-alpha-up-alt {\r\n  --fa: \"\\f882\";\r\n  --fa--fa: \"\\f882\\f882\"; }\r\n\r\n.fa-fire-flame-curved {\r\n  --fa: \"\\f7e4\";\r\n  --fa--fa: \"\\f7e4\\f7e4\"; }\r\n\r\n.fa-fire-alt {\r\n  --fa: \"\\f7e4\";\r\n  --fa--fa: \"\\f7e4\\f7e4\"; }\r\n\r\n.fa-tornado {\r\n  --fa: \"\\f76f\";\r\n  --fa--fa: \"\\f76f\\f76f\"; }\r\n\r\n.fa-file-circle-plus {\r\n  --fa: \"\\e494\";\r\n  --fa--fa: \"\\e494\\e494\"; }\r\n\r\n.fa-book-quran {\r\n  --fa: \"\\f687\";\r\n  --fa--fa: \"\\f687\\f687\"; }\r\n\r\n.fa-quran {\r\n  --fa: \"\\f687\";\r\n  --fa--fa: \"\\f687\\f687\"; }\r\n\r\n.fa-anchor {\r\n  --fa: \"\\f13d\";\r\n  --fa--fa: \"\\f13d\\f13d\"; }\r\n\r\n.fa-border-all {\r\n  --fa: \"\\f84c\";\r\n  --fa--fa: \"\\f84c\\f84c\"; }\r\n\r\n.fa-face-angry {\r\n  --fa: \"\\f556\";\r\n  --fa--fa: \"\\f556\\f556\"; }\r\n\r\n.fa-angry {\r\n  --fa: \"\\f556\";\r\n  --fa--fa: \"\\f556\\f556\"; }\r\n\r\n.fa-cookie-bite {\r\n  --fa: \"\\f564\";\r\n  --fa--fa: \"\\f564\\f564\"; }\r\n\r\n.fa-arrow-trend-down {\r\n  --fa: \"\\e097\";\r\n  --fa--fa: \"\\e097\\e097\"; }\r\n\r\n.fa-rss {\r\n  --fa: \"\\f09e\";\r\n  --fa--fa: \"\\f09e\\f09e\"; }\r\n\r\n.fa-feed {\r\n  --fa: \"\\f09e\";\r\n  --fa--fa: \"\\f09e\\f09e\"; }\r\n\r\n.fa-draw-polygon {\r\n  --fa: \"\\f5ee\";\r\n  --fa--fa: \"\\f5ee\\f5ee\"; }\r\n\r\n.fa-scale-balanced {\r\n  --fa: \"\\f24e\";\r\n  --fa--fa: \"\\f24e\\f24e\"; }\r\n\r\n.fa-balance-scale {\r\n  --fa: \"\\f24e\";\r\n  --fa--fa: \"\\f24e\\f24e\"; }\r\n\r\n.fa-gauge-simple-high {\r\n  --fa: \"\\f62a\";\r\n  --fa--fa: \"\\f62a\\f62a\"; }\r\n\r\n.fa-tachometer {\r\n  --fa: \"\\f62a\";\r\n  --fa--fa: \"\\f62a\\f62a\"; }\r\n\r\n.fa-tachometer-fast {\r\n  --fa: \"\\f62a\";\r\n  --fa--fa: \"\\f62a\\f62a\"; }\r\n\r\n.fa-shower {\r\n  --fa: \"\\f2cc\";\r\n  --fa--fa: \"\\f2cc\\f2cc\"; }\r\n\r\n.fa-desktop {\r\n  --fa: \"\\f390\";\r\n  --fa--fa: \"\\f390\\f390\"; }\r\n\r\n.fa-desktop-alt {\r\n  --fa: \"\\f390\";\r\n  --fa--fa: \"\\f390\\f390\"; }\r\n\r\n.fa-m {\r\n  --fa: \"\\4d\";\r\n  --fa--fa: \"\\4d\\4d\"; }\r\n\r\n.fa-table-list {\r\n  --fa: \"\\f00b\";\r\n  --fa--fa: \"\\f00b\\f00b\"; }\r\n\r\n.fa-th-list {\r\n  --fa: \"\\f00b\";\r\n  --fa--fa: \"\\f00b\\f00b\"; }\r\n\r\n.fa-comment-sms {\r\n  --fa: \"\\f7cd\";\r\n  --fa--fa: \"\\f7cd\\f7cd\"; }\r\n\r\n.fa-sms {\r\n  --fa: \"\\f7cd\";\r\n  --fa--fa: \"\\f7cd\\f7cd\"; }\r\n\r\n.fa-book {\r\n  --fa: \"\\f02d\";\r\n  --fa--fa: \"\\f02d\\f02d\"; }\r\n\r\n.fa-user-plus {\r\n  --fa: \"\\f234\";\r\n  --fa--fa: \"\\f234\\f234\"; }\r\n\r\n.fa-check {\r\n  --fa: \"\\f00c\";\r\n  --fa--fa: \"\\f00c\\f00c\"; }\r\n\r\n.fa-battery-three-quarters {\r\n  --fa: \"\\f241\";\r\n  --fa--fa: \"\\f241\\f241\"; }\r\n\r\n.fa-battery-4 {\r\n  --fa: \"\\f241\";\r\n  --fa--fa: \"\\f241\\f241\"; }\r\n\r\n.fa-house-circle-check {\r\n  --fa: \"\\e509\";\r\n  --fa--fa: \"\\e509\\e509\"; }\r\n\r\n.fa-angle-left {\r\n  --fa: \"\\f104\";\r\n  --fa--fa: \"\\f104\\f104\"; }\r\n\r\n.fa-diagram-successor {\r\n  --fa: \"\\e47a\";\r\n  --fa--fa: \"\\e47a\\e47a\"; }\r\n\r\n.fa-truck-arrow-right {\r\n  --fa: \"\\e58b\";\r\n  --fa--fa: \"\\e58b\\e58b\"; }\r\n\r\n.fa-arrows-split-up-and-left {\r\n  --fa: \"\\e4bc\";\r\n  --fa--fa: \"\\e4bc\\e4bc\"; }\r\n\r\n.fa-hand-fist {\r\n  --fa: \"\\f6de\";\r\n  --fa--fa: \"\\f6de\\f6de\"; }\r\n\r\n.fa-fist-raised {\r\n  --fa: \"\\f6de\";\r\n  --fa--fa: \"\\f6de\\f6de\"; }\r\n\r\n.fa-cloud-moon {\r\n  --fa: \"\\f6c3\";\r\n  --fa--fa: \"\\f6c3\\f6c3\"; }\r\n\r\n.fa-briefcase {\r\n  --fa: \"\\f0b1\";\r\n  --fa--fa: \"\\f0b1\\f0b1\"; }\r\n\r\n.fa-person-falling {\r\n  --fa: \"\\e546\";\r\n  --fa--fa: \"\\e546\\e546\"; }\r\n\r\n.fa-image-portrait {\r\n  --fa: \"\\f3e0\";\r\n  --fa--fa: \"\\f3e0\\f3e0\"; }\r\n\r\n.fa-portrait {\r\n  --fa: \"\\f3e0\";\r\n  --fa--fa: \"\\f3e0\\f3e0\"; }\r\n\r\n.fa-user-tag {\r\n  --fa: \"\\f507\";\r\n  --fa--fa: \"\\f507\\f507\"; }\r\n\r\n.fa-rug {\r\n  --fa: \"\\e569\";\r\n  --fa--fa: \"\\e569\\e569\"; }\r\n\r\n.fa-earth-europe {\r\n  --fa: \"\\f7a2\";\r\n  --fa--fa: \"\\f7a2\\f7a2\"; }\r\n\r\n.fa-globe-europe {\r\n  --fa: \"\\f7a2\";\r\n  --fa--fa: \"\\f7a2\\f7a2\"; }\r\n\r\n.fa-cart-flatbed-suitcase {\r\n  --fa: \"\\f59d\";\r\n  --fa--fa: \"\\f59d\\f59d\"; }\r\n\r\n.fa-luggage-cart {\r\n  --fa: \"\\f59d\";\r\n  --fa--fa: \"\\f59d\\f59d\"; }\r\n\r\n.fa-rectangle-xmark {\r\n  --fa: \"\\f410\";\r\n  --fa--fa: \"\\f410\\f410\"; }\r\n\r\n.fa-rectangle-times {\r\n  --fa: \"\\f410\";\r\n  --fa--fa: \"\\f410\\f410\"; }\r\n\r\n.fa-times-rectangle {\r\n  --fa: \"\\f410\";\r\n  --fa--fa: \"\\f410\\f410\"; }\r\n\r\n.fa-window-close {\r\n  --fa: \"\\f410\";\r\n  --fa--fa: \"\\f410\\f410\"; }\r\n\r\n.fa-baht-sign {\r\n  --fa: \"\\e0ac\";\r\n  --fa--fa: \"\\e0ac\\e0ac\"; }\r\n\r\n.fa-book-open {\r\n  --fa: \"\\f518\";\r\n  --fa--fa: \"\\f518\\f518\"; }\r\n\r\n.fa-book-journal-whills {\r\n  --fa: \"\\f66a\";\r\n  --fa--fa: \"\\f66a\\f66a\"; }\r\n\r\n.fa-journal-whills {\r\n  --fa: \"\\f66a\";\r\n  --fa--fa: \"\\f66a\\f66a\"; }\r\n\r\n.fa-handcuffs {\r\n  --fa: \"\\e4f8\";\r\n  --fa--fa: \"\\e4f8\\e4f8\"; }\r\n\r\n.fa-triangle-exclamation {\r\n  --fa: \"\\f071\";\r\n  --fa--fa: \"\\f071\\f071\"; }\r\n\r\n.fa-exclamation-triangle {\r\n  --fa: \"\\f071\";\r\n  --fa--fa: \"\\f071\\f071\"; }\r\n\r\n.fa-warning {\r\n  --fa: \"\\f071\";\r\n  --fa--fa: \"\\f071\\f071\"; }\r\n\r\n.fa-database {\r\n  --fa: \"\\f1c0\";\r\n  --fa--fa: \"\\f1c0\\f1c0\"; }\r\n\r\n.fa-share {\r\n  --fa: \"\\f064\";\r\n  --fa--fa: \"\\f064\\f064\"; }\r\n\r\n.fa-mail-forward {\r\n  --fa: \"\\f064\";\r\n  --fa--fa: \"\\f064\\f064\"; }\r\n\r\n.fa-bottle-droplet {\r\n  --fa: \"\\e4c4\";\r\n  --fa--fa: \"\\e4c4\\e4c4\"; }\r\n\r\n.fa-mask-face {\r\n  --fa: \"\\e1d7\";\r\n  --fa--fa: \"\\e1d7\\e1d7\"; }\r\n\r\n.fa-hill-rockslide {\r\n  --fa: \"\\e508\";\r\n  --fa--fa: \"\\e508\\e508\"; }\r\n\r\n.fa-right-left {\r\n  --fa: \"\\f362\";\r\n  --fa--fa: \"\\f362\\f362\"; }\r\n\r\n.fa-exchange-alt {\r\n  --fa: \"\\f362\";\r\n  --fa--fa: \"\\f362\\f362\"; }\r\n\r\n.fa-paper-plane {\r\n  --fa: \"\\f1d8\";\r\n  --fa--fa: \"\\f1d8\\f1d8\"; }\r\n\r\n.fa-road-circle-exclamation {\r\n  --fa: \"\\e565\";\r\n  --fa--fa: \"\\e565\\e565\"; }\r\n\r\n.fa-dungeon {\r\n  --fa: \"\\f6d9\";\r\n  --fa--fa: \"\\f6d9\\f6d9\"; }\r\n\r\n.fa-align-right {\r\n  --fa: \"\\f038\";\r\n  --fa--fa: \"\\f038\\f038\"; }\r\n\r\n.fa-money-bill-1-wave {\r\n  --fa: \"\\f53b\";\r\n  --fa--fa: \"\\f53b\\f53b\"; }\r\n\r\n.fa-money-bill-wave-alt {\r\n  --fa: \"\\f53b\";\r\n  --fa--fa: \"\\f53b\\f53b\"; }\r\n\r\n.fa-life-ring {\r\n  --fa: \"\\f1cd\";\r\n  --fa--fa: \"\\f1cd\\f1cd\"; }\r\n\r\n.fa-hands {\r\n  --fa: \"\\f2a7\";\r\n  --fa--fa: \"\\f2a7\\f2a7\"; }\r\n\r\n.fa-sign-language {\r\n  --fa: \"\\f2a7\";\r\n  --fa--fa: \"\\f2a7\\f2a7\"; }\r\n\r\n.fa-signing {\r\n  --fa: \"\\f2a7\";\r\n  --fa--fa: \"\\f2a7\\f2a7\"; }\r\n\r\n.fa-calendar-day {\r\n  --fa: \"\\f783\";\r\n  --fa--fa: \"\\f783\\f783\"; }\r\n\r\n.fa-water-ladder {\r\n  --fa: \"\\f5c5\";\r\n  --fa--fa: \"\\f5c5\\f5c5\"; }\r\n\r\n.fa-ladder-water {\r\n  --fa: \"\\f5c5\";\r\n  --fa--fa: \"\\f5c5\\f5c5\"; }\r\n\r\n.fa-swimming-pool {\r\n  --fa: \"\\f5c5\";\r\n  --fa--fa: \"\\f5c5\\f5c5\"; }\r\n\r\n.fa-arrows-up-down {\r\n  --fa: \"\\f07d\";\r\n  --fa--fa: \"\\f07d\\f07d\"; }\r\n\r\n.fa-arrows-v {\r\n  --fa: \"\\f07d\";\r\n  --fa--fa: \"\\f07d\\f07d\"; }\r\n\r\n.fa-face-grimace {\r\n  --fa: \"\\f57f\";\r\n  --fa--fa: \"\\f57f\\f57f\"; }\r\n\r\n.fa-grimace {\r\n  --fa: \"\\f57f\";\r\n  --fa--fa: \"\\f57f\\f57f\"; }\r\n\r\n.fa-wheelchair-move {\r\n  --fa: \"\\e2ce\";\r\n  --fa--fa: \"\\e2ce\\e2ce\"; }\r\n\r\n.fa-wheelchair-alt {\r\n  --fa: \"\\e2ce\";\r\n  --fa--fa: \"\\e2ce\\e2ce\"; }\r\n\r\n.fa-turn-down {\r\n  --fa: \"\\f3be\";\r\n  --fa--fa: \"\\f3be\\f3be\"; }\r\n\r\n.fa-level-down-alt {\r\n  --fa: \"\\f3be\";\r\n  --fa--fa: \"\\f3be\\f3be\"; }\r\n\r\n.fa-person-walking-arrow-right {\r\n  --fa: \"\\e552\";\r\n  --fa--fa: \"\\e552\\e552\"; }\r\n\r\n.fa-square-envelope {\r\n  --fa: \"\\f199\";\r\n  --fa--fa: \"\\f199\\f199\"; }\r\n\r\n.fa-envelope-square {\r\n  --fa: \"\\f199\";\r\n  --fa--fa: \"\\f199\\f199\"; }\r\n\r\n.fa-dice {\r\n  --fa: \"\\f522\";\r\n  --fa--fa: \"\\f522\\f522\"; }\r\n\r\n.fa-bowling-ball {\r\n  --fa: \"\\f436\";\r\n  --fa--fa: \"\\f436\\f436\"; }\r\n\r\n.fa-brain {\r\n  --fa: \"\\f5dc\";\r\n  --fa--fa: \"\\f5dc\\f5dc\"; }\r\n\r\n.fa-bandage {\r\n  --fa: \"\\f462\";\r\n  --fa--fa: \"\\f462\\f462\"; }\r\n\r\n.fa-band-aid {\r\n  --fa: \"\\f462\";\r\n  --fa--fa: \"\\f462\\f462\"; }\r\n\r\n.fa-calendar-minus {\r\n  --fa: \"\\f272\";\r\n  --fa--fa: \"\\f272\\f272\"; }\r\n\r\n.fa-circle-xmark {\r\n  --fa: \"\\f057\";\r\n  --fa--fa: \"\\f057\\f057\"; }\r\n\r\n.fa-times-circle {\r\n  --fa: \"\\f057\";\r\n  --fa--fa: \"\\f057\\f057\"; }\r\n\r\n.fa-xmark-circle {\r\n  --fa: \"\\f057\";\r\n  --fa--fa: \"\\f057\\f057\"; }\r\n\r\n.fa-gifts {\r\n  --fa: \"\\f79c\";\r\n  --fa--fa: \"\\f79c\\f79c\"; }\r\n\r\n.fa-hotel {\r\n  --fa: \"\\f594\";\r\n  --fa--fa: \"\\f594\\f594\"; }\r\n\r\n.fa-earth-asia {\r\n  --fa: \"\\f57e\";\r\n  --fa--fa: \"\\f57e\\f57e\"; }\r\n\r\n.fa-globe-asia {\r\n  --fa: \"\\f57e\";\r\n  --fa--fa: \"\\f57e\\f57e\"; }\r\n\r\n.fa-id-card-clip {\r\n  --fa: \"\\f47f\";\r\n  --fa--fa: \"\\f47f\\f47f\"; }\r\n\r\n.fa-id-card-alt {\r\n  --fa: \"\\f47f\";\r\n  --fa--fa: \"\\f47f\\f47f\"; }\r\n\r\n.fa-magnifying-glass-plus {\r\n  --fa: \"\\f00e\";\r\n  --fa--fa: \"\\f00e\\f00e\"; }\r\n\r\n.fa-search-plus {\r\n  --fa: \"\\f00e\";\r\n  --fa--fa: \"\\f00e\\f00e\"; }\r\n\r\n.fa-thumbs-up {\r\n  --fa: \"\\f164\";\r\n  --fa--fa: \"\\f164\\f164\"; }\r\n\r\n.fa-user-clock {\r\n  --fa: \"\\f4fd\";\r\n  --fa--fa: \"\\f4fd\\f4fd\"; }\r\n\r\n.fa-hand-dots {\r\n  --fa: \"\\f461\";\r\n  --fa--fa: \"\\f461\\f461\"; }\r\n\r\n.fa-allergies {\r\n  --fa: \"\\f461\";\r\n  --fa--fa: \"\\f461\\f461\"; }\r\n\r\n.fa-file-invoice {\r\n  --fa: \"\\f570\";\r\n  --fa--fa: \"\\f570\\f570\"; }\r\n\r\n.fa-window-minimize {\r\n  --fa: \"\\f2d1\";\r\n  --fa--fa: \"\\f2d1\\f2d1\"; }\r\n\r\n.fa-mug-saucer {\r\n  --fa: \"\\f0f4\";\r\n  --fa--fa: \"\\f0f4\\f0f4\"; }\r\n\r\n.fa-coffee {\r\n  --fa: \"\\f0f4\";\r\n  --fa--fa: \"\\f0f4\\f0f4\"; }\r\n\r\n.fa-brush {\r\n  --fa: \"\\f55d\";\r\n  --fa--fa: \"\\f55d\\f55d\"; }\r\n\r\n.fa-file-half-dashed {\r\n  --fa: \"\\e698\";\r\n  --fa--fa: \"\\e698\\e698\"; }\r\n\r\n.fa-mask {\r\n  --fa: \"\\f6fa\";\r\n  --fa--fa: \"\\f6fa\\f6fa\"; }\r\n\r\n.fa-magnifying-glass-minus {\r\n  --fa: \"\\f010\";\r\n  --fa--fa: \"\\f010\\f010\"; }\r\n\r\n.fa-search-minus {\r\n  --fa: \"\\f010\";\r\n  --fa--fa: \"\\f010\\f010\"; }\r\n\r\n.fa-ruler-vertical {\r\n  --fa: \"\\f548\";\r\n  --fa--fa: \"\\f548\\f548\"; }\r\n\r\n.fa-user-large {\r\n  --fa: \"\\f406\";\r\n  --fa--fa: \"\\f406\\f406\"; }\r\n\r\n.fa-user-alt {\r\n  --fa: \"\\f406\";\r\n  --fa--fa: \"\\f406\\f406\"; }\r\n\r\n.fa-train-tram {\r\n  --fa: \"\\e5b4\";\r\n  --fa--fa: \"\\e5b4\\e5b4\"; }\r\n\r\n.fa-user-nurse {\r\n  --fa: \"\\f82f\";\r\n  --fa--fa: \"\\f82f\\f82f\"; }\r\n\r\n.fa-syringe {\r\n  --fa: \"\\f48e\";\r\n  --fa--fa: \"\\f48e\\f48e\"; }\r\n\r\n.fa-cloud-sun {\r\n  --fa: \"\\f6c4\";\r\n  --fa--fa: \"\\f6c4\\f6c4\"; }\r\n\r\n.fa-stopwatch-20 {\r\n  --fa: \"\\e06f\";\r\n  --fa--fa: \"\\e06f\\e06f\"; }\r\n\r\n.fa-square-full {\r\n  --fa: \"\\f45c\";\r\n  --fa--fa: \"\\f45c\\f45c\"; }\r\n\r\n.fa-magnet {\r\n  --fa: \"\\f076\";\r\n  --fa--fa: \"\\f076\\f076\"; }\r\n\r\n.fa-jar {\r\n  --fa: \"\\e516\";\r\n  --fa--fa: \"\\e516\\e516\"; }\r\n\r\n.fa-note-sticky {\r\n  --fa: \"\\f249\";\r\n  --fa--fa: \"\\f249\\f249\"; }\r\n\r\n.fa-sticky-note {\r\n  --fa: \"\\f249\";\r\n  --fa--fa: \"\\f249\\f249\"; }\r\n\r\n.fa-bug-slash {\r\n  --fa: \"\\e490\";\r\n  --fa--fa: \"\\e490\\e490\"; }\r\n\r\n.fa-arrow-up-from-water-pump {\r\n  --fa: \"\\e4b6\";\r\n  --fa--fa: \"\\e4b6\\e4b6\"; }\r\n\r\n.fa-bone {\r\n  --fa: \"\\f5d7\";\r\n  --fa--fa: \"\\f5d7\\f5d7\"; }\r\n\r\n.fa-table-cells-row-unlock {\r\n  --fa: \"\\e691\";\r\n  --fa--fa: \"\\e691\\e691\"; }\r\n\r\n.fa-user-injured {\r\n  --fa: \"\\f728\";\r\n  --fa--fa: \"\\f728\\f728\"; }\r\n\r\n.fa-face-sad-tear {\r\n  --fa: \"\\f5b4\";\r\n  --fa--fa: \"\\f5b4\\f5b4\"; }\r\n\r\n.fa-sad-tear {\r\n  --fa: \"\\f5b4\";\r\n  --fa--fa: \"\\f5b4\\f5b4\"; }\r\n\r\n.fa-plane {\r\n  --fa: \"\\f072\";\r\n  --fa--fa: \"\\f072\\f072\"; }\r\n\r\n.fa-tent-arrows-down {\r\n  --fa: \"\\e581\";\r\n  --fa--fa: \"\\e581\\e581\"; }\r\n\r\n.fa-exclamation {\r\n  --fa: \"\\21\";\r\n  --fa--fa: \"\\21\\21\"; }\r\n\r\n.fa-arrows-spin {\r\n  --fa: \"\\e4bb\";\r\n  --fa--fa: \"\\e4bb\\e4bb\"; }\r\n\r\n.fa-print {\r\n  --fa: \"\\f02f\";\r\n  --fa--fa: \"\\f02f\\f02f\"; }\r\n\r\n.fa-turkish-lira-sign {\r\n  --fa: \"\\e2bb\";\r\n  --fa--fa: \"\\e2bb\\e2bb\"; }\r\n\r\n.fa-try {\r\n  --fa: \"\\e2bb\";\r\n  --fa--fa: \"\\e2bb\\e2bb\"; }\r\n\r\n.fa-turkish-lira {\r\n  --fa: \"\\e2bb\";\r\n  --fa--fa: \"\\e2bb\\e2bb\"; }\r\n\r\n.fa-dollar-sign {\r\n  --fa: \"\\24\";\r\n  --fa--fa: \"\\24\\24\"; }\r\n\r\n.fa-dollar {\r\n  --fa: \"\\24\";\r\n  --fa--fa: \"\\24\\24\"; }\r\n\r\n.fa-usd {\r\n  --fa: \"\\24\";\r\n  --fa--fa: \"\\24\\24\"; }\r\n\r\n.fa-x {\r\n  --fa: \"\\58\";\r\n  --fa--fa: \"\\58\\58\"; }\r\n\r\n.fa-magnifying-glass-dollar {\r\n  --fa: \"\\f688\";\r\n  --fa--fa: \"\\f688\\f688\"; }\r\n\r\n.fa-search-dollar {\r\n  --fa: \"\\f688\";\r\n  --fa--fa: \"\\f688\\f688\"; }\r\n\r\n.fa-users-gear {\r\n  --fa: \"\\f509\";\r\n  --fa--fa: \"\\f509\\f509\"; }\r\n\r\n.fa-users-cog {\r\n  --fa: \"\\f509\";\r\n  --fa--fa: \"\\f509\\f509\"; }\r\n\r\n.fa-person-military-pointing {\r\n  --fa: \"\\e54a\";\r\n  --fa--fa: \"\\e54a\\e54a\"; }\r\n\r\n.fa-building-columns {\r\n  --fa: \"\\f19c\";\r\n  --fa--fa: \"\\f19c\\f19c\"; }\r\n\r\n.fa-bank {\r\n  --fa: \"\\f19c\";\r\n  --fa--fa: \"\\f19c\\f19c\"; }\r\n\r\n.fa-institution {\r\n  --fa: \"\\f19c\";\r\n  --fa--fa: \"\\f19c\\f19c\"; }\r\n\r\n.fa-museum {\r\n  --fa: \"\\f19c\";\r\n  --fa--fa: \"\\f19c\\f19c\"; }\r\n\r\n.fa-university {\r\n  --fa: \"\\f19c\";\r\n  --fa--fa: \"\\f19c\\f19c\"; }\r\n\r\n.fa-umbrella {\r\n  --fa: \"\\f0e9\";\r\n  --fa--fa: \"\\f0e9\\f0e9\"; }\r\n\r\n.fa-trowel {\r\n  --fa: \"\\e589\";\r\n  --fa--fa: \"\\e589\\e589\"; }\r\n\r\n.fa-d {\r\n  --fa: \"\\44\";\r\n  --fa--fa: \"\\44\\44\"; }\r\n\r\n.fa-stapler {\r\n  --fa: \"\\e5af\";\r\n  --fa--fa: \"\\e5af\\e5af\"; }\r\n\r\n.fa-masks-theater {\r\n  --fa: \"\\f630\";\r\n  --fa--fa: \"\\f630\\f630\"; }\r\n\r\n.fa-theater-masks {\r\n  --fa: \"\\f630\";\r\n  --fa--fa: \"\\f630\\f630\"; }\r\n\r\n.fa-kip-sign {\r\n  --fa: \"\\e1c4\";\r\n  --fa--fa: \"\\e1c4\\e1c4\"; }\r\n\r\n.fa-hand-point-left {\r\n  --fa: \"\\f0a5\";\r\n  --fa--fa: \"\\f0a5\\f0a5\"; }\r\n\r\n.fa-handshake-simple {\r\n  --fa: \"\\f4c6\";\r\n  --fa--fa: \"\\f4c6\\f4c6\"; }\r\n\r\n.fa-handshake-alt {\r\n  --fa: \"\\f4c6\";\r\n  --fa--fa: \"\\f4c6\\f4c6\"; }\r\n\r\n.fa-jet-fighter {\r\n  --fa: \"\\f0fb\";\r\n  --fa--fa: \"\\f0fb\\f0fb\"; }\r\n\r\n.fa-fighter-jet {\r\n  --fa: \"\\f0fb\";\r\n  --fa--fa: \"\\f0fb\\f0fb\"; }\r\n\r\n.fa-square-share-nodes {\r\n  --fa: \"\\f1e1\";\r\n  --fa--fa: \"\\f1e1\\f1e1\"; }\r\n\r\n.fa-share-alt-square {\r\n  --fa: \"\\f1e1\";\r\n  --fa--fa: \"\\f1e1\\f1e1\"; }\r\n\r\n.fa-barcode {\r\n  --fa: \"\\f02a\";\r\n  --fa--fa: \"\\f02a\\f02a\"; }\r\n\r\n.fa-plus-minus {\r\n  --fa: \"\\e43c\";\r\n  --fa--fa: \"\\e43c\\e43c\"; }\r\n\r\n.fa-video {\r\n  --fa: \"\\f03d\";\r\n  --fa--fa: \"\\f03d\\f03d\"; }\r\n\r\n.fa-video-camera {\r\n  --fa: \"\\f03d\";\r\n  --fa--fa: \"\\f03d\\f03d\"; }\r\n\r\n.fa-graduation-cap {\r\n  --fa: \"\\f19d\";\r\n  --fa--fa: \"\\f19d\\f19d\"; }\r\n\r\n.fa-mortar-board {\r\n  --fa: \"\\f19d\";\r\n  --fa--fa: \"\\f19d\\f19d\"; }\r\n\r\n.fa-hand-holding-medical {\r\n  --fa: \"\\e05c\";\r\n  --fa--fa: \"\\e05c\\e05c\"; }\r\n\r\n.fa-person-circle-check {\r\n  --fa: \"\\e53e\";\r\n  --fa--fa: \"\\e53e\\e53e\"; }\r\n\r\n.fa-turn-up {\r\n  --fa: \"\\f3bf\";\r\n  --fa--fa: \"\\f3bf\\f3bf\"; }\r\n\r\n.fa-level-up-alt {\r\n  --fa: \"\\f3bf\";\r\n  --fa--fa: \"\\f3bf\\f3bf\"; }\r\n\r\n.sr-only,\r\n.fa-sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border-width: 0; }\r\n\r\n.sr-only-focusable:not(:focus),\r\n.fa-sr-only-focusable:not(:focus) {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border-width: 0; }\r\n:root, :host {\r\n  --fa-style-family-brands: 'Font Awesome 6 Brands';\r\n  --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands'; }\r\n\r\n@font-face {\r\n  font-family: 'Font Awesome 6 Brands';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\r\n\r\n.fab,\r\n.fa-brands {\r\n  font-weight: 400; }\r\n\r\n.fa-monero {\r\n  --fa: \"\\f3d0\"; }\r\n\r\n.fa-hooli {\r\n  --fa: \"\\f427\"; }\r\n\r\n.fa-yelp {\r\n  --fa: \"\\f1e9\"; }\r\n\r\n.fa-cc-visa {\r\n  --fa: \"\\f1f0\"; }\r\n\r\n.fa-lastfm {\r\n  --fa: \"\\f202\"; }\r\n\r\n.fa-shopware {\r\n  --fa: \"\\f5b5\"; }\r\n\r\n.fa-creative-commons-nc {\r\n  --fa: \"\\f4e8\"; }\r\n\r\n.fa-aws {\r\n  --fa: \"\\f375\"; }\r\n\r\n.fa-redhat {\r\n  --fa: \"\\f7bc\"; }\r\n\r\n.fa-yoast {\r\n  --fa: \"\\f2b1\"; }\r\n\r\n.fa-cloudflare {\r\n  --fa: \"\\e07d\"; }\r\n\r\n.fa-ups {\r\n  --fa: \"\\f7e0\"; }\r\n\r\n.fa-pixiv {\r\n  --fa: \"\\e640\"; }\r\n\r\n.fa-wpexplorer {\r\n  --fa: \"\\f2de\"; }\r\n\r\n.fa-dyalog {\r\n  --fa: \"\\f399\"; }\r\n\r\n.fa-bity {\r\n  --fa: \"\\f37a\"; }\r\n\r\n.fa-stackpath {\r\n  --fa: \"\\f842\"; }\r\n\r\n.fa-buysellads {\r\n  --fa: \"\\f20d\"; }\r\n\r\n.fa-first-order {\r\n  --fa: \"\\f2b0\"; }\r\n\r\n.fa-modx {\r\n  --fa: \"\\f285\"; }\r\n\r\n.fa-guilded {\r\n  --fa: \"\\e07e\"; }\r\n\r\n.fa-vnv {\r\n  --fa: \"\\f40b\"; }\r\n\r\n.fa-square-js {\r\n  --fa: \"\\f3b9\"; }\r\n\r\n.fa-js-square {\r\n  --fa: \"\\f3b9\"; }\r\n\r\n.fa-microsoft {\r\n  --fa: \"\\f3ca\"; }\r\n\r\n.fa-qq {\r\n  --fa: \"\\f1d6\"; }\r\n\r\n.fa-orcid {\r\n  --fa: \"\\f8d2\"; }\r\n\r\n.fa-java {\r\n  --fa: \"\\f4e4\"; }\r\n\r\n.fa-invision {\r\n  --fa: \"\\f7b0\"; }\r\n\r\n.fa-creative-commons-pd-alt {\r\n  --fa: \"\\f4ed\"; }\r\n\r\n.fa-centercode {\r\n  --fa: \"\\f380\"; }\r\n\r\n.fa-glide-g {\r\n  --fa: \"\\f2a6\"; }\r\n\r\n.fa-drupal {\r\n  --fa: \"\\f1a9\"; }\r\n\r\n.fa-jxl {\r\n  --fa: \"\\e67b\"; }\r\n\r\n.fa-dart-lang {\r\n  --fa: \"\\e693\"; }\r\n\r\n.fa-hire-a-helper {\r\n  --fa: \"\\f3b0\"; }\r\n\r\n.fa-creative-commons-by {\r\n  --fa: \"\\f4e7\"; }\r\n\r\n.fa-unity {\r\n  --fa: \"\\e049\"; }\r\n\r\n.fa-whmcs {\r\n  --fa: \"\\f40d\"; }\r\n\r\n.fa-rocketchat {\r\n  --fa: \"\\f3e8\"; }\r\n\r\n.fa-vk {\r\n  --fa: \"\\f189\"; }\r\n\r\n.fa-untappd {\r\n  --fa: \"\\f405\"; }\r\n\r\n.fa-mailchimp {\r\n  --fa: \"\\f59e\"; }\r\n\r\n.fa-css3-alt {\r\n  --fa: \"\\f38b\"; }\r\n\r\n.fa-square-reddit {\r\n  --fa: \"\\f1a2\"; }\r\n\r\n.fa-reddit-square {\r\n  --fa: \"\\f1a2\"; }\r\n\r\n.fa-vimeo-v {\r\n  --fa: \"\\f27d\"; }\r\n\r\n.fa-contao {\r\n  --fa: \"\\f26d\"; }\r\n\r\n.fa-square-font-awesome {\r\n  --fa: \"\\e5ad\"; }\r\n\r\n.fa-deskpro {\r\n  --fa: \"\\f38f\"; }\r\n\r\n.fa-brave {\r\n  --fa: \"\\e63c\"; }\r\n\r\n.fa-sistrix {\r\n  --fa: \"\\f3ee\"; }\r\n\r\n.fa-square-instagram {\r\n  --fa: \"\\e055\"; }\r\n\r\n.fa-instagram-square {\r\n  --fa: \"\\e055\"; }\r\n\r\n.fa-battle-net {\r\n  --fa: \"\\f835\"; }\r\n\r\n.fa-the-red-yeti {\r\n  --fa: \"\\f69d\"; }\r\n\r\n.fa-square-hacker-news {\r\n  --fa: \"\\f3af\"; }\r\n\r\n.fa-hacker-news-square {\r\n  --fa: \"\\f3af\"; }\r\n\r\n.fa-edge {\r\n  --fa: \"\\f282\"; }\r\n\r\n.fa-threads {\r\n  --fa: \"\\e618\"; }\r\n\r\n.fa-napster {\r\n  --fa: \"\\f3d2\"; }\r\n\r\n.fa-square-snapchat {\r\n  --fa: \"\\f2ad\"; }\r\n\r\n.fa-snapchat-square {\r\n  --fa: \"\\f2ad\"; }\r\n\r\n.fa-google-plus-g {\r\n  --fa: \"\\f0d5\"; }\r\n\r\n.fa-artstation {\r\n  --fa: \"\\f77a\"; }\r\n\r\n.fa-markdown {\r\n  --fa: \"\\f60f\"; }\r\n\r\n.fa-sourcetree {\r\n  --fa: \"\\f7d3\"; }\r\n\r\n.fa-google-plus {\r\n  --fa: \"\\f2b3\"; }\r\n\r\n.fa-diaspora {\r\n  --fa: \"\\f791\"; }\r\n\r\n.fa-foursquare {\r\n  --fa: \"\\f180\"; }\r\n\r\n.fa-stack-overflow {\r\n  --fa: \"\\f16c\"; }\r\n\r\n.fa-github-alt {\r\n  --fa: \"\\f113\"; }\r\n\r\n.fa-phoenix-squadron {\r\n  --fa: \"\\f511\"; }\r\n\r\n.fa-pagelines {\r\n  --fa: \"\\f18c\"; }\r\n\r\n.fa-algolia {\r\n  --fa: \"\\f36c\"; }\r\n\r\n.fa-red-river {\r\n  --fa: \"\\f3e3\"; }\r\n\r\n.fa-creative-commons-sa {\r\n  --fa: \"\\f4ef\"; }\r\n\r\n.fa-safari {\r\n  --fa: \"\\f267\"; }\r\n\r\n.fa-google {\r\n  --fa: \"\\f1a0\"; }\r\n\r\n.fa-square-font-awesome-stroke {\r\n  --fa: \"\\f35c\"; }\r\n\r\n.fa-font-awesome-alt {\r\n  --fa: \"\\f35c\"; }\r\n\r\n.fa-atlassian {\r\n  --fa: \"\\f77b\"; }\r\n\r\n.fa-linkedin-in {\r\n  --fa: \"\\f0e1\"; }\r\n\r\n.fa-digital-ocean {\r\n  --fa: \"\\f391\"; }\r\n\r\n.fa-nimblr {\r\n  --fa: \"\\f5a8\"; }\r\n\r\n.fa-chromecast {\r\n  --fa: \"\\f838\"; }\r\n\r\n.fa-evernote {\r\n  --fa: \"\\f839\"; }\r\n\r\n.fa-hacker-news {\r\n  --fa: \"\\f1d4\"; }\r\n\r\n.fa-creative-commons-sampling {\r\n  --fa: \"\\f4f0\"; }\r\n\r\n.fa-adversal {\r\n  --fa: \"\\f36a\"; }\r\n\r\n.fa-creative-commons {\r\n  --fa: \"\\f25e\"; }\r\n\r\n.fa-watchman-monitoring {\r\n  --fa: \"\\e087\"; }\r\n\r\n.fa-fonticons {\r\n  --fa: \"\\f280\"; }\r\n\r\n.fa-weixin {\r\n  --fa: \"\\f1d7\"; }\r\n\r\n.fa-shirtsinbulk {\r\n  --fa: \"\\f214\"; }\r\n\r\n.fa-codepen {\r\n  --fa: \"\\f1cb\"; }\r\n\r\n.fa-git-alt {\r\n  --fa: \"\\f841\"; }\r\n\r\n.fa-lyft {\r\n  --fa: \"\\f3c3\"; }\r\n\r\n.fa-rev {\r\n  --fa: \"\\f5b2\"; }\r\n\r\n.fa-windows {\r\n  --fa: \"\\f17a\"; }\r\n\r\n.fa-wizards-of-the-coast {\r\n  --fa: \"\\f730\"; }\r\n\r\n.fa-square-viadeo {\r\n  --fa: \"\\f2aa\"; }\r\n\r\n.fa-viadeo-square {\r\n  --fa: \"\\f2aa\"; }\r\n\r\n.fa-meetup {\r\n  --fa: \"\\f2e0\"; }\r\n\r\n.fa-centos {\r\n  --fa: \"\\f789\"; }\r\n\r\n.fa-adn {\r\n  --fa: \"\\f170\"; }\r\n\r\n.fa-cloudsmith {\r\n  --fa: \"\\f384\"; }\r\n\r\n.fa-opensuse {\r\n  --fa: \"\\e62b\"; }\r\n\r\n.fa-pied-piper-alt {\r\n  --fa: \"\\f1a8\"; }\r\n\r\n.fa-square-dribbble {\r\n  --fa: \"\\f397\"; }\r\n\r\n.fa-dribbble-square {\r\n  --fa: \"\\f397\"; }\r\n\r\n.fa-codiepie {\r\n  --fa: \"\\f284\"; }\r\n\r\n.fa-node {\r\n  --fa: \"\\f419\"; }\r\n\r\n.fa-mix {\r\n  --fa: \"\\f3cb\"; }\r\n\r\n.fa-steam {\r\n  --fa: \"\\f1b6\"; }\r\n\r\n.fa-cc-apple-pay {\r\n  --fa: \"\\f416\"; }\r\n\r\n.fa-scribd {\r\n  --fa: \"\\f28a\"; }\r\n\r\n.fa-debian {\r\n  --fa: \"\\e60b\"; }\r\n\r\n.fa-openid {\r\n  --fa: \"\\f19b\"; }\r\n\r\n.fa-instalod {\r\n  --fa: \"\\e081\"; }\r\n\r\n.fa-files-pinwheel {\r\n  --fa: \"\\e69f\"; }\r\n\r\n.fa-expeditedssl {\r\n  --fa: \"\\f23e\"; }\r\n\r\n.fa-sellcast {\r\n  --fa: \"\\f2da\"; }\r\n\r\n.fa-square-twitter {\r\n  --fa: \"\\f081\"; }\r\n\r\n.fa-twitter-square {\r\n  --fa: \"\\f081\"; }\r\n\r\n.fa-r-project {\r\n  --fa: \"\\f4f7\"; }\r\n\r\n.fa-delicious {\r\n  --fa: \"\\f1a5\"; }\r\n\r\n.fa-freebsd {\r\n  --fa: \"\\f3a4\"; }\r\n\r\n.fa-vuejs {\r\n  --fa: \"\\f41f\"; }\r\n\r\n.fa-accusoft {\r\n  --fa: \"\\f369\"; }\r\n\r\n.fa-ioxhost {\r\n  --fa: \"\\f208\"; }\r\n\r\n.fa-fonticons-fi {\r\n  --fa: \"\\f3a2\"; }\r\n\r\n.fa-app-store {\r\n  --fa: \"\\f36f\"; }\r\n\r\n.fa-cc-mastercard {\r\n  --fa: \"\\f1f1\"; }\r\n\r\n.fa-itunes-note {\r\n  --fa: \"\\f3b5\"; }\r\n\r\n.fa-golang {\r\n  --fa: \"\\e40f\"; }\r\n\r\n.fa-kickstarter {\r\n  --fa: \"\\f3bb\"; }\r\n\r\n.fa-square-kickstarter {\r\n  --fa: \"\\f3bb\"; }\r\n\r\n.fa-grav {\r\n  --fa: \"\\f2d6\"; }\r\n\r\n.fa-weibo {\r\n  --fa: \"\\f18a\"; }\r\n\r\n.fa-uncharted {\r\n  --fa: \"\\e084\"; }\r\n\r\n.fa-firstdraft {\r\n  --fa: \"\\f3a1\"; }\r\n\r\n.fa-square-youtube {\r\n  --fa: \"\\f431\"; }\r\n\r\n.fa-youtube-square {\r\n  --fa: \"\\f431\"; }\r\n\r\n.fa-wikipedia-w {\r\n  --fa: \"\\f266\"; }\r\n\r\n.fa-wpressr {\r\n  --fa: \"\\f3e4\"; }\r\n\r\n.fa-rendact {\r\n  --fa: \"\\f3e4\"; }\r\n\r\n.fa-angellist {\r\n  --fa: \"\\f209\"; }\r\n\r\n.fa-galactic-republic {\r\n  --fa: \"\\f50c\"; }\r\n\r\n.fa-nfc-directional {\r\n  --fa: \"\\e530\"; }\r\n\r\n.fa-skype {\r\n  --fa: \"\\f17e\"; }\r\n\r\n.fa-joget {\r\n  --fa: \"\\f3b7\"; }\r\n\r\n.fa-fedora {\r\n  --fa: \"\\f798\"; }\r\n\r\n.fa-stripe-s {\r\n  --fa: \"\\f42a\"; }\r\n\r\n.fa-meta {\r\n  --fa: \"\\e49b\"; }\r\n\r\n.fa-laravel {\r\n  --fa: \"\\f3bd\"; }\r\n\r\n.fa-hotjar {\r\n  --fa: \"\\f3b1\"; }\r\n\r\n.fa-bluetooth-b {\r\n  --fa: \"\\f294\"; }\r\n\r\n.fa-square-letterboxd {\r\n  --fa: \"\\e62e\"; }\r\n\r\n.fa-sticker-mule {\r\n  --fa: \"\\f3f7\"; }\r\n\r\n.fa-creative-commons-zero {\r\n  --fa: \"\\f4f3\"; }\r\n\r\n.fa-hips {\r\n  --fa: \"\\f452\"; }\r\n\r\n.fa-css {\r\n  --fa: \"\\e6a2\"; }\r\n\r\n.fa-behance {\r\n  --fa: \"\\f1b4\"; }\r\n\r\n.fa-reddit {\r\n  --fa: \"\\f1a1\"; }\r\n\r\n.fa-discord {\r\n  --fa: \"\\f392\"; }\r\n\r\n.fa-chrome {\r\n  --fa: \"\\f268\"; }\r\n\r\n.fa-app-store-ios {\r\n  --fa: \"\\f370\"; }\r\n\r\n.fa-cc-discover {\r\n  --fa: \"\\f1f2\"; }\r\n\r\n.fa-wpbeginner {\r\n  --fa: \"\\f297\"; }\r\n\r\n.fa-confluence {\r\n  --fa: \"\\f78d\"; }\r\n\r\n.fa-shoelace {\r\n  --fa: \"\\e60c\"; }\r\n\r\n.fa-mdb {\r\n  --fa: \"\\f8ca\"; }\r\n\r\n.fa-dochub {\r\n  --fa: \"\\f394\"; }\r\n\r\n.fa-accessible-icon {\r\n  --fa: \"\\f368\"; }\r\n\r\n.fa-ebay {\r\n  --fa: \"\\f4f4\"; }\r\n\r\n.fa-amazon {\r\n  --fa: \"\\f270\"; }\r\n\r\n.fa-unsplash {\r\n  --fa: \"\\e07c\"; }\r\n\r\n.fa-yarn {\r\n  --fa: \"\\f7e3\"; }\r\n\r\n.fa-square-steam {\r\n  --fa: \"\\f1b7\"; }\r\n\r\n.fa-steam-square {\r\n  --fa: \"\\f1b7\"; }\r\n\r\n.fa-500px {\r\n  --fa: \"\\f26e\"; }\r\n\r\n.fa-square-vimeo {\r\n  --fa: \"\\f194\"; }\r\n\r\n.fa-vimeo-square {\r\n  --fa: \"\\f194\"; }\r\n\r\n.fa-asymmetrik {\r\n  --fa: \"\\f372\"; }\r\n\r\n.fa-font-awesome {\r\n  --fa: \"\\f2b4\"; }\r\n\r\n.fa-font-awesome-flag {\r\n  --fa: \"\\f2b4\"; }\r\n\r\n.fa-font-awesome-logo-full {\r\n  --fa: \"\\f2b4\"; }\r\n\r\n.fa-gratipay {\r\n  --fa: \"\\f184\"; }\r\n\r\n.fa-apple {\r\n  --fa: \"\\f179\"; }\r\n\r\n.fa-hive {\r\n  --fa: \"\\e07f\"; }\r\n\r\n.fa-gitkraken {\r\n  --fa: \"\\f3a6\"; }\r\n\r\n.fa-keybase {\r\n  --fa: \"\\f4f5\"; }\r\n\r\n.fa-apple-pay {\r\n  --fa: \"\\f415\"; }\r\n\r\n.fa-padlet {\r\n  --fa: \"\\e4a0\"; }\r\n\r\n.fa-amazon-pay {\r\n  --fa: \"\\f42c\"; }\r\n\r\n.fa-square-github {\r\n  --fa: \"\\f092\"; }\r\n\r\n.fa-github-square {\r\n  --fa: \"\\f092\"; }\r\n\r\n.fa-stumbleupon {\r\n  --fa: \"\\f1a4\"; }\r\n\r\n.fa-fedex {\r\n  --fa: \"\\f797\"; }\r\n\r\n.fa-phoenix-framework {\r\n  --fa: \"\\f3dc\"; }\r\n\r\n.fa-shopify {\r\n  --fa: \"\\e057\"; }\r\n\r\n.fa-neos {\r\n  --fa: \"\\f612\"; }\r\n\r\n.fa-square-threads {\r\n  --fa: \"\\e619\"; }\r\n\r\n.fa-hackerrank {\r\n  --fa: \"\\f5f7\"; }\r\n\r\n.fa-researchgate {\r\n  --fa: \"\\f4f8\"; }\r\n\r\n.fa-swift {\r\n  --fa: \"\\f8e1\"; }\r\n\r\n.fa-angular {\r\n  --fa: \"\\f420\"; }\r\n\r\n.fa-speakap {\r\n  --fa: \"\\f3f3\"; }\r\n\r\n.fa-angrycreative {\r\n  --fa: \"\\f36e\"; }\r\n\r\n.fa-y-combinator {\r\n  --fa: \"\\f23b\"; }\r\n\r\n.fa-empire {\r\n  --fa: \"\\f1d1\"; }\r\n\r\n.fa-envira {\r\n  --fa: \"\\f299\"; }\r\n\r\n.fa-google-scholar {\r\n  --fa: \"\\e63b\"; }\r\n\r\n.fa-square-gitlab {\r\n  --fa: \"\\e5ae\"; }\r\n\r\n.fa-gitlab-square {\r\n  --fa: \"\\e5ae\"; }\r\n\r\n.fa-studiovinari {\r\n  --fa: \"\\f3f8\"; }\r\n\r\n.fa-pied-piper {\r\n  --fa: \"\\f2ae\"; }\r\n\r\n.fa-wordpress {\r\n  --fa: \"\\f19a\"; }\r\n\r\n.fa-product-hunt {\r\n  --fa: \"\\f288\"; }\r\n\r\n.fa-firefox {\r\n  --fa: \"\\f269\"; }\r\n\r\n.fa-linode {\r\n  --fa: \"\\f2b8\"; }\r\n\r\n.fa-goodreads {\r\n  --fa: \"\\f3a8\"; }\r\n\r\n.fa-square-odnoklassniki {\r\n  --fa: \"\\f264\"; }\r\n\r\n.fa-odnoklassniki-square {\r\n  --fa: \"\\f264\"; }\r\n\r\n.fa-jsfiddle {\r\n  --fa: \"\\f1cc\"; }\r\n\r\n.fa-sith {\r\n  --fa: \"\\f512\"; }\r\n\r\n.fa-themeisle {\r\n  --fa: \"\\f2b2\"; }\r\n\r\n.fa-page4 {\r\n  --fa: \"\\f3d7\"; }\r\n\r\n.fa-hashnode {\r\n  --fa: \"\\e499\"; }\r\n\r\n.fa-react {\r\n  --fa: \"\\f41b\"; }\r\n\r\n.fa-cc-paypal {\r\n  --fa: \"\\f1f4\"; }\r\n\r\n.fa-squarespace {\r\n  --fa: \"\\f5be\"; }\r\n\r\n.fa-cc-stripe {\r\n  --fa: \"\\f1f5\"; }\r\n\r\n.fa-creative-commons-share {\r\n  --fa: \"\\f4f2\"; }\r\n\r\n.fa-bitcoin {\r\n  --fa: \"\\f379\"; }\r\n\r\n.fa-keycdn {\r\n  --fa: \"\\f3ba\"; }\r\n\r\n.fa-opera {\r\n  --fa: \"\\f26a\"; }\r\n\r\n.fa-itch-io {\r\n  --fa: \"\\f83a\"; }\r\n\r\n.fa-umbraco {\r\n  --fa: \"\\f8e8\"; }\r\n\r\n.fa-galactic-senate {\r\n  --fa: \"\\f50d\"; }\r\n\r\n.fa-ubuntu {\r\n  --fa: \"\\f7df\"; }\r\n\r\n.fa-draft2digital {\r\n  --fa: \"\\f396\"; }\r\n\r\n.fa-stripe {\r\n  --fa: \"\\f429\"; }\r\n\r\n.fa-houzz {\r\n  --fa: \"\\f27c\"; }\r\n\r\n.fa-gg {\r\n  --fa: \"\\f260\"; }\r\n\r\n.fa-dhl {\r\n  --fa: \"\\f790\"; }\r\n\r\n.fa-square-pinterest {\r\n  --fa: \"\\f0d3\"; }\r\n\r\n.fa-pinterest-square {\r\n  --fa: \"\\f0d3\"; }\r\n\r\n.fa-xing {\r\n  --fa: \"\\f168\"; }\r\n\r\n.fa-blackberry {\r\n  --fa: \"\\f37b\"; }\r\n\r\n.fa-creative-commons-pd {\r\n  --fa: \"\\f4ec\"; }\r\n\r\n.fa-playstation {\r\n  --fa: \"\\f3df\"; }\r\n\r\n.fa-quinscape {\r\n  --fa: \"\\f459\"; }\r\n\r\n.fa-less {\r\n  --fa: \"\\f41d\"; }\r\n\r\n.fa-blogger-b {\r\n  --fa: \"\\f37d\"; }\r\n\r\n.fa-opencart {\r\n  --fa: \"\\f23d\"; }\r\n\r\n.fa-vine {\r\n  --fa: \"\\f1ca\"; }\r\n\r\n.fa-signal-messenger {\r\n  --fa: \"\\e663\"; }\r\n\r\n.fa-paypal {\r\n  --fa: \"\\f1ed\"; }\r\n\r\n.fa-gitlab {\r\n  --fa: \"\\f296\"; }\r\n\r\n.fa-typo3 {\r\n  --fa: \"\\f42b\"; }\r\n\r\n.fa-reddit-alien {\r\n  --fa: \"\\f281\"; }\r\n\r\n.fa-yahoo {\r\n  --fa: \"\\f19e\"; }\r\n\r\n.fa-dailymotion {\r\n  --fa: \"\\e052\"; }\r\n\r\n.fa-affiliatetheme {\r\n  --fa: \"\\f36b\"; }\r\n\r\n.fa-pied-piper-pp {\r\n  --fa: \"\\f1a7\"; }\r\n\r\n.fa-bootstrap {\r\n  --fa: \"\\f836\"; }\r\n\r\n.fa-odnoklassniki {\r\n  --fa: \"\\f263\"; }\r\n\r\n.fa-nfc-symbol {\r\n  --fa: \"\\e531\"; }\r\n\r\n.fa-mintbit {\r\n  --fa: \"\\e62f\"; }\r\n\r\n.fa-ethereum {\r\n  --fa: \"\\f42e\"; }\r\n\r\n.fa-speaker-deck {\r\n  --fa: \"\\f83c\"; }\r\n\r\n.fa-creative-commons-nc-eu {\r\n  --fa: \"\\f4e9\"; }\r\n\r\n.fa-patreon {\r\n  --fa: \"\\f3d9\"; }\r\n\r\n.fa-avianex {\r\n  --fa: \"\\f374\"; }\r\n\r\n.fa-ello {\r\n  --fa: \"\\f5f1\"; }\r\n\r\n.fa-gofore {\r\n  --fa: \"\\f3a7\"; }\r\n\r\n.fa-bimobject {\r\n  --fa: \"\\f378\"; }\r\n\r\n.fa-brave-reverse {\r\n  --fa: \"\\e63d\"; }\r\n\r\n.fa-facebook-f {\r\n  --fa: \"\\f39e\"; }\r\n\r\n.fa-square-google-plus {\r\n  --fa: \"\\f0d4\"; }\r\n\r\n.fa-google-plus-square {\r\n  --fa: \"\\f0d4\"; }\r\n\r\n.fa-web-awesome {\r\n  --fa: \"\\e682\"; }\r\n\r\n.fa-mandalorian {\r\n  --fa: \"\\f50f\"; }\r\n\r\n.fa-first-order-alt {\r\n  --fa: \"\\f50a\"; }\r\n\r\n.fa-osi {\r\n  --fa: \"\\f41a\"; }\r\n\r\n.fa-google-wallet {\r\n  --fa: \"\\f1ee\"; }\r\n\r\n.fa-d-and-d-beyond {\r\n  --fa: \"\\f6ca\"; }\r\n\r\n.fa-periscope {\r\n  --fa: \"\\f3da\"; }\r\n\r\n.fa-fulcrum {\r\n  --fa: \"\\f50b\"; }\r\n\r\n.fa-cloudscale {\r\n  --fa: \"\\f383\"; }\r\n\r\n.fa-forumbee {\r\n  --fa: \"\\f211\"; }\r\n\r\n.fa-mizuni {\r\n  --fa: \"\\f3cc\"; }\r\n\r\n.fa-schlix {\r\n  --fa: \"\\f3ea\"; }\r\n\r\n.fa-square-xing {\r\n  --fa: \"\\f169\"; }\r\n\r\n.fa-xing-square {\r\n  --fa: \"\\f169\"; }\r\n\r\n.fa-bandcamp {\r\n  --fa: \"\\f2d5\"; }\r\n\r\n.fa-wpforms {\r\n  --fa: \"\\f298\"; }\r\n\r\n.fa-cloudversify {\r\n  --fa: \"\\f385\"; }\r\n\r\n.fa-usps {\r\n  --fa: \"\\f7e1\"; }\r\n\r\n.fa-megaport {\r\n  --fa: \"\\f5a3\"; }\r\n\r\n.fa-magento {\r\n  --fa: \"\\f3c4\"; }\r\n\r\n.fa-spotify {\r\n  --fa: \"\\f1bc\"; }\r\n\r\n.fa-optin-monster {\r\n  --fa: \"\\f23c\"; }\r\n\r\n.fa-fly {\r\n  --fa: \"\\f417\"; }\r\n\r\n.fa-square-bluesky {\r\n  --fa: \"\\e6a3\"; }\r\n\r\n.fa-aviato {\r\n  --fa: \"\\f421\"; }\r\n\r\n.fa-itunes {\r\n  --fa: \"\\f3b4\"; }\r\n\r\n.fa-cuttlefish {\r\n  --fa: \"\\f38c\"; }\r\n\r\n.fa-blogger {\r\n  --fa: \"\\f37c\"; }\r\n\r\n.fa-flickr {\r\n  --fa: \"\\f16e\"; }\r\n\r\n.fa-viber {\r\n  --fa: \"\\f409\"; }\r\n\r\n.fa-soundcloud {\r\n  --fa: \"\\f1be\"; }\r\n\r\n.fa-digg {\r\n  --fa: \"\\f1a6\"; }\r\n\r\n.fa-tencent-weibo {\r\n  --fa: \"\\f1d5\"; }\r\n\r\n.fa-letterboxd {\r\n  --fa: \"\\e62d\"; }\r\n\r\n.fa-symfony {\r\n  --fa: \"\\f83d\"; }\r\n\r\n.fa-maxcdn {\r\n  --fa: \"\\f136\"; }\r\n\r\n.fa-etsy {\r\n  --fa: \"\\f2d7\"; }\r\n\r\n.fa-facebook-messenger {\r\n  --fa: \"\\f39f\"; }\r\n\r\n.fa-audible {\r\n  --fa: \"\\f373\"; }\r\n\r\n.fa-think-peaks {\r\n  --fa: \"\\f731\"; }\r\n\r\n.fa-bilibili {\r\n  --fa: \"\\e3d9\"; }\r\n\r\n.fa-erlang {\r\n  --fa: \"\\f39d\"; }\r\n\r\n.fa-x-twitter {\r\n  --fa: \"\\e61b\"; }\r\n\r\n.fa-cotton-bureau {\r\n  --fa: \"\\f89e\"; }\r\n\r\n.fa-dashcube {\r\n  --fa: \"\\f210\"; }\r\n\r\n.fa-42-group {\r\n  --fa: \"\\e080\"; }\r\n\r\n.fa-innosoft {\r\n  --fa: \"\\e080\"; }\r\n\r\n.fa-stack-exchange {\r\n  --fa: \"\\f18d\"; }\r\n\r\n.fa-elementor {\r\n  --fa: \"\\f430\"; }\r\n\r\n.fa-square-pied-piper {\r\n  --fa: \"\\e01e\"; }\r\n\r\n.fa-pied-piper-square {\r\n  --fa: \"\\e01e\"; }\r\n\r\n.fa-creative-commons-nd {\r\n  --fa: \"\\f4eb\"; }\r\n\r\n.fa-palfed {\r\n  --fa: \"\\f3d8\"; }\r\n\r\n.fa-superpowers {\r\n  --fa: \"\\f2dd\"; }\r\n\r\n.fa-resolving {\r\n  --fa: \"\\f3e7\"; }\r\n\r\n.fa-xbox {\r\n  --fa: \"\\f412\"; }\r\n\r\n.fa-square-web-awesome-stroke {\r\n  --fa: \"\\e684\"; }\r\n\r\n.fa-searchengin {\r\n  --fa: \"\\f3eb\"; }\r\n\r\n.fa-tiktok {\r\n  --fa: \"\\e07b\"; }\r\n\r\n.fa-square-facebook {\r\n  --fa: \"\\f082\"; }\r\n\r\n.fa-facebook-square {\r\n  --fa: \"\\f082\"; }\r\n\r\n.fa-renren {\r\n  --fa: \"\\f18b\"; }\r\n\r\n.fa-linux {\r\n  --fa: \"\\f17c\"; }\r\n\r\n.fa-glide {\r\n  --fa: \"\\f2a5\"; }\r\n\r\n.fa-linkedin {\r\n  --fa: \"\\f08c\"; }\r\n\r\n.fa-hubspot {\r\n  --fa: \"\\f3b2\"; }\r\n\r\n.fa-deploydog {\r\n  --fa: \"\\f38e\"; }\r\n\r\n.fa-twitch {\r\n  --fa: \"\\f1e8\"; }\r\n\r\n.fa-flutter {\r\n  --fa: \"\\e694\"; }\r\n\r\n.fa-ravelry {\r\n  --fa: \"\\f2d9\"; }\r\n\r\n.fa-mixer {\r\n  --fa: \"\\e056\"; }\r\n\r\n.fa-square-lastfm {\r\n  --fa: \"\\f203\"; }\r\n\r\n.fa-lastfm-square {\r\n  --fa: \"\\f203\"; }\r\n\r\n.fa-vimeo {\r\n  --fa: \"\\f40a\"; }\r\n\r\n.fa-mendeley {\r\n  --fa: \"\\f7b3\"; }\r\n\r\n.fa-uniregistry {\r\n  --fa: \"\\f404\"; }\r\n\r\n.fa-figma {\r\n  --fa: \"\\f799\"; }\r\n\r\n.fa-creative-commons-remix {\r\n  --fa: \"\\f4ee\"; }\r\n\r\n.fa-cc-amazon-pay {\r\n  --fa: \"\\f42d\"; }\r\n\r\n.fa-dropbox {\r\n  --fa: \"\\f16b\"; }\r\n\r\n.fa-instagram {\r\n  --fa: \"\\f16d\"; }\r\n\r\n.fa-cmplid {\r\n  --fa: \"\\e360\"; }\r\n\r\n.fa-upwork {\r\n  --fa: \"\\e641\"; }\r\n\r\n.fa-facebook {\r\n  --fa: \"\\f09a\"; }\r\n\r\n.fa-gripfire {\r\n  --fa: \"\\f3ac\"; }\r\n\r\n.fa-jedi-order {\r\n  --fa: \"\\f50e\"; }\r\n\r\n.fa-uikit {\r\n  --fa: \"\\f403\"; }\r\n\r\n.fa-fort-awesome-alt {\r\n  --fa: \"\\f3a3\"; }\r\n\r\n.fa-phabricator {\r\n  --fa: \"\\f3db\"; }\r\n\r\n.fa-ussunnah {\r\n  --fa: \"\\f407\"; }\r\n\r\n.fa-earlybirds {\r\n  --fa: \"\\f39a\"; }\r\n\r\n.fa-trade-federation {\r\n  --fa: \"\\f513\"; }\r\n\r\n.fa-autoprefixer {\r\n  --fa: \"\\f41c\"; }\r\n\r\n.fa-whatsapp {\r\n  --fa: \"\\f232\"; }\r\n\r\n.fa-square-upwork {\r\n  --fa: \"\\e67c\"; }\r\n\r\n.fa-slideshare {\r\n  --fa: \"\\f1e7\"; }\r\n\r\n.fa-google-play {\r\n  --fa: \"\\f3ab\"; }\r\n\r\n.fa-viadeo {\r\n  --fa: \"\\f2a9\"; }\r\n\r\n.fa-line {\r\n  --fa: \"\\f3c0\"; }\r\n\r\n.fa-google-drive {\r\n  --fa: \"\\f3aa\"; }\r\n\r\n.fa-servicestack {\r\n  --fa: \"\\f3ec\"; }\r\n\r\n.fa-simplybuilt {\r\n  --fa: \"\\f215\"; }\r\n\r\n.fa-bitbucket {\r\n  --fa: \"\\f171\"; }\r\n\r\n.fa-imdb {\r\n  --fa: \"\\f2d8\"; }\r\n\r\n.fa-deezer {\r\n  --fa: \"\\e077\"; }\r\n\r\n.fa-raspberry-pi {\r\n  --fa: \"\\f7bb\"; }\r\n\r\n.fa-jira {\r\n  --fa: \"\\f7b1\"; }\r\n\r\n.fa-docker {\r\n  --fa: \"\\f395\"; }\r\n\r\n.fa-screenpal {\r\n  --fa: \"\\e570\"; }\r\n\r\n.fa-bluetooth {\r\n  --fa: \"\\f293\"; }\r\n\r\n.fa-gitter {\r\n  --fa: \"\\f426\"; }\r\n\r\n.fa-d-and-d {\r\n  --fa: \"\\f38d\"; }\r\n\r\n.fa-microblog {\r\n  --fa: \"\\e01a\"; }\r\n\r\n.fa-cc-diners-club {\r\n  --fa: \"\\f24c\"; }\r\n\r\n.fa-gg-circle {\r\n  --fa: \"\\f261\"; }\r\n\r\n.fa-pied-piper-hat {\r\n  --fa: \"\\f4e5\"; }\r\n\r\n.fa-kickstarter-k {\r\n  --fa: \"\\f3bc\"; }\r\n\r\n.fa-yandex {\r\n  --fa: \"\\f413\"; }\r\n\r\n.fa-readme {\r\n  --fa: \"\\f4d5\"; }\r\n\r\n.fa-html5 {\r\n  --fa: \"\\f13b\"; }\r\n\r\n.fa-sellsy {\r\n  --fa: \"\\f213\"; }\r\n\r\n.fa-square-web-awesome {\r\n  --fa: \"\\e683\"; }\r\n\r\n.fa-sass {\r\n  --fa: \"\\f41e\"; }\r\n\r\n.fa-wirsindhandwerk {\r\n  --fa: \"\\e2d0\"; }\r\n\r\n.fa-wsh {\r\n  --fa: \"\\e2d0\"; }\r\n\r\n.fa-buromobelexperte {\r\n  --fa: \"\\f37f\"; }\r\n\r\n.fa-salesforce {\r\n  --fa: \"\\f83b\"; }\r\n\r\n.fa-octopus-deploy {\r\n  --fa: \"\\e082\"; }\r\n\r\n.fa-medapps {\r\n  --fa: \"\\f3c6\"; }\r\n\r\n.fa-ns8 {\r\n  --fa: \"\\f3d5\"; }\r\n\r\n.fa-pinterest-p {\r\n  --fa: \"\\f231\"; }\r\n\r\n.fa-apper {\r\n  --fa: \"\\f371\"; }\r\n\r\n.fa-fort-awesome {\r\n  --fa: \"\\f286\"; }\r\n\r\n.fa-waze {\r\n  --fa: \"\\f83f\"; }\r\n\r\n.fa-bluesky {\r\n  --fa: \"\\e671\"; }\r\n\r\n.fa-cc-jcb {\r\n  --fa: \"\\f24b\"; }\r\n\r\n.fa-snapchat {\r\n  --fa: \"\\f2ab\"; }\r\n\r\n.fa-snapchat-ghost {\r\n  --fa: \"\\f2ab\"; }\r\n\r\n.fa-fantasy-flight-games {\r\n  --fa: \"\\f6dc\"; }\r\n\r\n.fa-rust {\r\n  --fa: \"\\e07a\"; }\r\n\r\n.fa-wix {\r\n  --fa: \"\\f5cf\"; }\r\n\r\n.fa-square-behance {\r\n  --fa: \"\\f1b5\"; }\r\n\r\n.fa-behance-square {\r\n  --fa: \"\\f1b5\"; }\r\n\r\n.fa-supple {\r\n  --fa: \"\\f3f9\"; }\r\n\r\n.fa-webflow {\r\n  --fa: \"\\e65c\"; }\r\n\r\n.fa-rebel {\r\n  --fa: \"\\f1d0\"; }\r\n\r\n.fa-css3 {\r\n  --fa: \"\\f13c\"; }\r\n\r\n.fa-staylinked {\r\n  --fa: \"\\f3f5\"; }\r\n\r\n.fa-kaggle {\r\n  --fa: \"\\f5fa\"; }\r\n\r\n.fa-space-awesome {\r\n  --fa: \"\\e5ac\"; }\r\n\r\n.fa-deviantart {\r\n  --fa: \"\\f1bd\"; }\r\n\r\n.fa-cpanel {\r\n  --fa: \"\\f388\"; }\r\n\r\n.fa-goodreads-g {\r\n  --fa: \"\\f3a9\"; }\r\n\r\n.fa-square-git {\r\n  --fa: \"\\f1d2\"; }\r\n\r\n.fa-git-square {\r\n  --fa: \"\\f1d2\"; }\r\n\r\n.fa-square-tumblr {\r\n  --fa: \"\\f174\"; }\r\n\r\n.fa-tumblr-square {\r\n  --fa: \"\\f174\"; }\r\n\r\n.fa-trello {\r\n  --fa: \"\\f181\"; }\r\n\r\n.fa-creative-commons-nc-jp {\r\n  --fa: \"\\f4ea\"; }\r\n\r\n.fa-get-pocket {\r\n  --fa: \"\\f265\"; }\r\n\r\n.fa-perbyte {\r\n  --fa: \"\\e083\"; }\r\n\r\n.fa-grunt {\r\n  --fa: \"\\f3ad\"; }\r\n\r\n.fa-weebly {\r\n  --fa: \"\\f5cc\"; }\r\n\r\n.fa-connectdevelop {\r\n  --fa: \"\\f20e\"; }\r\n\r\n.fa-leanpub {\r\n  --fa: \"\\f212\"; }\r\n\r\n.fa-black-tie {\r\n  --fa: \"\\f27e\"; }\r\n\r\n.fa-themeco {\r\n  --fa: \"\\f5c6\"; }\r\n\r\n.fa-python {\r\n  --fa: \"\\f3e2\"; }\r\n\r\n.fa-android {\r\n  --fa: \"\\f17b\"; }\r\n\r\n.fa-bots {\r\n  --fa: \"\\e340\"; }\r\n\r\n.fa-free-code-camp {\r\n  --fa: \"\\f2c5\"; }\r\n\r\n.fa-hornbill {\r\n  --fa: \"\\f592\"; }\r\n\r\n.fa-js {\r\n  --fa: \"\\f3b8\"; }\r\n\r\n.fa-ideal {\r\n  --fa: \"\\e013\"; }\r\n\r\n.fa-git {\r\n  --fa: \"\\f1d3\"; }\r\n\r\n.fa-dev {\r\n  --fa: \"\\f6cc\"; }\r\n\r\n.fa-sketch {\r\n  --fa: \"\\f7c6\"; }\r\n\r\n.fa-yandex-international {\r\n  --fa: \"\\f414\"; }\r\n\r\n.fa-cc-amex {\r\n  --fa: \"\\f1f3\"; }\r\n\r\n.fa-uber {\r\n  --fa: \"\\f402\"; }\r\n\r\n.fa-github {\r\n  --fa: \"\\f09b\"; }\r\n\r\n.fa-php {\r\n  --fa: \"\\f457\"; }\r\n\r\n.fa-alipay {\r\n  --fa: \"\\f642\"; }\r\n\r\n.fa-youtube {\r\n  --fa: \"\\f167\"; }\r\n\r\n.fa-skyatlas {\r\n  --fa: \"\\f216\"; }\r\n\r\n.fa-firefox-browser {\r\n  --fa: \"\\e007\"; }\r\n\r\n.fa-replyd {\r\n  --fa: \"\\f3e6\"; }\r\n\r\n.fa-suse {\r\n  --fa: \"\\f7d6\"; }\r\n\r\n.fa-jenkins {\r\n  --fa: \"\\f3b6\"; }\r\n\r\n.fa-twitter {\r\n  --fa: \"\\f099\"; }\r\n\r\n.fa-rockrms {\r\n  --fa: \"\\f3e9\"; }\r\n\r\n.fa-pinterest {\r\n  --fa: \"\\f0d2\"; }\r\n\r\n.fa-buffer {\r\n  --fa: \"\\f837\"; }\r\n\r\n.fa-npm {\r\n  --fa: \"\\f3d4\"; }\r\n\r\n.fa-yammer {\r\n  --fa: \"\\f840\"; }\r\n\r\n.fa-btc {\r\n  --fa: \"\\f15a\"; }\r\n\r\n.fa-dribbble {\r\n  --fa: \"\\f17d\"; }\r\n\r\n.fa-stumbleupon-circle {\r\n  --fa: \"\\f1a3\"; }\r\n\r\n.fa-internet-explorer {\r\n  --fa: \"\\f26b\"; }\r\n\r\n.fa-stubber {\r\n  --fa: \"\\e5c7\"; }\r\n\r\n.fa-telegram {\r\n  --fa: \"\\f2c6\"; }\r\n\r\n.fa-telegram-plane {\r\n  --fa: \"\\f2c6\"; }\r\n\r\n.fa-old-republic {\r\n  --fa: \"\\f510\"; }\r\n\r\n.fa-odysee {\r\n  --fa: \"\\e5c6\"; }\r\n\r\n.fa-square-whatsapp {\r\n  --fa: \"\\f40c\"; }\r\n\r\n.fa-whatsapp-square {\r\n  --fa: \"\\f40c\"; }\r\n\r\n.fa-node-js {\r\n  --fa: \"\\f3d3\"; }\r\n\r\n.fa-edge-legacy {\r\n  --fa: \"\\e078\"; }\r\n\r\n.fa-slack {\r\n  --fa: \"\\f198\"; }\r\n\r\n.fa-slack-hash {\r\n  --fa: \"\\f198\"; }\r\n\r\n.fa-medrt {\r\n  --fa: \"\\f3c8\"; }\r\n\r\n.fa-usb {\r\n  --fa: \"\\f287\"; }\r\n\r\n.fa-tumblr {\r\n  --fa: \"\\f173\"; }\r\n\r\n.fa-vaadin {\r\n  --fa: \"\\f408\"; }\r\n\r\n.fa-quora {\r\n  --fa: \"\\f2c4\"; }\r\n\r\n.fa-square-x-twitter {\r\n  --fa: \"\\e61a\"; }\r\n\r\n.fa-reacteurope {\r\n  --fa: \"\\f75d\"; }\r\n\r\n.fa-medium {\r\n  --fa: \"\\f23a\"; }\r\n\r\n.fa-medium-m {\r\n  --fa: \"\\f23a\"; }\r\n\r\n.fa-amilia {\r\n  --fa: \"\\f36d\"; }\r\n\r\n.fa-mixcloud {\r\n  --fa: \"\\f289\"; }\r\n\r\n.fa-flipboard {\r\n  --fa: \"\\f44d\"; }\r\n\r\n.fa-viacoin {\r\n  --fa: \"\\f237\"; }\r\n\r\n.fa-critical-role {\r\n  --fa: \"\\f6c9\"; }\r\n\r\n.fa-sitrox {\r\n  --fa: \"\\e44a\"; }\r\n\r\n.fa-discourse {\r\n  --fa: \"\\f393\"; }\r\n\r\n.fa-joomla {\r\n  --fa: \"\\f1aa\"; }\r\n\r\n.fa-mastodon {\r\n  --fa: \"\\f4f6\"; }\r\n\r\n.fa-airbnb {\r\n  --fa: \"\\f834\"; }\r\n\r\n.fa-wolf-pack-battalion {\r\n  --fa: \"\\f514\"; }\r\n\r\n.fa-buy-n-large {\r\n  --fa: \"\\f8a6\"; }\r\n\r\n.fa-gulp {\r\n  --fa: \"\\f3ae\"; }\r\n\r\n.fa-creative-commons-sampling-plus {\r\n  --fa: \"\\f4f1\"; }\r\n\r\n.fa-strava {\r\n  --fa: \"\\f428\"; }\r\n\r\n.fa-ember {\r\n  --fa: \"\\f423\"; }\r\n\r\n.fa-canadian-maple-leaf {\r\n  --fa: \"\\f785\"; }\r\n\r\n.fa-teamspeak {\r\n  --fa: \"\\f4f9\"; }\r\n\r\n.fa-pushed {\r\n  --fa: \"\\f3e1\"; }\r\n\r\n.fa-wordpress-simple {\r\n  --fa: \"\\f411\"; }\r\n\r\n.fa-nutritionix {\r\n  --fa: \"\\f3d6\"; }\r\n\r\n.fa-wodu {\r\n  --fa: \"\\e088\"; }\r\n\r\n.fa-google-pay {\r\n  --fa: \"\\e079\"; }\r\n\r\n.fa-intercom {\r\n  --fa: \"\\f7af\"; }\r\n\r\n.fa-zhihu {\r\n  --fa: \"\\f63f\"; }\r\n\r\n.fa-korvue {\r\n  --fa: \"\\f42f\"; }\r\n\r\n.fa-pix {\r\n  --fa: \"\\e43a\"; }\r\n\r\n.fa-steam-symbol {\r\n  --fa: \"\\f3f6\"; }\r\n:root, :host {\r\n  --fa-style-family-classic: 'Font Awesome 6 Free';\r\n  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free'; }\r\n\r\n@font-face {\r\n  font-family: 'Font Awesome 6 Free';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\"); }\r\n\r\n.far,\r\n.fa-regular {\r\n  font-weight: 400; }\r\n:root, :host {\r\n  --fa-style-family-classic: 'Font Awesome 6 Free';\r\n  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free'; }\r\n\r\n@font-face {\r\n  font-family: 'Font Awesome 6 Free';\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\r\n\r\n.fas,\r\n.fa-solid {\r\n  font-weight: 900; }\r\n@font-face {\r\n  font-family: 'Font Awesome 5 Brands';\r\n  font-display: block;\r\n  font-weight: 400;\r\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\r\n\r\n@font-face {\r\n  font-family: 'Font Awesome 5 Free';\r\n  font-display: block;\r\n  font-weight: 900;\r\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\r\n\r\n@font-face {\r\n  font-family: 'Font Awesome 5 Free';\r\n  font-display: block;\r\n  font-weight: 400;\r\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\"); }\r\n@font-face {\r\n  font-family: 'FontAwesome';\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\r\n\r\n@font-face {\r\n  font-family: 'FontAwesome';\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\r\n\r\n@font-face {\r\n  font-family: 'FontAwesome';\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\");\r\n  unicode-range: U+F003,U+F006,U+F014,U+F016-F017,U+F01A-F01B,U+F01D,U+F022,U+F03E,U+F044,U+F046,U+F05C-F05D,U+F06E,U+F070,U+F087-F088,U+F08A,U+F094,U+F096-F097,U+F09D,U+F0A0,U+F0A2,U+F0A4-F0A7,U+F0C5,U+F0C7,U+F0E5-F0E6,U+F0EB,U+F0F6-F0F8,U+F10C,U+F114-F115,U+F118-F11A,U+F11C-F11D,U+F133,U+F147,U+F14E,U+F150-F152,U+F185-F186,U+F18E,U+F190-F192,U+F196,U+F1C1-F1C9,U+F1D9,U+F1DB,U+F1E3,U+F1EA,U+F1F7,U+F1F9,U+F20A,U+F247-F248,U+F24A,U+F24D,U+F255-F25B,U+F25D,U+F271-F274,U+F278,U+F27B,U+F28C,U+F28E,U+F29C,U+F2B5,U+F2B7,U+F2BA,U+F2BC,U+F2BE,U+F2C0-F2C1,U+F2C3,U+F2D0,U+F2D2,U+F2D4,U+F2DC; }\r\n\r\n@font-face {\r\n  font-family: 'FontAwesome';\r\n  font-display: block;\r\n  src: url(\"../webfonts/fa-v4compatibility.woff2\") format(\"woff2\"), url(\"../webfonts/fa-v4compatibility.ttf\") format(\"truetype\");\r\n  unicode-range: U+F041,U+F047,U+F065-F066,U+F07D-F07E,U+F080,U+F08B,U+F08E,U+F090,U+F09A,U+F0AC,U+F0AE,U+F0B2,U+F0D0,U+F0D6,U+F0E4,U+F0EC,U+F10A-F10B,U+F123,U+F13E,U+F148-F149,U+F14C,U+F156,U+F15E,U+F160-F161,U+F163,U+F175-F178,U+F195,U+F1F8,U+F219,U+F27A; }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
